webpackJsonp([1],{

/***/ "+5wJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Jkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ExportsService_js__ = __webpack_require__("gHwv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterString: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('exports', ['exportsList', 'loadSingleExports'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('exports', ['loadExportsList']), {
    loadExports: function loadExports() {
      if (this.clientActive) {
        this.loadExportsList(this.currentClient.id);
      } else {
        this.loadExportsList();
      }
    },
    deleteExports: function deleteExports() {
      var exportIds = [];
      if (this.checked.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checked), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var exportIndex = _step.value;

            exportIds.push(this.exports[exportIndex].id);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        Object(__WEBPACK_IMPORTED_MODULE_3__services_ExportsService_js__["a" /* deleteExports */])(this.currentClient.id, exportIds);
        this.emptyChecked();
        this.showDialog = false;
      }
      this.loadClientToursList(this.currentClient.id);
    },
    showCurrentExport: function showCurrentExport(exportId) {
      if (exports.id === exportId) {
        this.loadSingleExports(exports);
      }
    }
  }),
  mounted: function mounted() {
    this.loadExports();
  }
});

/***/ }),

/***/ "+OK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapDiv"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingmy ),expression:"isLoadingmy "}],staticStyle:{"background":"rgba(0,0,0,0.5)","position":"fixed","display":"flex","justify-content":"center","align-items":"center","z-index":"1000001","left":"0","top":"0","height":"100%","width":"100%"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingmy),expression:"isLoadingmy"}],staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]),_vm._v(" "),_c('div',{staticClass:"map-header-avatar"},[_c('md-button',{staticClass:"avatar-button",on:{"click":function($event){}}},[(_vm.currentUser.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.currentUser.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                    "+_vm._s(_vm.getUserInitials(_vm.currentUser))+"\n                ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"pencilDivAlt"},[(_vm.routerPathName === 'Route')?_c('span',[(_vm.pencilIconSelectedAlt)?_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Exit alternate path editor"},on:{"click":function($event){_vm.toggleRouteEditingAlt(false)}}},[_c('img',{staticClass:"pencilSelected",attrs:{"src":"static/img/Alt_Pencil_Icon_on.png"}})]):_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Enable alternate path editor"},on:{"click":function($event){_vm.toggleRouteEditingAlt(true)}}},[_c('img',{attrs:{"src":"static/img/Alt_Pencil_Icon.png"}})])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"infopencilSelectedMy"},[_c('md-avatar',[_c('img',{staticClass:"infopencilSelected",staticStyle:{"height":"auto !important"},attrs:{"src":"static/img/Help_Icon.png"},on:{"click":function($event){_vm.showVideoPdf()}}})])],1),_vm._v(" "),_c('div',{staticClass:"circleRoute"},[(_vm.routerPathName === 'Route')?_c('span',[(_vm.circularToggle)?_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Hide TriggerZones"},on:{"click":function($event){ _vm.toggleRouteCircular(true) ; }}},[_c('img',{attrs:{"src":"static/img/Toggle-GPS-TriggerZONE-ON.png"}})]):_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"View TriggerZones"},on:{"click":function($event){ _vm.toggleRouteCircular(false);}}},[_c('img',{staticClass:"pencilSelected",attrs:{"src":"static/img/Toggle-GPS-TriggerZONE-OFF.png"}})])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pencilDiv"},[(_vm.routerPathName === 'Route')?_c('span',[(_vm.pencilIconSelected)?_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Exit path editor"},on:{"click":function($event){_vm.toggleRouteEditing(false)}}},[_c('img',{staticClass:"pencilSelected",attrs:{"src":"static/img/Pencil_Icon_on.png"}})]):_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Enable path editor"},on:{"click":function($event){_vm.toggleRouteEditing(true)}}},[_c('img',{attrs:{"src":"static/img/Pencil_Icon.png"}})])],1):_vm._e()]),_vm._v(" "),_c('gmap-map',{ref:"map",staticClass:"mapStyle",attrs:{"options":{scaleControl: true},"center":_vm.center,"zoom":14},on:{"idle":function($event){_vm.gettingBounds()},"click":function($event){_vm.createPath($event)},"center_changed":function($event){_vm.updateCenter($event)},"dragend":function($event){_vm.saveCenter()}}},[_vm._l((_vm.triggersList),function(trigger,index3){return (_vm.showTriggers)?_c('span',{key:index3},[(_vm.currentTriggerCheck(trigger))?_c('span',[_c('gmap-polygon',{attrs:{"zIndex":6,"paths":_vm.generateTriggerPolygonPaths(_vm.currentTrigger),"draggable":false,"editable":false,"options":_vm.triggerZonePolygon}}),_vm._v(" "),_c('gmap-polygon',{attrs:{"zIndex":6,"paths":_vm.generateTriggerPolygonPathsComplete(_vm.currentTrigger),"draggable":false,"editable":false,"options":_vm.triggerZonePolygonComplete}}),_vm._v(" "),_c('gmap-marker',{key:index3,attrs:{"zIndex":8,"position":_vm.getParsedTriggerLatLng(_vm.currentTrigger),"draggable":true,"clickable":true,"icon":_vm.currentTriggerPositionIcon},on:{"drag":function($event){_vm.updateTriggerPoints($event)}}}),_vm._v(" "),(_vm.headingEnabled)?_c('gmap-marker',{key:index3,attrs:{"zIndex":7,"position":_vm.getParsedTriggerLatLng(_vm.currentTrigger),"icon":_vm.headingArrowShape(trigger)}}):_vm._e(),_vm._v(" "),(_vm.headingEnabled)?_c('gmap-marker',{key:index3,attrs:{"zIndex":9,"position":_vm.headingRadiusHandlePosition,"draggable":true,"clickable":true,"icon":_vm.triggerEditIcon},on:{"drag":function($event){_vm.updateHeadingRadius($event)}}}):_vm._e(),_vm._v(" "),_c('gmap-marker',{key:index3,ref:"toleranceHandle",refInFor:true,attrs:{"zIndex":10,"position":_vm.tolerancePosition,"draggable":true,"clickable":true,"icon":_vm.triggerEditIcon},on:{"drag":function($event){_vm.updateTolerance($event)}}})],1):(_vm.circularToggle)?_c('span',[_c('gmap-polygon',{attrs:{"zIndex":6,"paths":_vm.generateTriggerPolygonPaths(trigger),"draggable":false,"editable":false,"options":_vm.triggerZonePolygon}}),_vm._v(" "),_c('gmap-polygon',{attrs:{"zIndex":6,"paths":_vm.generateTriggerPolygonPathsComplete(trigger),"draggable":false,"editable":false,"options":_vm.triggerZonePolygonComplete}}),_vm._v(" "),_c('gmap-marker',{key:index3,attrs:{"zIndex":8,"position":_vm.getParsedTriggerLatLng(trigger),"draggable":false,"icon":_vm.currentTriggerPositionIcon},on:{"click":function($event){_vm.loadTriggerSettings(trigger, index3)},"drag":function($event){_vm.updateTriggerPoints($event)}}}),_vm._v(" "),_c('gmap-marker',{key:index3,attrs:{"zIndex":5,"position":_vm.getParsedTriggerLatLng(trigger),"clickable":true,"icon":_vm.triggerPositionIcon(trigger)},on:{"click":function($event){_vm.loadTriggerSettings(trigger, index3)}}}),_vm._v(" "),(parseFloat(trigger.tolerance) < 180)?_c('gmap-marker',{key:index3,attrs:{"zIndex":4,"position":_vm.getParsedTriggerLatLng(trigger),"icon":_vm.headingArrowShape(trigger)}}):_vm._e(),_vm._v(" "),(trigger.hovered)?_c('gmap-marker',{key:index3,attrs:{"zIndex":10,"position":_vm.getParsedTriggerLatLng(trigger),"icon":_vm.triggerPositionIconHighlight}}):_vm._e()],1):(!_vm.circularToggle)?_c('span',[_c('gmap-marker',{key:index3,attrs:{"zIndex":5,"position":_vm.getParsedTriggerLatLng(trigger),"clickable":true,"icon":_vm.triggerPositionIcon(trigger)},on:{"click":function($event){_vm.loadTriggerSettings(trigger, index3)},"mouseover":function($event){_vm.toggleInfoWindowNew(trigger,index3,true,false)},"mouseout":function($event){_vm.toggleInfoWindowNew(trigger,index3,false,false)}}}),_vm._v(" "),(parseFloat(trigger.tolerance) < 180)?_c('gmap-marker',{key:index3,attrs:{"zIndex":4,"position":_vm.getParsedTriggerLatLng(trigger),"icon":_vm.headingArrowShape(trigger)}}):_vm._e(),_vm._v(" "),(trigger.hovered)?_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.getParsedTriggerLatLng(trigger)},on:{"closeclick":_vm.closeBox}},[_vm._v(_vm._s(trigger.triggerName)),_c('br'),_vm._v(" "),(trigger.activate != 'Proximity')?_c('span',[_vm._v("\n                            "+_vm._s(trigger.activate)+"\n                        ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(trigger.triggerMode != 'Queue')?_c('span',[(trigger.triggerMode  ==='Ignore')?_c('span',[_vm._v("\n                                IGN\n                            ")]):_c('span',[_vm._v("\n                                INT\n                            ")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("Radius : "+_vm._s(trigger.radiusDistance)+"\n                    ")]):_vm._e(),_vm._v(" "),(trigger.hovered)?_c('gmap-marker',{key:index3,attrs:{"zIndex":3,"position":_vm.getParsedTriggerLatLng(trigger),"icon":_vm.triggerPositionIconHighlight}}):_vm._e()],1):_vm._e()]):_vm._e()}),_vm._v(" "),_c('span',[_vm._l((_vm.topicsList),function(virtual,index){return (virtual.isReal===0 && _vm.topicAllChecks.includes(virtual.id))?_c('gmap-marker',{key:index,attrs:{"zIndex":2,"position":virtual.latLng,"clickable":true,"draggable":_vm.virtualTopicsMoveable,"icon":_vm.topicMarkerIcon(virtual)},on:{"dragend":function($event){_vm.updatePoints($event, virtual)},"mouseover":function($event){_vm.toggleInfoWindow(virtual,index,true,false)},"mouseout":function($event){_vm.toggleInfoWindow(virtual,index,false,false)}}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.topicsList),function(topic,index2){return (topic.isReal===1 && _vm.topicAllCheck.includes(topic.id))?_c('gmap-marker',{key:index2,attrs:{"zIndex":1,"position":topic.latLng,"clickable":true,"icon":_vm.topicMarkerIcon(topic)},on:{"mouseover":function($event){_vm.toggleInfoWindow(topic,index2,true,false)},"mouseout":function($event){_vm.toggleInfoWindow(topic,index2,false,false)}}}):_vm._e()}),_vm._v(" "),(_vm.currentTopic.name !== _vm.infoContent)?_c('span',[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":_vm.closeBox}},[_vm._v(_vm._s(_vm.infoContent))])],1):_vm._e()],2),_vm._v(" "),_c('span',[_c('gmap-polyline',{attrs:{"zIndex":11,"editable":_vm.routeEditingEnabled,"path":_vm.currentRoute.path,"options":_vm.polyLine},on:{"rightclick":function($event){_vm.clickDeleteNode($event)},"path_changed":_vm.updatePath}}),_vm._v(" "),_c('gmap-polyline',{attrs:{"zIndex":11,"editable":_vm.routeEditingEnabledAlt,"path":_vm.currentRouteAlt.alt_path,"options":_vm.polyLineAlt},on:{"rightclick":function($event){_vm.clickDeleteNodeAlt($event)},"path_changed":_vm.updatePathAlt}})],1)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.vertexToRemove !== null && _vm.pencilIconSelected),expression:"this.vertexToRemove !== null && pencilIconSelected"}],staticClass:"delete-parent",attrs:{"id":"vertex-delete-parent","oncontextmenu":"return false;"},on:{"mouseleave":_vm.removeDeleteVertexBox}},[_c('div',{staticClass:"delete-shadow",attrs:{"id":"vertex-delete-shadow"}}),_vm._v(" "),_c('div',{staticClass:"delete-button",attrs:{"id":"vertex-delete-box"},on:{"click":function($event){_vm.confirmDelete()}}},[_c('div',{staticClass:"delete-text unselectable"},[_vm._v("DELETE")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.vertexToRemove !== null && _vm.pencilIconSelectedAlt),expression:"this.vertexToRemove !== null && pencilIconSelectedAlt"}],staticClass:"delete-parent",attrs:{"id":"vertex-delete-parentAlt","oncontextmenu":"return false;"},on:{"mouseleave":_vm.removeDeleteVertexBoxAlt}},[_c('div',{staticClass:"delete-shadow",attrs:{"id":"vertex-delete-shadowAlt"}}),_vm._v(" "),_c('div',{staticClass:"delete-button",attrs:{"id":"vertex-delete-boxAlt"},on:{"click":function($event){_vm.confirmDelete()}}},[_c('div',{staticClass:"delete-text unselectable"},[_vm._v("DELETE")])])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n                Confirm Delete\n            ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n                Are you sure you want to delete this Vertex?\n            ")]),_vm._v(" "),(_vm.pencilIconSelectedAlt)?_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteVertexAlt()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1):_vm._e(),_vm._v(" "),(_vm.pencilIconSelected)?_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteVertex()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1):_vm._e()],1),_vm._v(" "),_c('modal',{attrs:{"name":"hello-world","resizable":true,"reset":true,"height":"60%","width":"60%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    Video\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    PDF\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    FAQ\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}}),_vm._v(" "+_vm._s(usermanual.question))])]):_vm._e(),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})]),_vm._v(" "+_vm._s(this.detailinfo.question))])]),_vm._v(" "),_c('p',{staticStyle:{"text-decoration":"none !important","margin-left":"65px"}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}}),_vm._v(_vm._s(this.detailinfo.answers))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logout-button conatinerForSupport"},[_c('a',{staticClass:"GFG",attrs:{"href":"https://www.listentech.com/listen-navilution-support/","target":"_blank"}},[_c('button',{staticClass:"md-button md-theme-default",staticStyle:{"margin-bottom":"10px","padding":"10px"}},[_vm._v("\n                            Website support\n                        ")])]),_vm._v(" "),_c('md-button',{staticClass:"md-button md-theme-default",attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v("\n                        Email support\n                    ")])],1)]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("PDF")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":"hello-world2","resizable":true,"reset":true,"height":"100%","width":"100%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    Video\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    PDF\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                    FAQ\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}}),_vm._v(" "+_vm._s(usermanual.question))])]):_vm._e(),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})]),_vm._v(" "+_vm._s(this.detailinfo.question))])]),_vm._v(" "),_c('p',{staticStyle:{"text-decoration":"none !important","margin-left":"65px"}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}}),_vm._v(_vm._s(this.detailinfo.answers))])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("PDF")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+nf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('em',{staticClass:"logo ng-scope"}),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"col col-md-4 centered my-auto"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"actions"},[_c('p',{staticClass:"centered"},[_c('a',{staticClass:"login-text text-center",on:{"click":function($event){_vm.returnToLast()}}},[_vm._v("Return")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-text ng-scope"},[_c('h3',[_vm._v("Forbidden")]),_vm._v(" "),_c('p',[_vm._v("You are not authorized to view the requested page.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+q4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsersForClient", function() { return getUsersForClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllUsers", function() { return getAllUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveNewUsers", function() { return saveNewUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUser", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUser", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserById", function() { return getUserById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserForClient", function() { return updateUserForClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getUsersForClient(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/users/' + clientId);
}

function getUserById(userId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/user/getuser/' + userId);
}

function getAllUsers() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/users');
}

function saveNewUsers(newUsers) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/users', { newUsers: newUsers });
}

function deleteUser(userId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/users/' + userId);
}

function updateUser(user) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/users', { user: user });
}

function updateUserForClient(user) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/updateUserForClient', { user: user });
}



/***/ }),

/***/ "+ufz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TourCard__ = __webpack_require__("1e7O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ToursService__ = __webpack_require__("jYpk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_bus_js__ = __webpack_require__("oNan");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDialog: false,
      showDeleteDialog: false,
      filterString: '',
      showModal_tours: false,
      exportModalClientId: '',
      exportModalTourIds: '',
      exportModalName: '',
      showdatalist: false,
      isShow: false,
      isLoading: false,
      copyTourStatusAlert: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('tours', ['tours', 'exportRunning', 'checked', 'checkComIncompA', 'redCount']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClientName', 'currentClient', 'clientLoaded']), {
    showTourButtons: function showTourButtons() {
      return this.checked.length > 0;
    },
    checkedIncomCom: function checkedIncomCom() {
      return this.redCount;
    },
    filterStringIsEmpty: function filterStringIsEmpty() {
      return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['loadClientToursList', 'exportTours', 'emptyChecked', 'closeExportModal', 'deleteTours', 'emptyCheckedRedGreen']), {
    openDialog: function openDialog() {
      this.showDialog = true;
    },
    closeDialog: function closeDialog() {
      this.showDialog = false;
    },
    closeDialog_export: function closeDialog_export() {
      this.showDeleteDialog = false;
      this.emptyChecked();
    },
    deleteTour: function deleteTour() {
      var tourIds = [];
      if (this.checked.length > 0) {
        // Checks that at least one tour is selected
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checked), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tourIndex = _step.value;

            tourIds.push(this.tours[tourIndex].id);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.deleteTours({ clientId: this.currentClient.id, tourIds: tourIds });
        this.emptyChecked();
        this.showDialog = false;
      }
    },
    createNewTour: function createNewTour() {
      var tour = {
        card: '',
        city: '',
        clientId: this.$store.state.client.currentClient.id,
        defaultActivate: 'Proximity',
        defaultDelay: '0',
        defaultRadiusDistance: '40',
        defaultTolerance: '60',
        description: '',
        id: '',
        name: '',
        systemId: '1'
      };

      this.$store.dispatch('tours/loadNewTour', tour);
      this.$store.dispatch('topics/setTopicsList', []);
      this.closeExportModal();
      this.$router.push('/tour/new');
    },
    filterCheck: function filterCheck(text) {
      var passesFilter = true;
      if (text && text.replace(/^\s+|\s+$/g, '').length > 0 && !this.filterStringIsEmpty) {
        passesFilter = text.toLowerCase().includes(this.filterString.toLowerCase());
      }
      return passesFilter;
    },
    selectedToursExport: function selectedToursExport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tourIds, tourName, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, tourIndex;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Creates and builds an array of tour IDs using the selected indexes from the tours tab
                tourIds = [];
                tourName = [];

                if (!(_this.checked.length > 0)) {
                  _context.next = 27;
                  break;
                }

                // Checks that at least one tour is selected
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 6;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.checked); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  tourIndex = _step2.value;

                  tourIds.push(_this.tours[tourIndex].id);
                  tourName.push(_this.tours[tourIndex].name);
                }
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 14:
                _context.prev = 14;
                _context.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 17:
                _context.prev = 17;

                if (!_didIteratorError2) {
                  _context.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context.finish(17);

              case 21:
                return _context.finish(14);

              case 22:
                _this.exportModalClientId = _this.currentClient.id;
                _this.exportModalTourIds = tourIds;
                _this.exportModalName = tourName;
                _this.exportTours({ tourIds: tourIds, clientId: _this.currentClient.id });
                _this.openModal();

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    },
    openModal: function openModal() {
      this.showDeleteDialog = true;
      this.isShow = true;
    },
    notShowModal: function notShowModal() {
      this.isShow = false;
    },
    copyAtoursAndCreateNewTour: function copyAtoursAndCreateNewTour(tourId) {
      var varCopytour = this;
      // this.isLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_6__services_ToursService__["b" /* copyTourToNewTours */])(tourId).then(function (responce) {
        varCopytour.loadClientToursList(varCopytour.currentClient.id);
        varCopytour.showdatalist = true;
        varCopytour.emptyChecked();
        varCopytour.emptyCheckedRedGreen();
        varCopytour.isLoading = false;
        if (responce.status === 200) {
          varCopytour.copyTourStatusAlert = true;
        }
      });
    },
    changeToursImagesParent: function changeToursImagesParent(filesDetails, tourId) {
      var varCopytour = this;
      this.isLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_6__services_ToursService__["a" /* changeToursImagesServices */])(filesDetails, tourId).then(function (responce) {
        var pp = varCopytour;
        varCopytour.loadClientToursList(varCopytour.currentClient.id).then(function (responce) {
          pp.emptyChecked();
          pp.isLoading = false;
        });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var pp = this;
    this.isLoading = true;
    this.loadClientToursList(this.currentClient.id).then(function (responce) {
      pp.showdatalist = true;
      pp.emptyChecked();
      pp.emptyCheckedRedGreen();
      pp.isLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["a" /* EventBus */].$on('openDialogForSingle', function ($params) {
      if ($params === 'delete') {
        _this2.openDialog();
      } else if ($params === 'export') {
        _this2.selectedToursExport();
      }
    });
  },

  components: {
    TourCard: __WEBPACK_IMPORTED_MODULE_5__TourCard__["a" /* default */],
    template: '#bs-modal',
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  }
});

/***/ }),

/***/ "+zoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"edit-permissions page-content"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"user-form-box"},[_c('div',{staticClass:"small-box"},[_c('md-checkbox',{attrs:{"value":"1"},on:{"change":function($event){}}},[_vm._v("Manage Topics of Interest")]),_vm._v(" "),_c('md-checkbox',{attrs:{"value":"1"},on:{"change":function($event){}}},[_vm._v("Manage Audio and Video content")]),_vm._v(" "),_c('md-checkbox',{attrs:{"value":"1"},on:{"change":function($event){}}},[_vm._v("Add Notes")]),_vm._v(" "),_c('md-checkbox',{attrs:{"value":"1"},on:{"change":function($event){}}},[_vm._v("Lock/Unlock Trigger Zones")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/3Nb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__ = __webpack_require__("4kyh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function newPassConfirmed(value) {
  return value === this.newPassword;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['getToken', 'isPasswordReset', 'isValidToken'])),
  data: function data() {
    return {
      token: '',
      newPassword: null,
      confirmPassword: null,
      resetUserPasswordVar: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['resetUserPassword', 'setToken', 'validateToken']), {
    returnToLogin: function returnToLogin() {
      this.$router.push('/login');
    },
    resetPassword: function resetPassword() {
      var _this = this;

      if (!this.$v.$invalid) {
        this.resetUserPasswordVar = true;
        this.resetUserPassword({ password: this.newPassword, token: this.token }).then(function () {
          _this.resetUserPasswordVar = false;
        });
      }
    },
    touchNewPassHanlder: function touchNewPassHanlder() {
      this.$v.newPassword.$touch();
    }
  }),
  validations: {
    newPassword: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(8),
      validPassword: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["c" /* validPassword */]
    },
    confirmPassword: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */],
      newPassConfirmed: newPassConfirmed
    }
  },
  mounted: function mounted() {
    this.token = this.$route.params.id;
    this.validateToken(this.token);
  }
});

/***/ }),

/***/ "/V2q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"users-settings-list"},_vm._l((_vm.userList),function(user){return _c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item",on:{"click":function($event){_vm.showCurrentUserProfile(user.id)}}},[_c('div',{staticClass:"avatar s-48"},[(user.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(user.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                                    "+_vm._s(_vm.getUserInitials(user))+"\n                                ")])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(user.firstName + ' ' + user.lastName)+" "),_c('small',[_vm._v(_vm._s(user.title))])])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('a',{staticClass:"email-link"},[_vm._v(_vm._s(user.email))])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(_vm.isAdmin)?_c('div',{staticClass:"el"},[(_vm.clientActive && _vm.isAdmin)?_c('div',{staticClass:"el admin-check"},[_c('md-checkbox',{attrs:{"disabled":user.isPrimaryContact === 1,"value":user.isPrimaryContact ? false : true,"aria-label":"Primary Contact"},on:{"change":function($event){_vm.toggleUserPrimaryContact(user)}}},[_vm._v("\n                                    Primary Contact\n                                ")])],1):_vm._e(),_vm._v(" "),(!_vm.clientActive && _vm.isAdmin && (user.id !== _vm.currentUser.id))?_c('div',{staticClass:"el admin-check"},[_c('md-checkbox',{attrs:{"value":user.isAdmin ? false : true,"aria-label":"Administrator"},on:{"change":function($event){_vm.toggleUserAdmin(user)}}},[_vm._v("\n                                    Cortex Administrator\n                                ")])],1):_vm._e(),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showCurrentUserProfile(user.id)}}},[_c('md-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),(user.id !== _vm.currentUser.id)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.confirmDelete(user)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":function($event){_vm.clickAddNewUsers()}}},[_c('md-icon',[_vm._v("add")])],1)],1)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete "),_c('b',[_vm._v(_vm._s(_vm.userToDeleteName))]),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteSelectedUser()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("FIJ3");
function injectStyle (ssrContext) {
  __webpack_require__("3GDT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0+Vm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"TriggersTabsContainer"},[_c('div',{staticClass:"btn-position-wrap"},[_c('md-tabs',{staticClass:"md-tabs-wrapper container",attrs:{"md-sync-route":"","md-alignment":"left"}},[(_vm.showTriggerTabs)?_c('span',[_c('md-tab',{attrs:{"md-label":"Settings","to":"/tour/trigger/settings"}}),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Notes","to":"/tour/trigger/notes"}})],1):_c('span',[_c('md-tab',{attrs:{"md-label":"Triggers","to":"/tour/topic/triggers"}}),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Notes","to":"/tour/topic/notes"}})],1)])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0iYr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSwitchTab_vue__ = __webpack_require__("qoN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3bbaa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSwitchTab_vue__ = __webpack_require__("cRr5");
function injectStyle (ssrContext) {
  __webpack_require__("eQ8z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c3bbaa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSwitchTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3bbaa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSwitchTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1/HW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "11zb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1AC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showInfo: false,
      checkTarballComplet: false,
      editTourName: '',
      editTourDes: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('tours', ['currentTour'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('tours', ['exportTours']), {
    getImageSrc: function getImageSrc(image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    toggleInfoBlock: function toggleInfoBlock(editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTour.name;
        this.editTourDes = this.currentTour.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTour.name = this.editTourName;
        this.currentTour.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious: function returnToPrevious() {
      this.$router.push('/client/tours');
    },
    saveTourDetails: function saveTourDetails() {
      if (this.currentTour.name.length >= 1 && this.currentTour.description.length >= 1) {
        Object(__WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__["k" /* saveTour */])(this.currentTour);
        this.toggleInfoBlock('SAVECLOSE');
      }
    },
    closeCheckTarballComplet: function closeCheckTarballComplet() {
      this.checkTarballComplet = false;
    },
    exportCurrentTour: function exportCurrentTour(tourId) {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__["c" /* checkExportTours */])(tourId).then(function (defs) {
        if (defs.data[0].activeInactiveImages === 0) {
          self.checkTarballComplet = true;
        } else {
          self.exportTours({ tourIds: [tourId], clientId: self.currentClient.id });
        }
      });
    }
  }),
  mounted: function mounted() {
    this.toggleShowSettings(false);
  }
});

/***/ }),

/***/ "1KSB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTourFigure_vue__ = __webpack_require__("e0nJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3d363d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTourFigure_vue__ = __webpack_require__("m07b");
function injectStyle (ssrContext) {
  __webpack_require__("Csjn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTourFigure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3d363d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewTourFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1YA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('p',[_vm._v("this is the media tab content")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1e7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourCard_vue__ = __webpack_require__("v8Pq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e087fed2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourCard_vue__ = __webpack_require__("7eFC");
function injectStyle (ssrContext) {
  __webpack_require__("aXAk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e087fed2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e087fed2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ARr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"new-client"}},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row"},[(_vm.recordUpdateSucc)?_c('p',{staticStyle:{"color":"red","position":"absolute","float":"right","right":"6%"}},[_vm._v("Please Fill Required fields")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block bigger-field without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"placeholder":"Name *"},model:{value:(_vm.newClient.companyName),callback:function ($$v) {_vm.$set(_vm.newClient, "companyName", $$v)},expression:"newClient.companyName"}})],1),_vm._v(" "),(_vm.validationErrors['newClient.companyName'])?_c('div',{staticClass:"new-client-error"},[_vm._v(_vm._s(_vm.validationErrors['newClient.companyName'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"type":"tel","placeholder":"Phone *"},model:{value:(_vm.newClient.phoneNumber),callback:function ($$v) {_vm.$set(_vm.newClient, "phoneNumber", $$v)},expression:"newClient.phoneNumber"}})],1),_vm._v(" "),(_vm.validationErrors['newClient.phoneNumber'])?_c('div',{staticClass:"new-client-error"},[_vm._v(_vm._s(_vm.validationErrors['newClient.phoneNumber'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Website (Example: https://example.io)"},model:{value:(_vm.newClient.website),callback:function ($$v) {_vm.$set(_vm.newClient, "website", $$v)},expression:"newClient.website"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Country"},model:{value:(_vm.newClient.country),callback:function ($$v) {_vm.$set(_vm.newClient, "country", $$v)},expression:"newClient.country"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"State/Province"},model:{value:(_vm.newClient.stateProvince),callback:function ($$v) {_vm.$set(_vm.newClient, "stateProvince", $$v)},expression:"newClient.stateProvince"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[_c('md-switch',{staticClass:"md-primary",model:{value:(_vm.newClient.isAnalytics),callback:function ($$v) {_vm.$set(_vm.newClient, "isAnalytics", $$v)},expression:"newClient.isAnalytics"}},[_vm._v("\n                                            Analytics\n                                        ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Address *"},on:{"blur":function($event){_vm.clientTouchHanlder('address')}},model:{value:(_vm.newClient.address),callback:function ($$v) {_vm.$set(_vm.newClient, "address", $$v)},expression:"newClient.address"}})],1),_vm._v(" "),(_vm.validationErrors['newClient.address'])?_c('div',{staticClass:"new-client-error"},[_vm._v(_vm._s(_vm.validationErrors['newClient.address'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-textarea',{attrs:{"placeholder":"Description"},model:{value:(_vm.newClient.description),callback:function ($$v) {_vm.$set(_vm.newClient, "description", $$v)},expression:"newClient.description"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"City"},model:{value:(_vm.newClient.city),callback:function ($$v) {_vm.$set(_vm.newClient, "city", $$v)},expression:"newClient.city"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Zip/Postal Code","required":""},on:{"blur":function($event){_vm.clientTouchHanlder('zipPostalCode')}},model:{value:(_vm.newClient.zipPostalCode),callback:function ($$v) {_vm.$set(_vm.newClient, "zipPostalCode", $$v)},expression:"newClient.zipPostalCode"}})],1),_vm._v(" "),(_vm.$v.newClient.zipPostalCode.$error)?_c('div',{staticClass:"new-client-error"},[_vm._v("Please provide an zip/postal code.")]):_vm._e()],1)])])])])]),_vm._v(" "),(_vm.detailsAreVisible)?_c('section',{staticClass:"global-section"},[(_vm.showContact)?_c('div',{staticClass:"row"},[(_vm.recordUpdateSucc)?_c('p',{staticStyle:{"color":"red","position":"absolute","float":"right","right":"6%"}},[_vm._v("Please Fill Required fields")]):_vm._e(),_vm._v(" "),(_vm.recordUpdateSuccs)?_c('p',{staticClass:"recordalert"},[_vm._v("Record updated successfully!")]):_vm._e(),_vm._v(" "),(_vm.contactFormError)?_c('div',{staticClass:"col-12 form-error"},[_vm._v(_vm._s(_vm.contactFormError))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"dynamic-contacts"},_vm._l((_vm.newClientContacts),function(contact,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"avatar-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"avatar upload s-48 gray"},[_c('md-icon',{staticClass:"icon icon-person"})],1),_vm._v(" "),_c('div',{staticClass:"client-name-box"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block client-name without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"type":"email","placeholder":"Email *"},on:{"blur":function($event){_vm.contactTouchHanlder(index, 'email')}},model:{value:(contact.email),callback:function ($$v) {_vm.$set(contact, "email", $$v)},expression:"contact.email"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.email'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.email'][0]))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"placeholder":"Position *"},on:{"blur":function($event){_vm.contactTouchHanlder(index, 'title')}},model:{value:(contact.title),callback:function ($$v) {_vm.$set(contact, "title", $$v)},expression:"contact.title"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.title'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.title'][0]))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"primary-contact"},[(_vm.hasMultipleContacts)?_c('md-checkbox',{attrs:{"aria-label":"Primary Contact"},on:{"change":function($event){_vm.setPrimaryContact(index)}},model:{value:(contact.isPrimaryContact),callback:function ($$v) {_vm.$set(contact, "isPrimaryContact", $$v)},expression:"contact.isPrimaryContact"}},[_vm._v("\n                                                            Primary Contact\n                                                        ")]):_c('md-checkbox',{attrs:{"disabled":"","aria-label":"Primary Contact"},on:{"change":function($event){_vm.setPrimaryContact(index)}},model:{value:(contact.isPrimaryContact),callback:function ($$v) {_vm.$set(contact, "isPrimaryContact", $$v)},expression:"contact.isPrimaryContact"}},[_vm._v("\n                                                            Primary Contact\n                                                        ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"First Name *"},on:{"blur":function($event){_vm.contactTouchHanlder(index, 'firstName')}},model:{value:(contact.firstName),callback:function ($$v) {_vm.$set(contact, "firstName", $$v)},expression:"contact.firstName"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.firstName'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.firstName'][0]))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Last Name *"},on:{"blur":function($event){_vm.contactTouchHanlder(index, 'lastName')}},model:{value:(contact.lastName),callback:function ($$v) {_vm.$set(contact, "lastName", $$v)},expression:"contact.lastName"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.lastName'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.lastName'][0]))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Direct # *"},on:{"blur":function($event){_vm.contactTouchHanlder(index, 'directPhone')}},model:{value:(contact.directPhone),callback:function ($$v) {_vm.$set(contact, "directPhone", $$v)},expression:"contact.directPhone"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.directPhone'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.directPhone'][0]))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Office # "},model:{value:(contact.officePhone),callback:function ($$v) {_vm.$set(contact, "officePhone", $$v)},expression:"contact.officePhone"}})],1),_vm._v(" "),(_vm.validationErrors['newContacts.' + index + '.officePhone'])?_c('div',{staticClass:"new-client-error"},[_c('span',[_vm._v(_vm._s(_vm.validationErrors['newContacts.' + index + '.officePhone'][0]))])]):_vm._e()],1)]),_vm._v(" "),(_vm.hasMultipleContacts)?_c('md-button',{attrs:{"aria-label":"Delete Contact"},on:{"click":function($event){_vm.deleteContact(index)}}},[_c('md-icon',[_vm._v("delete")])],1):_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Delete Contact"},on:{"click":function($event){_vm.deleteContacts(index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])])])}))])])]):_vm._e(),_vm._v(" "),(_vm.buttonVisibleParent)?_c('div',{staticClass:"add-button PARNET "},[_c('md-button',{staticClass:"md-icon-button md-primary",attrs:{"aria-label":"Add User"},on:{"click":function($event){_vm.addContactParent()}}},[_c('md-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),(_vm.checkChild)?_c('div',{staticClass:"add-button child"},[_c('md-button',{staticClass:"md-icon-button md-primary",attrs:{"aria-label":"Add User"},on:{"click":function($event){_vm.addContact()}}},[_c('md-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),(!this.checkChild && !this.contactFormError)?_c('div',{staticClass:"bottom-btn-position"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.recordUpdateSuccs)?_c('div',{staticClass:"wrap"},[(_vm.recordUpdateSuccs)?_c('p',{staticClass:"recordalert"},[_vm._v("Record Added successfully!")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.recordUpdateSuccs)?_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"save-client-button md-primary",attrs:{"aria-label":"Add New User"},on:{"click":function($event){_vm.clickSaveNewClient()}}},[_vm._v("Save")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(this.checkChild)?_c('div',{staticClass:"bottom-btn-position"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.recordUpdateSuccs)?_c('div',{staticClass:"wrap"},[(_vm.recordUpdateSuccs)?_c('p',{staticClass:"recordalert"},[_vm._v("Record Added successfully!")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.recordUpdateSuccs)?_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"save-client-button md-primary",staticStyle:{"margin-left":"55px","position":"absolute","right":"10%","bottom":"0px"},attrs:{"aria-label":"Add New User"},on:{"click":function($event){_vm.clickSaveNewClientAndContact()}}},[_vm._v("Save")])],1):_vm._e()]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Info")]),_vm._v(" "),_c('p',[_vm._v("Required fields are marked with *")]),_vm._v(" "),_c('p',[_vm._v("All open user forms must be completed.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Contacts")]),_vm._v(" "),_c('p',[_vm._v("Required fields are marked with *")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2FW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "2Ite":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__ = __webpack_require__("V8i3");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      popArray: [],
      notesIndexList: [],
      showDeleteDialog: false,
      saveFlag: false,
      returnPath: '',
      noteList: [{
        id: '',
        Description: '',
        editFlag: false
      }],
      editBoxId: [],
      editTableIndex: [],
      responseError: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['notesSave', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('topics', ['currentTopic'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['clearUserToEdit']), {
    refreshScreen: function refreshScreen() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.notesIndexList = [];
                _this.saveFlag = false;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["l" /* topicNotes */])(_this.currentTopic['id']);

              case 4:
                result = _context.sent;

                _this.noteList = result.data;
                _this.returnPath = _this.$store.state.RouterModule.from.fullPath;
                for (index = 0; index < _this.noteList.length; index++) {
                  _this.noteList[index]['editFlag'] = true;
                  _this.editTableIndex.push(index);
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveNotes: function saveNotes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["i" /* saveNotestopic */])(_this2.noteList, _this2.currentTopic['id']);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

                console.error('Could not save notes.', _context2.t0);

              case 8:
                _this2.saveFlag = false;
                _context2.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["l" /* topicNotes */])(_this2.currentTopic['id']);

              case 11:
                result = _context2.sent;

                _this2.noteList = result.data;
                _this2.returnPath = _this2.$store.state.RouterModule.from.fullPath;
                for (index = 0; index < _this2.noteList.length; index++) {
                  _this2.noteList[index]['editFlag'] = true;
                  _this2.editTableIndex.push(index);
                }

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    add: function add() {
      this.saveFlag = true;
      this.noteList.push({
        id: '',
        Description: '',
        editFlag: true
      });
      this.notesIndexList = [];
    },
    edit: function edit(index, id) {
      this.saveFlag = true;
      this.editBoxId.push(id);
      this.editTableIndex = this.editTableIndex.filter(function (item) {
        return item !== index;
      });
      this.notesIndexList = [];
    },
    confirmRemove: function confirmRemove(note, index) {
      this.showDeleteDialog = true;
      this.note = note;
      this.index = index;
      this.notesIndexList = [];
    },
    showComplete: function showComplete(note, index) {
      if (!this.notesIndexList.includes(index)) {
        this.notesIndexList.push(index);
      } else {
        this.notesIndexList.pop(index);
      }
    },
    remove: function remove(note, index) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, index1;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.editBoxId = _this3.editBoxId.filter(function (item) {
                  return item !== index;
                });
                _this3.editTableIndex = _this3.editTableIndex.filter(function (item) {
                  return item !== index;
                });
                _this3.editTableIndex = [];
                _context3.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["d" /* deleteNotestrigger */])(note.id);

              case 5:
                _context3.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["l" /* topicNotes */])(_this3.currentTopic['id']);

              case 7:
                result = _context3.sent;

                _this3.noteList = result.data;
                for (index1 = 0; index1 < _this3.noteList.length; index1++) {
                  _this3.noteList[index1]['editFlag'] = true;
                  _this3.editTableIndex.push(index1);
                }
                _this3.showDeleteDialog = false;
                _this3.notesIndexList = [];

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var result, index;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["l" /* topicNotes */])(_this4.currentTopic['id']);

            case 2:
              result = _context4.sent;

              _this4.noteList = result.data;
              _this4.returnPath = _this4.$store.state.RouterModule.from.fullPath;
              for (index = 0; index < _this4.noteList.length; index++) {
                _this4.noteList[index]['editFlag'] = true;
                _this4.editTableIndex.push(index);
              }

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ "2bQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2hD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicTriggerNoteTabs_vue__ = __webpack_require__("aSxc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b7d41f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicTriggerNoteTabs_vue__ = __webpack_require__("0+Vm");
function injectStyle (ssrContext) {
  __webpack_require__("uLEt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicTriggerNoteTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b7d41f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicTriggerNoteTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2l1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__ = __webpack_require__("FVxR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c55b89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__ = __webpack_require__("+OK9");
function injectStyle (ssrContext) {
  __webpack_require__("Hu7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c55b89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2mbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditClient_vue__ = __webpack_require__("WXyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b457eda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditClient_vue__ = __webpack_require__("98Qu");
function injectStyle (ssrContext) {
  __webpack_require__("/V2q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b457eda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b457eda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditClient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2xQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap",attrs:{"id":"generalSettings"}},[_c('div',{staticClass:"wrap"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row sub-section"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("New Language")]),_vm._v(" "),_c('div',{staticClass:"md-layout"},[_c('md-field',{staticClass:"half-field"},[_c('label',[_vm._v("Code")]),_vm._v(" "),_c('md-input',{attrs:{"name":"code","id":"code","minlength":"3","maxlength":"3"},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1),_vm._v(" "),_c('md-field',{staticClass:"half-field"},[_c('label',[_vm._v("Language")]),_vm._v(" "),_c('md-input',{attrs:{"name":"language","id":"language"},model:{value:(_vm.form.language),callback:function ($$v) {_vm.$set(_vm.form, "language", $$v)},expression:"form.language"}})],1),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",attrs:{"type":"submit"},on:{"click":function($event){_vm.newLanguage()}}},[_vm._v("save")])],1),_vm._v(" "),_c('div',{staticClass:"md-layout form-error"},[(_vm.error)?_c('p',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row sub-section"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Configured Languages")]),_vm._v(" "),_c('md-table',[_c('md-table-row',[_c('md-table-head',[_vm._v("Code")]),_vm._v(" "),_c('md-table-head',[_vm._v("Language")]),_vm._v(" "),_c('md-table-head',[_vm._v("Action")])],1),_vm._v(" "),_vm._l((_vm.languages),function(lang){return _c('md-table-row',{key:lang.language},[_c('md-table-cell',[_vm._v(_vm._s(lang.code))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(lang.language))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete Language(s)"},on:{"click":function($event){_vm.confirmDelete(lang)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)],1)})],2)],1)])])])])])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            If you delete CHANNEL "),_c('b',[_vm._v(_vm._s(_vm.languageDelete.language)+"("+_vm._s(_vm.languageDelete.code)+")")]),_vm._v(", you will delete this value from all customers using Cortex. Do you want to delete this CHANNEL? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.remove(_vm.languageDelete.id)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Configuration")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Notifications")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Languages")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Fbv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3GDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3P42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutesTab_vue__ = __webpack_require__("Od/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b80acc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutesTab_vue__ = __webpack_require__("syI6");
function injectStyle (ssrContext) {
  __webpack_require__("11zb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutesTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7b80acc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutesTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Vl3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3fQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      exportId: '',
      errormessageContent: '',
      elementVisible: false,
      elementNotVisible: false,
      exportsId: '',
      showDeleteDialog: false,
      showValidate: false,
      filterString: '',
      exportLists: '',
      exportListsWent: false,
      exportDataNotFound: false,
      singleExport: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('exports', ['exportsList'])),
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('exports', ['loadExportsList']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['loadClientToursList', 'exportToursDownload', 'emptyChecked']), {
    loadExports: function loadExports() {
      if (this.clientActive) {
        this.loadExportsList(this.currentClient.id);
      } else {
        this.loadExportsList();
      }
    },
    validateTours: function validateTours(exportsId) {
      this.exportsId = exportsId;
      this.showValidate = true;
    },
    tourValidation: function tourValidation(exportsId) {
      var p = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/client/exports/validateTours/' + exportsId + '/', {}).then(function (response) {
        if (response.data.message === 'INVALID') {
          p.getCLientExportList();
          p.showValidate = false;
          return false;
        } else {
          p.getCLientExportList();
          p.showValidate = false;
          return false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    confirmDelete: function confirmDelete(exportsId) {
      this.exportsId = exportsId;
      this.showDeleteDialog = true;
    },
    export_file: function export_file(exportsId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.exportToursDownload({ exportsId: exportsId });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeDialogExport: function closeDialogExport() {
      this.showDeleteDialog = false;
    },
    closeshowValidate: function closeshowValidate() {
      this.showValidate = false;
    },
    deleteSelectedExport: function deleteSelectedExport(exportsId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/client/exports/delete/' + exportsId + '/', {}).then(function (response) {
        _this2.getCLientExportList();
        _this2.showDeleteDialog = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    showCurrentExportDetails: function showCurrentExportDetails(exportId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/client/' + this.currentClient.id + '/exports/' + this.exportId, {}).then(function (response) {
        _this3.singleExport = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCLientExportList: function getCLientExportList() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/client/' + this.currentClient.id + '/exports/', {}).then(function (response) {
        _this4.isLoading = false;
        if (response.data === 1) {
          _this4.exportListsWent = true;
        } else {
          if (response.data.length === 0) {
            _this4.exportDataNotFound = true;
          } else {
            _this4.exportLists = response.data;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    downloadAvailable: function downloadAvailable(exports) {
      var isDownloadAvailable = false;
      if (exports.status === 1) {
        isDownloadAvailable = exports.export_error.includes('incomplete tour');
        if (exports.export_error.length === 0) {
          isDownloadAvailable = true;
        }
      }
      return isDownloadAvailable;
    }

  }),
  mounted: function mounted() {
    this.isLoading = true;
    this.getCLientExportList();
  }
});

/***/ }),

/***/ "3y59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4+RA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+hh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4kyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validPostalOrZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validateEmailContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validLatOrLng; });
function validPassword(value) {
  if (value) {
    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=}{><.])[A-Za-z\d!@#$%^&*()_\-+=}{><.]{8,50}/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function notWhitespace(value) {
  if (value) {
    return String(value).replace(/^\s+|\s+$/g, '').length > 0;
  } else {
    return false;
  }
}

function validateEmailContact(value) {
  if (value) {
    var regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function validPhoneNumber(value) {
  if (value) {
    var regex = /^(?=.*[0-9])[- +()0-9]+$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function validPostalOrZip(value) {
  if (value) {
    var regex = /^[a-zA-Z0-9]+(?:[\w -]*[a-zA-Z0-9]+)*$/;
    return String(value).length === 0 || value.replace(regex, '').length === 0;
  } else {
    return true;
  }
}

function validLatOrLng(value) {
  if (value) {
    var regex = /^[0-9.-]*$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}



/***/ }),

/***/ "55OV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55uo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReleaseSettings_vue__ = __webpack_require__("dqWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_LoginService__ = __webpack_require__("N8fj");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      latestVersion: '',
      msgStatus: false,
      showVersionForclient: false,
      singleReleaseData: '',
      releaseDetailPanel: false,
      releasePanel: true,
      releaseData: '',
      showquestion: true,
      showquestiondetail: false,
      isHidden: false,
      activeTab: 'homeActive',
      errorMessage: null,
      fileName: '',
      clickedval: '',
      vedioSrc: '',
      pdfSrc: '',
      choice: 'homeActive',
      listPanel: true,
      vedioPanel: false,
      pdfPanel: false,
      faqPanel: false,
      UserManualList: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      UserManualListfaq: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      isActive: '',
      resizeWidth: '60%',
      resizeHight: '60%',
      countMaax: 0,
      supportEmail: 'support@listentech.com',
      webSiteSupport: 'https://www.listentech.com/support/'
    };
  },

  components: {
    ReleaseSettings: __WEBPACK_IMPORTED_MODULE_5__ReleaseSettings_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
    routerPathName: function routerPathName(state) {
      return state.RouterModule.name;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['isAdmin', 'clientId', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClientName', 'currentClient', 'clientLoaded']), {
    creatingNewClient: function creatingNewClient() {
      return this.routerPathName === 'NewClient';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('client', ['loadClient', 'resetClient', 'toggleClientLoadedFlag']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['setUserToEdit', 'signOutUser']), {
    releaseMessage: function releaseMessage() {
      this.msgStatus = !this.msgStatus;
    },
    showVersionForclientClose: function showVersionForclientClose() {
      this.showVersionForclient = false;
    },
    versionDetails: function versionDetails() {
      this.showVersionForclient = true;
    },
    checkReleaseExistFunction: function checkReleaseExistFunction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["b" /* checkReleaseExist */])(_this.currentUser.id);

              case 2:
                response = _context.sent;

                _this.releaseData = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    makeActive: function makeActive(val) {
      if (val === 'homeActive' && this.activeTab !== 'homeActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'homeActive';
      }
      if (val === 'infoActive' && this.activeTab !== 'infoActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'infoActive';
      }
      if (val === 'faqActive' && this.activeTab !== 'faqActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'faqActive';
      }
      this.choice = val;
    },
    isActiveTab: function isActiveTab(val) {
      return this.choice === val;
    },
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    navToSwitchClientList: function navToSwitchClientList() {
      this.resetClient();
      this.$router.push({ path: '/clients/switch' });
    },
    navToClientList: function navToClientList() {
      this.resetClient();
      this.$router.push({ path: '/client/list' });
    },
    toggleClientLoaded: function toggleClientLoaded() {
      this.toggleClientLoadedFlag();
    },
    navToSettings: function navToSettings() {
      if (this.isAdmin) {
        this.$router.push('/settings/general');
      } else {
        this.$router.push('/settings/users');
      }
    },
    showCurrentUserProfile: function showCurrentUserProfile() {
      this.setUserToEdit(this.currentUser);
      this.$router.push('/user');
    },
    clickLogout: function clickLogout() {
      Object(__WEBPACK_IMPORTED_MODULE_7__services_LoginService__["logout"])(this.currentUser.id);
      this.signOutUser();
      this.$router.push('/login');
    },
    maxWindow: function maxWindow() {
      this.$modal.hide('hello-world');
      this.$modal.show('hello-world2');
    },
    minWindow: function minWindow() {
      this.$modal.show('hello-world');
      this.$modal.hide('hello-world2');
    },
    maxDo: function maxDo() {
      this.$modal.hide('hello-world');
      this.resizeWidth = '100%';
      this.resizeHight = '100%';
      this.$modal.show('hello-world');
    },
    fetchData: function fetchData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["g" /* exportAllUserService */])();

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    exportAllUserDetails: function exportAllUserDetails() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["g" /* exportAllUserService */])();

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showVideoPdf: function showVideoPdf() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$modal.show('hello-world');
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["m" /* getUserManual */])();

              case 3:
                result = _context4.sent;

                _this4.UserManualList = result.data;
                _this4.vedioPanel = false;
                _this4.pdfPanel = false;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    closeshowVideoPdf: function closeshowVideoPdf() {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    closeshowfaq: function closeshowfaq() {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    showVedio: function showVedio(id) {
      window.open('#/usermanual/video?' + id, '_blank');
    },
    showPdf: function showPdf(id) {
      window.open('#/usermanual/pdf?' + id, '_blank');
    },
    showfaq: function showfaq(detailfaq) {
      this.showquestion = false;
      this.showquestiondetail = true;
      this.detailinfo = detailfaq;
    },
    showfaqs: function showfaqs(detailfaq) {
      this.showquestion = true;
      this.showquestiondetail = false;
      this.detailinfo = detailfaq;
    },
    backList: function backList() {
      this.releaseDetailPanel = false;
      this.releasePanel = true;
    },
    releaseSettings: function releaseSettings() {
      this.$router.push('/settings/release');
    },
    maxWindowRelease: function maxWindowRelease() {
      this.$modal.hide('ReleaseModal');
      this.$modal.show('ReleaseModal1');
    },
    minWindowRelease: function minWindowRelease() {
      this.$modal.show('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    showRelease: function showRelease(releaseDataDetail) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var newData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.releasePanel = false;
                _this5.releaseDetailPanel = true;
                _this5.singleReleaseData = releaseDataDetail;
                newData = {
                  r_id: releaseDataDetail.id,
                  u_id: _this5.currentUser.id
                };
                _context5.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["s" /* releaseStatusUpdate */])(newData);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }),
  created: function created() {
    this.checkReleaseExistFunction();
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var latestThis;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              latestThis = _this6;

              Object(__WEBPACK_IMPORTED_MODULE_3__services_ReleaseService_js__["lastReleaselist"])().then(function (defs) {
                latestThis.latestVersion = defs.data[0].v_no;
              });
              _context6.prev = 2;

              if (!_this6.errorMessage) {
                _this6.errorMessage = null;
              }

              if (_this6.clientLoaded) {
                _context6.next = 14;
                break;
              }

              if (!(_this6.isAdmin === 0)) {
                _context6.next = 12;
                break;
              }

              _context6.next = 8;
              return _this6.loadClient({ isAdmin: false, clientId: _this6.clientId });

            case 8:
              _this6.toggleClientLoaded();
              _this6.$router.push('/client/tours');
              _context6.next = 14;
              break;

            case 12:
              _this6.toggleClientLoaded();
              _this6.navToClientList();

            case 14:
              _context6.next = 19;
              break;

            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6['catch'](2);

              _this6.errorMessage = 'System error:  could not load content';

            case 19:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[2, 16]]);
    }))();
  }
});

/***/ }),

/***/ "5ApK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('tours', ['currentTour'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('topics', ['loadTopics']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('routes', ['loadRoutes', 'clearCurrentRoute'])),
  mounted: function mounted() {
    this.loadRoutes(this.currentTour.id);
    this.loadTopics(this.currentTour.id);
    this.clearCurrentRoute();
  }
});

/***/ }),

/***/ "5Fdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    topicsList: [],
    currentTopic: {},
    virtualTopicCondition: false
  },
  getters: {
    topicsList: function topicsList(state) {
      return state.topicsList;
    },
    currentTopic: function currentTopic(state) {
      return state.currentTopic;
    }
  },
  mutations: {
    setTopicsList: function setTopicsList(state, topics) {
      if (topics) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(topics), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var topic = _step.value;

            topic.latLng = JSON.parse(topic.latLng);
            topic.selected = false;
            topic.hover = false;
            topic.mapHover = false;
            topic.expanded = false;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      state.topicsList = topics;
    },
    removeMapTopicsFromState: function removeMapTopicsFromState(state, index) {
      var topics = state.topicsList;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(topics), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var topic = _step2.value;

          topic.hover = false;
          topic.mapHover = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.topicsList = topics;
    },
    setCurrentTopic: function setCurrentTopic(state, topic) {
      state.currentTopic = topic;
    },
    setMapHover: function setMapHover(state, indexAndToggle) {
      var index = indexAndToggle[0];
      var toggle = indexAndToggle[1];
      state.topicsList[index].mapHover = toggle;
    },
    clearTopicsList: function clearTopicsList(state) {
      state.topicsList = [];
    },
    toggleVirtualConditional: function toggleVirtualConditional(state, condition) {
      state.virtualTopicCondition = condition;
    },
    toggleTopicHover: function toggleTopicHover(state, payload) {
      // state.topicsList[payload.index].hover = payload.hover;
      var topics = state.topicsList;
      topics[payload.index].hover = payload.hover;
      state.topicsList = topics;
    },
    resetSelectedTopics: function resetSelectedTopics(state) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.topicsList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var topic = _step3.value;

          topic.selected = false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    resetTopicHover: function resetTopicHover(state) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.topicsList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var topic = _step4.value;

          topic.hover = false;
          topic.mapHover = false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    clearCurrentTopic: function clearCurrentTopic(state) {
      state.currentTopic = {};
    },
    alphaSortTopics: function alphaSortTopics(state) {
      state.topicsList = __WEBPACK_IMPORTED_MODULE_4_vue__["default"]._.sortBy(state.topicsList, ['name']);
    }
  },
  actions: {
    loadTopics: function loadTopics(_ref, tourId) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('clearTopicsList');
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_ClientService_js__["k" /* getTopics */])(tourId);

              case 3:
                response = _context.sent;

                if (response.status === 200) {
                  commit('setTopicsList', response.data);
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadEditorTopic: function loadEditorTopic(_ref2, topic) {
      var commit = _ref2.commit,
          state = _ref2.state;

      commit('setCurrentTopic', topic);
    },
    setMapHover: function setMapHover(_ref3, indexAndToggle) {
      var commit = _ref3.commit;

      commit('setMapHover', indexAndToggle);
    },
    setTopicsList: function setTopicsList(_ref4, topicList) {
      var commit = _ref4.commit;

      commit('setTopicsList', topicList);
    },
    cleanTopicsList: function cleanTopicsList(_ref5) {
      var commit = _ref5.commit;

      commit('clearTopicsList');
    },
    toggleTopicHover: function toggleTopicHover(_ref6, payload) {
      var commit = _ref6.commit;

      commit('toggleTopicHover', payload);
    },
    toggleVirtualConditional: function toggleVirtualConditional(_ref7, condition) {
      var commit = _ref7.commit;

      commit('toggleVirtualConditional', condition);
    },
    resetSelectedTopics: function resetSelectedTopics(_ref8) {
      var commit = _ref8.commit;

      commit('resetSelectedTopics');
    },
    resetTopicHover: function resetTopicHover(_ref9) {
      var commit = _ref9.commit;

      commit('resetTopicHover');
    },
    removeMapTopicsFromState: function removeMapTopicsFromState(_ref10, index) {
      var _this2 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('removeMapTopicsFromState', index);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resetCurrentTopic: function resetCurrentTopic(_ref11) {
      var commit = _ref11.commit;

      commit('clearCurrentTopic');
    },
    reSortTopics: function reSortTopics(_ref12) {
      var commit = _ref12.commit;

      commit('alphaSortTopics');
    }
  }
});

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("KrRW");
function injectStyle (ssrContext) {
  __webpack_require__("AJr4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5aFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerStoryList_vue__ = __webpack_require__("7buH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8df2778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerStoryList_vue__ = __webpack_require__("XQge");
function injectStyle (ssrContext) {
  __webpack_require__("OpWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerStoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8df2778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerStoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("r/ZB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5s23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('em',{staticClass:"logo ng-scope"}),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"col col-md-4 centered my-auto"},[_c('div',{staticClass:"login-text ng-scope"},[_c('h3',[_vm._v("Recovery Email Sent")]),_vm._v(" "),_c('p',[_vm._v("If that email address is a valid Cortex account, we have sent you an email to assist you in resetting your password.")]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('p',{staticClass:"centered"},[_c('a',{staticClass:"login-text text-center",on:{"click":function($event){_vm.returnToLogin()}}},[_vm._v("Back to sign in")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6DyQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ClientService_js__ = __webpack_require__("Fedb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      checkedNames: [],
      selectAll: false,
      allClientId: [],
      showDialog: false,
      selected: 'A',
      country: null,
      options: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      arrayForUserLimit: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientList', 'currentClient'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('client', ['loadClient']), {
    onChange: function onChange(event, clientId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.arrayForUserLimit[clientId] = event.target.value;

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    selectAllFunction: function selectAllFunction() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.checkedNames = [];
                if (!_this2.selectAll) {
                  for (i in _this2.clientList) {
                    _this2.checkedNames.push(_this2.clientList[i].id);
                  }
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    enableClientForInCoTour: function enableClientForInCoTour() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.showDialog = true;
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ClientService_js__["f" /* enableClientForInCoTour */])(_this3.checkedNames, _this3.allClientId, _this3.arrayForUserLimit);

              case 3:
                _context3.next = 5;
                return _this3.loadClient({ isAdmin: true, search: '' });

              case 5:
                _this3.showDialog = false;

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var index;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.loadClient({ isAdmin: true, search: '' });

            case 2:
              for (index = 0; index < _this4.clientList.length; index++) {
                if (_this4.clientList[index].compIncomStatus === 1) {
                  _this4.checkedNames.push(_this4.clientList[index].id);
                }
                _this4.allClientId.push(_this4.clientList[index].id);
              }

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ "6Luw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicFigure_vue__ = __webpack_require__("zkGW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f3f53e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicFigure_vue__ = __webpack_require__("CpQh");
function injectStyle (ssrContext) {
  __webpack_require__("1/HW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicFigure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f3f53e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6QMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__ = __webpack_require__("lhSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68773fa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__ = __webpack_require__("unwr");
function injectStyle (ssrContext) {
  __webpack_require__("FKP7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68773fa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68773fa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6ZEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content"},[_c('div',{staticClass:"user-form-box"},[(_vm.formError)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-box"},[(_vm.isAdmin || _vm.userToEdit.id === _vm.currentUser.id)?_c('span',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.userToEdit.firstName),callback:function ($$v) {_vm.$set(_vm.userToEdit, "firstName", $$v)},expression:"userToEdit.firstName"}})],1),_vm._v(" "),(_vm.$v.userToEdit.firstName.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("This field is required.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.userToEdit.lastName),callback:function ($$v) {_vm.$set(_vm.userToEdit, "lastName", $$v)},expression:"userToEdit.lastName"}})],1),_vm._v(" "),(_vm.$v.userToEdit.lastName.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("This field is required.")]):_vm._e()],1)])]):_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"grey-text"},[_vm._v("Name ")]),_vm._v(" "+_vm._s(_vm.userToEdit.firstName + ' ' + _vm.userToEdit.lastName))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[(_vm.isAdmin || _vm.userToEdit.id === _vm.currentUser.id)?_c('span',[_c('md-field',[_c('label',[_vm._v("Email")]),_vm._v(" "),(_vm.isAdmin)?_c('md-input',{model:{value:(_vm.userToEdit.email),callback:function ($$v) {_vm.$set(_vm.userToEdit, "email", $$v)},expression:"userToEdit.email"}}):_c('md-input',{attrs:{"disabled":""},model:{value:(_vm.userToEdit.email),callback:function ($$v) {_vm.$set(_vm.userToEdit, "email", $$v)},expression:"userToEdit.email"}})],1),_vm._v(" "),(_vm.$v.userToEdit.email.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("Please enter a valid email.")]):_vm._e()],1):_c('div',{staticClass:"user-info"},[_vm._v(" "+_vm._s(_vm.userToEdit.email))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.isAdmin || _vm.userToEdit.id === _vm.currentUser.id)?_c('span',[_c('md-field',[_c('label',[_vm._v("Position")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.userToEdit.title),callback:function ($$v) {_vm.$set(_vm.userToEdit, "title", $$v)},expression:"userToEdit.title"}})],1),_vm._v(" "),(_vm.$v.userToEdit.title.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("This field is required.")]):_vm._e()],1):_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"grey-text"},[_vm._v("Role ")]),_vm._v(" "+_vm._s(_vm.userToEdit.title))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[(_vm.isAdmin || _vm.userToEdit.id === _vm.currentUser.id)?_c('span',[_c('md-field',[_c('label',[_vm._v("Office Number")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.userToEdit.officePhone),callback:function ($$v) {_vm.$set(_vm.userToEdit, "officePhone", $$v)},expression:"userToEdit.officePhone"}})],1),_vm._v(" "),(_vm.$v.userToEdit.officePhone.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("Please enter a valid phone number.")]):_vm._e()],1):_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"grey-text"},[_vm._v("Office ")]),_vm._v(" "+_vm._s(_vm.userToEdit.officePhone))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.isAdmin || _vm.userToEdit.id === _vm.currentUser.id)?_c('span',[_c('md-field',[_c('label',[_vm._v("Direct Number")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.userToEdit.directPhone),callback:function ($$v) {_vm.$set(_vm.userToEdit, "directPhone", $$v)},expression:"userToEdit.directPhone"}})],1),_vm._v(" "),(_vm.$v.userToEdit.directPhone.$invalid)?_c('div',{staticClass:"user-edit-error"},[_vm._v("Please enter a valid phone number.")]):_vm._e()],1):_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"grey-text"},[_vm._v("Direct ")]),_vm._v(" "+_vm._s(_vm.userToEdit.directPhone))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.clientActive && _vm.isAdmin)?_c('div',{staticClass:"primary-contact"},[_c('div',[(_vm.isSuperAdmin)?_c('md-checkbox',{attrs:{"aria-label":"Primary Contact"},on:{"change":_vm.setUserAsAdmin},model:{value:(_vm.superadmincheckbox),callback:function ($$v) {_vm.superadmincheckbox=$$v},expression:"superadmincheckbox"}},[_vm._v("\n                                Cortex Super Admin\n                            ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('md-checkbox',{attrs:{"aria-label":"Primary Contact"},model:{value:(_vm.admincheckBox),callback:function ($$v) {_vm.admincheckBox=$$v},expression:"admincheckBox"}},[_vm._v("\n                                Cortex Admin\n                            ")])],1),_vm._v(" "),(_vm.clientList.length > 0 && !_vm.admincheckBox)?_c('div',{attrs:{"id":"demo"}},_vm._l((_vm.clientList),function(client,index){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectClient),expression:"selectClient"}],staticClass:"multiple_select",attrs:{"type":"checkbox","id":'category_' + client.id},domProps:{"value":client.id,"checked":Array.isArray(_vm.selectClient)?_vm._i(_vm.selectClient,client.id)>-1:(_vm.selectClient)},on:{"change":function($event){var $$a=_vm.selectClient,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=client.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectClient=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectClient=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectClient=$$c}}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(client.companyName))])])})):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.adminEditedFields)?_c('div',{staticClass:"success"},[_vm._v("\n                Record updated successfully!\n                "),_c('span',{on:{"click":_vm.hideNotification}},[_vm._v("X")])]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.saveUserChanges()}}},[_vm._v("Save Changes")]):_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.saveUserChangesForClient()}}},[_vm._v(" Save Changes")]),_vm._v(" "),(_vm.userToEdit.last_activity == null)?_c('div',[(_vm.isAdmin)?_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.resendUserChanges(_vm.userToEdit.id)}}},[_vm._v("Resend E-Mail")]):_vm._e()],1):_vm._e()],1)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            "+_vm._s(this.message)+"\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Ok")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6beV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7+Hp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73Uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ToursService__ = __webpack_require__("jYpk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ExportsService_js__ = __webpack_require__("gHwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_EditorService_js__ = __webpack_require__("bTS4");










/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    toursList: [],
    currentTour: {},
    currentTourDup: {},
    checkTourSettingSave: false,
    currentTourImage: {},
    exportRunning: false,
    checked: [],
    checkComIncompA: [],
    redCount: 0,
    greenCount: 0
  },
  getters: {
    tours: function tours(state) {
      return state.toursList;
    },
    currentTour: function currentTour(state) {
      return state.currentTour;
    },
    currentTourDup: function currentTourDup(state) {
      return state.currentTourDup;
    },
    checkTourSettingSave: function checkTourSettingSave(state) {
      return state.checkTourSettingSave;
    },
    currentTourImage: function currentTourImage(state) {
      return state.currentTourImage;
    },
    exportRunning: function exportRunning(state) {
      return state.exportRunning;
    },
    checked: function checked(state) {
      return state.checked;
    },
    checkComIncompA: function checkComIncompA(state) {
      return state.checkComIncompA;
    },
    redCount: function redCount(state) {
      return state.redCount;
    },
    greenCount: function greenCount(state) {
      return state.greenCount;
    },
    TourSettingsChanged: function TourSettingsChanged(state) {
      var edited = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(state.currentTour)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          var currentValue = state.currentTour[key];
          console.log(currentValue);
          console.log(value);
          edited = true;
          // if (currentValue !== value) {
          //   edited = true;
          // }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return edited;
    }
  },
  mutations: {
    setGreenCount: function setGreenCount(state, greenCount) {
      state.greenCount = greenCount;
    },
    setRedCount: function setRedCount(state, redCount) {
      state.redCount = redCount;
    },
    setToursList: function setToursList(state, tours) {
      var start = 0;
      state.toursList = tours;
      state.redCount = start;
      state.greenCount = start;
    },
    setCurrentTour: function setCurrentTour(state, tour) {
      state.currentTour = tour;
    },
    setfunAgainSetCurrtTour: function setfunAgainSetCurrtTour(state, tour) {
      state.currentTour = tour;
    },
    setCurrentTourImage: function setCurrentTourImage(state, tour) {
      state.currentTourImage = tour;
    },
    pushTourToList: function pushTourToList(state, tour) {
      state.toursList.push(tour);
    },
    setUpdateCurDupli: function setUpdateCurDupli(state, tour) {
      state.currentTourDup = tour;
    },
    setCheckTourSettingSave: function setCheckTourSettingSave(state, tour) {
      state.checkTourSettingSave = tour;
    },
    setExportRunning: function setExportRunning(state, toggle) {
      state.exportRunning = toggle;
    },
    mutateCheckedList: function mutateCheckedList(state, passData) {
      var index = passData.indexFor;
      var activeInactiveImages = passData.incompletComplete;
      var found = false;
      var location;
      for (var i = 0; i < state.checked.length; i++) {
        if (state.checked[i] === index) {
          found = true;
          location = i;
          state.checkComIncompA.splice(state.checked[0], 1);
        }
      }
      if (found) {
        if (activeInactiveImages === 1) {
          state.greenCount -= 1;
        } else {
          state.redCount -= 1;
        }
        state.checked.splice(location, 1);
      } else {
        state.checked.push(index);
      }
    },
    checkComIncomplist: function checkComIncomplist(state, dataAll) {
      var index = dataAll.indexFor;
      var param = dataAll.incompletComplete;
      for (var i = 0; i < state.checked.length; i++) {
        if (state.checked[i] === index) {
          if (param === 1) {
            state.greenCount += 1;
          } else {
            state.redCount += 1;
          }
          state.checkComIncompA[state.checked[i]] = param;
        }
      }
    },
    emptyChecked: function emptyChecked(state) {
      state.checked = [];
    },
    emptyCheckedRedGreen: function emptyCheckedRedGreen(state) {
      if (state.redCount === 0) {
        state.redCount = 0;
      }
      state.greenCount = 0;
    }
  },
  actions: {
    deleteTours: function deleteTours(_ref3, data) {
      var _this = this;

      var commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, tours;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ToursService__["c" /* deleteTours */])(data.clientId, data.tourIds);

              case 2:
                response = _context.sent;

                if (!(response.data === 'success')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ToursService__["e" /* getTours */])(data.clientId);

              case 6:
                tours = _context.sent;

                tours['setRedCount'] = 0;
                tours['setGreenCount'] = 0;
                commit('setToursList', tours.data);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadClientToursList: function loadClientToursList(_ref4, clientId) {
      var _this2 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tours;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ToursService__["e" /* getTours */])(clientId);

              case 2:
                tours = _context2.sent;

                commit('setToursList', tours.data);
                tours['setRedCount'] = 0;
                tours['setGreenCount'] = 0;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadTourEditor: function loadTourEditor(_ref5, tour) {
      var commit = _ref5.commit;

      commit('setCurrentTour', tour);
    },
    updateCurDupli: function updateCurDupli(_ref6, tour) {
      var commit = _ref6.commit;

      commit('setUpdateCurDupli', tour);
      commit('setCheckTourSettingSave', false);
    },
    funAgainSetCurrtTour: function funAgainSetCurrtTour(_ref7, tour) {
      var commit = _ref7.commit;

      commit('setfunAgainSetCurrtTour', tour);
    },
    updateCheckTourSettingSave: function updateCheckTourSettingSave(_ref8) {
      var commit = _ref8.commit;

      commit('setCheckTourSettingSave', true);
    },
    loadTourEditorImage: function loadTourEditorImage(_ref9, tour) {
      var commit = _ref9.commit;

      commit('setCurrentTourImage', tour);
    },
    addNewTour: function addNewTour(_ref10, tour) {
      var commit = _ref10.commit;

      commit('pushTourToList', tour);
    },
    loadNewTour: function loadNewTour(_ref11, tour) {
      var commit = _ref11.commit;

      commit('setCurrentTour', tour);
      commit('setCurrentTourImage', tour);
    },
    exportRunningOn: function exportRunningOn(_ref12) {
      var commit = _ref12.commit;

      commit('setExportRunning', true);
    },
    exportRunningOff: function exportRunningOff(_ref13) {
      var commit = _ref13.commit;

      commit('setExportRunning', false);
    },
    exportTours: function exportTours(_ref14, payload) {
      var _this3 = this;

      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch('exportRunningOn'); // enable spinner
                // Call services function to trigger HTTP POST with Axios to get the export
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["v" /* toursExport */])(payload);

              case 3:
                response = _context3.sent;

                // If successful...
                if (response.status === 200) {} else {
                  // Export failed
                  dispatch('exportRunningOff');
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkExportTours: function checkExportTours(tourId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_EditorService_js__["c" /* checkExportTours */])(tourId);

              case 2:
                response = _context4.sent;
                return _context4.abrupt('return', response);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    closeExportModal: function closeExportModal(_ref15) {
      var _this5 = this;

      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch('exportRunningOff');

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    exportToursDownload: function exportToursDownload(_ref16, payload) {
      var _this6 = this;

      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, a, blob, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch('exportRunningOn'); // enable spinner
                // Call services function to trigger HTTP POST with Axios to get the export
                _context6.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_ExportsService_js__["d" /* toursExportDownload */])(payload);

              case 3:
                response = _context6.sent;

                // If successful...
                if (response.status === 200) {
                  // Start by creating a hidden link element
                  a = document.createElement('a');

                  document.body.appendChild(a);
                  a.style = 'display: none';
                  // Create a blob from the response data, and create a download url for it
                  blob = new Blob([response.data], { type: 'application/x-gzip' });
                  url = window.URL.createObjectURL(blob);
                  // Set the link to the download url, give it the proper appdata name, and click it

                  a.href = url;
                  a.download = 'appdata' + payload.exportsId + '.tar.gz';
                  a.click();
                  // Kill the download url
                  window.URL.revokeObjectURL(url);
                  dispatch('exportRunningOff'); // disable spinner
                } else {
                  // Export failed
                  dispatch('exportRunningOff');
                }

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    clearCurrentTour: function clearCurrentTour(_ref17) {
      var commit = _ref17.commit;

      commit('setCurrentTour', {});
      commit('setCurrentTourImage', {});
    },
    mutateCheckedList: function mutateCheckedList(_ref18, passData) {
      var commit = _ref18.commit;

      commit('mutateCheckedList', passData);
    },
    checkComIncomp: function checkComIncomp(_ref19, dataAll) {
      var commit = _ref19.commit;

      commit('checkComIncomplist', dataAll);
    },
    emptyChecked: function emptyChecked(_ref20) {
      var commit = _ref20.commit;

      commit('emptyChecked');
    },
    emptyCheckedRedGreen: function emptyCheckedRedGreen(_ref21) {
      var commit = _ref21.commit;

      commit('emptyCheckedRedGreen');
    }
  }
});

/***/ }),

/***/ "7BXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouteSettings_vue__ = __webpack_require__("Jzxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce2fa0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouteSettings_vue__ = __webpack_require__("HQCj");
function injectStyle (ssrContext) {
  __webpack_require__("a3hw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouteSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce2fa0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouteSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Gqz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"users-settings-list"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.UserManualList),function(usermanual){return _c('div',{key:usermanual.email,staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item"},[_c('h3',[_vm._v(_vm._s(usermanual.email))])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('span',{staticClass:"email-link"},[_vm._v(_vm._s(usermanual.dateLogIn))])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(_vm.isAdmin)?_c('div',[_c('div',{staticClass:"el email-item"},[_c('a',{staticClass:"email-link"},[_vm._v(_vm._s(usermanual.timeOfLogIn))])])]):_vm._e()])])])}))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item"},[_c('span',{staticClass:"boldContent"},[_vm._v("  Email ID ")])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('span',{staticClass:"email-link boldContent"},[_vm._v(" Date Logged In ")])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('span',{staticClass:"boldContent"},[_vm._v("Time of Log In")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7buH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])({
    storyFiles: function storyFiles(state) {
      return state.triggers.storyFiles;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']))
});

/***/ }),

/***/ "7eFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"tour-card",class:{'item-checked' : _vm.isChecked()}},[_c('md-ripple',[_c('md-card-media',{staticClass:"tourCheckedCss",nativeOn:{"click":function($event){_vm.tourChecked(_vm.tour.activeInactiveImages), _vm.tourCheckedIncomplete(_vm.tour.activeInactiveImages)}}},[_c('span',{staticClass:"select-tour material-icons",attrs:{"role":"button"}})]),_vm._v(" "),_c('img',{staticClass:"navigateToEditorImages",attrs:{"src":_vm.getImageSrc(_vm.tour.card)},on:{"click":function($event){_vm.navigateToEditor()}}}),_vm._v(" "),_c('md-card-content',[_c('a',{staticClass:"no-line",on:{"click":function($event){_vm.navigateToEditor()}}},[(_vm.tour.activeInactiveImages === 1)?_c('span',[_c('h3',[_c('img',{staticClass:"completeImages",attrs:{"src":"static/img/complete.png"}}),_vm._v(_vm._s(_vm.tour.name))])]):_c('span',[_c('h3',[_c('img',{staticClass:"inCompleteImages",staticStyle:{"width":"13px"},attrs:{"src":"static/img/inComplete.png"}}),_vm._v(_vm._s(_vm.tour.name))])]),_vm._v(" "),_c('h4',{staticClass:"tourDescription"},[_vm._v(_vm._s(_vm.tour.description))])]),_vm._v(" "),(_vm.showThreeDots)?_c('md-menu',{staticClass:"upload-btn",staticStyle:{"float":"right","margin-top":"-20%"},attrs:{"md-size":"big","md-direction":"bottom-end"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('md-menu-content',{staticClass:"mdMenuContent"},[(_vm.checkedIncomCom === 0 || _vm.currentClient.compIncomStatus === 1)?_c('md-menu-item',[_c('md-button',{staticClass:"export-button ",on:{"click":function($event){_vm.openDialogForSingle('export')}}},[_vm._v("EXPORT")])],1):_vm._e(),_vm._v(" "),(_vm.checkedIncomCom === 0 || _vm.checkedIncomCom === 1 ||  _vm.currentClient.compIncomStatus === 1)?_c('md-menu-item',[_c('md-button',{staticClass:"export-button ",on:{"click":function($event){_vm.copyToursAndCreateNew(_vm.tour.id)}}},[_vm._v("COPY TOUR")])],1):_vm._e(),_vm._v(" "),_c('md-menu-item',[_c('form',{attrs:{"id":"tourImage","enctype":"multipart/form-data"}},[_c('md-button',{staticClass:"export-button "},[_c('label',{staticClass:"md-button",attrs:{"for":"files"}},[_vm._v("CHANGE TOUR IMAGE ")])]),_vm._v(" "),_c('input',{ref:"files",staticClass:"file-input",attrs:{"accept":"image/*","type":"file","id":"files"},on:{"change":function($event){_vm.handleFileUpload($event,_vm.tour.id)}}})],1)]),_vm._v(" "),_c('md-menu-item',{staticStyle:{"margin-left":"39px"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.openDialogForSingle('delete')}}},[_c('md-icon',[_vm._v("delete")])],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7eGZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8G2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToursTab_vue__ = __webpack_require__("+ufz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4e764b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToursTab_vue__ = __webpack_require__("YM2e");
function injectStyle (ssrContext) {
  __webpack_require__("yMzV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c4e764b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToursTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4e764b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToursTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8VAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_UserService_js__ = __webpack_require__("+q4l");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialog: false,
      userIdToDelete: null,
      userToDeleteName: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['userList', 'isAdmin', 'currentUser'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['loadUserList', 'setUserToEdit']), {
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    clickAddNewUsers: function clickAddNewUsers() {
      this.$router.push('/settings/users/add');
    },
    confirmDelete: function confirmDelete(user) {
      this.showDeleteDialog = true;
      this.userIdToDelete = user.id;
      this.userToDeleteName = user.firstName + ' ' + user.lastName;
    },
    closeDialog: function closeDialog() {
      this.showDeleteDialog = false;
      this.userIdToDelete = null;
      this.userToDeleteName = null;
    },
    deleteSelectedUser: function deleteSelectedUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["deleteUser"])(_this.userIdToDelete).then(function (response) {
                  _this.loadUsers();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 2:
                _this.showDeleteDialog = false;
                _this.userIdToDelete = null;
                _this.userToDeleteName = null;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadUsers: function loadUsers() {
      if (this.clientActive) {
        this.loadUserList(this.currentClient.id);
      } else {
        this.loadUserList();
      }
    },
    toggleUserAdmin: function toggleUserAdmin(user) {
      user.isAdmin = !user.isAdmin;
      this.callUpdateUser(user);
    },
    toggleUserPrimaryContact: function toggleUserPrimaryContact(user) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.userList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var userInList = _step.value;

          if (userInList.isPrimaryContact === 1 && userInList.clientId === this.currentClient.id) {
            userInList.isPrimaryContact = 0;
          } else if (userInList.id === user.id) {
            user.isPrimaryContact = 1;
            userInList = user;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.callUpdateUser(user);
    },
    callUpdateUser: function callUpdateUser(user) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["updateUser"])(user).catch(function (error) {
                  console.log(error.response.data);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showCurrentUserProfile: function showCurrentUserProfile(userId) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.userList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var user = _step2.value;

          if (user.id === userId) {
            this.setUserToEdit(user);
            this.$router.push('/user');
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }),
  mounted: function mounted() {
    this.loadUsers();
  }
});

/***/ }),

/***/ "8a7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourMediaTab_vue__ = __webpack_require__("wQ/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf4e11b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourMediaTab_vue__ = __webpack_require__("1YA8");
function injectStyle (ssrContext) {
  __webpack_require__("WtAB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bf4e11b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourMediaTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf4e11b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourMediaTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8eX7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ExportsService__ = __webpack_require__("gHwv");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    exportsList: []
  },
  getters: {
    exportsList: function exportsList(state) {
      return state.exportsList;
    }
  },
  mutations: {
    setExportsList: function setExportsList(state, exports) {
      state.exportsList = exports;
    }
  },
  actions: {
    loadExportsList: function loadExportsList(_ref) {
      var _this = this;

      var commit = _ref.commit;
      var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var exportsList, allExports;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                exportsList = [];

                if (!clientId) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_ExportsService__["b" /* getAllExports */])(clientId);

              case 5:
                allExports = _context.sent;

                exportsList = allExports.data;

              case 7:
                commit('setExportsList', exportsList.data, global);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                throw _context.t0;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    }
  },
  loadSingleExport: function loadSingleExport(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var exportId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var exportSingle, singleExport;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              exportSingle = null;

              if (!exportId) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_2__services_ExportsService__["c" /* getSingleExport */])(exportId);

            case 5:
              singleExport = _context2.sent;

              exportSingle = singleExport.data;

            case 7:
              commit('setExportSingle', exportSingle.data, global);
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);
              throw _context2.t0;

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 10]]);
    }))();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "9/ht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading && _vm.analytics.usage.topicData.length > 0)?_c('div',{staticClass:"line-item statistics"},[_c('div',{staticClass:"statistic"},[_c('strong',[_vm._v(_vm._s(_vm.analytics.total))]),_vm._v(" "),_c('span',[_vm._v("Peak Usage")])]),_vm._v(" "),_c('div',{staticClass:"statistic"},[_c('strong',[_vm._v(_vm._s(_vm.analytics.usage.topicData ? _vm.analytics.usage.topicData.length : ''))]),_vm._v(" "),_c('span',[_vm._v("Topics")])])]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"analytics-chart"},[(_vm.analytics.usage.topicData)?_c('line-chart',{ref:"chart",attrs:{"id":"topicChart","curve":false,"data":_vm.analytics.usage.topicData,"discrete":true,"lineWidth":"1","legend":"none","refresh":5,"height":"400px"}}):(!_vm.isLoading)?_c('div',{staticClass:"centered"},[_vm._v("No Analytics data for period.")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"data-table"},[(false)?[_c('div',[(_vm.analytics.usage.topicData)?_c('md-table',{attrs:{"md-card":""},scopedSlots:_vm._u([{key:"md-table-row",fn:function(ref){
var row = ref.row;
return _c('md-table-row',{},[_c('md-table-cell',{attrs:{"md-label":"Topic of Interest","md-sort-by":"name"}},[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('md-table-cell',{attrs:{"md-label":"Peak User Sessions","md-sort-by":"sessions"}},[_vm._v(_vm._s(row.sessions))])],1)}}]),model:{value:(_vm.analytics.usage.topicData),callback:function ($$v) {_vm.$set(_vm.analytics.usage, "topicData", $$v)},expression:"analytics.usage.topicData"}},[_c('md-table-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Topics")])])],1):_vm._e()],1)]:_vm._e(),_vm._v(" "),_c('table',[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.analytics.usage.topicData),function(topic,index){return _c('tr',{key:index},[_c('td',[_c('md-icon',{staticClass:"marker",style:({ color: topic.color })},[_vm._v("fiber_manual_record")]),_vm._v("\n                    "+_vm._s(topic.name)+"\n                ")],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s(topic.total))])])}))])],2):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"sort-el"},[_c('a',[_vm._v("Topic of Interest")])])]),_vm._v(" "),_c('th',{staticClass:"right-align half-cell"},[_c('span',{staticClass:"sort-el"},[_c('a',[_vm._v("Peak User Sessions")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "98Qu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap",attrs:{"id":"edit-client"}},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_c('md-button',{staticClass:"md-icon-button cancel-edit-client",on:{"click":function($event){_vm.cancelEditClient()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block bigger-field without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"placeholder":"Name *"},on:{"blur":function($event){_vm.touchHanlder('companyName')}},model:{value:(_vm.currentClient.companyName),callback:function ($$v) {_vm.$set(_vm.currentClient, "companyName", $$v)},expression:"currentClient.companyName"}})],1),_vm._v(" "),(_vm.$v.currentClient.companyName.$invalid)?_c('div',{staticClass:"client-error"},[_vm._v("Please provide a unique name for the new client.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"type":"tel","placeholder":"Phone *"},on:{"blur":function($event){_vm.touchHanlder('phoneNumber')}},model:{value:(_vm.currentClient.phoneNumber),callback:function ($$v) {_vm.$set(_vm.currentClient, "phoneNumber", $$v)},expression:"currentClient.phoneNumber"}})],1),_vm._v(" "),(_vm.$v.currentClient.phoneNumber.$invalid)?_c('div',{staticClass:"client-error"},[_vm._v("Please provide a valid phone number.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Website (Example: https://example.io)"},on:{"blur":function($event){_vm.touchHanlder('website')}},model:{value:(_vm.currentClient.website),callback:function ($$v) {_vm.$set(_vm.currentClient, "website", $$v)},expression:"currentClient.website"}})],1),_vm._v(" "),(_vm.$v.currentClient.website.$error)?_c('div',{staticClass:"client-error"},[_vm._v("Please provide a valid URL (Must include HTTP or HTTPS protocol).")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Country"},model:{value:(_vm.currentClient.country),callback:function ($$v) {_vm.$set(_vm.currentClient, "country", $$v)},expression:"currentClient.country"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"State/Province"},model:{value:(_vm.currentClient.stateProvince),callback:function ($$v) {_vm.$set(_vm.currentClient, "stateProvince", $$v)},expression:"currentClient.stateProvince"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[_c('md-switch',{staticClass:"md-primary",on:{"change":function($event){_vm.toggleCurrentClientIsAnalytics($event)}},model:{value:(_vm.isAnalytics),callback:function ($$v) {_vm.isAnalytics=$$v},expression:"isAnalytics"}},[_vm._v("\n                                        Analytics\n                                    ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Address *"},on:{"blur":function($event){_vm.touchHanlder('address')}},model:{value:(_vm.currentClient.address),callback:function ($$v) {_vm.$set(_vm.currentClient, "address", $$v)},expression:"currentClient.address"}})],1),_vm._v(" "),(_vm.$v.currentClient.address.$invalid)?_c('div',{staticClass:"client-error"},[_vm._v("Please provide an address.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-textarea',{attrs:{"placeholder":"Description"},model:{value:(_vm.currentClient.description),callback:function ($$v) {_vm.$set(_vm.currentClient, "description", $$v)},expression:"currentClient.description"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"City"},model:{value:(_vm.currentClient.city),callback:function ($$v) {_vm.$set(_vm.currentClient, "city", $$v)},expression:"currentClient.city"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Zip/Postal Code"},on:{"blur":function($event){_vm.touchHanlder('zipPostalCode')}},model:{value:(_vm.currentClient.zipPostalCode),callback:function ($$v) {_vm.$set(_vm.currentClient, "zipPostalCode", $$v)},expression:"currentClient.zipPostalCode"}})],1),_vm._v(" "),(_vm.$v.currentClient.zipPostalCode.$error)?_c('div',{staticClass:"client-error"},[_vm._v("Please provide a valid postal code or zip number.")]):_vm._e()],1)])])])],1)]),_vm._v(" "),(!_vm.$v.$invalid && _vm.clientEdited)?_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"save-client-button md-primary",on:{"click":function($event){_vm.saveClientChanges()}}},[_vm._v("Save")])],1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Edit Client Details")]),_vm._v("\n                    Required fields are marked with *\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9V4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourRoute_vue__ = __webpack_require__("j8gs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b045484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourRoute_vue__ = __webpack_require__("P88y");
function injectStyle (ssrContext) {
  __webpack_require__("7+Hp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourRoute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b045484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourRoute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9cD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayVideoPdf_vue__ = __webpack_require__("Cjbi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71853b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayVideoPdf_vue__ = __webpack_require__("uTQT");
function injectStyle (ssrContext) {
  __webpack_require__("nayk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71853b5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayVideoPdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71853b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayVideoPdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9iII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ReleaseService_js__ = __webpack_require__("w98i");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialog: false,
      releaseIdToDelete: null,
      releaseToDeleteName: null,
      rowStatus: [],
      showExpand: false
    };
  },
  props: ['clinetVersionCheck', 'latestVersion'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['userList', 'isAdmin', 'isSuperAdmin', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('release', ['releaseList'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['loadUserList', 'setUserToEdit']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('release', ['loadReleaseList', 'setReleaseToEdit', 'setReleaseToEditVersion']), {
    clickAddNewRelease: function clickAddNewRelease() {
      this.$router.replace('/settings/release/add');
    },
    expandAll: function expandAll(status, index) {
      this.showExpand = true;
      this.$set(this.rowStatus, index, this.rowStatus[index] ? 0 : 1);
    },
    confirmDelete: function confirmDelete(releaseId, releasebuildRNo) {
      this.showDeleteDialog = true;
      this.releaseIdToDelete = releaseId;
      this.releaseToDeleteName = releasebuildRNo;
    },
    closeDialog: function closeDialog() {
      this.showDeleteDialog = false;
      this.releaseIdToDelete = null;
      this.releaseToDeleteName = null;
    },
    deleteSelectedRelease: function deleteSelectedRelease() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ReleaseService_js__["deleteRelease"])(_this.releaseIdToDelete).then(function (response) {
                  _this.loadReleaseList();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 2:
                _this.showDeleteDialog = false;
                _this.releaseIdToDelete = null;
                _this.releaseToDeleteName = null;
                _this.loadReleaseList(_this.currentUser.id);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadUsers: function loadUsers() {
      if (this.clientActive) {
        this.loadUserList(this.currentClient.id);
      } else {
        this.loadUserList();
      }
    },
    showCurrentReleaseProfile: function showCurrentReleaseProfile(releaseId, releaseVersionNo) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.releaseList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var release = _step.value;

          if (release.v_no === releaseVersionNo) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(release.description), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var build = _step2.value;

                if (build.id === releaseId) {
                  this.setReleaseToEdit(build);
                  this.$router.push('/settings/release/edit');
                  return;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    showCurrentReleaseProfileVersion: function showCurrentReleaseProfileVersion(releaseId, releaseVersionNo) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.releaseList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var release = _step3.value;

          if (release.v_no === releaseVersionNo) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(release.description), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var build = _step4.value;

                if (build.id === releaseId) {
                  this.setReleaseToEditVersion(build);
                  this.$router.push('/settings/release/editVersion');
                  return;
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }),
  created: function created() {
    this.loadReleaseList(this.currentUser.id);
  },
  mounted: function mounted() {
    this.loadUsers();
  }
});

/***/ }),

/***/ "9kP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"add-user global-section"},[_c('div',{staticClass:"row"},[(_vm.formError)?_c('div',{staticClass:"col-12 form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('md-button',{staticClass:"md-icon-button cancel-add-user",on:{"click":function($event){_vm.cancelAddRelease()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Version No."},model:{value:(_vm.v_no),callback:function ($$v) {_vm.v_no=$$v},expression:"v_no"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Build Number"},model:{value:(_vm.r_no),callback:function ($$v) {_vm.r_no=$$v},expression:"r_no"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_c('datepicker',{staticClass:"border-0 el",attrs:{"placeholder":"Build Date","format":_vm.format},model:{value:(_vm.r_date),callback:function ($$v) {_vm.r_date=$$v},expression:"r_date"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.newUsers),function(user,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"uploadImgWrapper"},[_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"client-name-box"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Functionality Name"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'functionalityName')}},model:{value:(user.functionalityName),callback:function ($$v) {_vm.$set(user, "functionalityName", $$v)},expression:"user.functionalityName"}})],1),_vm._v(" "),(_vm.$v.newUsers.$each[index].functionalityName.$error)?_c('div',{staticClass:"new-user-error"},[_vm._v("Please provide a functionality name for this release functionality.")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"textareaWrapper"},[_c('md-field',{staticClass:"md-block boder-0"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(user.functionalityDesc),expression:"user.functionalityDesc"}],staticClass:"textareaW",attrs:{"placeholder":"Description"},domProps:{"value":(user.functionalityDesc)},on:{"blur":function($event){_vm.userTouchHanlder(index, 'functionalityDesc')},"input":function($event){if($event.target.composing){ return; }_vm.$set(user, "functionalityDesc", $event.target.value)}}})]),_vm._v(" "),(_vm.$v.newUsers.$each[index].functionalityDesc.$error)?_c('div',{staticClass:"new-user-error"},[_vm._v("Please provide a description for this release functionality.")]):_vm._e(),_vm._v(" "),(_vm.hasMultipleUsers)?_c('md-button',{staticClass:"md-icon-button delete-btn ",attrs:{"aria-label":"Delete Functionality"},on:{"click":function($event){_vm.deleteUser(index)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1)]),_vm._v(" "),_c('input',{staticClass:"textareaW",attrs:{"type":"hidden","placeholder":"Description"},domProps:{"value":user.functionalityDescVer}})])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bottomBtnWrapper"},[_c('div',[_c('div',{},[_c('md-button',{staticClass:"save-user-button md-primary",staticStyle:{"margin-left":"1150px"},attrs:{"aria-label":"Add New Client"},on:{"click":function($event){_vm.clickSaveNewRelease()}}},[_vm._v("Save")])],1)])])])])],2)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"user-saving-message"},[_c('span',[_c('md-progress-spinner',{staticClass:"md-accent user-saving-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}),_vm._v("\n                Saving Release...\n            ")],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Add New Build Notes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar upload s-48 feature-icon-m"},[_c('img',{attrs:{"src":"static/img/settings.svg","alt":"feature icon","width":"34"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9r/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSettings_vue__ = __webpack_require__("8VAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a41455e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersSettings_vue__ = __webpack_require__("/YDy");
function injectStyle (ssrContext) {
  __webpack_require__("uYfp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a41455e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a41455e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AJr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AU4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"add-user global-section"},[_c('div',{staticClass:"row"},[_c('md-button',{staticClass:"md-icon-button cancel-add-user",on:{"click":function($event){_vm.cancelEditRelease()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false)],1),_vm._v(" "),(_vm.formError)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"disabled":true,"placeholder":"Version No."},model:{value:(_vm.releaseToEdit.v_no),callback:function ($$v) {_vm.$set(_vm.releaseToEdit, "v_no", $$v)},expression:"releaseToEdit.v_no"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_vm._v(_vm._s(_vm.releaseToEdit.date)+"\n                            "),_c('datepicker',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"disabled":true,"placeholder":"Release Date","format":_vm.format},model:{value:(_vm.releaseToEdit.date),callback:function ($$v) {_vm.$set(_vm.releaseToEdit, "date", $$v)},expression:"releaseToEdit.date"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.releaseDetail),function(releasefunction,index){return _c('div',{key:index,staticClass:"row"},[_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"textareaWrapper"},[_c('md-field',{staticClass:"md-block boder-0"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(releasefunction.descriptionVersion),expression:"releasefunction.descriptionVersion"}],staticClass:"textareaW",attrs:{"placeholder":"Description"},domProps:{"value":(releasefunction.descriptionVersion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(releasefunction, "descriptionVersion", $event.target.value)}}})]),_vm._v(" "),(_vm.hasMultipleRelease)?_c('md-button',{staticClass:"md-icon-button delete-btn ",attrs:{"aria-label":"Delete Functionality"},on:{"click":function($event){_vm.deleteRelease(index)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1)])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bottomBtnWrapper"},[_c('div',{},[_c('md-button',{staticClass:"save-user-button md-primary",staticStyle:{"margin-left":"1000px"},attrs:{"aria-label":"Add New Client"},on:{"click":function($event){_vm.clickSaveNewRelease()}}},[_vm._v("Update")])],1)])])])],2)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"user-saving-message"},[_c('span',[_c('md-progress-spinner',{staticClass:"md-accent user-saving-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}),_vm._v("\n                 Updating Release...\n            ")],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Edit Version Notes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4"},[_c('div',{staticClass:"uploadImgWrapper"},[_c('div',{staticClass:"avatar upload s-48 feature-icon-m",staticStyle:{"float":"right"}},[_c('img',{attrs:{"src":"static/img/settings.svg","alt":"feature icon","width":"34"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Af2g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Arye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap",attrs:{"id":"ClientListTab"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('md-field',{staticClass:"search-field",staticStyle:{"width":"30%"}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-input',{on:{"keyup":_vm.searchList},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.clientList.length == 0)?_c('h3',{staticStyle:{"color":"red","padding-left":"400px","margin-top":"-40px"}},[_vm._v("\n          Client not exists\n       ")]):_vm._e(),_vm._v(" "),_c('md-list',{staticClass:"clients-wrap"},_vm._l((_vm.clientList),function(client,index){return (_vm.clientList != null)?_c('div',{staticClass:"collapsing-list-item",attrs:{"id":client.id}},[_c('md-list-item',{staticClass:"line-item client-line"},[_c('div',{staticClass:"left-item",on:{"click":function($event){_vm.navToClient(client)}}},[_c('b-tooltip',{attrs:{"title":"Client Tours","triggers":"focus","positioning":"top"}},[_c('a',{staticClass:"client-nav",on:{"click":function($event){_vm.navToClient(client)}}},[_c('h2',[_vm._v(_vm._s(client.companyName)+"\n                                "),(client.description!=null)?_c('div',{on:{"click":function($event){_vm.navToClient(client)}}},[(client.user)?_c('small',[_vm._v(_vm._s(client.description.substring(0, 90))),(client.description.length>=90)?_c('span',[_vm._v("....")]):_vm._e()]):_vm._e()]):_vm._e()])])])],1),_vm._v(" "),_c('div',{staticClass:"left-item",on:{"click":function($event){_vm.navToClient(client)}}},[_c('b-tooltip',{attrs:{"title":"Client Tours","triggers":"focus","positioning":"top"}},[_c('a',{staticClass:"client-nav",on:{"click":function($event){_vm.navToClient(client)}}},[_c('div',{staticClass:"progress-bar",attrs:{"data-v-8248d938":"","data-v-85b4f9ea":"","id":"progress-bar-line"}},[_c('svg',{staticStyle:{"height":"20px","width":"220px"},attrs:{"id":"line-progress"}},[_c('line',{attrs:{"x1":"0","y1":"50%","x2":"100%","y2":"50%","stroke":"#00A8CA","stroke-width":"20"}}),_vm._v(" "),_c('line',{attrs:{"x1":"0","y1":"50%","x2":client.media_size_p,"y2":"50%","stroke":"#228b22","stroke-width":"20px"}}),_vm._v(" "),_c('text',{staticStyle:{"display":"inherit","fill":"rgb(255, 255, 255)","font-size":"10px","font-family":"Helvetica","text-shadow":"rgb(0, 0, 0) 1px 1px 1px"},attrs:{"x":"45%","y":"64%"}},[_vm._v(" "+_vm._s(client.media_length))])])])])])],1),_vm._v(" "),_c('div',{staticClass:"right-item",on:{"click":function($event){_vm.navToClient(client)}}},[_c('b-tooltip',{attrs:{"title":"Client Tours","triggers":"focus","positioning":"top"}},[(client.activeInactiveImages === 1)?_c('span',{on:{"click":function($event){_vm.navToClient(client)}}},[_c('img',{staticClass:"completeImages",attrs:{"src":"static/img/complete.png"}})]):_vm._e()])],1),_vm._v(" "),_c('b-tooltip',{attrs:{"title":"Client Tours","triggers":"focus","positioning":"top"}},[_c('div',{staticClass:"right-item",on:{"click":function($event){_vm.navToClient(client)}}},[_c('div',{staticClass:"el"}),_vm._v(" "),(client.user)?_c('span',{staticClass:"d-flex"},[_c('div',{staticClass:"el no-outline-btn",on:{"click":function($event){_vm.navToClient(client)}}},[(_vm.hasAvatar(client))?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(client.user.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                                    "+_vm._s(_vm.getClientInitials(client))+"\n                                ")])],1),_vm._v(" "),_c('div',{staticClass:"el position-width no-outline-btn",on:{"click":function($event){_vm.navToClient(client)}}},[_c('h4',[_vm._v(_vm._s(client.user.firstName + ' ' + client.user.lastName)+"\n                                    "),_c('small',[_vm._v(_vm._s(client.user.title))])])])]):_c('span',{staticClass:"d-flex"},[_c('div',{staticClass:"el no-outline-btn",on:{"click":function($event){_vm.navToClient(client)}}},[_c('md-avatar',{})],1),_vm._v(" "),_c('div',{staticClass:"el position-width no-outline-btn"},[_c('p')])])])]),_vm._v(" "),_c('div',{staticClass:"right-item",attrs:{"id":"clientListDelete"}},[_c('b-tooltip',{attrs:{"title":"Delete","triggers":"focus","positioning":"top"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.confirmDelete(client.id, index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('b-tooltip',{attrs:{"title":"Edit","triggers":"focus","positioning":"top"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"clientListEdit"},on:{"click":function($event){_vm.editClient(client)}}},[_c('md-icon',[_vm._v("mode_edit")])],1)],1)],1),_vm._v(" "),_c('img',{staticClass:"client_list_img ",staticStyle:{},attrs:{"src":client.img,"id":"imgeExpand"},on:{"click":function($event){_vm.clickExpandFunc(index)}}})],1),_vm._v(" "),(client.expended)?_c('md-listz',{staticClass:"right-item",staticStyle:{"padding-right":"5px"}},[_c('md-list-item',{staticClass:"md-inset"},[_c('div',{staticClass:"client-info-wrap line-item"},[_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el"},[(client.user)?_c('div',{staticClass:"info-element"},[_c('dl',[_c('dt',[_vm._v("Office")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getFullOfficeNumber(client)))]),_vm._v(" "),_c('dt',[_vm._v("Direct")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getFullDirectNumber(client)))]),_vm._v(" "),_c('dt',[_vm._v("Email")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(client.user.email))])])]):_c('div',{staticClass:"info-element"},[_vm._v("\n                                    This client has no contacts.\n                                ")])])])])])],1):_vm._e()],1):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":function($event){_vm.clickNewClient()}}},[_c('md-icon',[_vm._v("add")])],1)],1)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete this client?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteClient(_vm.clientId,_vm.clientIndex)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AzWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('em',{staticClass:"logo ng-scope"}),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"col col-md-4 centered my-auto"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"actions"},[_c('p',{staticClass:"centered"},[_c('a',{staticClass:"login-text text-center",on:{"click":function($event){_vm.returnToLogin()}}},[_vm._v("Back to sign in")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-text ng-scope"},[_c('h3',[_vm._v("Access Denied")]),_vm._v(" "),_c('p',[_vm._v("You do not have permission to view the requested page.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B1Vw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGbQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BJh3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewClient_vue__ = __webpack_require__("QfQe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c71d53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewClient_vue__ = __webpack_require__("2ARr");
function injectStyle (ssrContext) {
  __webpack_require__("2bQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06c71d53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c71d53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewClient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C0D7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggersTab_vue__ = __webpack_require__("RO8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2ec1ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggersTab_vue__ = __webpack_require__("kPd+");
function injectStyle (ssrContext) {
  __webpack_require__("YuBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggersTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2ec1ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggersTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CJXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TopicRoutesContainer"},[_c('div',{staticClass:"btn-position-wrap"},[_c('md-tabs',{staticClass:"md-tabs-wrapper container",attrs:{"md-sync-route":"","md-alignment":"left"}},[_c('md-tab',{attrs:{"md-label":"Topics","to":"/tour/topicRoutes/topics"}}),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Routes","to":"/tour/topicRoutes/routes"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CLCS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LibraryService__ = __webpack_require__("FIGs");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    assignableMedia: [],
    library: {},
    stories: [],
    tourLibrary: {},
    isUploading: false,
    isValidating: false,
    tourNotifications: [],
    uploadError: false,
    uploadResults: null
  },
  getters: {
    getAssignableMedia: function getAssignableMedia(state) {
      return state.assignableMedia;
    },
    getLibrary: function getLibrary(state) {
      return state.library;
    },
    getStories: function getStories(state) {
      return state.stories;
    },
    getTourLibrary: function getTourLibrary(state) {
      return state.tourLibrary;
    },
    getUploadError: function getUploadError(state) {
      return state.uploadError;
    },
    isUploading: function isUploading(state) {
      return state.isUploading;
    },
    isValidating: function isValidating(state) {
      return state.isValidating;
    },
    tourNotifications: function tourNotifications(state) {
      return state.tourNotifications;
    },
    uploadResults: function uploadResults(state) {
      return state.uploadResults;
    }
  },
  mutations: {
    setAssignableMedia: function setAssignableMedia(state, media) {
      state.assignableMedia = media;
    },
    setLanguageOpen: function setLanguageOpen(state, indexes) {
      if (state.library[indexes.category][indexes.index]) {
        state.library[indexes.category][indexes.index].expanded = true;
      }
    },
    setLibrary: function setLibrary(state, library) {
      state.library = library;
    },
    clearLibrary: function clearLibrary(state) {
      state.library = {
        story: {},
        filler: {},
        music: {},
        notification: {},
        safety: {}
      };
    },
    setStories: function setStories(state, media) {
      state.stories = media;
    },
    setTourLibrary: function setTourLibrary(state, library) {
      state.tourLibrary = library;
    },
    setUploadError: function setUploadError(state, isError) {
      state.uploadError = isError;
    },
    toggleExpanded: function toggleExpanded(state, indexes) {
      state.library[indexes.category][indexes.index].expanded = !state.library[indexes.category][indexes.index].expanded;
    },
    toggleExpandedAll: function toggleExpandedAll(state, expand) {
      for (var key in state.library[expand.category]) {
        if (state.library[expand.category].hasOwnProperty(key)) {
          state.library[expand.category][key].expanded = expand.expand;
        }
      }
    },
    setIsUploading: function setIsUploading(state, toggle) {
      state.isUploading = toggle;
    },
    setIsValidating: function setIsValidating(state, toggle) {
      state.isValidating = toggle;
    },
    setTourNotifications: function setTourNotifications(state, notifications) {
      state.tourNotifications = notifications;
    },
    setUploadResults: function setUploadResults(state, results) {
      state.uploadResults = results;
    }
  },
  actions: {
    removeFromLibrary: function removeFromLibrary(_ref, data) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["d" /* deleteLibraryItem */])(data.clientId, data.libraryItemId);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    removeFromLibraryMultiple: function removeFromLibraryMultiple(_ref2, data) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["e" /* deleteLibraryItemMultiple */])(data.clientId, data.libraryItemId);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reorderLibrary: function reorderLibrary(_ref3, data) {
      var _this3 = this;

      var commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var responsen, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["p" /* updatePriorityLibraryStory */])(data);

              case 2:
                responsen = _context3.sent;

                if (!(responsen.data === 'success')) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["g" /* getLibrary */])(data.clientId);

              case 6:
                response = _context3.sent;

                commit('setLibrary', response.data);
                return _context3.abrupt('return', 'Success');

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadAssignableMedia: function loadAssignableMedia(_ref4, data) {
      var _this4 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["f" /* getAssignableMediaForTour */])(data.clientId, data.tourId, data.type);

              case 2:
                response = _context4.sent;

                if (!(response.data === 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', response.data);

              case 7:
                commit('setAssignableMedia', response.data);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    loadLibrary: function loadLibrary(_ref5, clientId) {
      var _this5 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit('clearLibrary');
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["g" /* getLibrary */])(clientId);

              case 3:
                response = _context5.sent;

                commit('setLibrary', response.data);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    loadLibraryAndValidate: function loadLibraryAndValidate(_ref6, clientId) {
      var _this6 = this;

      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                dispatch('library/isValidatingOn', {}, { root: true });
                _context6.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["h" /* getLibraryAndValidate */])(clientId);

              case 4:
                _context6.next = 11;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);

                dispatch('library/isValidatingOff', {}, { root: true });
                console.log(_context6.t0);
                throw _context6.t0;

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 6]]);
      }))();
    },
    loadStories: function loadStories(_ref7, data) {
      var _this7 = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["l" /* getStoryMediaForTour */])(data);

              case 2:
                response = _context7.sent;

                commit('setStories', response.data);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    loadTourLibrary: function loadTourLibrary(_ref8, data) {
      var _this8 = this;

      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["i" /* getLibraryForTour */])(data.clientId, data.tourId);

              case 2:
                response = _context8.sent;

                commit('setTourLibrary', response.data);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    reorderTourLibrary: function reorderTourLibrary(_ref9, data) {
      var _this9 = this;

      var commit = _ref9.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var responsen, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["o" /* updatePriorityForTourMedia */])(data);

              case 2:
                responsen = _context9.sent;

                if (!(responsen.data === 'success')) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["i" /* getLibraryForTour */])(data.clientId, data.tourId);

              case 6:
                response = _context9.sent;

                commit('setTourLibrary', response.data);
                return _context9.abrupt('return', 'Success');

              case 9:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    toggleExpandLanguages: function toggleExpandLanguages(_ref10, indexes) {
      var commit = _ref10.commit;

      commit('toggleExpanded', indexes);
    },
    toggleExpandLanguagesAll: function toggleExpandLanguagesAll(_ref11, expand) {
      var commit = _ref11.commit;

      commit('toggleExpandedAll', expand);
    },
    forceLanguageOpen: function forceLanguageOpen(_ref12, indexes) {
      var commit = _ref12.commit;

      commit('setLanguageOpen', indexes);
    },
    addMediaToTour: function addMediaToTour(_ref13, data) {
      var _this10 = this;

      var commit = _ref13.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["c" /* addTourMedia */])(data);

              case 3:
                _context10.next = 8;
                break;

              case 5:
                _context10.prev = 5;
                _context10.t0 = _context10['catch'](0);

                console.log(_context10.t0);

              case 8:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 5]]);
      }))();
    },
    removeMediaFromTour: function removeMediaFromTour(_ref14, data) {
      var _this11 = this;

      var commit = _ref14.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["m" /* removeTourMedia */])(data);

              case 3:
                _context11.next = 8;
                break;

              case 5:
                _context11.prev = 5;
                _context11.t0 = _context11['catch'](0);

                console.log(_context11.t0);

              case 8:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[0, 5]]);
      }))();
    },
    isUploadingOn: function isUploadingOn(_ref15) {
      var commit = _ref15.commit;

      commit('setIsUploading', true);
    },
    isUploadingOff: function isUploadingOff(_ref16) {
      var commit = _ref16.commit;

      commit('setIsUploading', false);
    },
    isUploadErrorOn: function isUploadErrorOn(_ref17) {
      var commit = _ref17.commit;

      commit('setUploadError', true);
    },
    isUploadErrorOff: function isUploadErrorOff(_ref18) {
      var commit = _ref18.commit;

      commit('setUploadError', false);
    },
    isValidatingOn: function isValidatingOn(_ref19) {
      var commit = _ref19.commit;

      commit('setIsValidating', true);
    },
    isValidatingOff: function isValidatingOff(_ref20) {
      var commit = _ref20.commit;

      commit('setIsValidating', false);
    },
    loadTourNotifications: function loadTourNotifications(_ref21, payload) {
      var _this12 = this;

      var commit = _ref21.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_LibraryService__["j" /* getNotificationsForTour */])(payload.tourId, payload.clientId);

              case 3:
                response = _context12.sent;

                if (response.status === 200) {
                  commit('setTourNotifications', response.data);
                }
                _context12.next = 10;
                break;

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12['catch'](0);

                console.log(_context12.t0);

              case 10:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[0, 7]]);
      }))();
    },
    clearTourNotifications: function clearTourNotifications(_ref22) {
      var commit = _ref22.commit;

      commit('setTourNotifications', []);
    },
    setUploadResults: function setUploadResults(_ref23, results) {
      var commit = _ref23.commit;

      commit('setUploadResults', results);
    },
    setValidationResults: function setValidationResults(_ref24, results) {
      var commit = _ref24.commit;

      commit('setLibrary', results);
    },
    clearUploadResults: function clearUploadResults(_ref25) {
      var commit = _ref25.commit;

      commit('setUploadResults', null);
    }
  }
});

/***/ }),

/***/ "Cjbi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ClientService_js__ = __webpack_require__("Fedb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialog: true,
      videoSrc: '',
      fileName: '',
      videoContent: false,
      pdfContent: false,
      faqContent: false,
      userManualId: '',
      isActive: ''
    };
  },
  methods: {},
  mounted: function mounted() {
    if (this.$route.path === '/usermanual/pdf') {
      this.pdfContent = true;
      this.videoContent = false;
      this.faqContent = false;
    } else if (this.$route.path === '/usermanual/video') {
      this.videoContent = true;
      this.pdfContent = false;
      this.faqContent = false;
    } else {
      this.videoContent = false;
      this.pdfContent = false;
      this.faqContent = true;
    }
    this.fileName = this.$route.fullPath;
    this.fileName = this.fileName.split('?');
    var url = this;
    this.isActive = '100% importent';
    Object(__WEBPACK_IMPORTED_MODULE_0__services_ClientService_js__["n" /* getUserManualById */])(this.fileName[1]).then(function (responce) {
      url.videoSrc = responce.data[0].path;
      document.title = responce.data[0].attachment_name;
      url.$modal.show('hello-world');
    });
  }
});

/***/ }),

/***/ "CpQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"tourFigure"},[(!_vm.showInfo)?_c('div',[_c('img',{staticClass:"topicFigureHeight",attrs:{"src":_vm.getImageSrc(_vm.currentTopic.avatar)}}),_vm._v(" "),_c('div',{staticClass:"gradient-box"}),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item ",staticStyle:{"position":"fixed"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Back to Route","aria-label":"Back"},on:{"click":_vm.returnToPrevious}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed","margin-left":"3%"}},[_c('h3',{staticClass:"link",on:{"click":function($event){_vm.toggleInfoBlock('EDITOPEN')}}},[_vm._v(_vm._s(_vm.currentTopic.name))])])])]):_vm._e(),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"info-block"},[_c('h3',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTopic.name),expression:"currentTopic.name"}],attrs:{"maxlength":"60","rows":"1","placeholder":"Topic Name"},domProps:{"value":(_vm.currentTopic.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTopic, "name", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTopic.description),expression:"currentTopic.description"}],attrs:{"maxlength":"200"},domProps:{"value":(_vm.currentTopic.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTopic, "description", $event.target.value)}}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button close-info",on:{"click":function($event){_vm.toggleInfoBlock('EDITCLOSE')}}},[_c('md-icon',[_vm._v("close")])],1),_vm._v(" "),_c('md-button',{staticClass:"save-button md-raised md-primary",on:{"click":_vm.saveTopicDetails}},[_vm._v("Save")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Csjn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D85/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DQUZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7fw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerNotesTab_vue__ = __webpack_require__("2Ite");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd2efe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerNotesTab_vue__ = __webpack_require__("YQmb");
function injectStyle (ssrContext) {
  __webpack_require__("SD+W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerNotesTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd2efe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerNotesTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EaKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"topicsTab"}},[_c('div',{staticClass:"search open-search"},[_c('div',{staticClass:"search-holder"},[_c('md-icon',{staticClass:"search-glass-icon"},[_vm._v("search")]),_vm._v(" "),(_vm.topicsSelected)?_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"md-input-focused md-input-container"},[_c('GmapAutocomplete',{ref:"search",staticClass:"md-input",attrs:{"disabled":"","placeholder":"","bounds":_vm.bounds},on:{"place_changed":_vm.newPlaceSelected},model:{value:(_vm.autocompleteInput),callback:function ($$v) {_vm.autocompleteInput=$$v},expression:"autocompleteInput"}})],1),_vm._v(" "),_c('div',{staticClass:"autocomplete-buttons"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete Topic(s)"},on:{"click":function($event){_vm.confirmDelete()}}},[_c('md-icon',[_vm._v("delete")])],1)],1)]):_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"md-input-focused md-input-container"},[_c('GmapAutocomplete',{ref:"search",staticClass:"md-input",attrs:{"placeholder":"","bounds":_vm.bounds},on:{"place_changed":_vm.newPlaceSelected},model:{value:(_vm.autocompleteInput),callback:function ($$v) {_vm.autocompleteInput=$$v},expression:"autocompleteInput"}})],1),_vm._v(" "),_c('div',{staticClass:"autocomplete-buttons"},[(_vm.topicsSelected)?_c('span',[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete Topic(s)"},on:{"click":function($event){_vm.confirmDelete()}}},[_c('md-icon',[_vm._v("delete")])],1)],1):_c('span',[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Add Topic"},on:{"click":_vm.addTopic}},[_c('md-icon',{staticClass:"icon-add_circle"})],1)],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"scroll-list",attrs:{"id":"scrollSize"}},[_c('span',{class:[{'checkbox' : _vm.checkTopicsinList()}, {'checkbox-disabled' : !_vm.checkTopicsinList()}]},[_c('md-checkbox',{staticClass:"checkbox",attrs:{"type":"checkbox"},on:{"change":function($event){_vm.toggleSelectAll($event)}},model:{value:(_vm.selectAllTopics),callback:function ($$v) {_vm.selectAllTopics=$$v},expression:"selectAllTopics"}},[_vm._v("Select All")])],1),_vm._v(" "),_c('md-list',{staticClass:"img-list check-avatar selectable",attrs:{"id":"topicsTabList"}},_vm._l((_vm.topics),function(topic,index){return _c('span',[_c('md-list-item',{class:[{'items-active' : _vm.topicsSelected }, {'back-grey' : topic.mapHover }],on:{"click":function($event){},"mouseover":function($event){_vm.hoverOn(index)},"mouseleave":function($event){_vm.hoverOff(index)}}},[_c('div',{class:[topic.selected ? 'item-selected' : 'item-unselected'],attrs:{"role":"button"}},[_c('div',{staticClass:"avatar s-36 material-icons  material-icons-My",on:{"click":function($event){_vm.toggleSelectedTopic(index)}}},[(topic.selected)?_c('span',[_vm._v(_vm._s(topic.positionInitial))]):_c('img',{attrs:{"src":_vm.getImageSrc(topic.avatar)}})]),_vm._v(" "),_c('div',{staticClass:"md-list-item-text",on:{"click":function($event){_vm.toggleExpand(index)}}},[_c('h3',[_vm._v(_vm._s(topic.name))]),_vm._v(" "),_c('p',{attrs:{"id":"topicAddress"}},[_vm._v(_vm._s(topic.address))])])])])],1)}))],1),_vm._v(" "),(_vm.vTopicCondition)?_c('footer',{staticClass:"aside-btn"},[_c('div',{staticClass:"btn-wrap"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.saveChanges}},[_vm._v("Save Topic Changes")])],1)]):(_vm.topicsSelected)?_c('footer',{staticClass:"aside-btn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.routesList.length > 0)),expression:"(routesList.length > 0)"}],staticClass:"btn-wrap",class:{ 'add-btn': _vm.topicsSelected > 0 && (_vm.routesList.length > 0) }},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.showDialog = true}}},[_vm._v("Add to Route")])],1),_vm._v(" "),_c('div',{staticClass:"btn-wrap",class:{ 'add-btn': _vm.topicsSelected && (_vm.routesList.length > 0) }},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.createNewRoute}},[_vm._v("Create Route")])],1)]):_vm._e(),_vm._v(" "),_c('md-dialog',{staticClass:"small-modal addToRouteDialog",attrs:{"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Add to Route")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showDialog = false}}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('md-list',{staticClass:"scroll-list"},_vm._l((_vm.routesList),function(route){return _c('md-list-item',{key:route.id},[_c('button',{staticClass:"extraClass",on:{"click":function($event){_vm.addTopicsToRoute(route)}}},[_vm._v(_vm._s(route.name))])])}))],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"scroll-cont-wrap"},_vm._l((_vm.routesNames),function(routesName,key){return _c('md-list',{key:routesName},[(key !== 'notAssigned')?_c('div',[_vm._v("\n                        If you delete the TOPIC "),_c('b',[_vm._v("'"+_vm._s(key.toUpperCase())+"'")]),_vm._v(", it will be removed from:\n                        "),_vm._l((routesName),function(routeName){return _c('md-list',{key:routeName},[_c('b',[_vm._v(" - "+_vm._s(_vm.titleCase(routeName)))])])})],2):_vm._e(),_vm._v(" "),(key == 'notAssigned' && routesName.length!== 0)?_c('div',[_vm._v("\n                        The following will be removed from the list of TOPICS:\n                        "),_vm._l((routesName),function(topicname){return _c('md-list',{key:topicname},[_c('b',[_vm._v(" - "+_vm._s(topicname.toUpperCase()))])])})],2):_vm._e()])})),_vm._v("\n            Do you want to continue with this delete request?\n            "),_c('p',{staticClass:"instruction-delete"},[_c('b',[_vm._v("o ")]),_vm._v("To continue with the delete request, click DELETE. "),_c('br'),_c('b',[_vm._v("o ")]),_vm._v("To stop the delete request, click CANCEL.")])]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.clickDeleteTopics()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EkYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    showSettings: false,
    showTriggerTabs: false
  },
  getters: {
    showSettings: function showSettings(state) {
      return state.showSettings;
    },
    showTriggerTabs: function showTriggerTabs(state) {
      return state.showTriggerTabs;
    }
  },
  mutations: {
    setShowSettings: function setShowSettings(state, show) {
      state.showSettings = show; // sets to either true or false
    },
    setShowTriggerTabs: function setShowTriggerTabs(state, show) {
      state.showTriggerTabs = show; // sets to either true or false
    }
  },
  actions: {
    toggleShowSettings: function toggleShowSettings(_ref, show) {
      var commit = _ref.commit;

      commit('setShowSettings', show);
    },
    toggleShowTriggerTabs: function toggleShowTriggerTabs(_ref2, show) {
      var commit = _ref2.commit;

      commit('setShowTriggerTabs', show);
    }
  }
});

/***/ }),

/***/ "EtkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content"},[_c('div',{staticClass:"user-form-box"},[(_vm.formError)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),(_vm.passwordResetMessage)?_c('div',{staticStyle:{"text-align":"center","color":"#00A8CA"}},[_vm._v(_vm._s('Record updated successfully!')+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-box"},[_c('md-field',{attrs:{"md-toggle-password":false}},[_c('label',[_vm._v("Old Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"blur":function($event){_vm.touchHanlder('oldPass')}},model:{value:(_vm.oldPass),callback:function ($$v) {_vm.oldPass=$$v},expression:"oldPass"}}),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"right"}},[_vm._v("Enter your current password")])],1),_vm._v(" "),(_vm.$v.oldPass.$error)?_c('div',{staticClass:"user-edit-error"},[_vm._v("Please enter your current password.")]):_vm._e(),_vm._v(" "),_c('md-field',{attrs:{"md-toggle-password":false}},[_c('label',[_vm._v("New Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"blur":function($event){_vm.touchHanlder('newPass')}},model:{value:(_vm.newPass),callback:function ($$v) {_vm.newPass=$$v},expression:"newPass"}}),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"right"}},[_vm._v("\n                    Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character\n                ")])],1),_vm._v(" "),(_vm.$v.newPass.$error)?_c('div',{staticClass:"user-edit-error"},[_vm._v("\n                Please enter a valid password (Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character).\n            ")]):_vm._e(),_vm._v(" "),_c('md-field',{attrs:{"md-toggle-password":false}},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"blur":function($event){_vm.touchHanlder('confirmPass')}},model:{value:(_vm.confirmPass),callback:function ($$v) {_vm.confirmPass=$$v},expression:"confirmPass"}}),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"right"}},[_vm._v("Confirmation must match your new password")])],1),_vm._v(" "),(_vm.$v.confirmPass.$error)?_c('div',{staticClass:"user-edit-error"},[_vm._v("Please re-enter your new password (must match your new password).")]):_vm._e(),_vm._v(" "),(!_vm.$v.$invalid)?_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.updatePassword()}}},[_vm._v("Change Password")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FIGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTourMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteLibraryItemMultiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteLibraryItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAssignableMediaForTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getLibraryAndValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getLibraryForTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSignedUrlForLibraryItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getStoryMediaForTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removeTourMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getNotificationsForTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updatePriorityLibraryStory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updatePriorityForTourMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFileWithRouteApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addLibraryFileToRouteApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updatePriorityForTopicROute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getLibrary(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/');
}

function getLibraryAndValidate(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/validate').then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('library/isValidatingOff');
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('library/setValidationResults', response.data);
  });
}

function getLibraryForTour(clientId, tourId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/tour/' + tourId);
}

function getSignedUrlForLibraryItem(clientId, libraryItemId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/media/' + libraryItemId + '/signedUrl');
}

function getAssignableMediaForTour(clientId, tourId, type) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/tour/' + tourId + '/media/' + type);
}

function getStoryMediaForTour(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + data.clientId + '/library/story/tour/' + data.tourId + '/topic/' + data.topicId + '/currentRouteId/' + data.currentRouteID);
}

function deleteLibraryItem(clientId, libraryId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/client/' + clientId + '/library/media/' + libraryId);
}

function deleteLibraryItemMultiple(clientId, libraryId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + clientId + '/library/mediaMutiple/', libraryId);
}

function addTourMedia(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + data.clientId + '/library/tour/' + data.tourId, data);
}

function removeTourMedia(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + data.clientId + '/library/tour/' + data.tourId + '/remove', data);
}

function getNotificationsForTour(tourId, clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/library/tour/' + tourId + '/notifications');
}

function addFileWithRouteApi() {
  var clientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/addFileWithRouteApi');
}

function addLibraryFileToRouteApi(libraryID) {
  var clientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + clientId + '/addLibraryFileToRouteApi', libraryID);
}

function updatePriorityLibraryStory(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/updatePriorityLibraryStory', data);
}

function updatePriorityForTourMedia(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/updatePriorityTourMedia', data);
}

function updatePriorityForTopicROute(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/updatePriorityForTopicROute', data);
}



/***/ }),

/***/ "FIJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FKP7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FVxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    $route: function $route(to, from) {
      this.circularToggle = false;
      if (to.path !== '/tour/route') {
        this.togglePencilIconSelectedAlt(false);
        this.togglePencilIconSelected(false);
      }
    }
  },
  data: function data() {
    return {
      showDeleteDialog: false,
      deleteIndexVertex: '',
      isLoadingmy: false,
      isLoading: false,
      fullPage: true,
      isHidden: false,
      showquestion: true,
      showquestiondetail: false,
      circularToggle: false,
      reportedCenter: {
        latLng: {
          lat: null,
          lng: null
        }
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoOptions: {
        disableAutoPan: true,
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      topicPositionIcon: {
        url: 'static/svg/SEGMENT/TOI@2x.svg.svg'
      },
      topicPositionIconHighlight: {
        url: 'static/svg/SEGMENT/TOI_selected@2x.svg.svg'
      },
      virtualTopicPositionIcon: {
        url: 'static/svg/SEGMENT/Floating TOI@2x.svg.svg'
      },
      virtualTopicPositionIconHighlight: {
        url: 'static/svg/SEGMENT/Floating TOI_selected@2x.svg.svg'
      },
      currentTriggerPositionIcon: {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillColor: '#FFFFFF',
        fillOpacity: 1,
        scale: 0.1,
        strokeColor: '#007789',
        strokeWeight: 3
      },
      triggerPositionIconHighlight: {
        path: 'M-200,0a200,200 0 1,0 400,0a200,200 0 1,0 -400,0',
        fillColor: '#33DDFF',
        strokeWeight: 0,
        fillOpacity: 0.8,
        scale: 0.1
      },
      triggerZonePolygon: {
        strokeWeight: 0,
        strokeColor: 'rgb(85, 192, 228)',
        fillColor: '#08a8ca',
        fillOpacity: 0.725
      },
      triggerZonePolygonComplete: {
        strokeWeight: 2.0,
        strokeColor: 'rgb(85, 192, 228)',
        fillColor: '#FFFFFF',
        fillOpacity: 0
      },
      triggerEditIcon: {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillColor: '#007789',
        fillOpacity: 1,
        scale: 0.07,
        strokeColor: '#FFFFFF',
        strokeWeight: 1
      },
      polyLine: {
        strokeColor: '#00a6c9',
        strokeWeight: 2.5
      },
      polyLineAlt: {
        strokeColor: '#8D3D2B',
        strokeWeight: 2.5
      },
      activeTab: 'homeActive',
      errorMessage: null,
      clickedval: '',
      vedioSrc: '',
      pdfSrc: '',
      choice: 'homeActive',
      listPanel: true,
      vedioPanel: false,
      pdfPanel: false,
      topicAllCheck: [],
      topicAllChecks: [],
      UserManualList: [{
        id: '',
        attachment_name: '',
        type: '',
        path: ''
      }],
      isActive: '',
      resizeWidth: '60%',
      resizeHight: '60%',
      supportEmail: 'support@listentech.com',
      webSiteSupport: 'https://www.listentech.com/support/'
    };
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
    routerPathName: function routerPathName(state) {
      return state.RouterModule.name;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['currentUser']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('map', ['pencilIconSelected', 'pencilIconSelectedAlt', 'center']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('topics', ['currentTopic', 'topicsList']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('routes', ['routesListLength', 'routesList', 'currentRoute', 'currentRouteAlt', 'vertexToRemove']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('triggers', ['triggersList', 'currentTrigger', 'headingEnabled']), {
    showTriggers: function showTriggers() {
      var _this = this;

      var possibleRoutes = ['TopicTriggers', 'TopicNotes', 'TriggerSettings', 'TriggerNotes', 'Route'];
      return possibleRoutes.findIndex(function (element) {
        return element === _this.routerPathName;
      }) >= 0;
    },
    headingRadiusHandlePosition: function headingRadiusHandlePosition() {
      var latLng = new google.maps.LatLng({ lat: parseFloat(this.currentTrigger.latLng.lat), lng: parseFloat(this.currentTrigger.latLng.lng) });
      return google.maps.geometry.spherical.computeOffset(latLng, this.currentTrigger.radiusDistance, parseFloat(this.currentTrigger.heading) + 180);
    },
    tolerancePosition: function tolerancePosition() {
      var toleranceHeading = parseFloat(this.currentTrigger.heading) + 180 - parseFloat(this.currentTrigger.tolerance) / 2;
      var baselatLng = new google.maps.LatLng(this.getParsedTriggerLatLng(this.currentTrigger));
      return google.maps.geometry.spherical.computeOffset(baselatLng, this.currentTrigger.radiusDistance, toleranceHeading);
    },
    routeEditingEnabled: function routeEditingEnabled() {
      var editingEnabled = false;
      if (this.routerPathName === 'Route') {
        if (this.pencilIconSelected) {
          editingEnabled = true;
        }
      }
      return editingEnabled;
    },
    routeEditingEnabledAlt: function routeEditingEnabledAlt() {
      var editingEnabledAlt = false;
      if (this.routerPathName === 'Route') {
        if (this.pencilIconSelectedAlt) {
          editingEnabledAlt = true;
        }
      }
      return editingEnabledAlt;
    },
    virtualTopicsMoveable: function virtualTopicsMoveable() {
      var moveable = false;
      if (this.routerPathName === 'TopicsTab') {
        moveable = true;
      }
      return moveable;
    },
    showRoutePath: function showRoutePath() {
      return this.routerPathName !== 'TopicsTab' && this.routerPathName !== 'RoutesTab';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('editor', ['toggleShowTriggerTabs']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('topics', ['loadEditorTopic', 'setMapHover']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('triggers', ['setMapHoverTrigger', 'updateCurrentTriggerLatLng', 'setCurrentTrigger', 'updateCurrentTriggerHeadingRadius', 'updateCurrentTriggerTolerance']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('routes', ['addCurrentPath', 'setUpdateCheck', 'setVertex', 'addCurrentPathAlt', 'setUpdateCheckAlt', 'setVertexAlt']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('map', ['togglePencilIconSelected', 'togglePencilIconSelectedAlt', 'setBounds', 'setBoundsAlt']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('user', ['setUserToEdit']), {
    makeActive: function makeActive(val) {
      if (val === 'homeActive' && this.activeTab !== 'homeActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'homeActive';
      }
      if (val === 'infoActive' && this.activeTab !== 'infoActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'infoActive';
      }
      if (val === 'faqActive' && this.activeTab !== 'faqActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'faqActive';
      }
      this.choice = val;
    },
    maxWindow: function maxWindow() {
      this.$modal.hide('hello-world');
      this.$modal.show('hello-world2');
    },
    minWindow: function minWindow() {
      this.$modal.show('hello-world');
      this.$modal.hide('hello-world2');
    },
    maxDo: function maxDo() {
      this.$modal.hide('hello-world');
      this.resizeWidth = '100%';
      this.resizeHight = '100%';
      this.$modal.show('hello-world');
    },
    showVideoPdf: function showVideoPdf() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$modal.show('hello-world');
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__["m" /* getUserManual */])();

              case 3:
                result = _context.sent;

                _this2.UserManualList = result.data;
                _this2.vedioPanel = false;
                _this2.pdfPanel = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    closeshowVideoPdf: function closeshowVideoPdf() {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
    },
    showVedio: function showVedio(id) {
      window.open('#/usermanual/video?' + id, '_blank');
    },
    showPdf: function showPdf(id) {
      window.open('#/usermanual/pdf?' + id, '_blank');
    },
    showfaq: function showfaq(detailfaq) {
      this.showquestion = false;
      this.showquestiondetail = true;
      this.detailinfo = detailfaq;
    },
    showfaqs: function showfaqs(detailfaq) {
      this.showquestion = true;
      this.showquestiondetail = false;
      this.detailinfo = detailfaq;
    },
    backList: function backList() {
      this.listPanel = true;
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.pdfSrc = '';
      this.vedioSrc = '';
    },

    isActiveTab: function isActiveTab(val) {
      return this.choice === val;
    },
    toggleInfoWindow: function toggleInfoWindow(marker, index, toggle, center) {
      if (center) {
        this.$store.dispatch('map/setCenter', marker);
      } else {
        if (marker.orderInRoute) {
          this.$bus.$emit('scrollList', { topicIndex: marker.orderInRoute - 1, toggle: toggle });
        } else {
          this.$bus.$emit('scrollList', { topicIndex: index, toggle: toggle });
        }
      }
      this.infoWinOpen = false;
      this.infoWindowPos = marker.latLng;
      this.infoContent = marker.name;
      this.infoWinOpen = toggle;
      this.setMapHover([index, toggle]);
    },
    toggleInfoWindowNew: function toggleInfoWindowNew(trigger, index, toggle, center) {
      if (center) {
        this.$store.dispatch('map/setCenter', trigger);
      }
      this.infoWinOpen = false;
      this.infoWindowPos = trigger.latLng;

      this.infoContent = 'Length - ' + trigger.file_length;
      if (trigger.file_length) {
        this.infoWinOpen = toggle;
      }
      this.setMapHoverTrigger([index, toggle]);
    },
    toggleRouteCircular: function toggleRouteCircular(status) {
      var _this3 = this;

      this.isLoadingmy = true;
      setTimeout(function () {
        if (status === true) {
          _this3.circularToggle = false;
        } else {
          _this3.circularToggle = true;
        }
        _this3.isLoadingmy = false;
      }, 0);
    },
    closeBox: function closeBox() {
      this.infoWinOpen = false;
    },

    /*
                When the user clicks on the map, createPath is ran.
                It checks if clickHandler is true, which will determine if the user is at the TourRoute.vue component.
                It then checks if this is a new route with no path. If it is, it just assigns it an empty array value.
                It takes the currentRoute path, and adds the new vertice (e) to the path variable.
                  */
    createPath: function createPath(e) {
      if (this.routeEditingEnabled) {
        var currentRoutePath = this.currentRoute.path;
        if (currentRoutePath === null) {
          currentRoutePath = [];
        }
        currentRoutePath.push({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        this.addCurrentPath(currentRoutePath);
        this.setUpdateCheck(true);
        var listLength = this.routesListLength - 1;
        if (this.routesList[listLength].path === null || this.routesList[listLength].path === '') {
          this.routesList[listLength].path = [];
        }
        // this.routesList[listLength].path.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
      } else {
        this.createPathAlt(e);
      }
    },
    createPathAlt: function createPathAlt(e) {
      if (this.routeEditingEnabledAlt) {
        var currentRoutePathAlt = this.currentRouteAlt.alt_path;
        if (currentRoutePathAlt === null || currentRoutePathAlt === '') {
          currentRoutePathAlt = [];
        }
        currentRoutePathAlt.push({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        this.addCurrentPathAlt(currentRoutePathAlt);
        this.setUpdateCheckAlt(true);
        var listLength = this.routesListLength - 1;
        if (this.routesList[listLength].alt_path === null || this.routesList[listLength].alt_path === '') {
          this.routesList[listLength].alt_path = [];
        }
        // this.routesList[listLength].alt_path.push({lat: e.latLng.lat(), lng: e.latLng.lng()});
      }
    },
    gettingBounds: function gettingBounds() {
      this.setBounds(this.$refs.map.$mapObject.getBounds());
    },
    gettingBoundsAlt: function gettingBoundsAlt() {
      this.setBoundsAlt(this.$refs.map.$mapObject.getBoundsAlt());
    },

    /*
                When the center is changed on the map, newCenter is ran.
                It takes the new center coordinates (e), and dispatches it to the state to save it.
                  */
    updateCenter: function updateCenter(e) {
      this.reportedCenter.latLng.lat = e.lat();
      this.reportedCenter.latLng.lng = e.lng();
    },
    saveCenter: function saveCenter() {
      this.$store.dispatch('map/setCenter', this.reportedCenter);
    },


    /*
                When a virtual topic (virtual marker) is moved, updatePoints is ran.
                The new coordinates (e) is saved as the new coordinates for the virtual marker (virtual).
                Then a dispatch to topicsModule happens to assign true to virtualTopicCondition.
                This variable determines when a virtual marker is moved, and the change can be saved.
                  */
    updatePoints: function updatePoints(e, virtual) {
      virtual.latLng.lat = e.latLng.lat();
      virtual.latLng.lng = e.latLng.lng();
      this.$store.dispatch('topics/toggleVirtualConditional', true);
      return virtual;
    },


    /*
                When a path is moved/edited, updatePath is ran. The new path (e) is saved,
                then is sent to routesModule to overwrite the previous currentRoute.
                After, setUpdateCheck is run to set the updateCheck condition to true. This lets the application
                know that a change has happened, and will make the Save button availible.
                  */
    updatePath: function updatePath(e) {
      if (this.routeEditingEnabled) {
        var currentRoutePath = [];
        for (var i = 0; i < e.getLength(); i++) {
          currentRoutePath.push({ lat: e.getAt(i).lat(), lng: e.getAt(i).lng() });
        }
        this.addCurrentPath(currentRoutePath);
        this.setUpdateCheck(true);
      }
    },
    updatePathAlt: function updatePathAlt(e) {
      if (this.routeEditingEnabledAlt) {
        var currentRoutePathAlt = [];
        for (var i = 0; i < e.getLength(); i++) {
          currentRoutePathAlt.push({ lat: e.getAt(i).lat(), lng: e.getAt(i).lng() });
        }
        this.addCurrentPathAlt(currentRoutePathAlt);
        this.setUpdateCheckAlt(true);
      }
    },
    clickDeleteNode: function clickDeleteNode(event) {
      if (this.routeEditingEnabled && !(event.vertex === undefined)) {
        var latLng = new google.maps.LatLng({ lat: this.currentRoute.path[event.vertex].lat, lng: this.currentRoute.path[event.vertex].lng });
        var map = this.$refs.map.$mapObject;
        var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        var point = new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale); // google maps pixel location
        point.x += 302;
        point.y -= 38;
        var deleteBox = document.getElementById('vertex-delete-parent');
        deleteBox.style.left = point.x + 'px';
        deleteBox.style.top = point.y + 'px';
        this.setVertex(event.vertex);
      }
    },
    clickDeleteNodeAlt: function clickDeleteNodeAlt(event) {
      if (this.routeEditingEnabledAlt && !(event.vertex === undefined)) {
        var latLng = new google.maps.LatLng({ lat: this.currentRouteAlt.alt_path[event.vertex].lat, lng: this.currentRouteAlt.alt_path[event.vertex].lng });
        var map = this.$refs.map.$mapObject;
        var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        var point = new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale); // google maps pixel location
        point.x += 302;
        point.y -= 38;
        var deleteBox = document.getElementById('vertex-delete-parentAlt');
        deleteBox.style.left = point.x + 'px';
        deleteBox.style.top = point.y + 'px';
        this.setVertex(event.vertex);
      }
    },
    deleteVertex: function deleteVertex() {
      var currentRoutePath = this.currentRoute.path;
      currentRoutePath.splice(this.deleteIndexVertex, 1);
      this.addCurrentPath(currentRoutePath);
      this.setUpdateCheck(true);
      this.setVertex(null);
      this.showDeleteDialog = false;
    },
    deleteVertexAlt: function deleteVertexAlt() {
      var currentRoutePathAlt = this.currentRoute.alt_path;
      currentRoutePathAlt.splice(this.deleteIndexVertex, 1);
      this.addCurrentPathAlt(currentRoutePathAlt);
      this.setUpdateCheckAlt(true);
      this.setVertexAlt(null);
      this.showDeleteDialog = false;
    },
    confirmDelete: function confirmDelete() {
      this.deleteIndexVertex = this.vertexToRemove;
      this.showDeleteDialog = true;
    },
    removeDeleteVertexBox: function removeDeleteVertexBox() {
      this.setVertex(null);
    },
    removeDeleteVertexBoxAlt: function removeDeleteVertexBoxAlt() {
      this.setVertex(null);
    },
    currentTriggerCheck: function currentTriggerCheck(trigger) {
      var isCurrent = false;
      if (this.currentTrigger.id) {
        if (trigger.id === this.currentTrigger.id) {
          isCurrent = true;
        }
      }
      return isCurrent;
    },
    updateTriggerPoints: function updateTriggerPoints(e) {
      var newLatLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      };
      this.updateCurrentTriggerLatLng(newLatLng);
    },

    // Opens sidebar settings for a trigger zone when it's map icon is clicked
    loadTriggerSettings: function loadTriggerSettings(trigger, index) {
      this.circularToggle = false;
      // This initial if/else block checks to see if a current topic is set and if
      // it is the parent topic for the trigger zone selected, if not it sets the current topic
      var topic = null;
      if (this.currentTopic.id) {
        if (this.currentTopic.id !== trigger.toiId) {
          topic = this.getTopic(trigger.toiId);
        }
      } else {
        topic = this.getTopic(trigger.toiId);
      }
      if (topic !== null) {
        this.loadEditorTopic(topic);
      }

      this.setCurrentTrigger(trigger);
      this.toggleShowTriggerTabs(true);
      this.$router.push('/tour/trigger');
    },

    // Helper function for loadTriggerSettings
    getTopic: function getTopic(topicId) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.topicsList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var topic = _step.value;

          if (topic.id === topicId) {
            return topic;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    },
    topicMarkerIcon: function topicMarkerIcon(topic) {
      if (topic.isReal === 0) {
        if (topic.selected || topic.id === this.currentTopic.id) {
          return this.virtualTopicPositionIconHighlight;
        }
        if (topic.hover || topic.mapHover) {
          return this.virtualTopicPositionIconHighlight;
        } else {
          return this.virtualTopicPositionIcon;
        }
      } else if (topic.isReal === 1) {
        if (topic.selected || topic.id === this.currentTopic.id) {
          return this.topicPositionIconHighlight;
        }
        if (topic.hover || topic.mapHover) {
          return this.topicPositionIconHighlight;
        } else {
          return this.topicPositionIcon;
        }
      }
    },
    generateTriggerPolygonPaths: function generateTriggerPolygonPaths(trigger) {
      var polyPoints = [];
      var deltaHeading = parseFloat(Math.round(trigger.tolerance)) / 2 / 50;
      var baselatLng = this.getParsedTriggerLatLng(trigger);

      polyPoints.push(baselatLng); // push in the base point first
      for (var ctr = 0; ctr <= 100; ctr++) {
        var polyPointHeading = parseFloat(trigger.heading) + 180 - parseFloat(Math.round(trigger.tolerance)) / 2 + deltaHeading * ctr;
        var latLng = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(baselatLng), parseFloat(trigger.radiusDistance), polyPointHeading);
        polyPoints.push({ lat: latLng.lat(), lng: latLng.lng() });
      }
      return polyPoints;
    },
    generateTriggerPolygonPathsComplete: function generateTriggerPolygonPathsComplete(trigger) {
      var polyPoints = [];
      var deltaHeading = parseFloat(Math.round(trigger.tolerance)) / 2 / 50;
      var baselatLng = this.getParsedTriggerLatLng(trigger);

      polyPoints.push(baselatLng); // push in the base point first
      for (var ctr = 100; ctr <= 36000; ctr++) {
        var polyPointHeading = parseFloat(trigger.heading) + 180 - parseFloat(Math.round(trigger.tolerance)) / 2 + deltaHeading * ctr;
        var latLng = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(baselatLng), parseFloat(trigger.radiusDistance), polyPointHeading);
        polyPoints.push({ lat: latLng.lat(), lng: latLng.lng() });
      }
      return polyPoints;
    },
    getParsedTriggerLatLng: function getParsedTriggerLatLng(trigger) {
      return { lat: parseFloat(trigger.latLng.lat), lng: parseFloat(trigger.latLng.lng) };
    },
    headingArrowShape: function headingArrowShape(trigger) {
      var heading = parseFloat(trigger.heading);
      var icon = {};
      if (isNaN(heading)) {
        heading = 0.00;
      } else {
        icon = {
          path: 'm0.19672,-15.70492l-7.5,18.29l0.71,0.71l6.79,-3l6.79,3l0.71,-0.71l-7.5,-18.29z',
          fillOpacity: 1,
          strokeWeight: 1,
          scale: 1.4
        };
        if (this.currentTriggerCheck(trigger)) {
          icon.strokeColor = '#007789';
          icon.rotation = parseFloat(this.currentTrigger.heading);
        } else {
          icon.strokeColor = '#FFFFFF';
          icon.rotation = heading;
        }
        if (trigger.toiId === this.currentTopic.id) {
          icon.fillColor = '#007789';
        } else {
          icon.fillColor = '#00a6c9';
        }
      }
      return icon;
    },
    updateHeadingRadius: function updateHeadingRadius(e) {
      var newLatLng = new google.maps.LatLng({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      var currentlatLng = new google.maps.LatLng({ lat: parseFloat(this.currentTrigger.latLng.lat), lng: parseFloat(this.currentTrigger.latLng.lng) });

      var newRadius = google.maps.geometry.spherical.computeDistanceBetween(currentlatLng, newLatLng);
      newRadius = Math.round(newRadius * 100) / 100;

      var newHeading = 0;
      if (this.headingEnabled) {
        newHeading = google.maps.geometry.spherical.computeHeading(currentlatLng, newLatLng);
        newHeading = (newHeading + 180) % 360;
        newHeading = Math.round(newHeading * 100) / 100;
      } else {
        newHeading = parseFloat(this.currentTrigger.heading);
      }

      this.updateCurrentTriggerHeadingRadius({ heading: String(newHeading), radius: newRadius });
    },
    updateTolerance: function updateTolerance(e) {
      var newLatLng = new google.maps.LatLng({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      var currentBaselatLng = new google.maps.LatLng(this.getParsedTriggerLatLng(this.currentTrigger));

      var newToleranceHeading = google.maps.geometry.spherical.computeHeading(currentBaselatLng, newLatLng);
      var currentHeading = (parseFloat(this.currentTrigger.heading) + 180) % 360;
      var newTolerance = (Math.abs(newToleranceHeading - currentHeading) + 360) % 360;

      newTolerance = newTolerance * 2;
      newTolerance = Math.round(newTolerance * 100) / 100;

      this.updateCurrentTriggerTolerance(newTolerance);
    },
    toggleRouteEditing: function toggleRouteEditing(toggle) {
      this.togglePencilIconSelected(toggle);
      this.togglePencilIconSelectedAlt(false);
    },
    toggleRouteEditingAlt: function toggleRouteEditingAlt(toggle) {
      this.togglePencilIconSelectedAlt(toggle);
      this.togglePencilIconSelected(false);
    },
    triggerPositionIcon: function triggerPositionIcon(trigger) {
      var icon = {
        path: 'M-100,0a100,100 0 1,0 200,0a100,100 0 1,0 -200,0',
        fillOpacity: 1,
        scale: 0.1,
        strokeColor: '#FFFFFF',
        strokeWeight: 1.5
      };

      if (trigger.toiId === this.currentTopic.id) {
        icon.fillColor = '#007789';
      } else {
        icon.fillColor = '#00a6c9';
      }

      return icon;
    },
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    }
  }),
  beforeMount: function beforeMount() {
    if (this.topicsList.length !== 0) {
      this.isLoading = true;
      for (var index = 0; index < this.topicsList.length; index++) {
        var element = this.topicsList[index].id;
        this.topicAllCheck.push(element);
        this.isLoading = false;
      }
    }
    if (this.topicsList.length !== 0) {
      this.isLoading = true;
      for (var _index = 0; _index < this.topicsList.length; _index++) {
        var elements = this.topicsList[_index].id;
        this.topicAllChecks.push(elements);
        this.isLoading = false;
      }
    }
    if (this.topicsList.length === 0) {
      this.isLoading = false;
    }
    this.$bus.$off('hoveredTopic');
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$bus.$on('hoveredTopic', function ($params) {
      _this4.toggleInfoWindow(_this4.topicsList[$params.topicIndex], $params.topicIndex, $params.toggle, true);
    });
    this.togglePencilIconSelectedAlt(false);
    this.togglePencilIconSelected(false);
  }
});

/***/ }),

/***/ "Fedb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getClientList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRoutes; });
/* unused harmony export newTour */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return toursExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return saveNewClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return saveNewClientContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getUserManualVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteUsermanual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteUsermanualfaq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUserManualPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getUserManualfaq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getUserManual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateUsermnualList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return exportAllUserService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUserManualById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkReleaseExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToursCopyRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return releaseStatusUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUserActivityDetails; });
/* unused harmony export checkUrlExist */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkRouteIsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return enableClientForInCoTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return multipleDownloadFunction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");



var toursExport = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var currentClientId;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentClientId = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id;
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_axios___default()({
              method: 'post',
              url: 'api/client/' + currentClientId + '/exportTours',
              responseType: 'arraybuffer',
              data: payload
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].dispatch('tours/exportRunningOff');
              console.log(error);
            }));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function toursExport(_x) {
    return _ref.apply(this, arguments);
  };
}();





function getClientList(search) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/clients/' + search);
}

function getClient(clientId) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + clientId);
}

function getTopics(tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + currentClientId + '/getTopics/' + tourId);
}

function getRoutes(tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + currentClientId + '/getRoutes/' + tourId);
}

function addToursCopyRoute() {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + currentClientId + '/getAllToursForCopy');
}

function checkRouteIsComplete(routeID, tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/checkRouteIsComplete/', {
    clientIdCurrent: currentClientId,
    routeID: routeID,
    tourId: tourId
  });
  // return axios.get('api/client/' + currentClientId + '/checkRouteIsComplete/' + routeID);
}

function getUserManual() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/getUserManual');
}

function getUserManualVideo() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/getUserManualVideo');
}

function deleteUsermanual(usermanualId) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/deleteUsermanual/', { usermanualId: usermanualId });
}

function deleteUsermanualfaq(usermanualId) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/deleteUsermanualfaq/', { usermanualId: usermanualId });
}

function getUserManualPdf() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/getUserManualPdf');
}

function getUserManualfaq() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/getUserManualfaq');
}

function getUserActivityDetails(clientIdCurrent) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/getUserActivityDetails/', { clientIdCurrent: clientIdCurrent });
}

function enableClientForInCoTour(allEnableClinetId, allClientID, arrayForUserLimit) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/enableClientForInCoTour/', {
    allEnableClinetId: allEnableClinetId,
    allClientID: allClientID,
    arrayForUserLimit: arrayForUserLimit
  });
}

function checkUrlExist(urlckeck) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/checkUrlExist', { currentUrlCheck: urlckeck });
}

function multipleDownloadFunction(urlckeck) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/multipleDownloadFunction', { library_data: urlckeck });
}

function newTour() {
  var tour = {
    card: '',
    city: '',
    clientId: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.client.currentClient.id,
    defaultActivate: 'Proximity',
    defaultDelay: '0',
    defaultRadiusDistance: '40',
    defaultTolerance: '60',
    description: '',
    id: '',
    name: '',
    systemId: ''
  };
  __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].dispatch('tours/loadNewTour', tour);
}

function exportAllUserService() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/exportAllUserService');
}

function saveNewClient(newClient) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client', { newClient: newClient });
}

function saveNewClientContact(newClient, newContacts) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/clientandcontact', { newClient: newClient, newContacts: newContacts });
}

function updateUsermnualList(userManualLists) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/client/updateSequence', { userManualList: userManualLists });
}

function getUserManualById(userManualLists) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + userManualLists + '/getUserManualById');
}

function updateClient(client) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('api/client/' + client.id, { client: client });
}

function checkReleaseExist(UserId) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/releaseExist/user/' + UserId);
}

function releaseStatusUpdate(releaseData) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/releaseStatusUpdate/', { releaseData: releaseData });
}



/***/ }),

/***/ "Fi+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_UserService_js__ = __webpack_require__("+q4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__ = __webpack_require__("4kyh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function newPassConfirmed(value) {
  return value === this.newPass;
}

function uniqueNewPass(value) {
  return value !== this.oldPass;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      oldPass: '',
      newPass: '',
      confirmPass: '',
      formError: null,
      passwordResetMessage: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['initialUser'])),
  methods: {
    touchHanlder: function touchHanlder(key) {
      if (!this.$v[key].$dirty) {
        this.$v[key].$touch();
      }
    },
    updatePassword: function updatePassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = _this.initialUser;

                user.oldPass = _this.oldPass;
                user.newPass = _this.newPass;
                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["updateUser"])(user).then(function (response) {
                  _this.oldPass = '';
                  _this.newPass = '';
                  _this.confirmPass = '';
                  _this.formError = null;
                  _this.$v.$reset();
                  _this.passwordResetMessage = true;
                  setTimeout(function () {
                    _this.passwordResetMessage = false;
                  }, 4000);
                }).catch(function (error) {
                  if (error.response.data.type === 'INCORRECT_PASS') {
                    _this.formError = error.response.data.message;
                  }
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  validations: {
    oldPass: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
      notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]

    },
    newPass: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
      notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minLength"])(8),
      uniqueNewPass: uniqueNewPass,
      validPassword: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["c" /* validPassword */]
    },
    confirmPass: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
      notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
      newPassConfirmed: newPassConfirmed
    }
  }
});

/***/ }),

/***/ "HQCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-settings"},[_c('div',{staticClass:"tour-settings-content"},[_c('md-button',{staticClass:"md-icon-button close-tour-settings",on:{"click":function($event){_vm.toggleShowSettings(false), _vm.closeSaveButton()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_c('md-tabs',{staticClass:"centered-title",attrs:{"md-border-bottom":"","md-dynamic-height":""}},[_c('md-tab',{attrs:{"md-label":"Preferences"}},[(_vm.recordUpdateSucc)?_c('p',{staticStyle:{"color":"green","position":"fixed","float":"right","right":"6%"}},[_vm._v("Record updated successfully!")]):_vm._e(),_vm._v(" "),((_vm.routeSettingsChanged && !_vm.$v.currentRoute.$invalid) || _vm.forcommentaryNotification)?_c('md-button',{staticClass:"md-raised md-primary",staticStyle:{"color":"green","position":"fixed","float":"right","right":"6%","margin-top":"10px"},on:{"click":function($event){_vm.clickSaveRouteSettings()}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('md-content',[_c('div',{staticClass:"wrap"},[_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('h2',{staticClass:"section-title"},[_vm._v("Route Settings ")])]),_vm._v(" "),_c('div',{staticClass:"col-8 align-col"},[_c('div',{staticClass:"row bottom-spacer"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Commentary Notification")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("Notifies passengers commentary will begin")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Notification Sound")])])]),_vm._v(" "),_c('div',{staticClass:"row notification-sound-row"},[_c('div',{staticClass:"col-8"},[_c('md-field',[(_vm.tourNotifications.length > 0)?_c('md-select',{staticClass:"half-field",attrs:{"placeholder":"Select a notification sound...","id":"notificationSelect"},model:{value:(_vm.currentRoute.notificationSongId),callback:function ($$v) {_vm.$set(_vm.currentRoute, "notificationSongId", $$v)},expression:"currentRoute.notificationSongId"}},_vm._l((_vm.tourNotifications),function(notification,index){return _c('md-option',{key:index,attrs:{"value":notification.id}},[_vm._v(_vm._s(notification.friendly_name))])})):_c('div',[_c('h3',[_vm._v("No notification sounds available.")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4 setting-col"},[_c('md-switch',{attrs:{"value":true},on:{"change":function($event){_vm.toggleNotificationSound($event)}},model:{value:(_vm.soundToggle),callback:function ($$v) {_vm.soundToggle=$$v},expression:"soundToggle"}})],1)]),_vm._v(" "),(_vm.$v.currentRoute.notificationSongId.$invalid && _vm.currentRoute.notificationSound === 1)?_c('div',{staticClass:"row settings-form-error"},[_c('div',{staticClass:"col-8"},[_vm._v("\n                                            Notifications are enabled, a notification sound must be selected.\n                                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row bottom-spacer"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Commentary Delay")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("The delay between the notification and when the commentary begins. (1s to 9s)")])]),_vm._v(" "),_c('div',{staticClass:"col-4 setting-col"},[_c('md-field',{staticClass:"small-field",attrs:{"md-counter":false,"md-no-float":""}},[_c('md-input',{attrs:{"maxlength":"1"},model:{value:(_vm.currentRoute.commentaryDelay),callback:function ($$v) {_vm.$set(_vm.currentRoute, "commentaryDelay", $$v)},expression:"currentRoute.commentaryDelay"}})],1)],1)]),_vm._v(" "),(_vm.$v.currentRoute.commentaryDelay.$invalid)?_c('div',{staticClass:"row settings-form-error"},[_c('div',{staticClass:"col-8"},[_vm._v("\n                                            Please enter a valid number between 1 and 9\n                                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row bottom-spacer"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Seatback Notification")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("*Only visible for the Navilution Evo system.")])]),_vm._v(" "),_c('div',{staticClass:"col-4 setting-col"},[_c('md-switch',{attrs:{"value":true},on:{"change":function($event){_vm.toggleSeatbackNotification($event)}},model:{value:(_vm.seatbackToggle),callback:function ($$v) {_vm.seatbackToggle=$$v},expression:"seatbackToggle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Seatback Illumination Notification")]),_vm._v(" "),_c('p',{staticClass:"light"},[_vm._v("Seatback LED flash. (2s to 9s)")])]),_vm._v(" "),_c('div',{staticClass:"col-4 setting-col"},[_c('md-field',{staticClass:"small-field",attrs:{"md-counter":false,"md-no-float":""}},[_c('md-input',{attrs:{"maxlength":"1"},model:{value:(_vm.currentRoute.audioControllerFlashTime),callback:function ($$v) {_vm.$set(_vm.currentRoute, "audioControllerFlashTime", $$v)},expression:"currentRoute.audioControllerFlashTime"}})],1)],1)]),_vm._v(" "),(_vm.$v.currentRoute.audioControllerFlashTime.$invalid)?_c('div',{staticClass:"row settings-form-error"},[_c('div',{staticClass:"col-8"},[_vm._v("\n                                            Please enter a valid number between 2 and 9\n                                        ")])]):_vm._e()])])])])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HV5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_UserService_js__ = __webpack_require__("+q4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__ = __webpack_require__("4kyh");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function uniqueEmail(value) {
  var contacts = this.newUsers;
  var matches = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(contacts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var contact = _step.value;

      if (contact.email) {
        if (contact.email.toLowerCase() === value.toLowerCase()) {
          matches = matches + 1;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return matches <= 1;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newUsers: [{
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        clientId: [],
        isAdmin: false,
        isSuperAdmin: false,
        isPrimaryContact: false
      }],
      formError: null,
      showDialog: false,
      showDialogForUserLimit: false,
      validationErrors: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['clientActive', 'clientList', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['isSuperAdmin']), {
    hasMultipleUsers: function hasMultipleUsers() {
      return this.newUsers.length > 1;
    }
  }),
  methods: {
    setUserAsAdmin: function setUserAsAdmin(index) {
      var newUsers = this.newUsers;
      if (newUsers[index].isSuperAdmin) {
        newUsers[index].isAdmin = true;
      }
      this.newUsers = newUsers;
    },
    userTouchHanlder: function userTouchHanlder(index, key) {
      if (!this.$v.newUsers.$each[index][key].$dirty) {
        this.$v.newUsers.$each[index][key].$touch();
      }
    },
    cancelAddUser: function cancelAddUser() {
      this.$router.push('/settings/users');
    },
    addUser: function addUser() {
      var newUser = {
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isAdmin: false,
        isSuperAdmin: false,
        isPrimaryContact: false
      };
      if (this.clientActive) {
        newUser.clientId = this.currentClient.id;
      } else {
        newUser.clientId = null;
      }
      this.validationErrors = [];
      this.newUsers.push(newUser);
    },
    deleteUser: function deleteUser(index) {
      // remove the validations from the deleted user
      var validationErrors = this.validationErrors;

      if (validationErrors['newUsers.' + index + '.firstName']) {
        delete validationErrors['newUsers.' + index + '.firstName'];
        delete validationErrors['newUsers.' + index + '.lastName'];
        delete validationErrors['newUsers.' + index + '.email'];
        delete validationErrors['newUsers.' + index + '.directPhone'];
        delete validationErrors['newUsers.' + index + '.title'];
      }

      this.validationErrors = validationErrors;

      if (this.newUsers[index].isPrimaryContact) {
        if (index === 0) {
          this.newUsers[1].isPrimaryContact = true;
        } else {
          this.newUsers[0].isPrimaryContact = true;
        }
      }

      this.newUsers.splice(index, 1);
    },
    closeDialogForUserLimit: function closeDialogForUserLimit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showDialogForUserLimit = false;

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clickSaveNewUser: function clickSaveNewUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showDialog = true;
                _this2.validationErrors = [];
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_UserService_js__["saveNewUsers"])(_this2.newUsers).then(function (response) {
                  if (response.data === 0) {
                    _this2.showDialog = false;
                    _this2.showDialogForUserLimit = true;
                  } else {
                    _this2.$router.push('/settings/users');
                    _this2.showDialog = false;
                  }
                }).catch(function (error) {
                  _this2.formError = '';
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    _this2.formError = error.response.data.message;
                  }

                  if (error.response.data.errors) {
                    _this2.validationErrors = error.response.data.errors;
                  }

                  _this2.showDialog = false;
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  validations: {
    newUsers: {
      $each: {
        firstName: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */]
        },
        lastName: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */]
        },
        title: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */]
        },
        email: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["email"],
          uniqueEmail: uniqueEmail
        },
        directPhone: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */],
          validPhoneNumber: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["d" /* validPhoneNumber */]
        },
        officePhone: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */],
          validPhoneNumber: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["d" /* validPhoneNumber */]
        },
        clientId: {
          required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.clientActive) {
      this.newUsers[0].clientId = this.currentClient.id;
    }
  }
});

/***/ }),

/***/ "Hqu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouteFigure_vue__ = __webpack_require__("YBbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a95c32d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouteFigure_vue__ = __webpack_require__("g4iZ");
function injectStyle (ssrContext) {
  __webpack_require__("Lcx2")
  __webpack_require__("bdgJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouteFigure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a95c32d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouteFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hu7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I8BZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      chart: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('analytics', { analytics: 'analytics', colors: 'getColors', isLoading: 'isLoading' })),
  methods: {
    redrawChart: function redrawChart(data) {
      if (this.chart) {
        this.chart.chart.data = data;
      }
    },
    toggleLanguage: function toggleLanguage($language) {},
    drawChart: function drawChart(data) {
      var dataTable = new google.visualization.DataTable();
      var rows = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;

          dataTable.addColumn('number', line.name);
          rows.push(line.data);
          dataTable.addRows(line.data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var options = {
        curveType: 'function'
      };

      var chart = new google.visualization.LineChart(document.getElementById('chart'));
      chart.draw(dataTable, options);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.chart = _this.$refs.chart;

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "IbK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRelease_vue__ = __webpack_require__("bOGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6a6d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRelease_vue__ = __webpack_require__("ad+7");
function injectStyle (ssrContext) {
  __webpack_require__("3Fbv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60d6a6d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRelease_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6a6d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRelease_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_analyticsModule__ = __webpack_require__("rN30");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_clientModule__ = __webpack_require__("VrTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_editorModule_js__ = __webpack_require__("EkYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_exportsModule_js__ = __webpack_require__("8iQc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_fileModule__ = __webpack_require__("wCeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_languageModule__ = __webpack_require__("bgO2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_libraryModule__ = __webpack_require__("CLCS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_mapModule__ = __webpack_require__("kTEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_routesModule__ = __webpack_require__("rRtF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_timezoneModule__ = __webpack_require__("xyYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_topicsModule__ = __webpack_require__("5Fdy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_toursModule__ = __webpack_require__("73Uf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_triggersModule__ = __webpack_require__("qb4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_userModule__ = __webpack_require__("cTu9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_releaseModule__ = __webpack_require__("hJG6");
/**

 Vuex state store
 Main js file for defining the Vuex store for the state for Cortex,
 used to collect and export all of the actions, mutations and modules
 as a single store for access across the app

 **/


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  namespace: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    analytics: __WEBPACK_IMPORTED_MODULE_2__modules_analyticsModule__["a" /* default */],
    client: __WEBPACK_IMPORTED_MODULE_3__modules_clientModule__["a" /* default */],
    editor: __WEBPACK_IMPORTED_MODULE_4__modules_editorModule_js__["a" /* default */],
    exports: __WEBPACK_IMPORTED_MODULE_5__modules_exportsModule_js__["a" /* default */],
    file: __WEBPACK_IMPORTED_MODULE_6__modules_fileModule__["a" /* default */],
    language: __WEBPACK_IMPORTED_MODULE_7__modules_languageModule__["a" /* default */],
    library: __WEBPACK_IMPORTED_MODULE_8__modules_libraryModule__["a" /* default */],
    map: __WEBPACK_IMPORTED_MODULE_9__modules_mapModule__["a" /* default */],
    routes: __WEBPACK_IMPORTED_MODULE_10__modules_routesModule__["a" /* default */],
    timezone: __WEBPACK_IMPORTED_MODULE_11__modules_timezoneModule__["a" /* default */],
    topics: __WEBPACK_IMPORTED_MODULE_12__modules_topicsModule__["a" /* default */],
    tours: __WEBPACK_IMPORTED_MODULE_13__modules_toursModule__["a" /* default */],
    triggers: __WEBPACK_IMPORTED_MODULE_14__modules_triggersModule__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_15__modules_userModule__["a" /* default */],
    release: __WEBPACK_IMPORTED_MODULE_16__modules_releaseModule__["a" /* default */]
  }
}));

/***/ }),

/***/ "Ihqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__ = __webpack_require__("V8i3");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      popArray: [],
      notesIndexList: [],
      showDeleteDialog: false,
      saveFlag: false,
      returnPath: '',
      noteList: [{
        id: '',
        Description: '',
        editFlag: false
      }],
      editBoxId: [],
      editTableIndex: [],
      responseError: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['notesSave', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('triggers', ['currentTrigger'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['clearUserToEdit']), {
    refreshScreen: function refreshScreen() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.notesIndexList = [];
                _this.saveFlag = false;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["n" /* triggerNotesByZone */])(_this.currentTrigger['id']);

              case 4:
                result = _context.sent;

                _this.noteList = result.data;
                _this.returnPath = _this.$store.state.RouterModule.from.fullPath;
                for (index = 0; index < _this.noteList.length; index++) {
                  _this.noteList[index]['editFlag'] = true;
                  _this.editTableIndex.push(index);
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveNotes: function saveNotes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["j" /* saveNotestrigger */])(_this2.noteList, _this2.currentTrigger['id'], _this2.currentTrigger['toiId']);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

                console.error('Could not save notes.', _context2.t0);

              case 8:
                _this2.saveFlag = false;
                _context2.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["n" /* triggerNotesByZone */])(_this2.currentTrigger['id']);

              case 11:
                result = _context2.sent;

                _this2.noteList = result.data;
                _this2.returnPath = _this2.$store.state.RouterModule.from.fullPath;
                for (index = 0; index < _this2.noteList.length; index++) {
                  _this2.noteList[index]['editFlag'] = true;
                  _this2.editTableIndex.push(index);
                }

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    add: function add() {
      this.saveFlag = true;
      this.noteList.push({
        id: '',
        Description: '',
        editFlag: true
      });
      this.notesIndexList = [];
    },
    edit: function edit(index, id) {
      this.saveFlag = true;
      this.editBoxId.push(id);
      this.editTableIndex = this.editTableIndex.filter(function (item) {
        return item !== index;
      });
      this.notesIndexList = [];
    },
    confirmRemove: function confirmRemove(note, index) {
      this.showDeleteDialog = true;
      this.note = note;
      this.index = index;
      this.notesIndexList = [];
    },
    showComplete: function showComplete(note, index) {
      if (!this.notesIndexList.includes(index)) {
        this.notesIndexList.push(index);
      } else {
        this.notesIndexList.pop(index);
      }
    },
    remove: function remove(note, index) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, index1;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.editBoxId = _this3.editBoxId.filter(function (item) {
                  return item !== index;
                });
                _this3.editTableIndex = _this3.editTableIndex.filter(function (item) {
                  return item !== index;
                });
                _this3.editTableIndex = [];
                _context3.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["d" /* deleteNotestrigger */])(note.id);

              case 5:
                _context3.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["n" /* triggerNotesByZone */])(_this3.currentTrigger['id']);

              case 7:
                result = _context3.sent;

                _this3.noteList = result.data;
                for (index1 = 0; index1 < _this3.noteList.length; index1++) {
                  _this3.noteList[index1]['editFlag'] = true;
                  _this3.editTableIndex.push(index1);
                }
                _this3.showDeleteDialog = false;
                _this3.notesIndexList = [];

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var result, index;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_4__services_TriggerService_js__["n" /* triggerNotesByZone */])(_this4.currentTrigger['id']);

            case 2:
              result = _context4.sent;

              _this4.noteList = result.data;
              _this4.returnPath = _this4.$store.state.RouterModule.from.fullPath;
              for (index = 0; index < _this4.noteList.length; index++) {
                _this4.noteList[index]['editFlag'] = true;
                _this4.editTableIndex.push(index);
              }

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ "IrxW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jg8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"triggerSettings"}},[_c('div',{staticClass:"scroll-list"},[_c('div',{staticClass:"trigger-settings"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Activate")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.currentTrigger.activate),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "activate", $$v)},expression:"currentTrigger.activate"}},[_c('md-option',{attrs:{"value":"Enter"}},[_vm._v("Enter")]),_vm._v(" "),_c('md-option',{attrs:{"value":"Exit"}},[_vm._v("Exit")]),_vm._v(" "),_c('md-option',{attrs:{"value":"Proximity"}},[_vm._v("Proximity")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Radius Distance (m)")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.currentTrigger.radiusDistance),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "radiusDistance", $$v)},expression:"currentTrigger.radiusDistance"}})],1),_vm._v(" "),(_vm.$v.currentTrigger.radiusDistance.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Radius must be number greater than 0")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('md-field',{staticClass:"md-has-value"},[_c('label',[_vm._v("Heading")]),_vm._v(" "),(_vm.headingEnabled)?_c('md-input',{model:{value:(_vm.currentTrigger.heading),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "heading", $$v)},expression:"currentTrigger.heading"}}):_c('md-input',{attrs:{"disabled":"","placeholder":"Omnidirectional","value":""}})],1),_vm._v(" "),(_vm.$v.currentTrigger.heading.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Heading must be between [0 and 360]")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Tolerance (deg)")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.currentTrigger.tolerance),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "tolerance", $$v)},expression:"currentTrigger.tolerance"}})],1),_vm._v(" "),(_vm.$v.currentTrigger.tolerance.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Tolerance must be between [30 and 360]")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Mode")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.currentTrigger.triggerMode),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "triggerMode", $$v)},expression:"currentTrigger.triggerMode"}},[_c('md-option',{attrs:{"value":"Interrupt"}},[_vm._v("Interrupt")]),_vm._v(" "),_c('md-option',{attrs:{"value":"Ignore"}},[_vm._v("Ignore")]),_vm._v(" "),_c('md-option',{attrs:{"value":"Queue"}},[_vm._v("Queue")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('md-field',{staticClass:"md-has-value"},[_c('label',[_vm._v("Delay (s)")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.currentTrigger.delay),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "delay", $$v)},expression:"currentTrigger.delay"}})],1),_vm._v(" "),(_vm.$v.currentTrigger.delay.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Delay must be a valid numeric value")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('md-field',[_c('label',[_vm._v("Latitude")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.currentTrigger.latLng.lat),callback:function ($$v) {_vm.$set(_vm.currentTrigger.latLng, "lat", $$v)},expression:"currentTrigger.latLng.lat"}})],1),_vm._v(" "),(_vm.$v.currentTrigger.latLng.lat.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Latitude must be a valid numeric value [-90 to 90]")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('md-field',[_c('label',[_vm._v("Longitude")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.currentTrigger.latLng.lng),callback:function ($$v) {_vm.$set(_vm.currentTrigger.latLng, "lng", $$v)},expression:"currentTrigger.latLng.lng"}})],1),_vm._v(" "),(_vm.$v.currentTrigger.latLng.lng.$invalid)?_c('span',{staticClass:"trigger-form-error"},[_vm._v("Longitude must be a valid numeric value [-180 to 180]")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('md-field',[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.currentTrigger.on_off),callback:function ($$v) {_vm.$set(_vm.currentTrigger, "on_off", $$v)},expression:"currentTrigger.on_off"}},[_c('md-option',{attrs:{"value":"1"}},[_vm._v("On")]),_vm._v(" "),_c('md-option',{attrs:{"value":"0"}},[_vm._v("Off")])],1)],1)],1)])])]),_vm._v(" "),(_vm.triggerEdited && !_vm.$v.currentTrigger.$invalid)?_c('footer',{staticClass:"aside-btn"},[_c('div',{staticClass:"btn-wrap"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.saveTriggerZone(_vm.currentTrigger); _vm.returnToPrevious(); _vm.toggleShowTriggerTabs();}}},[_vm._v("Save Trigger Zone")])],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JmY9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jzxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      soundToggle: false,
      seatbackToggle: false,
      commentaryNotification: false,
      checkSaveOrNot: 1,
      forcommentaryNotification: false,
      recordUpdateSucc: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('routes', ['currentRoute', 'routeSettingsChanged']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('library', ['tourNotifications'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('routes', ['saveRoute']), {
    toggleNotificationSound: function toggleNotificationSound(toggled) {
      if (toggled) {
        this.currentRoute.notificationSound = 1;
      } else {
        this.currentRoute.notificationSound = 0;
      }
    },
    closeSaveButton: function closeSaveButton() {
      this.forcommentaryNotification = false;
    },
    toggleSeatbackNotification: function toggleSeatbackNotification(toggled) {
      if (toggled) {
        this.currentRoute.audioControllerNotification = 1;
      } else {
        this.currentRoute.audioControllerNotification = 0;
      }
    },
    clickSaveRouteSettings: function clickSaveRouteSettings() {
      var _this = this;

      this.saveRoute(this.currentRoute);
      this.checkSaveOrNot = 0;
      this.currentRoute.commentary = 0;
      this.forcommentaryNotification = false;
      this.recordUpdateSucc = true;
      setTimeout(function () {
        _this.recordUpdateSucc = false;
      }, 3000);
    }
  }),
  validations: {
    currentRoute: {
      commentaryDelay: {
        minValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minValue"])(1),
        maxValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxValue"])(9),
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"]
      },
      audioControllerFlashTime: {
        minValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minValue"])(2),
        maxValue: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxValue"])(9),
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"]
      },
      notificationSongId: {
        required: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["requiredIf"])(function () {
          return this.currentRoute.notificationSound === 1;
        })
      }
    }
  },
  mounted: function mounted() {
    this.soundToggle = this.currentRoute.notificationSound === 1;
    this.seatbackToggle = this.currentRoute.audioControllerNotification === 1;
    this.commentaryNotification = this.currentRoute.commentary === 0;
    if (this.currentRoute.commentary === 1) {
      this.commentaryNotification = true;
    }
    var varForThis = this;
    this.$bus.$on('changevariableValueOfRouteSetting', function () {
      varForThis.saveRoute(varForThis.currentRoute);
      if (varForThis.checkSaveOrNot === 1) {
        //
      }
    });
  }
});

/***/ }),

/***/ "K7Pi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__("fXhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__ = __webpack_require__("Fedb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BasicSelect',
  components: {
    downloadexcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */]
  },
  data: function data() {
    return {
      returnPath: null,
      country: null,
      json_fields: {
        'FirstName': 'firstName',
        'LastName': 'lastName',
        'Email': 'email',
        'Roles': 'roles',
        'OfficePhone': 'officePhone',
        'DirectPhone': 'directPhone',
        'Cortex admin': 'isAdmin',
        'Company Name': 'companyName'
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['setUserToEdit']), {
    navToClientList: function navToClientList() {
      this.$router.push({ path: this.returnPath });
    },
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    showCurrentUserProfile: function showCurrentUserProfile() {
      this.setUserToEdit(this.currentUser);
      this.$router.push('/user');
    },
    fetchData: function fetchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__["g" /* exportAllUserService */])();

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['isAdmin', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClientName'])),
  mounted: function mounted() {
    if (this.clientActive && this.currentUser.isAdmin === 1) {
      this.returnPath = '/client/tours';
    } else {
      if (this.currentUser.isAdmin === 1) {
        this.returnPath = '/client/list';
      } else {
        this.returnPath = '/clients/switch';
      }
    }
  }
});

/***/ }),

/***/ "KQvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("vpE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec961946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("UntK");
function injectStyle (ssrContext) {
  __webpack_require__("tSaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec961946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec961946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerSettingsTab_vue__ = __webpack_require__("pu7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cfb94e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerSettingsTab_vue__ = __webpack_require__("Jg8s");
function injectStyle (ssrContext) {
  __webpack_require__("Mxtf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerSettingsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cfb94e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerSettingsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Knv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function validateUpload(filename) {
  var fileExt = filename.trim().split('.').pop().trim().toLowerCase();
  if (fileExt !== 'sql') {
    return false;
  }

  if (filename === null || filename.length === 0 || filename.length > 70) {
    return false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allOption: 0,
      currentView: '/client/analytics/audience',
      importRunning: false,
      showDialog: false,
      showWarningDialog: false,
      showClientWarningDialog: false,
      fileNames: [],
      files: [],
      percentCompleted: 0,
      dateRanges: [{ label: 'Last day', value: 1 }, { label: 'Last 7 days', value: 7 }, { label: 'Last 30 days', value: 30 }, { label: 'Last 60 days', value: 60 }, { label: 'Last 90 days', value: 90 }, { label: 'Last 690 days', value: 690 }],
      validationError: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('analytics', { analytics: 'analytics', fileResults: 'fileResults', invalidTours: 'getInvalidTours', isLoading: 'isLoading', isUploading: 'isUploading' }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('language', { languages: 'getLanguageList', tourLanguages: 'getTourLanguageList' }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('routes', { routes: 'routesList' }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('tours', ['tours']), {
    showLanguageDropdown: function showLanguageDropdown() {
      var show = false;
      if (this.$store.state.RouterModule.name === 'analyticsTopic') {
        show = true;
      }
      return show;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('analytics', ['checkTimeZonesForClient', 'getAnalyticsData', 'importFiles', 'setFileResults', 'resetAnalytics']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('language', ['loadLanguageList', 'loadTourLanguageList', 'addTourLanguage', 'removeTourLanguage', 'setTourLanguageList', 'updateLanguageOrder', 'updateTourLanguages']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('routes', ['loadRoutes']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['loadClientToursList']), {
    closeDialog: function closeDialog() {
      this.files = [];
      this.showDialog = false;
    },
    closeWarningDialog: function closeWarningDialog() {
      this.showWarningDialog = false;
    },
    closeClientWarningDialog: function closeClientWarningDialog() {
      this.showClientWarningDialog = false;
    },
    processFiles: function processFiles(evt) {
      if (this.currentClient.isAnalytics) {
        var uploads = evt.target.files;
        for (var _i = uploads.length - 1; _i >= 0; _i--) {
          var filenameValidation = validateUpload(uploads[_i].name);
          if (filenameValidation === false) {
            this.validationError = uploads[_i].name + ' is invalid, please try again.';
            this.showDialog = true;
            return;
          }
          this.files.push(uploads[_i]);
        }

        var config = {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: function (progressEvent) {
            this.percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
            this.$forceUpdate();
          }.bind(this)
        };

        var data = new FormData();
        if (this.files.length > 0) {
          for (var i = 0; i < this.files.length; i++) {
            var file = this.files[i];
            var fileName = file.name;
            this.fileNames[i] = { fileName: fileName, result: false };
            data.append('files[]', file);
          }

          this.showDialog = true;
        }
        data.append('clientId', this.currentClient.id);
        var postData = {
          data: data,
          config: config
        };
        this.importFiles(postData);
        evt.target.form.reset();
      } else {
        this.showClientWarningDialog = true;
      }
    },
    switchView: function switchView() {
      this.$router.push(this.currentView);
    },
    loadAnalytics: function loadAnalytics() {
      if (this.currentClient.isAnalytics) {
        if (this.analytics.tourId === null || this.analytics.tourId === 0 || this.analytics.tourId === 'all') {
          this.analytics.routeId = null;
        }
        this.getAnalyticsData({
          clientId: this.currentClient.id,
          dateRange: this.analytics.dateRange ? this.analytics.dateRange : 30,
          tourId: this.analytics.tourId ? this.analytics.tourId > 0 ? this.analytics.tourId : '' : '',
          routeId: this.analytics.routeId ? this.analytics.tourId > 0 && this.analytics.routeId !== 'all' ? this.analytics.routeId : '' : '',
          language: this.analytics.language ? this.analytics.language !== 'all' ? this.analytics.language : '' : ''
        });
      } else {
        this.showClientWarningDialog = true;
      }
    },
    getDropdownValues: function getDropdownValues() {
      if (this.analytics.tourId !== null && this.analytics.tourId > 0) {
        this.loadLanguageList(this.analytics.tourId);
        this.loadRoutes(this.analytics.tourId);
        this.loadTourLanguageList(this.analytics.tourId);
      }
    },
    drawChart: function drawChart() {
      var data = new google.visualization.DataTable();
      var rows = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.analytics.usage.chartData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;

          data.addColumn('number', line.name);
          rows.push(line.data);
          data.addRows(line.data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var options = {
        curveType: 'function'
      };

      var chart = new google.visualization.LineChart(document.getElementById('chart'));
      chart.draw(data, options);
    },
    showWarning: function showWarning() {
      if (this.currentClient.isAnalytics) {
        this.showWarningDialog = true;
      } else {
        this.showClientWarningDialog = true;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.checkTimeZonesForClient(_this.currentClient.id);

            case 2:
              _this.loadClientToursList(_this.currentClient.id);
              _this.resetAnalytics({
                clientId: _this.currentClient.id,
                tourId: null,
                routeId: null,
                language: null,
                dateRange: 30,
                usage: {
                  languages: []
                }
              });
              _this.loadAnalytics();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "KrRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LBYO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lcx2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LfLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LiuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_LibraryService_js__ = __webpack_require__("FIGs");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var convertTimeHHMMSS = function convertTimeHHMMSS(val) {
  var hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};
var AudioPlayer = {
  template: '\n        <div class="player">\n        <div class="player-controls">\n            <div><a v-on:click.prevent="stop" title="Stop" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="playing = !playing" title="Play/Pause" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!playing" fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"/>\n                    <path v-else fill="currentColor" d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"/>\n                </svg>\n            </a></div>\n            <div>\n                <div v-on:click="seek" class="player-progress" title="Time played : Total time">\n                    <div :style="{ width: this.percentComplete + \'%\' }" class="player-seeker"></div>\n                </div>\n                <div class="player-time">\n                    <div class="player-time-current">{{ currentTime }}</div>\n                    <div class="player-time-total">{{ durationTime }}</div>\n                </div>\n            </div>\n            <div><a v-on:click.prevent="download" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="innerLoop = !innerLoop" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!innerLoop" fill="currentColor" d="M1,12V5h3v6h10V8l5,4.5L14,17v-3H3C1.895,14,1,13.104,1,12z"/>\n                    <path v-else fill="currentColor" d="M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="mute" title="Mute" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!muted" fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"/>\n                    <path v-else fill="currentColor" d="M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="" v-on:mouseenter="showVolume = true" title="Volume" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"/>\n                </svg>\n                <input v-model.lazy.number="volume" v-show="showVolume" type="range" min="0" max="100"/></a></div>\n        </div>\n        <audio :loop="innerLoop" ref="audiofile" :src="file" preload="auto" style="display: none;"></audio>\n        </div>',
  props: {
    file: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    };
  },
  computed: {
    currentTime: function currentTime() {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime: function durationTime() {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete: function percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted: function muted() {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing: function playing(value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume: function volume(value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download: function download() {
      this.stop();
      window.open(this.file, 'download');
    },
    load: function load() {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },
    mute: function mute() {
      if (this.muted) {
        this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek: function seek(e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }
      var el = e.target.getBoundingClientRect();
      var seekPos = (e.clientX - el.left) / el.width;
      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop: function stop() {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update: function update(e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  created: function created() {
    this.innerLoop = this.loop;
  },
  mounted: function mounted() {
    var _this = this;

    this.audio = this.$el.querySelectorAll('audio')[0];
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', function () {
      _this.playing = false;
    });
    this.audio.addEventListener('play', function () {
      _this.playing = true;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showMaxFileUplaodError: false,
      arrayLibraryDetails: [],
      arrayLibraryDetailsFiller: [],
      arrayLibraryDetailsMusic: [],
      arrayLibraryDetailNotification: [],
      arrayLibraryDetailsafety: [],
      arraListName: [],
      selectAllCheckBoxFiller: [],
      selectAllCheckBoxMusic: [],
      selectAllCheckBoxNotification: [],
      selectAllCheckBoxSafety: [],
      selectAllCheckBox: [],
      shoMultiple: false,
      shoMultiplefiller: false,
      shoMultiplemusic: false,
      shoMultiplenotification: false,
      shoMultiplesafety: false,
      isActive: false,
      isLoadingmy: false,
      libraryItemDelete: '',
      showDeleteDialog: false,
      showDeleteDialogMultiple: false,
      showDeleteDialogMultipleF: false,
      showDeleteDialogMultipleM: false,
      showDeleteDialogMultipleN: false,
      showDeleteDialogMultilesafety: false,
      storiesExpand: false,
      fillersExpand: false,
      musicExpand: false,
      notificationsExpand: false,
      safetyExpand: false,
      expandAll: {
        story: false,
        filler: false,
        music: false,
        notification: false,
        safety: false
      },
      filterString: '',
      file: null,
      files: [],
      vedioSrc: '',
      percentCompleted: 0,
      showDialog: false,
      showValidateDialog: false,
      validationError: null,
      storageFileUrl: '',
      file1: '',
      enabled: true,
      librarystory: [],
      dragging: false,
      showDialogAllRoute: false,
      arrayAllRoute: [],
      routeId: '',
      tempArray: [],
      selectClient: [],
      dataForPost: '',
      ArrayinUse: [],
      duplicateContent: true,
      showLoader: false,
      uploadFiles: [],
      disableCloseButtonOnFileUploadModal: true,
      maxUploaidingFileLimit: 20
    };
  },

  components: {
    AudioPlayer: AudioPlayer,
    draggable: __WEBPACK_IMPORTED_MODULE_11_vuedraggable___default.a
  },
  watch: {
    arrayLibraryDetails: function arrayLibraryDetails() {
      if (this.arrayLibraryDetails.length > 0) {
        this.shoMultiple = true;
      } else {
        this.shoMultiple = false;
      }
    },
    arrayLibraryDetailsFiller: function arrayLibraryDetailsFiller() {
      if (this.arrayLibraryDetailsFiller.length > 0) {
        this.shoMultiplefiller = true;
      } else {
        this.shoMultiplefiller = false;
      }
    },
    arrayLibraryDetailsMusic: function arrayLibraryDetailsMusic() {
      if (this.arrayLibraryDetailsMusic.length > 0) {
        this.shoMultiplemusic = true;
      } else {
        this.shoMultiplemusic = false;
      }
    },
    arrayLibraryDetailNotification: function arrayLibraryDetailNotification() {
      if (this.arrayLibraryDetailNotification.length > 0) {
        this.shoMultiplenotification = true;
      } else {
        this.shoMultiplenotification = false;
      }
    },
    arrayLibraryDetailsafety: function arrayLibraryDetailsafety() {
      if (this.arrayLibraryDetailsafety.length > 0) {
        this.shoMultiplesafety = true;
      } else {
        this.shoMultiplesafety = false;
      }
    },

    uploadFiles: {
      deep: true,
      handler: function handler(uploadFiles) {
        var _this2 = this;

        var refreshFilesInLibrary = true;
        uploadFiles.forEach(function (file, index) {
          if (!file.message) {
            refreshFilesInLibrary = false;
          }
          var iconInfo = _this2.getUploadedFileIcon(file);
          _this2.uploadFiles[index].iconInfo.icon = iconInfo.icon;
          _this2.uploadFiles[index].iconInfo.color = iconInfo.color;
          _this2.uploadFiles[index].failureMessage = _this2.getUploadedFileFailureMessage(file);
          _this2.uploadFiles[index].progressBarColor = _this2.getUploadedFileProgressBarColor(file);
          _this2.uploadFiles[index].progressBarMessage = _this2.getUploadedFileProgressBarMessage(file);
        });
        if (refreshFilesInLibrary) {
          this.library = this.loadLibrary(this.currentClient.id);
          this.disableCloseButtonOnFileUploadModal = false;
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('library', { library: 'getLibrary', isUploading: 'isUploading', isValidating: 'isValidating', results: 'uploadResults', uploadError: 'getUploadError' }), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('user', ['isAdmin']), {
    convertObjToStory: function convertObjToStory() {
      var obj = this.library.story;
      var array = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, key, value);
      });
      return array;
    },
    convertObjToSafety: function convertObjToSafety() {
      var obj = this.library.safety;
      var array = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref4) {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, key, value);
      });
      return array;
    },
    convertObjToFiller: function convertObjToFiller() {
      var obj = this.library.filler;
      var array = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, key, value);
      });
      return array;
    },
    filterStringIsEmpty: function filterStringIsEmpty() {
      if (this.filterString.length === 0) {
        this.filterString = '';
      }
      if (this.filterString.length > 0) {
        return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
      }
    },
    fileName: function fileName() {
      if (this.file.name) {
        return this.file.name;
      } else {
        return 'NULL';
      }
    },
    resultsSuccessesAndFails: function resultsSuccessesAndFails() {
      var successes = 0;
      var fails = 0;
      var swaps = 0;
      var duplicate = 0;
      var diffCategory = '';
      if (this.results) {
        if (this.results.sameFileDiff === 1) {
          duplicate = duplicate + 1;
          diffCategory = this.results.diffCategory;
        } else {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(this.results)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref10 = _step.value;

              var _ref11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref10, 1);

              var value = _ref11[0];

              if (this.results[value] === 'uploaded') {
                successes = successes + 1;
              } else if (this.results[value] === 'replaced') {
                swaps = swaps + 1;
              } else if (this.results[value] === 'File bitrate is greater than 128kbps please upload different file.' || this.results[value] === '=> File prefix does not match' || this.results[value] === 'diffCategory') {
                fails = fails + 1;
              } else if (this.results[value] === 'failed') {
                fails = fails + 1;
              } else if (this.results === '1') {
                duplicate = duplicate + 1;
              } else if (this.validationError) {
                fails = fails + 1;
              } else {
                swaps = swaps + 1;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
      if (this.results.sameFileUpdated === 1) {
        return 'File Overwrite Successfully';
      }
      if (this.results.bitRateFalse === 1) {
        return 'File bitrate is greater than 128kbps please upload different file. ';
      }
      var successText = '';
      var failText = '';
      var swapText = '';
      if (successes === 1) {
        successText = successes + ' file added, ';
      } else {
        successText = successes + ' files added, ';
      }
      if (swaps === 1) {
        swapText = swaps + ' file overwritten and ';
      } else {
        swapText = swaps + ' files overwritten and ';
      }
      if (fails === 1) {
        failText = fails + ' file failed.';
      } else {
        failText = fails + ' files failed.';
      }
      if (duplicate === 1) {
        console.log(diffCategory);
      } else {
        return successText + swapText + failText;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('library', ['forceLanguageOpen', 'loadLibrary', 'loadLibraryAndValidate', 'removeFromLibrary', 'removeFromLibraryMultiple', 'toggleExpandLanguages', 'toggleExpandLanguagesAll', 'clearUploadResults', 'reorderLibrary']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('file', ['uploadFile', 'uploadFiles']), {
    checkMove: function checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    endDragging: function endDragging(dragging) {
      dragging = false;
    },
    selectAllCheckEvent: function selectAllCheckEvent(event) {
      if (event.length === 1) {
        var item;
        var item2 = void 0;
        for (item in this.library.story) {
          for (item2 in this.library.story[item].media) {
            var id = this.library.story[item].media[item2].id;
            this.arrayLibraryDetails.push(id);
          }
        }
      } else {
        this.arrayLibraryDetails = [];
      }
    },
    selectAllCheckEventFiller: function selectAllCheckEventFiller(event) {
      if (event.length === 1) {
        var itemf;
        var item2f = void 0;
        for (itemf in this.library.filler) {
          for (item2f in this.library.filler[itemf].media) {
            var id = this.library.filler[itemf].media[item2f].id;
            this.arrayLibraryDetailsFiller.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsFiller = [];
      }
    },
    selectAllCheckEventMusic: function selectAllCheckEventMusic(event) {
      if (event.length === 1) {
        var itemf;
        var item2f = void 0;
        for (itemf in this.library.music) {
          for (item2f in this.library.music[itemf].media) {
            var id = this.library.music[itemf].media[item2f].id;
            this.arrayLibraryDetailsMusic.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsMusic = [];
      }
    },
    selectAllCheckEventNotification: function selectAllCheckEventNotification(event) {
      if (event.length === 1) {
        var itemf;
        var item2f = void 0;
        for (itemf in this.library.notification) {
          for (item2f in this.library.notification[itemf].media) {
            var id = this.library.notification[itemf].media[item2f].id;
            this.arrayLibraryDetailNotification.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailNotification = [];
      }
    },
    selectAllCheckEventSafety: function selectAllCheckEventSafety(event) {
      if (event.length === 1) {
        var itemf;
        var item2f = void 0;
        for (itemf in this.library.safety) {
          for (item2f in this.library.safety[itemf].media) {
            var id = this.library.safety[itemf].media[item2f].id;
            this.arrayLibraryDetailsafety.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsafety = [];
      }
    },

    inArray: function inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] === needle) return true;
      }
      return false;
    },
    multipleDownload: function multipleDownload(libraryItem) {
      var mediaNmae = libraryItem;
      if (libraryItem === 'STORY') {
        libraryItem = this.arrayLibraryDetails;
      } else if (libraryItem === 'Filler') {
        libraryItem = this.arrayLibraryDetailsFiller;
      } else if (libraryItem === 'Music') {
        libraryItem = this.arrayLibraryDetailsMusic;
      } else if (libraryItem === 'Notification') {
        libraryItem = this.arrayLibraryDetailNotification;
      } else if (libraryItem === 'Safety') {
        libraryItem = this.arrayLibraryDetailsafety;
      }
      Object(__WEBPACK_IMPORTED_MODULE_10__services_ClientService_js__["r" /* multipleDownloadFunction */])({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem,
        'mediaNmae': mediaNmae
      }).then(function (responce) {
        var i = 0;

        function myLoop(responce) {
          var urlTemp = responce.data[i].mediaLink;
          var filename = responce.data[i].filename;
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlTemp, { responseType: 'blob' }).then(function (response) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
          });
          i++;
          if (i < responce.data.length) {
            myLoop(responce);
          }
        }

        myLoop(responce);
      });
    },
    checkBoxGetName: function checkBoxGetName(event, name) {
      if (event.length !== 0) {
        this.arraListName.push(name);
      }
      if (event.length === 0) {
        this.arraListName = [];
      }
    },
    downloadPdf: function downloadPdf() {
      var pp = this;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('api/multMediaFileDownload').then(function (response) {
        for (var index = 0; index < pp.arraListName.length; index++) {
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          // Create a blob from the response data, and create a download url for it
          var blob = new Blob([response.data]);
          var url = window.URL.createObjectURL(blob);
          // Set the link to the download url, give it the proper appdata name, and click it
          a.href = url;
          a.download = pp.arraListName[index];
          a.click();
        }
        pp.arraListName = [];
      });
    },
    onUpdate: function onUpdate(cate) {
      this.isLoadingmy = true;
      this.savelistStoryOrder(cate);
    },
    savelistStoryOrder: function savelistStoryOrder(cate) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (cate === 'Filler') {
                  _this3.ArrayinUse = _this3.convertObjToFiller;
                } else {
                  _this3.ArrayinUse = _this3.convertObjToSafety;
                }
                _this3.reorderLibrary({
                  'clientId': _this3.currentClient.id,
                  'newArray': _this3.ArrayinUse,
                  'cate': cate
                }).then(function () {
                  _this3.isLoadingmy = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    addFileWithRoute: function addFileWithRoute(libraryID) {
      var _this4 = this;

      this.tempArray['libraryID'] = libraryID;
      Object(__WEBPACK_IMPORTED_MODULE_12__services_LibraryService_js__["a" /* addFileWithRouteApi */])().then(function (response) {
        _this4.arrayAllRoute = response.data;
      }).catch(function (error) {
        console.log('erros : ', error);
      });
      this.showDialogAllRoute = true;
    },
    addLibraryFileToRoute: function addLibraryFileToRoute(libraryID) {
      var _this5 = this;

      this.dataForPost = {
        'libraryId': libraryID,
        'routeID': this.selectClient
      };
      Object(__WEBPACK_IMPORTED_MODULE_12__services_LibraryService_js__["b" /* addLibraryFileToRouteApi */])(this.dataForPost).then(function (response) {
        _this5.showDialogAllRoute = false;
      }).catch(function (error) {
        console.log('erros : ', error);
      });
    },
    hasVideo: function hasVideo(story, heading) {
      var hasVid = false;
      if (heading === 'category') {
        for (var file = 0; file < story.media.length; file++) {
          if (story.media[file].isVideo === 1) {
            hasVid = true;
          }
        }
      } else if (heading === 'file' && story.isVideo === 1) {
        hasVid = true;
      }
      return hasVid;
    },
    getFilesSize: function getFilesSize() {
      var _this6 = this;

      this.upload_size = 0;
      this.files.map(function (item) {
        _this6.upload_size += parseInt(item.size);
      });
      this.upload_size = Number(this.upload_size.toFixed(1));
      this.$forceUpdate();
    },
    toggleExpand: function toggleExpand(type) {
      if (type === 'story') {
        this.storiesExpand = !this.storiesExpand;
      } else if (type === 'filler') {
        this.fillersExpand = !this.fillersExpand;
      } else if (type === 'music') {
        this.musicExpand = !this.musicExpand;
      } else if (type === 'notification') {
        this.notificationsExpand = !this.notificationsExpand;
      } else if (type === 'safety') {
        this.safetyExpand = !this.safetyExpand;
      }
    },
    toggleExpandAll: function toggleExpandAll(type) {
      this.expandAll[type] = !this.expandAll[type];
      this.toggleExpandLanguagesAll({ 'category': type, 'expand': this.expandAll[type] });
    },
    toggleLanguageExpand: function toggleLanguageExpand(category, index) {
      this.toggleExpandLanguages({ 'category': category, 'index': index });
    },
    forceOpen: function forceOpen(category, index) {
      this.forceLanguageOpen({ 'category': category, 'index': index });
    },
    filterCheck: function filterCheck(text) {
      var passesFilter = true;
      if (!this.filterStringIsEmpty) {
        if (this.filterString.length > 0) {
          if (this.filterString && this.filterString.trim().length) {
            passesFilter = text.toLowerCase().includes(this.filterString.toLowerCase());
          }
        }
      }
      return passesFilter;
    },
    onFileUpload: function onFileUpload(evt, category) {
      this.file = evt.target.files[0];
      var data = new FormData();
      data.append('clientId', this.currentClient.id);
      data.append('category', category);
      data.append('file', this.file);
      this.uploadFile(data);
      this.showDialog = true;
    },
    onFileUploadMulti: function onFileUploadMulti(event, category) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var files, i, uploadFile, _loop, _i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.showDialog = _this7.disableCloseButtonOnFileUploadModal = true;

                _this7.uploadFiles = [];
                files = event.target.files;

                if (files.length) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return', false);

              case 5:
                if (!(files.length > _this7.maxUploaidingFileLimit)) {
                  _context3.next = 9;
                  break;
                }

                _this7.showMaxFileUplaodError = true;
                _this7.showDialog = _this7.disableCloseButtonOnFileUploadModal = false;
                return _context3.abrupt('return', false);

              case 9:

                for (i = 0; i < files.length; i++) {
                  uploadFile = {
                    name: files[i].name,
                    progress: 0,
                    message: '',
                    iconInfo: {
                      icon: '',
                      color: ''
                    },
                    failureMessage: '',
                    progressBarColor: '',
                    progressBarMessage: ''
                  };


                  _this7.uploadFiles.push(uploadFile);
                }

                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(_i) {
                  var formData, config, res;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          formData = new FormData();

                          formData.append('clientId', _this7.currentClient.id);
                          formData.append('category', category);
                          formData.append('files[]', files[_i]);

                          config = {
                            onUploadProgress: function onUploadProgress(progressEvent) {
                              _this7.uploadFiles[_i].progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                            }
                          };
                          _context2.next = 7;
                          return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('api/client/' + _this7.currentClient.id + '/files/upload', formData, config);

                        case 7:
                          res = _context2.sent;

                          if (res.status === 200) {
                            _this7.uploadFiles[_i].message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(res.data)[0];
                          }

                        case 9:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _loop, _this7);
                });
                _i = 0;

              case 12:
                if (!(_i < files.length)) {
                  _context3.next = 17;
                  break;
                }

                return _context3.delegateYield(_loop(_i), 't0', 14);

              case 14:
                _i++;
                _context3.next = 12;
                break;

              case 17:
                event.target.form.reset();
                // previous code
                // Array.prototype.forEach.call(files, (file, index) => {
                //   let formData = new FormData();
                //   formData.append('clientId', this.currentClient.id);
                //   formData.append('category', category);
                //   formData.append('files[]', file);

                //   let uploadFile = {
                //     name: file.name,
                //     progress: 0,
                //     message: '',
                //     iconInfo: {
                //       icon: '',
                //       color: ''
                //     },
                //     failureMessage: '',
                //     progressBarColor: '',
                //     progressBarMessage: ''
                //   };

                //   this.uploadFiles.push(uploadFile);
                //   console.log('uploadfile',this.uploadFile);
                //   console.log('formData', formData);

                //    let config = {
                //     onUploadProgress: (progressEvent) => {
                //       uploadFiles[index].progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                //     }
                //   };
                //   // axios.post('api/client/' + this.currentClient.id + '/files/upload', formData, config).then((response) => {
                //   //   uploadFiles[index].message = Object.values(response.data)[0];
                //   // }).catch((error) => {
                //   //   console.log(error.response.data);
                //   // });
                // });
                // event.target.form.reset();

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    getUploadedFileIcon: function getUploadedFileIcon(file) {
      var iconInfo = {
        icon: '',
        color: ''
      };

      if (!file.message) {
        return iconInfo;
      }

      switch (file.message) {
        case 'uploaded':
          iconInfo.icon = 'done';
          iconInfo.color = 'green';
          break;
        case 'replaced':
          iconInfo.icon = 'refresh';
          iconInfo.color = 'green';
          break;
        default:
          iconInfo.icon = 'cancel';
          iconInfo.color = 'red';
          break;
      }
      return iconInfo;
    },
    getUploadedFileFailureMessage: function getUploadedFileFailureMessage(file) {
      var failureMessage = '';
      if (!file.message) {
        return failureMessage;
      }
      switch (file.message) {
        case 'failed':
          failureMessage = 'The file is not valid. Valid characters are [a-z][A-Z][0-9][ _]';
          break;
        case 'fail':
          failureMessage = 'The file is not valid. Incorrect file format.';
          break;
        case 'File bitrate is greater than 128kbps please upload different file.':
          failureMessage = 'File bitrate is greater than 128kbps please upload different file.';
          break;
        case 'diffCategory':
          failureMessage = 'This file name has already been added to your library in a different section. Please create a copy of the file with a unique file name and try again.';
          break;
        case '=> File prefix does not match':
          failureMessage = 'Filename missing Channel Prefix';
          break;
        case 'dependent':
          failureMessage = 'Media is not dependent on file prefix';
          break;
      }
      return failureMessage;
    },
    getUploadedFileProgressBarColor: function getUploadedFileProgressBarColor(file) {
      var progressBarColor = 'green';
      if (file.progress === 100) {
        if (!file.message) {
          progressBarColor = 'green progress-striped active';
        } else {
          if (file.message === 'uploaded' || file.message === 'replaced') {
            progressBarColor = 'blue';
          } else {
            progressBarColor = 'red';
          }
        }
      }
      return progressBarColor;
    },
    getUploadedFileProgressBarMessage: function getUploadedFileProgressBarMessage(file) {
      var message = file.progress + '%';
      if (file.progress === 100) {
        if (!file.message) {
          message = 'Processing';
        } else {
          if (file.message === 'uploaded' || file.message === 'replaced') {
            message = 'Completed';
          } else {
            message = 'Failed';
          }
        }
      }
      return message;
    },
    confirmRemove: function confirmRemove(libraryItem) {
      this.showDeleteDialog = true;
      this.libraryItemDelete = libraryItem;
    },
    confirmRemoveMultipl: function confirmRemoveMultipl(libraryItem) {
      this.showDeleteDialogMultiple = true;
    },
    confirmRemoveMultiplF: function confirmRemoveMultiplF(libraryItem) {
      this.showDeleteDialogMultipleF = true;
    },
    confirmRemoveMultiplM: function confirmRemoveMultiplM(libraryItem) {
      this.showDeleteDialogMultipleM = true;
    },
    confirmRemoveMultiplN: function confirmRemoveMultiplN(libraryItem) {
      this.showDeleteDialogMultipleN = true;
    },
    confirmRemoveMultiplS: function confirmRemoveMultiplS(libraryItem) {
      this.showDeleteDialogMultilesafety = true;
    },
    deleteMedia: function deleteMedia(libraryItem) {
      var _this8 = this;

      this.removeFromLibrary({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem.id
      }).then(function () {
        _this8.loadLibrary(_this8.currentClient.id).then(function () {
          _this8.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
      this.showDeleteDialog = false;
      this.libraryItemDelete = '';
    },
    deleteMediaMultiple: function deleteMediaMultiple(libraryItem) {
      var _this9 = this;

      this.showLoader = true;
      libraryItem = this.arrayLibraryDetails;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(function () {
        _this9.loadLibrary(_this9.currentClient.id).then(function () {
          _this9.showDeleteDialogMultiple = false;
          _this9.showLoader = false;
          _this9.shoMultiple = false;
          _this9.storiesExpand = false;
          _this9.arrayLibraryDetails = [];
          _this9.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplefiller: function deleteMediaMultiplefiller(libraryItem) {
      var _this10 = this;

      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsFiller;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(function () {
        _this10.loadLibrary(_this10.currentClient.id).then(function () {
          _this10.showDeleteDialogMultipleF = false;
          _this10.showLoader = false;
          _this10.shoMultiplefiller = false;
          _this10.fillersExpand = false;
          _this10.arrayLibraryDetailsFiller = [];
          _this10.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplemusic: function deleteMediaMultiplemusic(libraryItem) {
      var _this11 = this;

      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsMusic;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(function () {
        _this11.loadLibrary(_this11.currentClient.id).then(function () {
          _this11.showDeleteDialogMultipleM = false;
          _this11.showLoader = false;
          _this11.shoMultiplemusic = false;
          _this11.musicExpand = false;
          _this11.arrayLibraryDetailsMusic = [];
          _this11.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplenotification: function deleteMediaMultiplenotification(libraryItem) {
      var _this12 = this;

      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailNotification;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(function () {
        _this12.loadLibrary(_this12.currentClient.id).then(function () {
          _this12.showDeleteDialogMultipleN = false;
          _this12.showLoader = false;
          _this12.shoMultiplenotification = false;
          _this12.notificationsExpand = false;
          _this12.arrayLibraryDetailNotification = [];
          _this12.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplesafety: function deleteMediaMultiplesafety(libraryItem) {
      var _this13 = this;

      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsafety;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(function () {
        _this13.loadLibrary(_this13.currentClient.id).then(function () {
          _this13.showDeleteDialogMultilesafety = false;
          _this13.showLoader = false;
          _this13.shoMultiplesafety = false;
          _this13.safetyExpand = false;
          _this13.arrayLibraryDetailsafety = [];
          _this13.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    validateLibrary: function validateLibrary() {
      this.showValidateDialog = true;
      this.loadLibraryAndValidate(this.currentClient.id);
    },
    closeDialog: function closeDialog() {
      this.showDialog = false;
    },
    closeValidateDialog: function closeValidateDialog() {
      this.showValidateDialog = false;
    },
    friendlyNameHasErrors: function friendlyNameHasErrors(item) {
      for (var i = 0; i < item.media.length; i++) {
        if (item.media[i].uploaded === false) {
          return true;
        }
      }
      return false;
    },
    categoryHasErrors: function categoryHasErrors(category) {
      for (var key in category) {
        if (category.hasOwnProperty(key)) {
          if (this.friendlyNameHasErrors(category[key]) === true) {
            return true;
          }
        }
      }
      return false;
    },
    imageExists: function imageExists(url, callback) {
      var img = new Image();
      img.onload = function () {
        return true;
      };
      img.onerror = function () {
        return false;
      };
      img.src = url;
    },
    playMedia: function playMedia(el, type) {
      var _this14 = this;

      Object(__WEBPACK_IMPORTED_MODULE_12__services_LibraryService_js__["k" /* getSignedUrlForLibraryItem */])(this.currentClient.id, el.id).then(function (response) {
        _this14.playVideMp3(response.data.signedUrl, type);
      }).catch(function (error) {
        console.log('erros : ', error);
      });
    },
    playVideMp3: function playVideMp3(signedUrl, type) {
      if (!signedUrl) {
        return;
      }
      if (type === 1) {
        this.$modal.show('video-file-play');
        this.vedioSrc = signedUrl;
        var vid = document.getElementById('video-container');
        vid.play();
      } else {
        this.$modal.show('audio-file-play');
        this.file1 = signedUrl;
      }
    },
    playSound: function playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    }
  }),
  mounted: function mounted() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this15.library = _this15.loadLibrary(_this15.currentClient.id);

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee3, _this15);
    }))();
  }
});

/***/ }),

/***/ "LvIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSettings_vue__ = __webpack_require__("qX0s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bd866ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSettings_vue__ = __webpack_require__("2xQu");
function injectStyle (ssrContext) {
  __webpack_require__("6beV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bd866ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a622acd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("hchd");
function injectStyle (ssrContext) {
  __webpack_require__("xQsh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a622acd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRelease_vue__ = __webpack_require__("k13r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d7a603_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRelease_vue__ = __webpack_require__("9kP7");
function injectStyle (ssrContext) {
  __webpack_require__("UvLs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44d7a603"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRelease_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d7a603_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRelease_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourGeneralTab_vue__ = __webpack_require__("VXrY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319288c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourGeneralTab_vue__ = __webpack_require__("LfLD");
function injectStyle (ssrContext) {
  __webpack_require__("qaDs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-319288c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourGeneralTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319288c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourGeneralTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mxtf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+kA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnableIncompleteTours_vue__ = __webpack_require__("6DyQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c33a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnableIncompleteTours_vue__ = __webpack_require__("Onoq");
function injectStyle (ssrContext) {
  __webpack_require__("UAtg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46c33a09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnableIncompleteTours_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c33a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnableIncompleteTours_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N1Dz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unauthorized_vue__ = __webpack_require__("TnT/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27856bac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unauthorized_vue__ = __webpack_require__("AzWE");
function injectStyle (ssrContext) {
  __webpack_require__("iXGw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27856bac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unauthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27856bac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unauthorized_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N8fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendResetEmail", function() { return sendResetEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPassword", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signIn", function() { return signIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePasswordResetToken", function() { return validatePasswordResetToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenanceAction", function() { return maintenanceAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenanceFlag", function() { return maintenanceFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenanceFlagForIP", function() { return maintenanceFlagForIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendOtp", function() { return sendOtp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SendOtpService", function() { return SendOtpService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signInUserToken", function() { return signInUserToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function sendResetEmail(email) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/forgotPassword', { email: email });
}

function resetPassword(newPassword, token) {
  if (newPassword && token) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/resetPassword', { token: token, password: newPassword });
  }
}

function signInUserToken(token) {
  var timezoneOffsetMinutes = new Date().getTimezoneOffset();
  timezoneOffsetMinutes = timezoneOffsetMinutes === 0 ? 0 : -timezoneOffsetMinutes;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/loginByToken', {
    token: token,
    timezoneOffsetMinutes: timezoneOffsetMinutes
  });
}

function signIn(email, password) {
  var timezoneOffsetMinutes = new Date().getTimezoneOffset();
  timezoneOffsetMinutes = timezoneOffsetMinutes === 0 ? 0 : -timezoneOffsetMinutes;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/login', {
    email: email,
    password: password,
    timezoneOffsetMinutes: timezoneOffsetMinutes
  });
}

function validatePasswordResetToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/validatePasswordResetToken', { token: token });
}

function logout(userId) {
  localStorage.access_token = 0;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/logout', { userId: userId });
}

function maintenanceAction(flag) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/maintenance', { flag: flag });
}

function sendOtp(flag) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/sendOtpOnMail', { flag: flag });
}

function SendOtpService(inputOtp) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/checkOtpActive', { inputOtp: inputOtp });
}

function maintenanceFlag() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/getmaintenanceflag');
}

function maintenanceFlagForIP() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/maintenanceFlagForIP');
}



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartkick__ = __webpack_require__("tZw+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartkick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_chartkick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_progress_bar__ = __webpack_require__("RN2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chartkick__ = __webpack_require__("B+1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chartkick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_chartkick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scss_styles_scss__ = __webpack_require__("D85/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scss_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__scss_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_dist_vue_material_min_css__ = __webpack_require__("4+hh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_async_computed__ = __webpack_require__("JJ92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_html_to_paper__ = __webpack_require__("rdHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_html_to_paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_html_to_paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_datepicker__ = __webpack_require__("IC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_event_bus__ = __webpack_require__("Mqd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_event_bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_event_bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highcharts_vue__ = __webpack_require__("5YuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_highcharts_vue__);




























// import moment from 'moment-timezone';




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_highcharts_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay___default.a);
var options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css', 'https://unpkg.com/kidlat-css/css/kidlat.css']
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_html_to_paper___default.a, options);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vuejs_datepicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_moment___default.a);
// Vue.use(moment);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_html_to_paper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_event_bus___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuejs_progress_bar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_chartkick___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_chartkick___default.a, { Chartkick: __WEBPACK_IMPORTED_MODULE_11_chartkick___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_12_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_async_computed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_js_modal___default.a, { dynamicDefaults: { clickToClose: false } });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__, {
  load: {
    libraries: ['geometry', 'places'],
    key: 'AIzaSyBtb6N--ABCYTQ4iE1kVTKKU6-yEQPF7x4'
  }
});

Object(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */], { moduleName: 'RouterModule' }); // syncs the vue-router to the Vuex store, accessible through this.$store.state.route

__WEBPACK_IMPORTED_MODULE_15_axios___default.a.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/401');
  } else if (error.response.status === 403) {
    __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/403');
  }
  throw error;
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */] }
});

/***/ }),

/***/ "OAKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LoginService__ = __webpack_require__("N8fj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      emialValid: false,
      validEMaliReq: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['sendResetPasswordEmail']), {
    validEmail: function validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sendEmail: function sendEmail() {
      var _this = this;

      if (!this.validEmail(this.email)) {
        this.validEMaliReq = true;
        setTimeout(function () {
          _this.validEMaliReq = false;
        }, 3000);
      } else {
        var pp = this;
        Object(__WEBPACK_IMPORTED_MODULE_2__services_LoginService__["sendResetEmail"])(this.email).then(function (defs) {
          if (defs.data.message === 'Account was not Found') {
            pp.emialValid = true;
            pp.$router.push('/email/sent');
          } else {
            pp.$router.push('/email/sent');
          }
        });
      }
    },
    returnToLogin: function returnToLogin() {
      this.$router.push('/login');
    }
  })
});

/***/ }),

/***/ "OMa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("/3Nb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba60f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("vlAV");
function injectStyle (ssrContext) {
  __webpack_require__("pMA0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eba60f4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba60f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Od/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__ = __webpack_require__("fcCE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_LanguageService_js__ = __webpack_require__("kOA1");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  expand: {},
  data: function data() {
    return {
      routeIdDelete: [],
      showDeleteDialog: false,
      selectedRouteID: [],
      copyCount: 0,
      ManageAddChannel: false,
      deleteCount: 0,
      clickedcopy: false,
      onetimeRouteCopy: false,
      showDialogAllTours: false,
      arrayChannelModal: false,
      addLanguages: [],
      arraytours: [],
      arrayChannel: [],
      tempArray: [],
      ArrayinUse: [],
      isLoadingmy: false,
      toursIdForCopy: '',
      nameOfRoute: '',
      settings: {
        wifi: true,
        bluetooth: false
      },
      notification: ['sound', 'vibrate'],
      tempArrayChannel: [],
      checkRouteCompleteORnot: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
    routes: function routes(state) {
      return state.routes.routesList;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('tours', ['currentTour', 'currentTourDup', 'checkTourSettingSave']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('routes', ['enableTourLanCheck', 'checkFileAnotherTours'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('routes', ['loadEditorRoute', 'insertNewRoute', 'loadRoutes', 'routeCody', 'changeState', 'changeStateForFile', 'reorderTourRoutes']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('topics', ['cleanTopicsList']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['funAgainSetCurrtTour']), {
    confirmDelete: function confirmDelete(routeId) {
      this.showDeleteDialog = true;
      this.routeIdDelete = routeId;
    },
    onUpdate: function onUpdate(routes) {
      this.isLoadingmy = true;
      this.savelistRouteOrder(routes);
    },
    savelistRouteOrder: function savelistRouteOrder(routes) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (routes != null) {
                  _this.ArrayinUse = routes;
                }
                _this.reorderTourRoutes({
                  'clientId': _this.currentClient.id,
                  'tourId': _this.currentTour.id,
                  'newArray': _this.ArrayinUse
                }).then(function () {
                  _this.isLoadingmy = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleHoverOn: function toggleHoverOn(index) {
      this.routes[index].hover = true;
    },
    toggleHoverLeave: function toggleHoverLeave(index) {
      this.routes[index].hover = false;
    },
    somethingchannel: function somethingchannel(event, defaultVal) {
      if (defaultVal === 'channelsadd') {
        this.ManageAddChannel = true;
      }
    },
    getImageSrc: function getImageSrc(image) {
      return 'static/img/' + image;
    },
    showDeleteDialogChannel: function showDeleteDialogChannel() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.changeState(false);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showDeleteDialogChannelLibrary: function showDeleteDialogChannelLibrary() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.changeStateForFile(false);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkRouteCompleteORnotOK: function checkRouteCompleteORnotOK() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.checkRouteCompleteORnot = false;

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    endDragging: function endDragging(dragging) {
      dragging = false;
    },
    addRouteAnotherTours: function addRouteAnotherTours(routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var routeComplete, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["c" /* checkRouteIsComplete */])(routeID, tourId);

              case 2:
                routeComplete = _context5.sent;

                if (!(routeComplete.data === 0)) {
                  _context5.next = 7;
                  break;
                }

                _this5.checkRouteCompleteORnot = true;
                _context5.next = 26;
                break;

              case 7:
                _context5.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["a" /* addToursCopyRoute */])(name);

              case 9:
                response = _context5.sent;

                _this5.arraytours = response.data;
                _this5.tempArray['routeID'] = routeID;
                _this5.tempArray['tourId'] = tourId;
                _this5.tempArray['routeTopics'] = routeTopics;
                _this5.tempArray['name'] = name;
                _this5.tempArray['description'] = description;
                _this5.tempArray['route_image'] = routeimage;
                _this5.tempArray['commentary'] = commentary;
                _this5.tempArray['notificationSound'] = notificationSound;
                _this5.tempArray['commentaryDelay'] = commentaryDelay;
                _this5.tempArray['audioControllerNotification'] = audioControllerNotification;
                _this5.tempArray['audioControllerFlashTime'] = audioControllerFlashTime;
                _this5.tempArray['alt_path'] = altpath;
                _this5.tempArray['headendSys'] = headendSys;
                _this5.tempArray['notificationSongId'] = notificationSongId;
                _this5.showDialogAllTours = true;

              case 26:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addchannelToARoute: function addchannelToARoute(routeID, tourId, routeTopics, name, description, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, headendSys, notificationSongId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, responsePertiRoute, arrOfCurrentRoute, index, element, _index, _element;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_LanguageService_js__["d" /* getLanguageListWithRoute */])(tourId);

              case 2:
                response = _context6.sent;
                _context6.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_LanguageService_js__["a" /* checkRouteHasLanguage */])(routeID);

              case 5:
                responsePertiRoute = _context6.sent;

                _this6.arrayChannel = response.data;
                arrOfCurrentRoute = responsePertiRoute.data;

                if (arrOfCurrentRoute.length > 0) {
                  for (index = 0; index < arrOfCurrentRoute.length; index++) {
                    element = arrOfCurrentRoute[index];

                    _this6.addLanguages.push(element);
                  }
                } else {
                  for (_index = 0; _index < _this6.arrayChannel.length; _index++) {
                    _element = _this6.arrayChannel[_index].id;

                    _this6.addLanguages.push(_element);
                  }
                }
                _this6.tempArrayChannel['routeID'] = routeID;
                _this6.tempArrayChannel['tourId'] = tourId;
                _this6.tempArrayChannel['routeTopics'] = routeTopics;
                _this6.tempArrayChannel['name'] = name;
                _this6.tempArrayChannel['description'] = description;
                _this6.tempArrayChannel['commentary'] = commentary;
                _this6.tempArrayChannel['notificationSound'] = notificationSound;
                _this6.tempArrayChannel['commentaryDelay'] = commentaryDelay;
                _this6.tempArrayChannel['audioControllerNotification'] = audioControllerNotification;
                _this6.tempArrayChannel['audioControllerFlashTime'] = audioControllerFlashTime;
                _this6.tempArrayChannel['headendSys'] = headendSys;
                _this6.tempArrayChannel['notificationSongId'] = notificationSongId;
                _this6.arrayChannelModal = true;

              case 22:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    addRouteAnotherToursModal: function addRouteAnotherToursModal(routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.onetimeRouteCopy = true;
                _this7.copyAllTours(routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId, _this7.toursIdForCopy);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    addChannelAnotherToursModal: function addChannelAnotherToursModal(routeID, tourId, routeTopics, name, description) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__["a" /* adChannelIdToARoute */])(routeID, _this8.addLanguages, tourId);

              case 2:
                _this8.loadRoutes(_this8.currentTour.id);
                _this8.ManageAddChannel = false;
                _this8.arrayChannelModal = false;

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    copyAllTours: function copyAllTours(routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId) {
      var _this9 = this;

      var toursIdForCopy = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, newRoute;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this9.clickedcopy === false)) {
                  _context9.next = 10;
                  break;
                }

                _this9.clickedcopy = true;
                _this9.selectedRouteID.push(parseInt(routeID));
                _context9.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__["d" /* getCopyName */])(name, routeID);

              case 5:
                response = _context9.sent;

                if (toursIdForCopy === tourId) {
                  _this9.nameOfRoute = response.data;
                } else {
                  _this9.nameOfRoute = name;
                }
                newRoute = {
                  copyRoute: 1,
                  name: _this9.nameOfRoute,
                  parentrouteID: routeID,
                  tourId: tourId,
                  vehicleId: null, // this should default to something or be selectable somehow (?)
                  description: description,
                  route_image: routeimage,
                  avatar: null,
                  channels: null,
                  path: null,
                  alt_path: altpath,
                  commentary: commentary,
                  notificationSound: notificationSound,
                  commentaryDelay: commentaryDelay,
                  audioControllerNotification: audioControllerNotification,
                  audioControllerFlashTime: audioControllerFlashTime,
                  headendSys: headendSys,
                  notificationSongId: notificationSongId,
                  routeTopics: routeTopics,
                  toursIdForCopy: toursIdForCopy
                };

                _this9.insertNewRoute(newRoute).then(function () {
                  _this9.$router.push('/tour/topicRoutes/routes');
                  if (toursIdForCopy) {
                    _this9.showDialogAllTours = false;
                    _this9.onetimeRouteCopy = false;
                  }
                });
                _this9.clickedcopy = false;

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    navigateToTourRoute: function navigateToTourRoute(route) {
      if (this.checkTourSettingSave === false) {
        this.currentTour.defaultActivate = this.currentTourDup.defaultActivate;
        this.currentTour.defaultDelay = this.currentTourDup.defaultDelay;
        this.currentTour.defaultRadiusDistance = this.currentTourDup.defaultRadiusDistance;
        this.currentTour.defaultTolerance = this.currentTourDup.defaultTolerance;
        this.funAgainSetCurrtTour(this.currentTour);
      }
      this.loadEditorRoute(route);
      this.$router.push('/tour/route');
    },
    clickDelete: function clickDelete(routeId) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, index, element;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__["b" /* deleteRoute */])(routeId);

              case 2:
                response = _context10.sent;

                for (index = 0; index < _this10.selectedRouteID.length; index++) {
                  element = _this10.selectedRouteID[index];

                  if (element === parseInt(routeId)) {
                    if (_this10.deleteCount === 0) {
                      _this10.selectedRouteID.splice(index, 1);
                    }
                    _this10.deleteCount++;
                  }
                }

                if (response.status === 200) {
                  _this10.loadRoutes(_this10.currentTour.id);
                  _this10.showDeleteDialog = false;
                  _this10.routeIdDelete = [];
                }

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    }
  }),
  mounted: function mounted() {
    if (this.checkTourSettingSave === false) {
      this.currentTour.defaultActivate = this.currentTourDup.defaultActivate;
      this.currentTour.defaultDelay = this.currentTourDup.defaultDelay;
      this.currentTour.defaultRadiusDistance = this.currentTourDup.defaultRadiusDistance;
      this.currentTour.defaultTolerance = this.currentTourDup.defaultTolerance;
      this.funAgainSetCurrtTour(this.currentTour);
    }
  }
});

/***/ }),

/***/ "OenE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploads; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__("IcnI");




function upload(formData) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/setUploadResults', response.data);
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/isUploadingOff');
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/loadLibrary', __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.client.currentClient.id);
  });
}

function uploads(postData) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/files/upload', postData.data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/setUploadResults', response.data);
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/isUploadingOff');
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('library/loadLibrary', __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.client.currentClient.id);
  });
}



/***/ }),

/***/ "OkT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialog: false,
      expand: [],
      expandShow: [],
      expandHide: [],
      clientId: '',
      clientIndex: '',
      value: 33.333333333,
      max: 50,
      Supportemail: 'rajeshs@gmail.com',
      latestVersion: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientList', 'currentClient'])),
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('client', ['loadClient', 'resetClient', 'loadClientEditor']), {
    hasAvatar: function hasAvatar(client) {
      return client.user.avatar !== null;
    },
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    clickExpandFunc: function clickExpandFunc(index) {
      var client = this.clientList[index];
      if (client.expended === false) {
        // arrow up
        client.img = 'static/img/image-rotate.png';
        client.expended = true;
      } else {
        // arrow down
        client.img = 'static/img/arrow.png';
        client.expended = false;
      }
      this.clientList[index] = client;
    },
    confirmDelete: function confirmDelete(id, index) {
      this.showDeleteDialog = true;
      this.clientId = id;
      this.clientIndex = index;
    },
    deleteClient: function deleteClient(id, index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/delete/', {
        id: id
      }).then(function (response) {
        _this.showDeleteDialog = false;
        _this.clientList.splice(index, 1);
      }).catch(function (error) {
        console.error(error);
      });
    },
    getClientInitials: function getClientInitials(client) {
      var clientInitials = '';

      if (client.user.firstName) {
        clientInitials += client.user.firstName.charAt(0);
      }
      if (client.lastName) {
        clientInitials += client.user.lastName.charAt(0);
      }
      if (clientInitials.length < 1) {
        clientInitials = 'NA';
      }

      return clientInitials;
    },
    getFullOfficeNumber: function getFullOfficeNumber(client) {
      var fullOfficeNum = void 0;
      if (client.user.officePhone !== null) {
        fullOfficeNum = client.user.officePhone;
        if (client.user.officeExt !== null) {
          fullOfficeNum += ', ' + client.user.officeExt;
        }
      } else {
        fullOfficeNum = 'Phone Not Listed';
      }
      return fullOfficeNum;
    },
    getFullDirectNumber: function getFullDirectNumber(client) {
      var fullDirectNum = void 0;
      if (client.user.directPhone !== null) {
        fullDirectNum = client.user.directPhone;
        if (client.user.directExt !== null) {
          fullDirectNum += ', ' + client.user.directExt;
        }
      } else {
        fullDirectNum = 'Phone Not Listed';
      }

      return fullDirectNum;
    },
    navToClient: function navToClient(client) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.loadClient({ isAdmin: false, clientId: client.id });

              case 2:
                _this2.$router.push('/client/tours');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    clickNewClient: function clickNewClient() {
      this.$router.push('/client/new');
    },
    editClient: function editClient(client) {
      this.loadClientEditor(client);
      this.$router.push('/client/edit');
    },
    clients: function clients() {
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/clients');
    },
    searchList: function searchList() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var searchval;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                searchval = _this3.search;
                _context2.next = 3;
                return _this3.loadClient({ isAdmin: true, search: searchval });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var latestThis;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              latestThis = _this4;

              _this4.isLoading = true;
              Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["lastReleaselist"])().then(function (defs) {
                latestThis.latestVersion = defs.data[0].v_no;
                latestThis.isLoading = false;
              });
              _context3.next = 5;
              return _this4.loadClient({ isAdmin: true, search: '' });

            case 5:
              if (_this4.currentClient) {
                _this4.resetClient();
              }

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),

/***/ "Onoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"users-settings-list"},[_c('div',{staticClass:"row marginBottom"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-3 peddingClassForAll peddingClassForAllLast"},[_c('label',{staticClass:"container"},[_vm._v("All\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"click":_vm.selectAllFunction,"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.clientList),function(client,index){return (_vm.clientList != null)?_c('span',{key:index,attrs:{"id":client.id}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row item-wrap "},[_c('div',{staticClass:"col-3 line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"el user-item"},[_c('h3',[_vm._v(_vm._s(client.companyName))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 line-item hovered-line list-group-item btn-visible"},[(client.user)?_c('span',[_c('div',{staticClass:"el email-item"},[_c('h3',[_vm._v(_vm._s(client.user.firstName + ' ' + client.user.lastName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(client.user.title))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-3",staticStyle:{"float":"right"}},[_c('label',{staticClass:"container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedNames),expression:"checkedNames"}],attrs:{"type":"checkbox","id":"jack"},domProps:{"value":client.id,"checked":Array.isArray(_vm.checkedNames)?_vm._i(_vm.checkedNames,client.id)>-1:(_vm.checkedNames)},on:{"change":function($event){var $$a=_vm.checkedNames,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=client.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedNames=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedNames=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedNames=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"el logout-button"},[_c('md-button',{on:{"click":function($event){_vm.enableClientForInCoTour()}}},[_vm._v("save")])],1)])],2)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"user-saving-message"},[_c('span',[_c('md-progress-spinner',{staticClass:"md-accent user-saving-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}),_vm._v("\n                    Saving User(s) Details...\n                ")],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OpWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P88y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"RouteView"}},[_c('div',{staticClass:"search open-search"},[_c('md-icon',{staticClass:"search-glass-icon"},[_vm._v("search")]),_vm._v(" "),_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"md-input-focused md-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterString),expression:"filterString"}],staticClass:"md-input",attrs:{"type":"text"},domProps:{"value":(_vm.filterString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterString=$event.target.value}}})])])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"mycheck",class:[{'scroll-list' : _vm.checkifNumberOfTopicsInRouteMoreThan4()}, {'scroll-list-smaller' : !_vm.checkifNumberOfTopicsInRouteMoreThan4()}],attrs:{"id":"scrollSize"}},[_c('md-list',{staticClass:"img-list check-avatar selectable"},[_c('draggable',{attrs:{"id":"topicsTabList"},on:{"update":function($event){_vm.onUpdate(_vm.topics)}},model:{value:(_vm.topics),callback:function ($$v) {_vm.topics=$$v},expression:"topics"}},_vm._l((_vm.topics),function(topic,index){return (_vm.filterCheck(topic.name))?_c('md-list-item',{key:topic.id,class:[{'topDotted': _vm.notTop(index)}, {'bottomDotted': _vm.notBottom(index)}, {'back-grey': topic.mapHover}],staticStyle:{"width":"100%"},on:{"click":function($event){},"mouseover":function($event){_vm.toggleHoverOn(index)},"mouseleave":function($event){_vm.toggleHoverLeave(index)}}},[(topic.checkCompleteImages == 1)?_c('span',[_c('img',{staticClass:"completeImages",attrs:{"src":"static/img/complete.png"}})]):_c('span',[_c('img',{staticClass:"inCompleteImages",staticStyle:{"width":"13px"},attrs:{"src":"static/img/inComplete.png"}})]),_vm._v(" "),_c('div',{staticClass:"routeNameInfo",attrs:{"role":"button"}},[_c('div',{staticClass:"avatar s-36 material-icons material-icons-My",on:{"click":function($event){_vm.navigateToTopic(topic, index)}}},[_c('img',{attrs:{"src":_vm.getImageSrc(topic.avatar)}})]),_vm._v(" "),_c('div',{staticClass:"md-list-item-text"},[_c('md-button',[_c('div',{on:{"click":function($event){_vm.navigateToTopic(topic, index)}}},[_c('h3',[_vm._v(_vm._s(topic.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(topic.address))])]),_vm._v(" "),_c('md-tooltip',{staticClass:"hoverAtchedStory",staticStyle:{"height":"auto","margin-left":"6%"},attrs:{"md-direction":"right","md-active":_vm.tooltipActive[index]},on:{"update:mdActive":function($event){_vm.$set(_vm.tooltipActive, index, $event)}}},[(_vm.triggersListTrue)?_c('span',_vm._l((_vm.triggersList),function(trigger){return _c('span',{key:trigger.toiId},[(topic.id == trigger.toiId)?_c('p',[(trigger.storyName)?_c('span',[_c('span',[_vm._v(_vm._s(trigger.storyName))]),_vm._v(" "),(trigger.extra_story_id)?_c('span',[_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(trigger.storyNameCopy))])]):_vm._e()]):_vm._e()]):_vm._e()])})):_vm._e()])],1)],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Remove Topic from Route"},on:{"click":function($event){_vm.confirmDelete(index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)]):_vm._e()}))],1)],1),_vm._v(" "),(_vm.pencilIconSelected)?_c('div',[((_vm.pencilIconSelected && _vm.pathHasPoints) || _vm.routeChanged)?_c('footer',{staticClass:"aside-btn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pencilIconSelected && _vm.pathHasPoints),expression:"pencilIconSelected && pathHasPoints"}],staticClass:"btn-wrap",class:{ 'add-btn': (_vm.routeChanged && _vm.pencilIconSelected && _vm.pathHasPoints) }},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.confirmDeleteClear(1)}}},[_vm._v("Clear Path")])],1),_vm._v(" "),_c('div',{staticClass:"btn-wrap",class:{ 'add-btn': (_vm.routeChanged && _vm.pencilIconSelected && _vm.pathHasPoints) }},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.pencilIconSelected && _vm.pathHasPoints),expression:"pencilIconSelected && pathHasPoints"}],staticClass:"md-raised md-primary",on:{"click":_vm.saveRoute}},[_vm._v("Save Route")])],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pencilIconSelectedAlt)?_c('div',[((_vm.pencilIconSelectedAlt && _vm.pathHasPointsAlt) || _vm.routeChangedAlt)?_c('footer',{staticClass:"aside-btn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pencilIconSelectedAlt && _vm.pathHasPointsAlt),expression:"pencilIconSelectedAlt && pathHasPointsAlt"}],staticClass:"btn-wrap",class:{ 'add-btn': (_vm.routeChangedAlt && _vm.pencilIconSelectedAlt && _vm.pathHasPointsAlt) }},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.confirmDeleteClear(0)}}},[_vm._v("Clear Alternate Path")])],1),_vm._v(" "),_c('div',{staticClass:"btn-wrap",class:{ 'add-btn': (_vm.routeChangedAlt && _vm.pencilIconSelectedAlt && _vm.pathHasPointsAlt) }},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.pencilIconSelectedAlt && _vm.pathHasPointsAlt),expression:"pencilIconSelectedAlt && pathHasPointsAlt"}],staticClass:"md-raised md-primary",on:{"click":_vm.saveRouteAlt}},[_vm._v("Save Alternate Route")])],1)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Deleting this Topic will delete these TriggerZones associated with it:\n            "),_c('div',[_c('br'),_vm._v(" "),_vm._l((_vm.triggersList),function(trigger){return _c('span',{key:trigger.toiId},[(_vm.showTriggerListId == trigger.toiId)?_c('p',{staticStyle:{"margin-bottom":"-15px"}},[_c('b',[_c('span',[_vm._v("-"+_vm._s(trigger.name))])])]):_vm._e()])})],2)]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.clickDeleteTopic(_vm.topicDeleteid)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogPath},on:{"update:mdActive":function($event){_vm.showDeleteDialogPath=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete this path?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.clickDeleteTopic(_vm.topicDeleteid)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogClear},on:{"update:mdActive":function($event){_vm.showDeleteDialogClear=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to erase the drawn path?\n        ")]),_vm._v(" "),(_vm.deletePathConfirmation === 1)?_c('div',[_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deletePath()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialogClear = false}}},[_vm._v("CANCEL")])],1)],1):_vm._e(),_vm._v(" "),(_vm.deletePathConfirmation === 0)?_c('div',[_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deletePathAlt()}}},[_vm._v("Delete")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialogClear = false}}},[_vm._v("CANCEL")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PPXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("OAKB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571d9957_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("ya+X");
function injectStyle (ssrContext) {
  __webpack_require__("7eGZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-571d9957"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571d9957_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PQ87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsAudience_vue__ = __webpack_require__("gC3n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2649884f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsAudience_vue__ = __webpack_require__("WW5V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsAudience_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2649884f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsAudience_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PbIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newTourTab"}},[_c('div',{staticClass:"scroll-list new-tour-sidebar"},[_c('div',{staticClass:"fields-wrap"},[_c('form',[_c('div',{staticClass:"line-item"},[_c('md-field',{attrs:{"md-no-float":"","name":"tourName"}},[_c('md-input',{staticClass:"ng-pristine ng-valid md-input ng-empty ng-touched",attrs:{"placeholder":"Tour Name","name":"tourName"},on:{"blur":function($event){_vm.nameFieldTouchHandler()}},model:{value:(_vm.newTourName),callback:function ($$v) {_vm.newTourName=$$v},expression:"newTourName"}})],1),_vm._v(" "),(_vm.$v.newTourName.$error)?_c('span',{staticClass:"new-tour-error"},[_vm._v("The tour name is required.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{attrs:{"md-no-float":"","name":"tourDesc"}},[_c('md-input',{staticClass:"ng-pristine ng-valid md-input ng-empty ng-touched",attrs:{"placeholder":"Tour Description","name":"tourDesc"},on:{"blur":function($event){_vm.descFieldTouchHandler()}},model:{value:(_vm.newTourDescription),callback:function ($$v) {_vm.newTourDescription=$$v},expression:"newTourDescription"}})],1),_vm._v(" "),(_vm.$v.newTourDescription.$error)?_c('span',{staticClass:"new-tour-error"},[_vm._v("The tour description is required.")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"md-field tourLocation"},[_c('GmapAutocomplete',{staticClass:"ng-pristine ng-valid md-input ng-empty ng-touched",attrs:{"placeholder":"Tour Location"},on:{"place_changed":_vm.getSelectedLocation}})],1),_vm._v(" "),(_vm.newTourLocation.id)?_c('span',{staticClass:"selected-tour-text"},[_vm._v("Selected Location: "+_vm._s(_vm.newTourLocation.formatted_address))]):_vm._e()])])])]),_vm._v(" "),(!_vm.$v.$invalid)?_c('footer',{staticClass:"aside-btn"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.createNewTour}},[_vm._v("Create")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PcsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PkVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_TopicService_js__ = __webpack_require__("v50o");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedTopics: [],
      selectedInput: {},
      autocompleteInput: '',
      showDialog: false,
      isLoadingmy: false,
      selectAllTopics: false,
      showDeleteDialog: false,
      routesNames: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
    realTopics: function realTopics(state) {
      return state.map.topicsOfInterest;
    },
    virtualTopics: function virtualTopics(state) {
      return state.map.virtualTopics;
    },
    currentTour: function currentTour(state) {
      return state.tours.currentTour;
    },
    vTopicCondition: function vTopicCondition(state) {
      return state.topics.virtualTopicCondition;
    },
    center: function center(state) {
      return state.map.center;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('routes', ['routesList']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('topics', { topics: 'topicsList' }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('map', ['bounds']), {
    topicsSelected: function topicsSelected() {
      return this.selectedTopics.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('routes', ['insertNewRoute', 'insertNewRouteTopics']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('topics', ['loadTopics', 'toggleTopicHover', 'setTopicsList', 'reSortTopics']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('routes', ['loadRoutes']), {
    toggleSelectedTopic: function toggleSelectedTopic(index) {
      this.topics[index].selected = !this.topics[index].selected;
      if (this.selectedTopics.includes(index)) {
        var selectedIndex = this.selectedTopics.indexOf(index);
        this.selectedTopics.splice(selectedIndex, 1);
      } else {
        this.selectedTopics.push(index);
      }
      this.checkAllSelected();
    },
    confirmDelete: function confirmDelete() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var topicIds, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                topicIds = _this.getTopicIdsFromIndexes();
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TopicService_js__["b" /* getRouteNames */])(topicIds);

              case 3:
                response = _context.sent;

                _this.routesNames = response.data;
                _this.showDeleteDialog = true;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    titleCase: function titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    checkTopicsinList: function checkTopicsinList() {
      return this.topics.length > 0;
    },
    toggleSelectAll: function toggleSelectAll(event) {
      if (event === true) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.topics)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var index = _step.value;

            if (!this.selectedTopics.includes(parseInt(index))) {
              this.topics[index].selected = true;
              this.selectedTopics.push(parseInt(index));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.topics), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var topic = _step2.value;

            topic.selected = false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.selectedTopics = [];
      }
    },
    checkAllSelected: function checkAllSelected() {
      if (this.selectedTopics.length === this.topics.length) {
        this.selectAllTopics = true;
      } else {
        this.selectAllTopics = false;
      }
    },
    hoverOn: function hoverOn(index) {
      this.$bus.$emit('hoveredTopic', { topicIndex: index, toggle: true });
      this.toggleTopicHover({ index: index, hover: true });
    },
    hoverOff: function hoverOff(index) {
      this.$bus.$emit('hoveredTopic', { topicIndex: index, toggle: false });
      this.toggleTopicHover({ index: index, hover: false });
    },
    getImageSrc: function getImageSrc(image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/' + image;
        } else {
          return image;
        }
      }
    },
    toggleExpand: function toggleExpand(index) {
      this.topics[index].expanded = !this.topics[index].expanded;
    },
    addTopic: function addTopic() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.$refs.search.$el.value.replace(/^\s+|\s+$/g, '').length > 0)) {
                  _context2.next = 7;
                  break;
                }

                if (_this2.autocompleteInput === _this2.$refs.search.$el.value) {
                  _this2.selectedInput.isReal = 1;
                  _this2.$store.dispatch('map/setCenter', _this2.selectedInput);
                  _this2.selectedInput.address = _this2.selectedInput.formatted_address;
                  if (_this2.selectedInput.photos) {
                    _this2.selectedInput.avatar = _this2.selectedInput.photos[0].getUrl({ 'maxWidth': 100, 'maxHeight': 100 }).replace('w100-h100-k', 'k');
                  } else {
                    _this2.selectedInput.avatar = 'topic_default.png';
                  }
                } else {
                  _this2.selectedInput.isReal = 0;
                  _this2.selectedInput.name = _this2.$refs.search.$el.value;
                  _this2.selectedInput.latLng = { lat: _this2.center.lat, lng: _this2.center.lng };
                  _this2.selectedInput.avatar = 'virtual_default.png';
                }

                if (!_this2.topicUniqueCheck(_this2.selectedInput.name)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__["g" /* newTopic */](_this2.selectedInput);

              case 5:
                response = _context2.sent;

                if (response.status === 200) {
                  _this2.$refs.search.$el.value = '';
                  _this2.selectedInput.id = response.data.id;
                  _this2.selectedInput.selected = false;
                  _this2.selectedInput.hover = false;
                  _this2.selectedInput.mapHover = false;
                  _this2.selectedInput.expanded = false;
                  _this2.selectedInput.stories = [];
                  _this2.topics.push(_this2.selectedInput);
                  _this2.reSortTopics();
                  _this2.selectedInput = {};
                } else {
                  console.log(response);
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    topicUniqueCheck: function topicUniqueCheck(topicName) {
      var unique = true;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.topics), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var topic = _step3.value;

          if (topic.name.toLowerCase() === topicName.toLowerCase()) {
            unique = false;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return unique;
    },
    newPlaceSelected: function newPlaceSelected(e) {
      this.autocompleteInput = this.$refs.search.$el.value;
      this.selectedInput = e;
      this.selectedInput.latLng = { lat: e.geometry.location.lat(), lng: e.geometry.location.lng() };
    },
    saveChanges: function saveChanges() {
      __WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__["o" /* updateTopics */]();
    },
    createNewRoute: function createNewRoute() {
      var _this3 = this;

      var routeTopics = this.getTopicIdsFromIndexes();
      var newRoute = {
        name: 'New ' + this.currentTour.city + ' Route',
        tourId: this.currentTour.id,
        vehicleId: null, // this should default to something or be selectable somehow (?)
        description: 'This is a new route.',
        avatar: null,
        channels: null,
        path: null,
        commentary: 0,
        notificationSound: 0,
        commentaryDelay: 1,
        audioControllerNotification: 0,
        audioControllerFlashTime: 2,
        headendSys: null,
        notificationSongId: null,
        routeTopics: routeTopics
      };
      this.insertNewRoute(newRoute).then(function () {
        _this3.$router.push('/tour/route');
      });
    },
    addTopicsToRoute: function addTopicsToRoute(route) {
      var _this4 = this;

      var topicsToAdd = this.getTopicIdsFromIndexes();
      this.insertNewRouteTopics({ route: route, newTopics: topicsToAdd }).then(function () {
        _this4.$router.push('/tour/route');
      });
    },
    clickDeleteTopics: function clickDeleteTopics() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var topicIds, response, forCheckthis;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                topicIds = _this5.getTopicIdsFromIndexes();
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TopicService_js__["a" /* deleteTopics */])(topicIds);

              case 3:
                response = _context3.sent;

                if (response.status === 200) {
                  _this5.selectedTopics = [];
                  forCheckthis = _this5;

                  _this5.loadTopics(_this5.currentTour.id).then(function (data) {
                    forCheckthis.loadRoutes(forCheckthis.currentTour.id);
                  });
                  _this5.showDeleteDialog = false;
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getTopicIdsFromIndexes: function getTopicIdsFromIndexes() {
      var indexes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedTopics;

      var topicIds = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(indexes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var index = _step4.value;

          topicIds.push(this.topics[index].id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return topicIds;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('scrollList');
  },
  mounted: function mounted() {
    this.$bus.$on('scrollList', function ($params) {
      if ($params.toggle) {
        var container = document.getElementById('scrollSize');
        var element = document.getElementById('topicsTabList').childNodes[$params.topicIndex];
        var cTop = container.scrollTop;
        var cBottom = cTop + container.clientHeight;
        var eTop = element.offsetTop;
        var eBottom = eTop + element.clientHeight;
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= cTop - eTop;
        } else if (eBottom > cBottom) {
          container.scrollTop += eBottom - cBottom;
        }
      }
    });
  }
});

/***/ }),

/***/ "QRNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_EditorService_js__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newTourName: '',
      newTourDescription: '',
      newTourLocation: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('tours', ['currentTour', 'currentTourImage'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['loadTourEditor']), {
    getSelectedLocation: function getSelectedLocation(place) {
      this.newTourLocation = place;
      var newCenter = { latLng: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() } };
      this.$store.dispatch('map/setCenter', newCenter);
      this.error = { state: false, message: '' };
    },
    getImageSrc: function getImageSrc(image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    nameFieldTouchHandler: function nameFieldTouchHandler() {
      if (!this.$v.newTourName.$dirty) {
        this.$v.newTourName.$touch();
      }
    },
    descFieldTouchHandler: function descFieldTouchHandler() {
      if (!this.$v.newTourDescription.$dirty) {
        this.$v.newTourDescription.$touch();
      }
    },
    createNewTour: function createNewTour() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newTour, newTourImage, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newTour = _this.currentTour;
                newTourImage = _this.currentTourImage;

                _this.error = { state: false, message: '' };
                newTour.name = _this.newTourName;
                newTour.description = _this.newTourDescription;
                newTour.city = _this.newTourLocation.name;
                newTour.image = newTourImage;
                if (_this.newTourLocation.photos) {
                  newTour.card = _this.newTourLocation.photos[0].getUrl({ 'maxWidth': 1500, 'maxHeight': 1500 }).replace('w100-h100-k', 'k');
                } else {
                  newTour.card = 'Cortex_Image_Placeholder.png';
                }
                newTour.latLng = { lat: _this.newTourLocation.geometry.location.lat(), lng: _this.newTourLocation.geometry.location.lng() };
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3__services_EditorService_js__["h" /* newTour */](newTour);

              case 11:
                response = _context.sent;

                if (response.data.success === true) {
                  newTour.id = response.data.tour.id;
                  newTour.card = response.data.tour.card;
                  _this.loadTourEditor(newTour);
                  _this.$router.push('/tour');
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  validations: {
    newTourName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    newTourDescription: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    newTourLocation: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('map/setCenter', { latLng: { lat: 40.4802649, lng: -111.9143293 } });
  }
});

/***/ }),

/***/ "QfQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__ = __webpack_require__("4kyh");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function uniqueClientName(value) {
  var clients = this.$store.getters['client/clientList'];
  var unique = true;
  if (value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(clients), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var client = _step.value;

        if (client.companyName.toLowerCase() === value.toLowerCase()) {
          unique = false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return unique;
}

function uniqueEmail(value) {
  var contacts = this.newClientContacts;
  var matches = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(contacts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var contact = _step2.value;

      if (contact.email) {
        if (contact.email.toLowerCase() === value.toLowerCase()) {
          matches = matches + 1;
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return matches <= 1;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      recordUpdateSucc: false,
      recordUpdateSuccs: false,
      detailsAreVisible: false,
      detailsAreVisibleChild: false,
      buttonVisibleParent: true,
      checkChild: false,
      showContact: false,
      forParentDelet: true,
      clientPhoneNumeberCheck: false,
      dataChek: 0,
      newClient: {
        companyName: null,
        phoneNumber: null,
        website: null,
        country: null,
        stateProvince: null,
        address: null,
        description: null,
        zipPostalCode: null,
        isAnalytics: false
      },
      newClientContacts: [{
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isPrimaryContact: true
      }],
      contactFormError: null,
      validationErrors: []
    };
  },
  computed: {
    hasMultipleContacts: function hasMultipleContacts() {
      return this.newClientContacts.length > 1;
    }
  },
  methods: {
    acceptNumber: function acceptNumber() {
      var x = this.newClient.phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClient.phoneNumber = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
      this.clientPhoneNumeberCheck = true;
    },
    acceptNumberContactOfficePhone: function acceptNumberContactOfficePhone(indexs) {
      var x = this.newClientContacts[indexs].officePhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClientContacts[indexs].officePhone = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
    },
    acceptNumberContactDirPhone: function acceptNumberContactDirPhone(indexs) {
      var x = this.newClientContacts[indexs].directPhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,9})/);
      this.newClientContacts[indexs].directPhone = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? x[3] : '');
    },
    clientTouchHanlder: function clientTouchHanlder(key) {
      if (key === 'phoneNumber') {}
      if (!this.$v.newClient[key].$dirty) {
        this.$v.newClient[key].$touch();
      }
    },
    contactTouchHanlder: function contactTouchHanlder(index, key) {
      if (!this.$v.newClientContacts.$each[index][key].$dirty) {
        this.$v.newClientContacts.$each[index][key].$touch();
      }
    },
    clickSaveNewClient: function clickSaveNewClient() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /* if (!this.newClient.companyName) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      }
                      if (!this.newClient.phoneNumber) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      }
                      if (!this.newClient.address) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      } else if (this.newClient.phoneNumber) {
                        setTimeout(() => {
                          this.recordUpdateSuccs = true;
                        }, 3000);
                        await saveNewClient(this.newClient)
                          .then(response => {
                            this.recordUpdateSuccs = true;
                            setTimeout(() => {
                              this.$router.push('/client/list');
                            }, 5000);
                            // this.$router.push('/client/list');
                          })
                          .catch(error => {
                            if (error.response.data.type === 'DUPLICATE_EMAIL') {
                              this.contactFormError = error.response.data.message;
                            }
                          });
                      }
                      return false; */
                _this.validationErrors = [];
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__["t" /* saveNewClient */])(_this.newClient).then(function (response) {
                  _this.recordUpdateSuccs = true;
                  setTimeout(function () {
                    _this.$router.push('/client/list');
                  }, 5000);
                }).catch(function (error) {
                  console.log(error.response.data);
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    _this.contactFormError = error.response.data.message;
                  }
                  _this.validationErrors = error.response.data.errors;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clickSaveNewClientAndContact: function clickSaveNewClientAndContact() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /* function validateEmail (email) {
                        const re = /\S+@\S+\.\S+/;
                        return re.test(email);
                      } */

                /* if (!this.newClient.companyName) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      }
                      if (!this.newClient.address) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      }
                      if (!this.newClient.phoneNumber) {
                        this.recordUpdateSucc = true;
                        setTimeout(() => {
                          this.recordUpdateSucc = false;
                        }, 3000);
                      }
                      for (var i = 0; i < this.newClientContacts.length; i++) {
                        if (!this.newClientContacts[i].email) {
                          if (!validateEmail(this.newClientContacts[i].email)) {
                            return false;
                          }
                          this.recordUpdateSucc = true;
                          setTimeout(() => {
                            this.recordUpdateSucc = false;
                          }, 3000);
                        } else if (!this.newClientContacts[i].title) {
                          this.recordUpdateSucc = true;
                          setTimeout(() => {
                            this.recordUpdateSucc = false;
                          }, 3000);
                        } else if (!this.newClientContacts[i].firstName) {
                          this.recordUpdateSucc = true;
                          setTimeout(() => {
                            this.recordUpdateSucc = false;
                          }, 3000);
                        } else if (!this.newClientContacts[i].lastName) {
                          this.recordUpdateSucc = true;
                          setTimeout(() => {
                            this.recordUpdateSucc = false;
                          }, 3000);
                        } else if (!this.newClientContacts[i].directPhone) {
                          this.recordUpdateSucc = true;
                          setTimeout(() => {
                            this.recordUpdateSucc = false;
                          }, 3000);
                        } else if (this.newClientContacts[i].directPhone) {
                          if (isNaN(this.newClientContacts[i].directPhone)) {
                            console.log(this.newClientContacts[i].directPhone + 'not a number');
                          } else { */
                _this2.validationErrors = [];
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService_js__["u" /* saveNewClientContact */])(_this2.newClient, _this2.newClientContacts).then(function (response) {
                  _this2.recordUpdateSuccs = true;
                  setTimeout(function () {
                    _this2.$router.push('/client/list');
                  }, 5000);
                }).catch(function (error) {
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    _this2.contactFormError = error.response.data.message;
                  }
                  _this2.validationErrors = error.response.data.errors;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addContactParent: function addContactParent() {
      this.detailsAreVisible = true;
      this.buttonVisibleParent = false;
      this.checkChild = true;
    },
    addContact: function addContact() {
      this.detailsAreVisible = true;
      this.newClientContacts.push({
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isPrimaryContact: false
      });
    },
    deleteContact: function deleteContact(index) {
      var validationErrors = this.validationErrors;

      if (validationErrors['newContacts.' + index + '.firstName']) {
        delete validationErrors['newContacts.' + index + '.firstName'];
        delete validationErrors['newContacts.' + index + '.lastName'];
        delete validationErrors['newContacts.' + index + '.email'];
        delete validationErrors['newContacts.' + index + '.directPhone'];
        delete validationErrors['newContacts.' + index + '.title'];
      }

      this.validationErrors = validationErrors;

      if (this.newClientContacts[index].isPrimaryContact) {
        if (index === 0) {
          this.newClientContacts[1].isPrimaryContact = true;
        } else {
          this.newClientContacts[0].isPrimaryContact = false;
        }
      }
      this.newClientContacts.splice(index, 1);
    },
    deleteContacts: function deleteContacts(index) {
      this.forParentDelet = false;
      this.newClientContacts[0].firstName = null;
      this.newClientContacts[0].lastName = null;
      this.newClientContacts[0].title = null;
      this.newClientContacts[0].email = null;
      this.newClientContacts[0].officePhone = null;
      this.newClientContacts[0].directPhone = null;
      this.detailsAreVisible = false;
      this.buttonVisibleParent = true;
      this.checkChild = false;
      this.validationErrors = [];
    },
    setPrimaryContact: function setPrimaryContact(primaryIndex) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.newClientContacts.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref = _step3.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var index = _ref2[0];
          var contact = _ref2[1];

          if (index === primaryIndex) {
            contact.isPrimaryContact = true;
          } else {
            contact.isPrimaryContact = false;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  },
  validations: {
    newClient: {
      companyName: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
        uniqueClientName: uniqueClientName
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
        validPhoneNumber: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["d" /* validPhoneNumber */]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
      },
      zipPostalCode: {
        validPostalOrZip: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["e" /* validPostalOrZip */]
      },
      website: {
        url: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["url"]
      }
    },
    newClientContacts: {
      $each: {
        firstName: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
        },
        lastName: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
        },
        title: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
        },
        email: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"],
          validateEmailContact: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["f" /* validateEmailContact */],
          uniqueEmail: uniqueEmail
        },
        directPhone: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
          validPhoneNumber: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["d" /* validPhoneNumber */]
        },
        officePhone: {
          notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
          validPhoneNumber: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["d" /* validPhoneNumber */]
        }
      }
    }
  }
});

/***/ }),

/***/ "QnAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourSettings_vue__ = __webpack_require__("VsjP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c311127_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourSettings_vue__ = __webpack_require__("nFFb");
function injectStyle (ssrContext) {
  __webpack_require__("8eX7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c311127"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c311127_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R3Xb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ClientService_js__ = __webpack_require__("Fedb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dragging: false,
      UserManualList: [],
      clientIdCurrent: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['userList', 'isAdmin', 'currentUser'])),
  methods: {
    loadUserActivity: function loadUserActivity() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.currentClient) {
                  _this.clientIdCurrent = _this.currentClient.id;
                } else {
                  _this.clientIdCurrent = _this.currentUser.clientId;
                }
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ClientService_js__["l" /* getUserActivityDetails */])(_this.clientIdCurrent);

              case 3:
                result = _context.sent;

                _this.UserManualList = result.data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadUserActivity();
  }
});

/***/ }),

/***/ "RO8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__ = __webpack_require__("V8i3");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var convertTimeHHMMSS = function convertTimeHHMMSS(val) {
  var hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};
var AudioPlayer = {
  template: '\n        <div class="player">\n        <div class="player-controls">\n            <div><a v-on:click.prevent="stop" title="Stop" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="playing = !playing" title="Play/Pause" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!playing" fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"/>\n                    <path v-else fill="currentColor" d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"/>\n                </svg>\n            </a></div>\n            <div>\n                <div v-on:click="seek" class="player-progress" title="Time played : Total time">\n                    <div :style="{ width: this.percentComplete + \'%\' }" class="player-seeker"></div>\n                </div>\n                <div class="player-time">\n                    <div class="player-time-current">{{ currentTime }}</div>\n                    <div class="player-time-total">{{ durationTime }}</div>\n                </div>\n            </div>\n            <div><a v-on:click.prevent="download" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="innerLoop = !innerLoop" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!innerLoop" fill="currentColor" d="M1,12V5h3v6h10V8l5,4.5L14,17v-3H3C1.895,14,1,13.104,1,12z"/>\n                    <path v-else fill="currentColor" d="M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="mute" title="Mute" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path v-if="!muted" fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"/>\n                    <path v-else fill="currentColor" d="M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"/>\n                </svg>\n            </a></div>\n            <div><a v-on:click.prevent="" v-on:mouseenter="showVolume = true" title="Volume" href="#">\n                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">\n                    <path fill="currentColor" d="M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"/>\n                </svg>\n                <input v-model.lazy.number="volume" v-show="showVolume" type="range" min="0" max="100"/></a></div>\n        </div>\n        <audio :loop="innerLoop" ref="audiofile" :src="file" preload="auto" style="display: none;"></audio>\n        </div>',
  props: {
    file: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    };
  },
  computed: {
    currentTime: function currentTime() {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime: function durationTime() {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete: function percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted: function muted() {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing: function playing(value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume: function volume(value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download: function download() {
      this.stop();
      window.open(this.file, 'download');
    },
    load: function load() {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },
    mute: function mute() {
      if (this.muted) {
        this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek: function seek(e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }
      var el = e.target.getBoundingClientRect();
      var seekPos = (e.clientX - el.left) / el.width;
      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop: function stop() {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update: function update(e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  created: function created() {
    this.innerLoop = this.loop;
  },
  mounted: function mounted() {
    var _this = this;

    this.audio = this.$el.querySelectorAll('audio')[0];
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', function () {
      _this.playing = false;
    });
    this.audio.addEventListener('play', function () {
      _this.playing = true;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      triggersListTemp: '',
      enabled: true,
      dragging: false,
      iconClick: false,
      rawIcon: 'videocam',
      showChilddData: [],
      addMoreInfoShow: true,
      reoveMoreInfoShow: false,
      secandStoryName: '',
      triggernotesids: [],
      stories_length: '',
      inCompleteImages: false,
      completeImages: false,
      showDeleteDialog: false,
      showDeleteDialogMore: false,
      triggerIdDelete: '',
      indexDataDelete: '',
      showDeleteDialogChannel: false,
      vedioSrc: '',
      file1: '',
      showModalForTrgPass: false,
      triggerZonePassword: '',
      triggerZonePassId: '',
      triggerZonePassName: '',
      isLoading: false
    };
  },
  components: {
    AudioPlayer: AudioPlayer,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('library', { stories: 'getStories' }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('routes', ['currentRoute']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('topics', ['currentTopic']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('triggers', { triggersList: 'triggersList', triggerStories: 'storyFiles', currentTrigger: 'currentTrigger' }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('tours', ['currentTour']), {
    sortedLanguages: {
      get: function get() {
        return this.triggersList;
      },
      set: function set(value) {
        this.updateTriggerZoneOrder({ triggersList: value });
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('map', ['setCenter']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('editor', ['toggleShowTriggerTabs']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('library', ['loadStories']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('triggers', ['assignStoryFiles', 'assignStory', 'loadTriggerList', 'setCurrentTrigger', 'addNewTrigger', 'clearCurrentTrigger', 'clearStateTriggersList', 'toggleTriggerHovered', 'saveTriggerZone', 'loadRouteTriggers', 'updateTriggerZoneOrder']), {
    loadStoryFiles: function loadStoryFiles(storyName, storyNameCopy, routeId, triggerId, topicId) {
      if (this.reoveMoreInfoShow === false) {
        // storyNameCopy = '';
      }
      this.assignStoryFiles({
        tourId: this.currentTour.id,
        friendlyName: storyName,
        friendlyNameCopy: storyNameCopy,
        routeId: routeId,
        triggerId: triggerId,
        topicId: topicId
      });
      this.toggleShowSettings(true);
    },
    onUpdate: function onUpdate() {
      this.showChilddData = [];
      this.saveUserManualOrder();
    },
    saveUserManualOrder: function saveUserManualOrder() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var results, result, list, count, pp, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["k" /* saveTriggerOrder */])(_this2.triggersList);

              case 2:
                results = _context.sent;

                if (!(results.data === 'success')) {
                  _context.next = 23;
                  break;
                }

                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["m" /* triggerIdsNotes */])(_this2.currentTopic.id);

              case 6:
                result = _context.sent;
                list = result.data;

                for (count = 0; count < list.length; count++) {
                  if (list[count]['tzId'] > 0) {
                    _this2.triggernotesids.push(list[count]['tzId']);
                  }
                }
                _context.next = 11;
                return _this2.clearCurrentTrigger();

              case 11:
                _context.next = 13;
                return _this2.clearStateTriggersList();

              case 13:
                _context.next = 15;
                return _this2.loadStories({ clientId: _this2.currentClient.id, tourId: _this2.currentTour.id, topicId: _this2.currentTopic.id, currentRouteID: _this2.currentRoute.id });

              case 15:
                pp = _this2;
                _context.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["b" /* checkChannels */])(_this2.currentTour.id);

              case 18:
                response = _context.sent;

                if (response.data === 'true') {
                  pp.isLoading = true;
                }
                _this2.loadRouteTriggers(_this2.currentRoute.id).then(function () {
                  pp.isLoading = false;
                  for (var i = 0; i < _this2.triggersList.length; i++) {
                    var extraStoryId = _this2.triggersList[i].extra_story_id;
                    if (extraStoryId) {
                      _this2.showChilddData.push(i);
                    }
                  }
                });
                if (_this2.showChilddData.length > 0) {
                  _this2.addMoreInfoShow = false;
                  _this2.reoveMoreInfoShow = true;
                }
                _this2.stories_length = _this2.stories[0].fileLengthSort;

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    confirmDeleteMore: function confirmDeleteMore(triggerId, index) {
      this.showDeleteDialogMore = true;
      this.triggerIdDelete = triggerId;
      this.indexDataDelete = index;
    },
    confirmDelete: function confirmDelete(triggerId, index) {
      this.showDeleteDialog = true;
      this.triggerIdDelete = triggerId;
      this.indexDataDelete = index;
    },
    MoreInfoFunction: function MoreInfoFunction(trigger, index) {
      this.triggersList[index].activeInactiveImages = 0;
      this.showChilddData.push(index);
      this.addMoreInfoShow = false;
      this.reoveMoreInfoShow = true;
    },
    removeMoreInfoFunction: function removeMoreInfoFunction(trigger, indexData) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.addMoreInfoShow = true;
                _this3.reoveMoreInfoShow = false;
                _this3.showChilddData = _this3.showChilddData.filter(function (item) {
                  return item !== indexData;
                });
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["h" /* removeMoreInfo */])(trigger);

              case 5:
                _context2.next = 7;
                return _this3.loadRouteTriggers(_this3.currentRoute.id);

              case 7:
                _this3.showDeleteDialogMore = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    triggerHasVideo: function triggerHasVideo(story) {
      for (var i = 0; i < this.stories.length; i++) {
        if (this.stories[i].friendly_name === story && this.stories[i].isVideo === 1) {
          return true;
        }
      }
      return false;
    },
    assignStoryToTrigger: function assignStoryToTrigger(trigger, triggerRouteId) {
      if (trigger.storyName && (!trigger.oldStoryName || trigger.oldStoryName !== trigger.storyName)) {
        this.assignStory({
          clientId: this.currentClient.id,
          tourId: this.currentTour.id,
          topicId: trigger.toiId,
          triggerId: trigger.id,
          friendly_name: trigger.storyName,
          routeId: triggerRouteId
        });
        this.loadStories({ clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id, currentRouteID: triggerRouteId });
        this.loadRouteTriggers(triggerRouteId);
      }
    },
    assignStoryToTriggerCopy: function assignStoryToTriggerCopy(trigger, copy, triggerRouteId) {
      if (trigger.storyNameCopy && (!trigger.oldStoryNameExtra || trigger.oldStoryNameExtra !== trigger.storyNameCopy)) {
        this.assignStory({
          clientId: this.currentClient.id,
          tourId: this.currentTour.id,
          topicId: trigger.toiId,
          triggerId: trigger.id,
          copyStory: copy,
          friendly_name: trigger.storyNameCopy,
          routeId: triggerRouteId
        });
      }
    },
    navToTriggerSettings: function navToTriggerSettings(trigger) {
      this.setCurrentTrigger(trigger);
      this.setCenter({ latLng: this.currentTrigger.latLng });
      this.toggleShowTriggerTabs(true);
      if (this.iconClick === false) {
        this.$router.push('/tour/trigger');
      } else {
        this.$router.push('/tour/trigger/notes');
      }
    },
    goChangeNote: function goChangeNote(trigger) {
      this.iconClick = true;
    },
    createTriggerZone: function createTriggerZone() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, newTrigger;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["b" /* checkChannels */])(_this4.currentTour.id);

              case 2:
                response = _context3.sent;

                if (response.data === 'true') {
                  newTrigger = {
                    id: null,
                    name: 'Trigger',
                    toiId: _this4.currentTopic.id,
                    routeId: _this4.currentRoute.id,
                    activate: _this4.currentTour.defaultActivate,
                    radiusDistance: _this4.currentTour.defaultRadiusDistance,
                    heading: String(0),
                    tolerance: _this4.currentTour.defaultTolerance,
                    triggerMode: 'Queue',
                    delay: _this4.currentTour.defaultDelay,
                    isLocked: 0,
                    latLng: { lng: _this4.currentTopic.latLng.lng, lat: _this4.currentTopic.latLng.lat },
                    storyId: null,
                    priority: _this4.currentTour.priority
                  };

                  _this4.addNewTrigger(newTrigger).then(function () {
                    _this4.setCenter({ latLng: newTrigger.latLng });
                    _this4.toggleShowTriggerTabs(true);
                    _this4.$router.push('/tour/trigger');
                  });
                } else {
                  _this4.showDeleteDialogChannel = true;
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    copyTriggerZone: function copyTriggerZone(triggerId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, result, list, count, i, extraStoryId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["c" /* copyTrigger */])(triggerId);

              case 2:
                response = _context4.sent;

                if (!(response.data === 'success')) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["m" /* triggerIdsNotes */])(_this5.currentTopic.id);

              case 6:
                result = _context4.sent;
                list = result.data;

                for (count = 0; count < list.length; count++) {
                  _this5.triggernotesids.push(list[count]['tzId']);
                }
                _context4.next = 11;
                return _this5.clearCurrentTrigger();

              case 11:
                _context4.next = 13;
                return _this5.clearStateTriggersList();

              case 13:
                _context4.next = 15;
                return _this5.loadStories({ clientId: _this5.currentClient.id, tourId: _this5.currentTour.id, topicId: _this5.currentTopic.id, currentRouteID: _this5.currentRoute.id });

              case 15:
                _context4.next = 17;
                return _this5.loadRouteTriggers(_this5.currentRoute.id);

              case 17:
                for (i = 0; i < _this5.triggersList.length; i++) {
                  extraStoryId = _this5.triggersList[i].extra_story_id;

                  if (extraStoryId) {
                    _this5.showChilddData.push(i);
                  }
                }
                if (_this5.showChilddData.length > 0) {
                  _this5.addMoreInfoShow = false;
                  _this5.reoveMoreInfoShow = true;
                }
                _this5.stories_length = _this5.stories[0].fileLengthSort;

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    hoverOn: function hoverOn(index, triggerName) {
      this.toggleTriggerHovered({ index: index, hovered: true, triggerName: triggerName });
    },
    hoverOff: function hoverOff(index) {
      this.toggleTriggerHovered({ index: index, hovered: false });
    },
    clickDeleteTrigger: function clickDeleteTrigger(triggerIdDelete, indexDataDelete) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["e" /* deleteTrigger */])(triggerIdDelete);

              case 2:
                response = _context5.sent;

                if (response.status === 200) {
                  _this6.showChilddData = _this6.showChilddData.filter(function (item) {
                    return item !== indexDataDelete;
                  });
                  _this6.clearCurrentTrigger();
                  _this6.clearStateTriggersList();
                  _this6.loadStories({ clientId: _this6.currentClient.id, tourId: _this6.currentTour.id, topicId: _this6.currentTopic.id });
                  _this6.loadRouteTriggers(_this6.currentRoute.id);
                  _this6.triggerIdDelete = '';
                  _this6.indexDataDelete = '';
                  _this6.showDeleteDialog = false;
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    playVideMp3: function playVideMp3(fileUrlVA, type) {
      if (!fileUrlVA) {
        return;
      }
      if (Number(type) === 1) {
        this.$modal.hide('audio-file-play');
        this.$modal.show('video-file-play');
        this.vedioSrc = fileUrlVA;
        var vid = document.getElementById('video-container');
        vid.play();
      } else {
        this.$modal.hide('video-file-play');
        this.$modal.show('audio-file-play');
        this.file1 = fileUrlVA;
      }
    },
    createPassword: function createPassword(triggerId, triggerName) {
      this.showModalForTrgPass = true;
      this.triggerZonePassId = triggerId;
      this.triggerZonePassName = triggerName;
    }
  }),
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var result, list, count, pp, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["m" /* triggerIdsNotes */])(_this7.currentTopic.id);

            case 2:
              result = _context6.sent;
              list = result.data;

              for (count = 0; count < list.length; count++) {
                if (list[count]['tzId'] > 0) {
                  _this7.triggernotesids.push(list[count]['tzId']);
                }
              }
              _context6.next = 7;
              return _this7.clearCurrentTrigger();

            case 7:
              _context6.next = 9;
              return _this7.clearStateTriggersList();

            case 9:
              _context6.next = 11;
              return _this7.loadStories({ clientId: _this7.currentClient.id, tourId: _this7.currentTour.id, topicId: _this7.currentTopic.id, currentRouteID: _this7.currentRoute.id });

            case 11:
              pp = _this7;
              _context6.next = 14;
              return Object(__WEBPACK_IMPORTED_MODULE_7__services_TriggerService_js__["b" /* checkChannels */])(_this7.currentTour.id);

            case 14:
              response = _context6.sent;

              if (response.data === 'true') {
                pp.isLoading = true;
              }
              _this7.loadRouteTriggers(_this7.currentRoute.id).then(function () {
                pp.isLoading = false;
                for (var i = 0; i < _this7.triggersList.length; i++) {
                  var extraStoryId = _this7.triggersList[i].extra_story_id;
                  if (extraStoryId) {
                    _this7.showChilddData.push(i);
                  }
                }
              });
              if (_this7.showChilddData.length > 0) {
                _this7.addMoreInfoShow = false;
                _this7.reoveMoreInfoShow = true;
              }
              _this7.stories_length = _this7.stories[0].fileLengthSort;

            case 19:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }
});

/***/ }),

/***/ "SD+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global"},[_c('header',{staticClass:"global-header"},[_c('div',{staticClass:"line-item"},[((_vm.isAdmin && _vm.currentClientName !== null) || _vm.creatingNewClient)?_c('div',{staticClass:"back-btn",attrs:{"aria-hidden":"true"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.navToClientList()}}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1):(!_vm.isAdmin)?_c('div',{staticClass:"back-btn",attrs:{"aria-hidden":"true"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.navToSwitchClientList()}}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('h1',[(_vm.currentClientName !== null)?_c('span',[_vm._v(_vm._s(_vm.currentClientName))]):(_vm.creatingNewClient)?_c('span',[_vm._v("Create New Client")]):_c('span',[_vm._v("Clients")])])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el popover-container",staticStyle:{"margin":"23px"}},[((_vm.isAdmin))?_c('span',{on:{"click":function($event){_vm.releaseSettings()}}},[(_vm.releaseData.count)?_c('span',{staticClass:"message-icon unread",staticStyle:{"cursor":"pointer","font-family":"Arial, Helvetica, sans-serif","font-size":"16px","color":"rgb(0, 168, 202)"}},[_vm._v("\n                            Version "+_vm._s(_vm.latestVersion)+"\n                        ")]):_c('span',{staticClass:"message-icon read",staticStyle:{"cursor":"pointer","font-family":"Arial, Helvetica, sans-serif","font-size":"16px","color":"rgb(0, 168, 202)"}},[_vm._v("\n                            Version "+_vm._s(_vm.latestVersion)+"\n                        ")])]):_c('span',{on:{"click":function($event){_vm.releaseSettings()}}},[_c('span',{staticClass:"message-icon unread",staticStyle:{"cursor":"pointer","font-family":"Arial, Helvetica, sans-serif","font-size":"16px","color":"rgb(0, 168, 202)"}},[_vm._v("\n                            Version "+_vm._s(_vm.latestVersion)+"\n                        ")])]),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.msgStatus),expression:"this.msgStatus"}],staticClass:"popover-main"},[_vm._v("Features in Cortex have changed. "),_c('a',{on:{"click":function($event){_vm.releaseSettings()}}},[_vm._v("Click here ")]),_vm._v(" for details.")])]),_vm._v(" "),_c('div',{staticClass:"el"},[_c('img',{staticClass:"pencilSelected",attrs:{"src":"static/img/Help_Icon-gr.png"},on:{"click":function($event){_vm.showVideoPdf()}}})]),_vm._v(" "),_c('div',{staticClass:"el header-avatar"},[_c('md-button',{staticClass:"avatar-button",on:{"click":function($event){_vm.showCurrentUserProfile()}}},[(_vm.currentUser.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.currentUser.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                            "+_vm._s(_vm.getUserInitials(_vm.currentUser))+"\n                        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.navToSettings()}}},[_c('md-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el logout-button"},[_c('md-button',{on:{"click":function($event){_vm.clickLogout()}}},[_vm._v("Logout")])],1)])]),_vm._v(" "),(_vm.currentClientName !== null)?_c('div',{staticClass:"client-tabs btn-position-wrap"},[_c('md-tabs',{staticClass:"centered-title md-tabs-wrapper container",attrs:{"md-sync-route":"","md-alignment":"left"}},[_c('md-tab',{attrs:{"md-label":"Tours","to":"/client/tours"}}),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Library","to":"/client/library"}}),_vm._v(" "),(_vm.currentClient.isAnalytics)?_c('md-tab',{attrs:{"md-label":"Analytics","to":"/client/analytics/audience"}}):_vm._e(),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Exports","to":"/client/exports"}})],1)],1):_vm._e()]),_vm._v(" "),(this.errorMessage === null)?_c('section',{staticClass:"page-content"},[_c('router-view')],1):_c('section',{staticClass:"page-content"},[_c('h3',{staticClass:"centered"},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('modal',{staticClass:"help-modal-small",attrs:{"name":"hello-world","resizable":true,"reset":true,"height":"60%","width":"60%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                Video\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                PDF\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                FAQ\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})]),_vm._v("\n                                        "+_vm._s(usermanual.question)+"\n                                    ")])]):_vm._e(),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',[_c('md-icon',{staticClass:"faq-section-back-button",staticStyle:{"padding-right":"15px"}},[_vm._v("arrow_back")]),_vm._v(" "),_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})],1),_vm._v("\n                                    "+_vm._s(this.detailinfo.question)+"\n                                ")])]),_vm._v(" "),_c('p',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important","margin-left":"0px"}},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}})]),_vm._v(_vm._s(this.detailinfo.answers))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logout-button conatinerForSupport"},[_c('a',{staticClass:"GFG",attrs:{"href":"https://www.listentech.com/listen-navilution-support/","target":"_blank"}},[_c('button',{staticClass:"md-button md-theme-default",staticStyle:{"margin-bottom":"10px","padding":"10px"}},[_vm._v("\n                        Website support\n                    ")])]),_vm._v(" "),_c('md-button',{staticClass:"md-button md-theme-default",attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v("\n                    Email support\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("PDF")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()]),_vm._v(" "),_c('modal',{staticClass:"help-modal-large",attrs:{"name":"hello-world2","resizable":true,"reset":true,"height":"100%","width":"100%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                Video\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                PDF\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                FAQ\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"0px","padding-right":"7.6px"},attrs:{"src":"static/img/Help_Icon-gr.png"}}),_vm._v("\n                                        "+_vm._s(usermanual.question)+"\n                                    ")])]):_vm._e(),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('md-icon',{staticClass:"faq-section-back-button"},[_vm._v("arrow_back")]),_vm._v(" "),_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"0px","padding-right":"7.6px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})],1),_vm._v("\n                                    "+_vm._s(this.detailinfo.question)+"\n                                ")])]),_vm._v(" "),_c('p',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"}},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}})]),_vm._v("\n                                "+_vm._s(this.detailinfo.answers)+"\n                            ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logout-button conatinerForSupport"},[_c('a',{staticClass:"GFG",attrs:{"href":"https://www.listentech.com/listen-navilution-support/","target":"_blank"}},[_c('button',{staticClass:"md-button md-theme-default",staticStyle:{"margin-bottom":"10px","padding":"10px"}},[_vm._v("\n                        Website support\n                    ")])]),_vm._v(" "),_c('md-button',{staticClass:"md-button md-theme-default",attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v("\n                    Email support\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Version")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":"ReleaseModal","resizable":true,"reset":true,"height":"60%","width":"60%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindowRelease()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindowRelease()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.releasePanel)?_c('button',{staticClass:"close md-button md-icon-button backBtn",attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon"},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.releasePanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                    Version List\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"vedionameList",attrs:{"id":"releseList"}},[(_vm.releaseData.release.length === 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No new version found.")]):_vm._l((_vm.releaseData.release),function(release,index){return _c('div',{key:index},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showRelease(release)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("settings")])]),_vm._v(" Version "+_vm._s(release.v_no))])])])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.releaseDetailPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                    Version Detail\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"customScrollWrapper"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"releaseWrapper",attrs:{"id":"releseDetail"}},[_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Version No.")]),_vm._v(" "+_vm._s(this.singleRsdeleaseData.v_no))]),_vm._v(" "),_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Date.")]),_vm._v(" "+_vm._s(this.singleReleaseData.date))])]),_vm._v(" "),_c('div',{attrs:{"id":"functionaldescription"}},_vm._l((this.singleReleaseData.detail),function(releasefunction,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"funcDespWrapper"},[_c('div',{staticClass:"dec-left-panel"},[_c('b',[_vm._v(_vm._s(releasefunction.heading)+" :- ")])]),_vm._v(" "),_c('div',{staticClass:"dec-right-panel"},[_vm._v(" "+_vm._s(releasefunction.description))])])])])])}))])])])])])]):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"name":"ReleaseModal1","resizable":true,"reset":true,"height":"100%","width":"100%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindowRelease()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindowRelease()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.releasePanel)?_c('button',{staticClass:"close md-button md-icon-button backBtn",attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon"},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.releasePanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                    Version List\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"vedionameList",attrs:{"id":"releseList"}},[(_vm.releaseData.release.length === 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No new version found.")]):_vm._l((_vm.releaseData.release),function(release,index){return _c('div',{key:index},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showRelease(release)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("settings")])]),_vm._v(" Version "+_vm._s(release.v_no)+"\n                                        ")])])])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.releaseDetailPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                    Version Detail\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"customScrollWrapper fullViewContent"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"releaseWrapper",attrs:{"id":"releseDetail"}},[_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Version No.")]),_vm._v(" "+_vm._s(this.singleReleaseData.v_no))]),_vm._v(" "),_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Date.")]),_vm._v(" "+_vm._s(this.singleReleaseData.date))])]),_vm._v(" "),_c('div',{attrs:{"id":"functionaldescription"}},_vm._l((this.singleReleaseData.detail),function(releasefunction,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"funcDespWrapper"},[_c('div',{staticClass:"dec-left-panel"},[_c('b',[_vm._v(_vm._s(releasefunction.heading)+" :- ")])]),_vm._v(" "),_c('div',{staticClass:"dec-right-panel"},[_vm._v(" "+_vm._s(releasefunction.description))])])])])])}))])])])])])]):_vm._e()])]),_vm._v(" "),_c('md-dialog',{staticStyle:{"width":"120%","height":"-webkit-fill-available"},attrs:{"md-click-outside-to-close":false,"md-active":_vm.showVersionForclient},on:{"update:mdActive":function($event){_vm.showVersionForclient=$event}}},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.showVersionForclientClose()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('ReleaseSettings',{attrs:{"clinetVersionCheck":"1"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SVpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-page"},[_c('div',{staticClass:"map-wrap"},[_c('tourMap',{key:_vm.topicsList.length}),_vm._v(" "),_c('aside',[_c('div',{staticClass:"sidebar scroll-list"},[_c('div',{staticClass:"aside-wrap"},[_c('router-view',{attrs:{"name":"header"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"body"}}),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.exportRunning},on:{"update:mdActive":function($event){_vm.exportRunning=$event}}},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('span',{staticClass:"md-dialog-title md-title",attrs:{"data-v-ec680dbc":""}},[_vm._v("\n                                You have requested an export of  "),_c('b',{attrs:{"data-v-ec680dbc":""}},[_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.currentTour.name))])]),_vm._v("- we will notify you via email when it is ready.\n                            ")]),_vm._v(" "),_c('div',{staticClass:"md-dialog-content",attrs:{"data-v-ec680dbc":""}},[_c('b',{attrs:{"data-v-ec680dbc":""}},[_vm._v("Client Name :")]),_vm._v("\n                                "+_vm._s(this.currentClientName)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"md-dialog-content",attrs:{"data-v-ec680dbc":""}},[_c('b',{attrs:{"data-v-ec680dbc":""}},[_vm._v("Tours Name :")]),_vm._v(" "),_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.currentTour.name))])]),_vm._v(" "),_c('div',{staticClass:"md-dialog-actions full-btn",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.closeDialog_export()}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Close")])])])])])])],1)])]),_vm._v(" "),(_vm.showTourSettings || _vm.showRouteSettings)?_c('div',{staticClass:"tour-settings-wrap",class:{'open-settings': _vm.showSettings}},[(_vm.showTourSettings)?_c('TourSettings'):(_vm.showRouteSettings)?_c('RouteSettings'):_vm._e()],1):_c('TriggerStoryList',{staticClass:"story-media-list",class:{'open-media-settings': _vm.showSettings}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SZyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsTab_vue__ = __webpack_require__("Knv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1329ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsTab_vue__ = __webpack_require__("gRkj");
function injectStyle (ssrContext) {
  __webpack_require__("Y1cb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1329ab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Spk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkTourTimeZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAnalytics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return importFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__("IcnI");




function checkTourTimeZones(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/analytics/timezones');
}

function importFile(postData) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/analytics', postData.data, postData.config).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('analytics/isUploadingOff');
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('analytics/loadImportResults', response.data);
  });
}

function getAnalytics(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + data.clientId + '/analytics?' + 'dateRange=' + data.dateRange + '&language=' + data.language + '&tourId=' + data.tourId + '&routeId=' + data.routeId).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('analytics/isLoadingOff');
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('analytics/loadAnalytics', response.data);
  });
}



/***/ }),

/***/ "T6Wp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TG7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    returnToLast: function returnToLast() {
      this.$router.go(-2);
    }
  }
});

/***/ }),

/***/ "TnT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    returnToLogin: function returnToLogin() {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ "UAtg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UFmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global"},[_c('header',{staticClass:"global-header"},[_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"back-btn",attrs:{"aria-hidden":"true"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.navToClientList()}}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[(_vm.clientActive)?_c('h1',[_vm._v(_vm._s(_vm.currentClientName)+" Settings")]):_c('h1',[_vm._v("Cortex Settings")])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el"},[_c('div',{staticClass:"md-layout-item"},[_c('md-field',[_c('md-select',{attrs:{"name":"country","id":"country","placeholder":"Available Reports"},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}},[_c('md-option',{attrs:{"value":"australia","title":"Reports"}},[_c('downloadexcel',{staticClass:"btn",attrs:{"name":"User Information Report.xls","fetch":_vm.fetchData,"fields":_vm.json_fields,"type":"csv"}},[_vm._v("\n                                        User Information\n                                    ")])],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"el header-avatar"},[_c('md-button',{staticClass:"avatar-button",on:{"click":function($event){_vm.showCurrentUserProfile()}}},[(_vm.currentUser.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.currentUser.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                            "+_vm._s(_vm.getUserInitials(_vm.currentUser))+"\n                        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("settings")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"client-tabs btn-position-wrap"},[_c('md-tabs',{staticClass:"centered-title md-tabs-wrapper container",attrs:{"md-sync-route":"","md-alignment":"left"}},[(_vm.isAdmin)?_c('md-tab',{attrs:{"md-label":"General","to":"/settings/general"}}):_vm._e(),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Users","to":"/settings/users"}}),_vm._v(" "),(_vm.isAdmin)?_c('md-tab',{attrs:{"md-label":"Support","to":"/settings/usermanual"}}):_vm._e(),_vm._v(" "),_c('md-tab',{attrs:{"md-label":"Version ","to":"/settings/release"}}),_vm._v(" "),(_vm.isAdmin)?_c('md-tab',{attrs:{"md-label":"Export Jobs","to":"/settings/exportjobs"}}):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('md-tab',{attrs:{"md-label":"LOG IN HISTORY","to":"/settings/lohinhistory"}}):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('md-tab',{attrs:{"md-label":"ENABLE INCOMPLETE TOURS","to":"/settings/enableincompletetours"}}):_vm._e()],1)],1)]),_vm._v(" "),_c('div',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UntK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenance)?_c('div',{},[_vm._m(0,false,false)]):(_vm.flagForActive)?_c('div',{staticClass:"maintance-box"},[_c('article',{staticStyle:{"margin":"0 33%"}},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"classCheckOtp"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.checkOtpSubmit()}}},[_c('div',{staticClass:"row"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"5%"}},[_c('md-input',{staticStyle:{"width":"70%"},attrs:{"type":"text"},model:{value:(_vm.inputOTP),callback:function ($$v) {_vm.inputOTP=$$v},expression:"inputOTP"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"5%","left":"10%"}},[_c('md-button',{staticClass:"md-primary md-ink-ripple md-raised",staticStyle:{"width":"70%"},attrs:{"id":"sign-in","type":"submit"}},[_vm._v("Send")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.siginInErrorForOTP)?_c('span',{staticClass:"md-error"},[_vm._v("Please enter correct OTP")]):_vm._e()],1)])])])])]):(_vm.flagForDeactive)?_c('div',{staticClass:"maintance-box"},[_c('article',{staticStyle:{"margin":"0 33%"}},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"classCheckOtp"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.checkOtpSubmit()}}},[_c('div',{staticClass:"row"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"5%"}},[_c('md-input',{staticStyle:{"width":"70%"},attrs:{"type":"text"},model:{value:(_vm.inputOTP),callback:function ($$v) {_vm.inputOTP=$$v},expression:"inputOTP"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"5%","left":"10%"}},[_c('md-button',{staticClass:"md-primary md-ink-ripple md-raised",staticStyle:{"width":"70%"},attrs:{"id":"sign-in","type":"submit"}},[_vm._v("Send\n                        ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.siginInErrorForOTP)?_c('span',{staticClass:"md-error"},[_vm._v("Please enter correct OTP")]):_vm._e()],1)])])])])]):_c('div',{staticClass:"login-box"},[(_vm.count > 10)?_c('div',{staticClass:"div"}):_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.signIn()}}},[_c('em',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"col col-md-4 text-center my-auto"},[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"line-item"},[_c('md-field',[_c('md-input',{staticClass:"login-input",attrs:{"id":"email","type":"email","placeholder":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{attrs:{"md-toggle-password":false}},[_c('md-input',{staticClass:"login-input",attrs:{"value":_vm.password,"type":"password","placeholder":"Password"},on:{"update:value":function($event){_vm.password=$event}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('md-button',{staticClass:"md-primary md-ink-ripple md-raised",attrs:{"id":"sign-in","type":"submit"}},[_vm._v("Sign In\n                            ")]),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[(_vm.wrongEmailIdmsgs)?_c('span',{staticClass:"md-error"},[_vm._v("Please fill the above fields")]):_vm._e(),_vm._v(" "),(_vm.wrongEmailIdmsg)?_c('span',{staticClass:"md-error"},[_vm._v("Incorrect email  or   password!")]):_vm._e(),_vm._v(" "),(_vm.siginInError)?_c('span',{staticClass:"md-error"},[_vm._v("Incorrect  password!")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('p',[_c('a',{staticClass:"login-text float-right cuattr",on:{"click":function($event){_vm.recoverPassword()}}},[_vm._v("Forgot Password?")])])])])],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintanceWrapper"},[_c('div',{staticClass:"innerPanel"},[_c('div',{staticClass:"audioLogo"},[_c('img',{attrs:{"src":"/static/img/logo.png"}})]),_vm._v(" "),_c('h1',{staticClass:"heading"},[_vm._v("Maintenance")]),_vm._v(" "),_c('div',{staticClass:"subHeading"},[_vm._v("We're undergoing a bit of scheduled maintenance.")]),_vm._v(" "),_c('p',{staticClass:"sorryText"},[_vm._v("Sorry for the inconvenience. We'll be back up and running as fast as possible.")]),_vm._v(" "),_c('p',[_vm._v("— The Cortex Team")]),_vm._v(" "),_c('h1',{staticClass:"heading"},[_vm._v("Travail d’entretien")]),_vm._v(" "),_c('div',{staticClass:"subHeading"},[_vm._v(" Afin d’améliorer la qualité de nos services, notre logiciel sera momentanément inaccessible")]),_vm._v(" "),_c('p',[_vm._v("\n                Veuillez nous excuser pour la gêne occasionné. Nous serons de retour aussi vite que possible.\n            ")]),_vm._v(" "),_c('p',[_vm._v("— L’équipe Cortex.")]),_vm._v(" "),_c('div',{staticClass:"cortexLogo"},[_c('img',{attrs:{"src":"/static/img/Navilution_Cortex_Logo_CMYK.jpg"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioLogo1"},[_c('img',{attrs:{"src":"/static/img/AudioConexus_Logo-Stacked_CMYK.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Please enter the 6-digit verification code we sent via Email:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioLogo1"},[_c('img',{attrs:{"src":"/static/img/AudioConexus_Logo-Stacked_CMYK.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Please enter the 6-digit verification code we sent via Email:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ur29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"add-user global-section"},[_c('div',{staticClass:"row"},[(_vm.formError)?_c('div',{staticClass:"col-12 form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('md-button',{staticClass:"md-icon-button cancel-add-user",on:{"click":function($event){_vm.cancelAddUser()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"dynamic-contacts"},[_vm._l((_vm.newUsers),function(user,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"avatar-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"avatar upload s-48 gray"},[_c('md-icon',{staticClass:"icon icon-person"})],1),_vm._v(" "),_c('div',{staticClass:"client-name-box"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"First Name*"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'firstName')}},model:{value:(user.firstName),callback:function ($$v) {_vm.$set(user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.firstName'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.firstName'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block client-name without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"placeholder":"Email*"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'email')}},model:{value:(user.email),callback:function ($$v) {_vm.$set(user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.email'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.email'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block without-line",attrs:{"md-no-float":""}},[_c('md-input',{attrs:{"placeholder":"Position*"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'title')}},model:{value:(user.title),callback:function ($$v) {_vm.$set(user, "title", $$v)},expression:"user.title"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.title'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.title'][0]))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Last Name*"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'lastName')}},model:{value:(user.lastName),callback:function ($$v) {_vm.$set(user, "lastName", $$v)},expression:"user.lastName"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.lastName'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.lastName'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Direct #*"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'directPhone')}},model:{value:(user.directPhone),callback:function ($$v) {_vm.$set(user, "directPhone", $$v)},expression:"user.directPhone"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.directPhone'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.directPhone'][0]))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Office #"},on:{"blur":function($event){_vm.userTouchHanlder(index, 'officePhone')}},model:{value:(user.officePhone),callback:function ($$v) {_vm.$set(user, "officePhone", $$v)},expression:"user.officePhone"}})],1),_vm._v(" "),(_vm.validationErrors['newUsers.' + index + '.officePhone'])?_c('div',{staticClass:"new-user-error"},[_vm._v(_vm._s(_vm.validationErrors['newUsers.' + index + '.officePhone'][0]))]):_vm._e()],1)]),_vm._v(" "),(_vm.hasMultipleUsers)?_c('md-button',{staticClass:"md-icon-button delete-btn",attrs:{"aria-label":"Delete User"},on:{"click":function($event){_vm.deleteUser(index)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 showClientList"},[(!_vm.clientActive)?_c('div',{staticClass:"primary-contact"},[(_vm.isSuperAdmin)?_c('div',[_c('md-checkbox',{attrs:{"aria-label":"Primary Contact"},on:{"change":function($event){_vm.setUserAsAdmin(index)}},model:{value:(user.isSuperAdmin),callback:function ($$v) {_vm.$set(user, "isSuperAdmin", $$v)},expression:"user.isSuperAdmin"}},[_vm._v("\n                                            Cortex Super Admin\n                                        ")])],1):_vm._e(),_vm._v(" "),_c('div',[(!user.isSuperAdmin)?_c('md-checkbox',{attrs:{"aria-label":"Primary Contact"},model:{value:(user.isAdmin),callback:function ($$v) {_vm.$set(user, "isAdmin", $$v)},expression:"user.isAdmin"}},[_vm._v("\n                                            Cortex Admin\n                                        ")]):_vm._e()],1),_vm._v(" "),(_vm.clientList.length > 0 && !user.isAdmin)?_c('div',{attrs:{"id":"demo"}},_vm._l((_vm.clientList),function(client,index){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(user.clientId),expression:"user.clientId"}],key:index,staticClass:"multiple_select",attrs:{"type":"checkbox","name":"test"},domProps:{"value":client.id,"checked":Array.isArray(user.clientId)?_vm._i(user.clientId,client.id)>-1:(user.clientId)},on:{"change":function($event){var $$a=user.clientId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=client.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(user.clientId=$$a.concat([$$v]))}else{$$i>-1&&(user.clientId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(user, "clientId", $$c)}}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(client.companyName))])])})):_c('div',[_c('h3',[_vm._v("No clients available.")])])]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"add-button"},[_c('md-button',{staticClass:"md-icon-button md-primary",attrs:{"aria-label":"Add User"},on:{"click":function($event){_vm.addUser()}}},[_c('md-icon',[_vm._v("add")])],1)],1)],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"save-user-button md-primary",attrs:{"aria-label":"Add New Client"},on:{"click":function($event){_vm.clickSaveNewUser()}}},[_vm._v("Save")])],1)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"user-saving-message"},[_c('span',[_c('md-progress-spinner',{staticClass:"md-accent user-saving-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}),_vm._v("\n                Saving User(s)...\n            ")],1)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialogForUserLimit},on:{"update:mdActive":function($event){_vm.showDialogForUserLimit=$event}}},[_c('md-dialog-content',[_vm._v("\n            Your user limit is full please contact to admin.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":_vm.closeDialogForUserLimit}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Add New Users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UvLs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V76v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotSent_vue__ = __webpack_require__("ojgw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59c2c30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotSent_vue__ = __webpack_require__("5s23");
function injectStyle (ssrContext) {
  __webpack_require__("wErJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a59c2c30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotSent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59c2c30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotSent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8i3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assignStoryToTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRouteTriggers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return doStoryFilesExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeMoreInfo; });
/* unused harmony export triggerNotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveNotestrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteNotestrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return triggerNotesByZone; });
/* unused harmony export updateNotestrigger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return triggerIdsNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return topicNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saveNotestopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkChannels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveTriggerOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function assignStoryToTrigger(data) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/triggers/' + data.triggerId + '/story', data);
}

function getRouteTriggers(routeId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  var currentTour = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.tours.currentTour.id;
  var currentTopic = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.topics.currentTopic.id;
  if (currentTopic) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/routes/' + routeId + '/tourId/' + currentTour + '/topicId/' + currentTopic + '/triggers');
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/routes/' + routeId + '/triggers');
  }
}

function deleteTrigger(triggerId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/client/' + currentClientId + '/trigger/' + triggerId);
}

function checkChannels(tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/checkChannels/tourId/' + tourId);
}

function copyTrigger(triggerId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/triggercopy/' + triggerId);
}

function doStoryFilesExist(tourAndFriendly) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/tour/story', { tourAndFriendly: tourAndFriendly });
}

function removeMoreInfo(trigger) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/removeMoreInfo', { trigger: trigger });
}

function deleteNotestrigger(noteid) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/triggerzone/delete-note', { noteid: noteid });
}

function triggerNotes(topicid) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/triggerzone/notes/' + topicid);
}

function triggerNotesByZone(tzid) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/triggerzone/notesbytriggerZone/' + tzid);
}

function saveNotestrigger(notesdata, currentTrigger, currentTopic) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/triggerzone/save-notes', { notesdata: notesdata, currentTrigger: currentTrigger, currentTopic: currentTopic });
}

function updateNotestrigger(notesdata) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/triggerzone/update-notes', { notesdata: notesdata });
}

function triggerIdsNotes(topicid) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/triggerzone/triggerIdsNotes/' + topicid);
}

function topicNotes(topicid) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/topiczone/topicNotes/' + topicid);
}

function saveNotestopic(notesdata, currentTopic) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/topiczone/save-topicNotes', { notesdata: notesdata, currentTopic: currentTopic });
}

function saveTriggerOrder(triggerZoneList) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/updateTriggerZoneSequence', { triggerZoneList: triggerZoneList });
}



/***/ }),

/***/ "VXrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VrTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ClientService__ = __webpack_require__("Fedb");







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    adminClientList: [],
    currentClient: null,
    currentClientName: null,
    clientLoaded: false,
    initialClient: null
  },
  getters: {
    clientList: function clientList(state) {
      return state.adminClientList;
    },
    currentClient: function currentClient(state) {
      return state.currentClient;
    },
    currentClientName: function currentClientName(state) {
      return state.currentClient !== null ? state.currentClient.companyName : null;
    },
    clientActive: function clientActive(state) {
      return state.currentClient !== null;
    },
    initialClient: function initialClient(state) {
      return state.initialClient;
    },
    clientLoaded: function clientLoaded(state) {
      return state.clientLoaded;
    }, // REVIEW Do we use this for anything??
    clientEdited: function clientEdited(state) {
      if (state.initialClient && state.currentClient) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.currentClient)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var editValue = state.currentClient[key] ? String(state.currentClient[key]).toLowerCase() : '';
            var initialValue = state.initialClient[key] ? String(state.initialClient[key]).toLowerCase() : '';
            if (editValue !== initialValue) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    }
  },
  mutations: {
    setAdminClientList: function setAdminClientList(state, clients) {
      var newClient = [];
      clients.forEach(function (client, index) {
        var imgUrl = client;
        imgUrl.img = 'static/img/arrow.png';
        imgUrl.expended = false;
        newClient[index] = imgUrl;
      });
      state.adminClientList = newClient;
      state.currentClient = null;
    },
    setCurrentClient: function setCurrentClient(state, client) {
      state.currentClient = client;
    },
    setClientLoaded: function setClientLoaded(state) {
      state.clientLoaded = !state.clientLoaded;
    },
    setInitialClient: function setInitialClient(state, client) {
      state.initialClient = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, client);
    },
    resetClient: function resetClient(state) {
      state.adminClientList = [];
      state.currentClient = null;
      state.currentClientName = null;
      state.clientLoaded = false;
      state.initialClient = null;
    },
    toggleCurrentClientIsAnalytics: function toggleCurrentClientIsAnalytics(state, toggled) {
      if (toggled) {
        state.currentClient.isAnalytics = 1;
      } else {
        state.currentClient.isAnalytics = 0;
      }
    }
  },
  actions: {
    loadClient: function loadClient(_ref, data) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var search, clients, _search, _clients, dataArr, client;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(data.isAdmin === true)) {
                  _context.next = 17;
                  break;
                }

                if (!(data.search === '')) {
                  _context.next = 9;
                  break;
                }

                search = 0;
                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService__["i" /* getClientList */])(search);

              case 5:
                clients = _context.sent;

                commit('setAdminClientList', clients.data);
                _context.next = 15;
                break;

              case 9:
                _search = data.search;
                _context.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService__["i" /* getClientList */])(_search);

              case 12:
                _clients = _context.sent;
                dataArr = typeof _clients.data === 'string' ? [] : _clients.data;

                commit('setAdminClientList', dataArr);

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.next = 19;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ClientService__["h" /* getClient */])(data.clientId);

              case 19:
                client = _context.sent;

                commit('setCurrentClient', client.data);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resetClient: function resetClient(_ref2) {
      var commit = _ref2.commit;

      commit('setCurrentClient', null);
    },
    toggleClientLoadedFlag: function toggleClientLoadedFlag(_ref3) {
      var commit = _ref3.commit;

      commit('setClientLoaded');
    },
    unloadClient: function unloadClient(_ref4) {
      var commit = _ref4.commit;

      commit('resetClient');
    },
    loadClientEditor: function loadClientEditor(_ref5, client) {
      var commit = _ref5.commit;

      commit('setInitialClient', client);
      commit('setCurrentClient', client);
    },
    toggleCurrentClientIsAnalytics: function toggleCurrentClientIsAnalytics(_ref6, toggled) {
      var commit = _ref6.commit;

      commit('toggleCurrentClientIsAnalytics', toggled);
    }
  }
});

/***/ }),

/***/ "VsjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__ = __webpack_require__("bTS4");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a
  },
  expand: {},
  data: function data() {
    return {
      showDialogCheck: false,
      activeItem: 0,
      recordUpdateSucc: false,
      clickSaveBtn: false,
      TourSettingstimezone: false,
      toleranceerror: false,
      TourSettingsChangedTets: false,
      isLoadingmy: false,
      enabled: true,
      dragging: false,
      showDeleteDialog: false,
      showDeleteDialogMedia: false,
      langDelete: [],
      categoryDelete: [],
      friendlyNameDelete: [],
      addLanguages: [],
      disableLanguages: [],
      addMedia: [],
      mediaDialogType: null,
      showDialog: false,
      showMediaDialog: false,
      showInfo: false,
      form: {
        activate: '',
        delay: '',
        radius: '',
        tolerance: ''
      },
      tourSaved: false,
      ArrayinUse: [],
      dataexte: [{ Id: 1, Name: 'Video 1', Content: ['Humor 1', 'Music 1', 'Movies 1', 'TV Shows 1'] }, { Id: 2, Name: 'Video 2', Content: ['Humor 2', 'Music 2', 'Movies 2', 'TV Shows 2'] }, { Id: 3, Name: 'Video 3', Content: ['Humor 3', 'Music 3', 'Movies 3', 'TV Shows 3'] }],
      defaultTriSet: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('tours', { tour: 'currentTour' }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('tours', ['TourSettingsChanged']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('language', { languages: 'getLanguageList', tourLanguages: 'getTourLanguageList', reordered: 'tourLanguagesReordered', checkRouteIsMappingTable: 'checkRouteIsMappingTable' }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('library', { assignableMedia: 'getAssignableMedia', library: 'getTourLibrary' }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('timezone', { timezones: 'getTimezones' }), {
    convertObjToSafety: function convertObjToSafety() {
      var obj = this.library.safety;
      if (obj !== undefined) {
        var array = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value);
        });
        return array;
      }
    },
    convertObjToFiller: function convertObjToFiller() {
      var obj = this.library.filler;
      if (obj !== undefined) {
        var array = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value);
        });
        return array;
      }
    },
    convertObjToMusic: function convertObjToMusic() {
      var obj = this.library.music;
      if (obj !== undefined) {
        var array = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(obj).map(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              key = _ref8[0],
              value = _ref8[1];

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value);
        });
        return array;
      }
    },

    sortedLanguages: {
      get: function get() {
        return this.tourLanguages;
      },
      set: function set(value) {
        this.updateLanguageOrder({ languages: value });
      }
    }
  }),
  watch: {
    addLanguages: function addLanguages() {
      // this.addLanguages.pop();
      if (this.addLanguages.length > 60) {
        var lastValue = this.addLanguages.pop();
        this.activeItem = lastValue;
        this.showDialogCheck = true;
      }
      if (this.addLanguages.length < 60) {
        this.activeItem = null;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('language', ['loadLanguageList', 'loadTourLanguageList', 'addTourLanguage', 'removeTourLanguage', 'removeTourLanguages', 'setTourLanguageList', 'updateLanguageOrder', 'updateTourLanguages', 'changeStateRouteIsMappingTable']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('library', ['addMediaToTour', 'loadAssignableMedia', 'loadTourLibrary', 'removeMediaFromTour', 'loadTourNotifications', 'reorderTourLibrary']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('timezone', ['loadTimezones']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('routes', ['loadRoutes']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('tours', ['updateCurDupli', 'updateCheckTourSettingSave']), {
    checkMove: function checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    something: function something(event, defaultVal) {
      var defaultTriSetP;
      var checkData = false;
      if (defaultVal === 'defaultRadiusDistance') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.defaultRadiusDistance;
      }
      if (defaultVal === 'defaultTolerance') {
        if (event.target.value > 29 && event.target.value < 361) {
          defaultTriSetP = this.defaultTriSet.defaultTolerance;
          this.toleranceerror = false;
          this.TourSettingsChangedTets = true;
          checkData = true;
        } else {
          this.toleranceerror = true;
          this.TourSettingsChangedTets = false;
          return false;
        }
      }
      if (defaultVal === 'defaultDelay') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.defaultDelay;
      }
      if (defaultVal === 'activate') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.activate;
      }
      if (defaultVal === 'timezone') {
        checkData = true;
        defaultTriSetP = this.defaultTriSet.timezone;
      }
      if (Number(event.target.value) !== Number(defaultTriSetP) && checkData === true) {
        if (this.toleranceerror === true) {
          this.TourSettingsChangedTets = false;
        } else {
          this.TourSettingsChangedTets = true;
        }
      }
    },
    toggleShowSettingsDummy: function toggleShowSettingsDummy() {
      if (this.TourSettingsChangedTets === true) {
        this.tour.defaultActivate = this.defaultTriSet.defaultActivate;
        this.tour.defaultDelay = this.defaultTriSet.defaultDelay;
        this.tour.defaultRadiusDistance = this.defaultTriSet.defaultRadiusDistance;
        this.tour.defaultTolerance = this.defaultTriSet.defaultTolerance;
        this.tour.timezone_id = this.defaultTriSet.timezone_id;
        this.TourSettingsChangedTets = false;
      }
    },
    addAllLangauge: function addAllLangauge() {
      var _this = this;

      this.showDialogCheck = false;
      this.addLanguages = [];
      this.activeItem = null;
      for (var index = 0; index < this.tourLanguages.length; index++) {
        var element = this.tourLanguages[index]['id'];
        this.addLanguages.push(element);
      }
      this.showDialog = true;

      // disable the selected langauge in the add languages modal
      this.tourLanguages.forEach(function (tourLanguage) {
        _this.disableLanguages.push(tourLanguage.id);
      });
    },
    endDragging: function endDragging(dragging) {
      dragging = false;
    },
    onUpdate: function onUpdate(cate) {
      this.isLoadingmy = true;
      this.savelistTourMediaOrder(cate);
    },
    savelistTourMediaOrder: function savelistTourMediaOrder(cate) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (cate === 'Filler') {
                  _this2.ArrayinUse = _this2.convertObjToFiller;
                } else if (cate === 'Safety') {
                  _this2.ArrayinUse = _this2.convertObjToSafety;
                } else {
                  _this2.ArrayinUse = _this2.convertObjToMusic;
                }
                _this2.reorderTourLibrary({
                  'clientId': _this2.currentClient.id,
                  'tourId': _this2.tour.id,
                  'newArray': _this2.ArrayinUse,
                  'cate': cate
                }).then(function () {
                  _this2.isLoadingmy = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    checkRouteIsMappingTableOk: function checkRouteIsMappingTableOk() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.changeStateRouteIsMappingTable(false);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    saveTour: function saveTour() {
      var _this4 = this;

      this.recordUpdateSucc = true;
      this.clickSaveBtn = true;
      this.TourSettingsChangedTets = false;
      this.defaultTriSet.defaultActivate = this.tour.defaultActivate;
      this.defaultTriSet.defaultDelay = this.tour.defaultDelay;
      this.defaultTriSet.defaultRadiusDistance = this.tour.defaultRadiusDistance;
      this.defaultTriSet.defaultTolerance = this.tour.defaultTolerance;
      this.defaultTriSet.timezone_id = this.tour.timezone_id;
      Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["k" /* saveTour */])(this.tour);
      this.updateCheckTourSettingSave(this.defaultTriSet);
      setTimeout(function () {
        _this4.recordUpdateSucc = false;
      }, 3000);
    },
    confirmDelete: function confirmDelete(lang) {
      this.showDeleteDialog = true;
      this.langDelete = lang;
      this.disableLanguages.pop(lang);
    },
    confirmDeleteMedia: function confirmDeleteMedia(category, friendlyName) {
      this.showDeleteDialogMedia = true;
      this.categoryDelete = category;
      this.friendlyNameDelete = friendlyName;
    },
    closeDialog: function closeDialog() {
      this.showDeleteDialog = false;
      this.showDeleteDialogMedia = false;
      this.langDelete = [];
      this.categoryDelete = [];
      this.friendlyNameDelete = [];
    },
    addTourLanguages: function addTourLanguages() {
      var _this5 = this;

      var pForThis = this;
      var addnewLanguageOrder = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tourLanguages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lang = _step.value;

          addnewLanguageOrder.push({
            id: lang.id,
            order: lang.order
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.addTourLanguage({ tourId: this.tour.id, addLanguages: this.addLanguages, languageOrder: addnewLanguageOrder }).then(function (data) {
        _this5.loadRoutes(_this5.tour.id);
        pForThis.loadRoutes(_this5.tour.id);
        pForThis.loadTourLibrary({ clientId: pForThis.currentClient.id, tourId: pForThis.tour.id }).then(function (data) {
          _this5.addLanguagesAfterSaving = _this5.addLanguages;
          _this5.showDeleteDialogMedia = false;
        });
      });
      this.showDialogCheck = true;
      this.showDialog = false;
    },
    addTourMedia: function addTourMedia(category) {
      var pForThisfoagin = this;
      this.addMediaToTour({
        clientId: this.currentClient.id,
        tourId: this.tour.id,
        friendly_names: this.addMedia,
        category: category
      }).then(function (data) {
        var pForThis = pForThisfoagin;
        pForThis.loadTourLibrary({ clientId: pForThis.currentClient.id, tourId: pForThis.tour.id }).then(function (data) {
          pForThis.addMedia = [];
          pForThis.showMediaDialog = false;
          pForThis.loadTourNotifications({ tourId: pForThis.tour.id, clientId: pForThis.currentClient.id });
        });
      });
    },
    removeLanguage: function removeLanguage(languageId) {
      var _this6 = this;

      var pForThis = this;
      var index = pForThis.addLanguages.indexOf(languageId);
      pForThis.addLanguages.splice(index, 1);
      this.removeTourLanguage({ tourId: this.tour.id, languageId: languageId }).then(function (data) {
        pForThis.loadRoutes(_this6.tour.id);
        pForThis.loadTourLibrary({ clientId: pForThis.currentClient.id, tourId: pForThis.tour.id }).then(function (data) {
          _this6.showDeleteDialogMedia = false;
        });
      });
      this.loadTourNotifications({ tourId: this.tour.id, clientId: this.currentClient.id });
      this.categoryDelete = [];
      this.friendlyNameDelete = [];
      this.showDialog = false;
      this.showDeleteDialog = false;
    },
    removeTourMedia: function removeTourMedia(category, friendlyName) {
      var _this7 = this;

      this.removeMediaFromTour({
        category: category,
        clientId: this.currentClient.id,
        tourId: this.tour.id,
        friendlyName: friendlyName
      }).then(function (data) {
        _this7.loadTourLibrary({ clientId: _this7.currentClient.id, tourId: _this7.tour.id }).then(function (data) {
          _this7.showDeleteDialogMedia = false;
        });
        _this7.loadTourNotifications({ tourId: _this7.tour.id, clientId: _this7.currentClient.id });
        _this7.categoryDelete = [];
        _this7.friendlyNameDelete = [];
      });
    },
    openMediaDialog: function openMediaDialog(type) {
      var varForThis = this;
      this.loadAssignableMedia({ clientId: this.currentClient.id, tourId: this.tour.id, type: type }).then(function (data) {
        varForThis.showMediaDialog = true;
      });
      this.mediaDialogType = type;
    },
    updateLanguages: function updateLanguages() {
      var _this8 = this;

      var newOrder = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tourLanguages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var lang = _step2.value;

          newOrder.push({
            id: lang.id,
            order: lang.order
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.updateTourLanguages({ tourId: this.tour.id, languageOrder: newOrder }).then(function () {
        _this8.loadTourLanguageList(_this8.tour.id);
      });
    },
    disableLanguage: function disableLanguage(languageId) {
      return this.disableLanguages.includes(languageId);
    }
  }),
  mounted: function mounted() {
    this.tour = this.currentTour;
    this.defaultTriSet['defaultActivate'] = this.tour.defaultActivate;
    this.defaultTriSet['defaultRadiusDistance'] = this.tour.defaultRadiusDistance;
    this.defaultTriSet['defaultTolerance'] = this.tour.defaultTolerance;
    this.defaultTriSet['defaultDelay'] = this.tour.defaultDelay;
    this.defaultTriSet['timezone_id'] = this.tour.timezone_id;
    this.updateCurDupli(this.defaultTriSet);
    if (this.tour.id !== '') {
      this.loadTourLanguageList(this.tour.id);
      this.loadTourLibrary({ clientId: this.currentClient.id, tourId: this.tour.id });
    }
    this.loadLanguageList();
    this.loadTimezones();
  }
});

/***/ }),

/***/ "WW5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('div',{staticClass:"line-item statistics"},[_c('div',{staticClass:"statistic"},[_c('strong',[_vm._v(_vm._s(_vm.analytics.total))]),_vm._v(" "),_c('span',[_vm._v("Peak Usage")])]),_vm._v(" "),_c('div',{staticClass:"statistic"},[_c('strong',[_vm._v(_vm._s(_vm.analytics.usage.languageData ? _vm.analytics.usage.languageData.length : 0))]),_vm._v(" "),_c('span',[_vm._v("Languages")])])]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"analytics-chart"},[(_vm.analytics.usage.languageData)?_c('line-chart',{attrs:{"colors":_vm.colors,"curve":false,"data":_vm.analytics.usage.languageData,"lineWidth":"1","legend":"none","height":"400px"}}):(!_vm.isLoading)?_c('div',{staticClass:"centered"},[_vm._v("No Analytics data for period.")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"data-table"},[_c('table',[_c('thead',[_c('tr',[_c('th',[(_vm.analytics.usage.languageData)?_c('span',{staticClass:"sort-el"},[_c('a',[_vm._v("Language")])]):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"right-align half-cell"},[(_vm.analytics.usage.languageData)?_c('span',{staticClass:"sort-el"},[_c('a',[_vm._v("Peak User Sessions")])]):_vm._e()])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.analytics.usage.languageData),function(language,index){return _c('tr',{key:index},[_c('td',[_c('md-icon',{staticClass:"marker",style:({ color: language.color })},[_vm._v("fiber_manual_record")]),_vm._v("\n                    "+_vm._s(language.name)+"\n                ")],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s(language.total))])])}))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WXyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__ = __webpack_require__("4kyh");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function uniqueClientName(value) {
  var clients = this.$store.getters['client/clientList'];
  var initialClientId = this.$store.getters['client/initialClient'].id;
  var unique = true;
  if (value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(clients), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var client = _step.value;

        if (client.id !== initialClientId) {
          if (client.companyName.toLowerCase() === value.toLowerCase()) {
            unique = false;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return unique;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      returnPath: null,
      isAnalytics: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClient', 'initialClient', 'clientEdited'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('client', ['toggleCurrentClientIsAnalytics']), {
    touchHanlder: function touchHanlder(key) {
      if (!this.$v.currentClient[key].$dirty) {
        this.$v.currentClient[key].$touch();
      }
    },
    cancelEditClient: function cancelEditClient() {
      this.$router.push(this.returnPath);
    },
    saveClientChanges: function saveClientChanges() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["w" /* updateClient */])(_this.currentClient).then(function (response) {
                  _this.$router.push('/client/list');
                }).catch(function (error) {
                  console.log(error.response.data.message);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  validations: {
    currentClient: {
      companyName: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */],
        uniqueClientName: uniqueClientName
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */],
        validPhoneNumber: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["d" /* validPhoneNumber */]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["a" /* notWhitespace */]
      },
      zipPostalCode: {
        validPostalOrZip: __WEBPACK_IMPORTED_MODULE_7__includes_validations_js__["e" /* validPostalOrZip */]
      },
      website: {
        url: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["url"]
      }
    }
  },
  mounted: function mounted() {
    this.returnPath = this.$store.state.RouterModule.from.fullPath;
    this.isAnalytics = this.currentClient.isAnalytics === 1;
  }
});

/***/ }),

/***/ "WtAB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X8Sg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XD2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__ = __webpack_require__("5YuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__("IC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ToursService__ = __webpack_require__("jYpk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateMaxValueStart: '',
      dateMaxValueEnd: '',
      message: 'rajesh',
      startDate: '',
      endDate: new Date(),
      arrayData: [],
      showDeleteDialogRe: false,
      exportListsWent: false,
      exportDataNotFound: true,
      exportLists: [],
      country: 'runningJobs',
      showDeleteDialog: false,
      jobsCount: '',
      exportIdQueue: '',
      jobIdQueue: '',
      reStartJobID: '',
      chartOptions: {
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        chart: {
          renderTo: 'container',
          customData: ''
        },
        xAxis: {
          type: 'datetime'
        },
        plotOptions: {
          column: {
            // pointStart: Date.UTC(2010, 0, 1) // feb 12, 2015
          },
          series: {
            events: {
              legendItemClick: function legendItemClick() {
                var PloatSingleData = [];
                var pp = this;
                setTimeout(function () {
                  pp.chart.series.forEach(function (sr) {
                    if (sr.visible) {
                      PloatSingleData.push(sr.name);
                    }
                  });
                  if (PloatSingleData.length > 1) {
                    pp.chart.series[0].setData(pp.chart.series[0].userOptions.mainData);
                    pp.chart.series[1].setData(pp.chart.series[1].userOptions.mainData);
                    pp.chart.series[2].setData(pp.chart.series[2].userOptions.mainData);
                  } else {
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Count (Queue Job Count)') {
                      pp.chart.series[0].setData(pp.chart.series[0].userOptions.customData);
                    }
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Size (Export Data MB)') {
                      pp.chart.series[1].setData(pp.chart.series[1].userOptions.customData);
                    }
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Complexity (Triggers/File Count)') {
                      pp.chart.series[2].setData(pp.chart.series[2].userOptions.customData);
                    }
                  }
                }, 20);
              }
            },
            step: 'left'
          }
        },
        tooltip: {
          xDateFormat: '%m-%d-%Y %H:%M'
        },
        series: '',
        customData: ''
      }
    };
  },

  components: {
    highcharts: __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__["Chart"],
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */],
    VueMoment: __WEBPACK_IMPORTED_MODULE_3_vue_moment___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('client', ['loadClient']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('tours', ['loadTourEditor', 'loadClientToursList']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('map', ['setCenter']), {
    openCLientCListPage: function openCLientCListPage(clientID) {
      var pp = this;
      this.loadClient({ isAdmin: false, clientId: clientID.clientId }).then(function () {
        pp.loadClientToursList(clientID.clientId).then(function () {
          pp.setCenter(clientID);
          pp.loadTourEditor(clientID).then(function () {
            pp.$router.push('/tour');
          });
        });
      });
    },
    splitedList: function splitedList(row) {
      return row !== null ? row.split(',') : '';
    },
    customFormatter: function customFormatter() {
      return __WEBPACK_IMPORTED_MODULE_3_vue_moment___default()(this.startDate).format('MMMM DD YYYY');
    },
    getExportJobsList: function getExportJobsList() {
      var _this = this;

      var queueJobData = {
        arrayData: this.arrayData,
        startDate: this.startDate,
        endDate: this.endDate
      };
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/getAllJobRunningData', queueJobData).then(function (response) {
        _this.isLoading = false;
        if (response.data === 1) {
          _this.exportListsWent = true;
        } else {
          if (response.data.length === 0) {
            _this.exportDataNotFound = false;
          } else {
            _this.exportDataNotFound = true;
            _this.exportLists = response.data.tableData;
            _this.jobsCount = response.data.tableData.length;
            var seri = [{
              name: 'Job Count (Queue Job Count)',
              customData: response.data.created_atForGraph,
              color: '#00A8CA',
              mainData: response.data.jobCountNorm,
              data: response.data.jobCountNorm
            }, {
              name: 'Job Size (Export Data MB)',
              customData: response.data.jobFilsSizeMainData,
              color: 'rgb(217, 83, 79)',
              mainData: response.data.jobFilsSizeNormData,
              data: response.data.jobFilsSizeNormData
            }, {
              name: 'Job Complexity (Triggers/File Count)',
              customData: response.data.jobComplexityMainData,
              color: 'rgb(67,67,72)',
              mainData: response.data.jobComplexityNormData,
              data: response.data.jobComplexityNormData
            }];
            _this.chartOptions.series = seri;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadQueueData: function loadQueueData() {
      this.getExportJobsList();
    },
    showModalPop: function showModalPop(exportId) {
      this.exportIdQueue = exportId;
      this.showDeleteDialog = true;
    },
    showModalPopRestart: function showModalPopRestart(jobId) {
      this.reStartJobID = jobId;
      this.showDeleteDialogRe = true;
    },
    deleteClient: function deleteClient(exportId) {
      var forThis = this;
      Object(__WEBPACK_IMPORTED_MODULE_4__services_ToursService__["d" /* deteleQueueJob */])(exportId).then(function (responce) {
        if (responce.data === exportId) {
          forThis.showDeleteDialog = false;
          forThis.getExportJobsList();
        }
      });
    },
    reStartQueueJob: function reStartQueueJob(jobId) {
      var forThis = this;
      Object(__WEBPACK_IMPORTED_MODULE_4__services_ToursService__["f" /* reStartQueueJobApi */])(jobId).then(function (responce) {
        if (responce.data === jobId) {
          forThis.showDeleteDialogRe = false;
          forThis.getExportJobsList();
        }
      });
    }
  }),
  mounted: function mounted() {
    this.arrayData.push('failed');
    this.arrayData.push('inprocess');
    this.arrayData.push('completed');
    this.arrayData.push('deleted');
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - 14);
    this.startDate = startDate;
    this.getExportJobsList();
  }
});

/***/ }),

/***/ "XQge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"size-controlmy"},[_c('div',{staticClass:"story-media-head"},[_c('div',{staticClass:"tour-settings-content"},[_c('md-button',{staticClass:"md-icon-button close-tour-settings",on:{"click":function($event){_vm.toggleShowSettings(false)}}},[_c('md-icon',{attrs:{"title":"Close"}},[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"md-tabs"},[_c('section',{staticClass:"media-section ng-scope"},[_c('div',{staticClass:"text-pad"},_vm._l((_vm.storyFiles),function(entry,index){return _c('div',{key:index,staticClass:"line-item"},[_c('div',{staticClass:"line-item title-line"},[(entry.name =='SHOWMORE')?_c('div',{staticClass:"left-item"},[_vm._m(1,true,false)]):_c('div',{staticClass:"left-item"},[_vm._v("\n                                    "+_vm._s(entry.name.substring(0, 45))+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(entry.name !='SHOWMORE')?_c('div',{staticClass:"el lock-el",attrs:{"ng-show":"item.lock"}},[(entry.filetype == 1)?_c('span',[_c('md-icon',{staticClass:"vid-icon",attrs:{"title":"This story has video"}},[_vm._v("videocam")])],1):_vm._e(),_vm._v(" "),(entry.exists === 1)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File is assigned correctly"}},[_vm._v("done")]):(entry.exists === 0)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_c('md-icon',{staticClass:"green-color",attrs:{"title":"File is assigned to another Tour"}},[_vm._v("done")])],1):_vm._e()])])])}))])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-title"},[_c('h2',[_vm._v("Story Media Files")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-titleCopy"},[_c('h2',[_vm._v(" More Story Media Files")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xdo3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y1cb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showInfo: false,
      checkTarballComplet: false,
      file: '',
      currentRouteImages: '',
      editTourName: '',
      editTourDes: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('routes', ['currentRoute']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('client', ['currentClient']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('tours', ['currentTour'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('tours', ['exportTours']), {
    getImageSrc: function getImageSrc(image) {
      return 'static/img/' + image;
    },
    callRouteSettingFunction: function callRouteSettingFunction(param) {
      this.clearCurrentRoute();
      this.$bus.$emit('changevariableValueOfRouteSetting');
    },
    toggleInfoBlock: function toggleInfoBlock(editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentRoute.name;
        this.editTourDes = this.currentRoute.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentRoute.name = this.editTourName;
        this.currentRoute.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious: function returnToPrevious() {
      this.$router.push('/tour/topicRoutes/routes');
    },
    saveRouteDetails: function saveRouteDetails() {
      if (this.currentRoute.name.length >= 1 && this.currentRoute.description.length >= 1) {
        var route = this.currentRoute;
        route.clientId = this.currentClient.id;
        route.systemId = 1; // temporary until we get sysId figured route
        Object(__WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__["m" /* updateRouteDetails */])(route);
        this.toggleInfoBlock('SAVECLOSE');
      }
    },
    closeCheckTarballComplet: function closeCheckTarballComplet() {
      this.checkTarballComplet = false;
    },
    exportCurrentTour: function exportCurrentTour(tourId) {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__["c" /* checkExportTours */])(tourId).then(function (defs) {
        if (defs.data[0].activeInactiveImages === 0) {
          self.checkTarballComplet = true;
        } else {
          self.exportTours({ tourIds: [tourId], clientId: self.currentClient.id });
        }
      });
    },
    handleFileUpload: function handleFileUpload(event) {
      this.file = event.target.files[0];
      var routeId = this.currentRoute.id;
      this.currentRouteImages = URL.createObjectURL(event.target.files[0]);
      this.currentRoute.route_image = URL.createObjectURL(event.target.files[0]);
      Object(__WEBPACK_IMPORTED_MODULE_1__services_EditorService_js__["q" /* uploadRouteFile */])(event.target.files[0], routeId);
    }
  }),
  mounted: function mounted() {
    if (!this.currentRoute.route_image) {
      this.currentRouteImages = 'static/img/' + this.currentRoute.avatar;
    } else {
      this.currentRouteImages = this.currentRoute.route_image;
    }
  }
});

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("3y59");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YJcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"exports-settings-list"},_vm._l((_vm.exportsList),function(exports){return _c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el exports-item",on:{"click":function($event){_vm.showCurrentExport(exports.id)}}},[_c('h3',[_vm._v(_vm._s(exports.requested_time)+" ")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(exports.fulfilled_time)+" ")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(exports.file_url)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(exports.export_id !== _vm.currentExport.export_id)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.confirmDelete(exports)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1)])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YM2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",attrs:{"id":"ToursTab"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"line-item toolbar"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"search open-search"},[_c('md-icon',{staticClass:"search-glass-icon"},[_vm._v("search")]),_vm._v(" "),_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"md-input-focused md-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterString),expression:"filterString"}],staticClass:"md-input",attrs:{"type":"text"},domProps:{"value":(_vm.filterString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterString=$event.target.value}}})])])],1)]),_vm._v(" "),_c('div',{staticClass:"right-item tour-buttons"},[(_vm.showTourButtons)?_c('span',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.openDialog()}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),(_vm.checkedIncomCom === 0 || _vm.currentClient.compIncomStatus === 1)?_c('div',{staticClass:"el"},[(_vm.exportRunning)?_c('md-button',{staticClass:"export-button ",on:{"click":_vm.selectedToursExport}},[_c('span',[_vm._v("EXPORT")])]):_c('md-button',{staticClass:"export-button",on:{"click":_vm.selectedToursExport}},[_c('span',[_vm._v("EXPORT")])])],1):_vm._e(),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('span',{staticClass:"md-dialog-title md-title",attrs:{"data-v-ec680dbc":""}},[_vm._v("\n                            You have requested an export of  "),_c('b',{attrs:{"data-v-ec680dbc":""}},_vm._l((_vm.exportModalName),function(item,i){return _c('span',{key:i},[(i>0)?_c('span',[_vm._v(_vm._s(', '))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(item))])])})),_vm._v("- we will notify you via email when it is ready.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"md-dialog-content",attrs:{"data-v-ec680dbc":""}},[_c('b',{attrs:{"data-v-ec680dbc":""}},[_vm._v("Client Name :")]),_vm._v("\n                            "+_vm._s(_vm.currentClientName)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"md-dialog-content",attrs:{"data-v-ec680dbc":""}},[_c('b',{attrs:{"data-v-ec680dbc":""}},[_vm._v("Description :")]),_vm._v(" "),_vm._l((_vm.exportModalName),function(item,i){return _c('span',{key:i},[(i>0)?_c('span',[_vm._v(_vm._s(', '))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(item))])])})],2),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog_export()}}},[_vm._v("Ok")])],1)],1)]),_vm._v(" "),(_vm.showModal_tours)?_c('div',{attrs:{"id":"bs-modal"}},[_c('div',{staticClass:"modal fade",attrs:{"id":"myModal","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.notShowModal}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("Save changes")])])])])])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el spinner-container"},[(_vm.exportRunning)?_c('md-progress-spinner',{staticClass:"md-accent export-running-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}):_vm._e()],1)])]),_vm._v(" "),(_vm.showdatalist)?_c('div',{staticClass:"row selectable"},_vm._l((_vm.tours),function(tour,index){return (_vm.filterCheck(tour.name))?_c('div',{key:tour.id,staticClass:"tour-card-wrap"},[_c('TourCard',{attrs:{"tour":tour,"index":index}})],1):_vm._e()})):_c('div',[_vm._v("\n        Loading records.\n    ")]),_vm._v(" "),_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":_vm.createNewTour}},[_c('md-icon',[_vm._v("add")])],1)],1)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            This will delete the tour, all of its routes, topics, triggers, and analytics data.\n            "),_c('div',{staticClass:"scroll-cont-wrap"},[_c('md-list',_vm._l((_vm.checked),function(index){return _c('md-list-item',{key:index,staticClass:"line-item"},[_c('div',{staticClass:"el"},[_vm._v(_vm._s(_vm.tours[index].name))])])}))],1)]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":_vm.deleteTour}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":_vm.closeDialog}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.copyTourStatusAlert},on:{"update:mdActive":function($event){_vm.copyTourStatusAlert=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n        You have requested to copy a tour we will notify you via email when it is ready.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.copyTourStatusAlert = false}}},[_vm._v("Ok")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title",attrs:{"id":"myModalLabel"}},[_vm._v("Export Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_vm._v("\n                                You have requested for following Tours:\n                                "),_c('h3',[_vm._v("Demo")]),_vm._v(" "),_c('h3',[_vm._v("Dave")]),_vm._v(" "),_c('h3',[_vm._v("Info")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YQmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"scroll-list"},[_c('div',{staticClass:"triggers-list",attrs:{"id":"NotesZone"}},[_c('div',{staticClass:"list-item heightAuto listing-height1"},[_c('button',{staticClass:"md-button md-theme-default",attrs:{"type":"button"},on:{"click":function($event){_vm.add()}}},[_vm._m(0,false,false)])]),_vm._v(" "),_c('div',{attrs:{"id":"add-Note"}},_vm._l((_vm.noteList),function(note,index){return _c('div',{key:index,staticClass:"md-button-content"},[_c('div',{staticClass:"line-item title-line paddingClass"},[_c('div',{staticClass:"left-item widthClass"},[(!_vm.editTableIndex.includes(index) && _vm.saveFlag)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(note.Description),expression:"note.Description"}],staticClass:"textAreaClass",attrs:{"id":"notes_description","placeholder":"Type note here ...."},domProps:{"value":(note.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(note, "Description", $event.target.value)}}}):(!_vm.notesIndexList.includes(index))?_c('p',[_c('span',{staticClass:"note_description"},[_vm._v(_vm._s(note.Description.substring(0, 60))),(note.Description.length>=60)?_c('span',[_vm._v("...")]):_vm._e()]),_vm._v(" "),(note.Description.length>=60)?_c('span',{on:{"click":function($event){_vm.showComplete(note,index)}}},[_vm._m(1,true,false)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notesdate"},[_vm._v(_vm._s(note.date))])]):(_vm.notesIndexList.includes(index))?_c('p',[_c('span',{staticClass:"note_description"},[_vm._v(_vm._s(note.Description.substring(0, 1100)))]),_vm._v(" "),(note.Description.length>=60)?_c('span',{on:{"click":function($event){_vm.showComplete(note,index)}}},[_vm._m(2,true,false)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notesdate"},[_vm._v(_vm._s(note.date))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item rightWidth"},[(_vm.editTableIndex.includes(index))?_c('i',{staticClass:"md-icon md-icon-font md-theme-default action",on:{"click":function($event){_vm.edit(index, note.id)}}},[_vm._v("mode_edit")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.editTableIndex.includes(index))?_c('i',{staticClass:"md-icon md-icon-font md-theme-default action",on:{"click":function($event){_vm.confirmRemove(note, index)}}},[_vm._v("delete")]):_vm._e()])])])}))]),_vm._v(" "),_c('div',{attrs:{"id":"SaveNotes"}},[(_vm.saveFlag)?_c('div',{staticClass:"btnClass"},[_c('button',{staticClass:"md-button md-primary md-raised btn-danger md-theme-default",on:{"click":function($event){_vm.refreshScreen()}}},[_vm._m(3,false,false)]),_vm._v(" "),_c('button',{staticClass:"md-button md-primary md-raised md-theme-default",attrs:{"type":"submit"},on:{"click":function($event){_vm.saveNotes()}}},[_vm._m(4,false,false)])]):_vm._e()])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog,"id":"NotesZoneModel"},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this note?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.remove(_vm.note, _vm.index)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_c('div',{staticClass:"line-item title-line"},[_c('div',{staticClass:"right-item"},[_c('i',{staticClass:"icon icon-add action"}),_vm._v("Add Note\n                                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"show_less"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Show more")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"show_less"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Show less")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Cancel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Save")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_error_Forbidden_vue__ = __webpack_require__("grG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_error_Unauthorized_vue__ = __webpack_require__("N1Dz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_settings_Settings_vue__ = __webpack_require__("wMqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings_GeneralSettings_vue__ = __webpack_require__("LvIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_settings_UsersSettings_vue__ = __webpack_require__("9r/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_settings_UsermanualSettings_vue__ = __webpack_require__("uvOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_settings_ExportJobs_vue__ = __webpack_require__("stSD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings_AddUser_vue__ = __webpack_require__("vKGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_settings_EditUser_vue__ = __webpack_require__("6QMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_EditUserPassword_vue__ = __webpack_require__("achx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_EditUserProfile_vue__ = __webpack_require__("y7VS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_EditUserPermissions_vue__ = __webpack_require__("ucxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_LogInHistory_vue__ = __webpack_require__("neHp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_EnableIncompleteTours_vue__ = __webpack_require__("N+kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_client_Client_vue__ = __webpack_require__("tpm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_client_AddRelease_vue__ = __webpack_require__("MDAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_client_EditRelease_vue__ = __webpack_require__("IbK8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_client_EditReleaseVersion_vue__ = __webpack_require__("psgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_client_ReleaseSettings_vue__ = __webpack_require__("dqWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_client_ClientListTab_vue__ = __webpack_require__("bp51");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_client_ClientSwitchTab_vue__ = __webpack_require__("0mKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_client_NewClient_vue__ = __webpack_require__("BJh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_client_EditClient_vue__ = __webpack_require__("2mbM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_client_LibraryTab_vue__ = __webpack_require__("vWLs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_client_AnalyticsTab_vue__ = __webpack_require__("SZyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_client_AnalyticsAudience_vue__ = __webpack_require__("PQ87");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_client_AnalyticsTopic_vue__ = __webpack_require__("q3O3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_client_ToursTab_vue__ = __webpack_require__("8G2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_client_ExportsTab_vue__ = __webpack_require__("m7Pd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_client_ExportDetailsTab_vue__ = __webpack_require__("cXeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_user_Login_vue__ = __webpack_require__("KQvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_user_ForgotPassword_vue__ = __webpack_require__("PPXG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_user_PlayVideoPdf_vue__ = __webpack_require__("9cD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_user_ForgotSent_vue__ = __webpack_require__("V76v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_user_ResetPassword_vue__ = __webpack_require__("OMa8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_tour_TourEditor_vue__ = __webpack_require__("pmPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_tour_TopicRouteTabs_vue__ = __webpack_require__("olkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_tour_TourSettings_vue__ = __webpack_require__("QnAI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_tour_TourGeneralTab_vue__ = __webpack_require__("MFQD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_tour_TourMediaTab_vue__ = __webpack_require__("8a7p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_tour_TopicsTab_vue__ = __webpack_require__("xM1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_tour_RoutesTab_vue__ = __webpack_require__("3P42");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_tour_newTour_vue__ = __webpack_require__("zNx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_tour_TourRoute_vue__ = __webpack_require__("9V4R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_tour_TourFigure_vue__ = __webpack_require__("va1m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_tour_NewTourFigure_vue__ = __webpack_require__("1KSB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_tour_RouteFigure_vue__ = __webpack_require__("Hqu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_tour_TopicFigure_vue__ = __webpack_require__("6Luw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_tour_TriggerFigure_vue__ = __webpack_require__("zR7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_tour_TopicTriggerNoteTabs_vue__ = __webpack_require__("2hD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_tour_TriggersTab_vue__ = __webpack_require__("C0D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_tour_TriggerSettingsTab_vue__ = __webpack_require__("KWel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_tour_TriggerNotesTab_vue__ = __webpack_require__("E7fw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_tour_TriggerNotesAddTab_vue__ = __webpack_require__("w+u0");
/**
 * Router
 *
 * Main js file for defining the routes used in the Cortex app
 *
 **/






























// import ReleaseSettingsForClient from '@/components/settings/ReleaseSettingsForClient.vue';






































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', redirect: '/login' }, {
    path: '/client',
    name: 'client',
    component: __WEBPACK_IMPORTED_MODULE_17__components_client_Client_vue__["a" /* default */],
    children: [{
      path: '/client/list',
      name: 'ClientListTab',
      component: __WEBPACK_IMPORTED_MODULE_22__components_client_ClientListTab_vue__["a" /* default */]
    }, {
      path: '/client/exportDetails',
      name: 'exportDetailsTab',
      component: __WEBPACK_IMPORTED_MODULE_32__components_client_ExportDetailsTab_vue__["a" /* default */]
    }, {
      path: '/client/tours',
      name: 'toursTab',
      component: __WEBPACK_IMPORTED_MODULE_30__components_client_ToursTab_vue__["a" /* default */]
    }, {
      path: '/client/library',
      name: 'libraryTab',
      component: __WEBPACK_IMPORTED_MODULE_26__components_client_LibraryTab_vue__["a" /* default */]
    }, {
      path: '/client/analytics',
      name: 'analyticsTab',
      component: __WEBPACK_IMPORTED_MODULE_27__components_client_AnalyticsTab_vue__["a" /* default */],
      children: [{
        path: '/client/analytics/audience',
        name: 'analyticsAudience',
        component: __WEBPACK_IMPORTED_MODULE_28__components_client_AnalyticsAudience_vue__["a" /* default */]
      }, {
        path: '/client/analytics/topic',
        name: 'analyticsTopic',
        component: __WEBPACK_IMPORTED_MODULE_29__components_client_AnalyticsTopic_vue__["a" /* default */]
      }]
    }, {
      path: '/client/exports',
      name: 'exportsTab',
      component: __WEBPACK_IMPORTED_MODULE_31__components_client_ExportsTab_vue__["a" /* default */]
    }, {
      path: '/client/new',
      name: 'NewClient',
      component: __WEBPACK_IMPORTED_MODULE_24__components_client_NewClient_vue__["a" /* default */]
    }]
  }, {
    path: '/clients/switch',
    name: 'ClientSwitchTab',
    component: __WEBPACK_IMPORTED_MODULE_23__components_client_ClientSwitchTab_vue__["a" /* default */]
  }, {
    path: '/client/edit',
    name: 'EditClient',
    component: __WEBPACK_IMPORTED_MODULE_25__components_client_EditClient_vue__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_33__components_user_Login_vue__["a" /* default */]
  }, {
    path: '/forgot',
    name: 'ForgotPassword',
    component: __WEBPACK_IMPORTED_MODULE_34__components_user_ForgotPassword_vue__["a" /* default */]
  }, {
    path: '/usermanual/video',
    name: 'PlayVideoPdf',
    component: __WEBPACK_IMPORTED_MODULE_35__components_user_PlayVideoPdf_vue__["a" /* default */]
  }, {
    path: '/usermanual/pdf',
    name: 'PlayVideoPdf',
    component: __WEBPACK_IMPORTED_MODULE_35__components_user_PlayVideoPdf_vue__["a" /* default */],
    title: 'Search'
  }, {
    path: '/usermanual/faq',
    name: 'PlayVideoPdf',
    component: __WEBPACK_IMPORTED_MODULE_35__components_user_PlayVideoPdf_vue__["a" /* default */],
    title: 'Search'
  }, {
    path: '/email/sent',
    name: 'ForgotSent',
    component: __WEBPACK_IMPORTED_MODULE_36__components_user_ForgotSent_vue__["a" /* default */]
  }, {
    path: '/reset/:id',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_37__components_user_ResetPassword_vue__["a" /* default */],
    props: true
  }, {
    path: '/settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_5__components_settings_Settings_vue__["a" /* default */],
    children: [{
      path: '/settings/release',
      name: 'releaseSettings',
      component: __WEBPACK_IMPORTED_MODULE_21__components_client_ReleaseSettings_vue__["a" /* default */]
    }, {
      path: '/settings/exportjobs',
      name: 'exportjobs',
      component: __WEBPACK_IMPORTED_MODULE_9__components_settings_ExportJobs_vue__["a" /* default */]
    }, {
      path: '/settings/release/add',
      name: 'addRelease',
      component: __WEBPACK_IMPORTED_MODULE_18__components_client_AddRelease_vue__["a" /* default */]
    }, {
      path: '/settings/release/edit',
      name: 'editRelease',
      component: __WEBPACK_IMPORTED_MODULE_19__components_client_EditRelease_vue__["a" /* default */]
    }, {
      path: '/settings/release/editVersion',
      name: 'editReleaseVersion',
      component: __WEBPACK_IMPORTED_MODULE_20__components_client_EditReleaseVersion_vue__["a" /* default */]
    }, {
      path: '/settings/general',
      name: 'generalSettings',
      component: __WEBPACK_IMPORTED_MODULE_6__components_settings_GeneralSettings_vue__["a" /* default */]
    }, {
      path: '/settings/usermanual',
      name: 'usermanual',
      component: __WEBPACK_IMPORTED_MODULE_8__components_settings_UsermanualSettings_vue__["a" /* default */]
    }, {
      path: '/settings/lohinhistory',
      name: 'lohinhistory',
      component: __WEBPACK_IMPORTED_MODULE_15__components_settings_LogInHistory_vue__["a" /* default */]
    }, {
      path: '/settings/enableincompletetours',
      name: 'enableincompletetours',
      component: __WEBPACK_IMPORTED_MODULE_16__components_settings_EnableIncompleteTours_vue__["a" /* default */]
    }, {
      path: '/settings/users',
      name: 'usersSettings',
      component: __WEBPACK_IMPORTED_MODULE_7__components_settings_UsersSettings_vue__["a" /* default */]
    }, {
      path: '/settings/users/add',
      name: 'usersSettingsAdd',
      component: __WEBPACK_IMPORTED_MODULE_10__components_settings_AddUser_vue__["a" /* default */]
    }]
  }, {
    path: '/tour',
    name: 'TourEditor',
    redirect: '/tour/topicRoutes',
    component: __WEBPACK_IMPORTED_MODULE_38__components_tour_TourEditor_vue__["a" /* default */],
    children: [{
      path: '/tour/topicRoutes',
      name: 'topicRoutes',
      redirect: '/tour/topicRoutes/topics',
      components: {
        header: __WEBPACK_IMPORTED_MODULE_47__components_tour_TourFigure_vue__["a" /* default */],
        body: __WEBPACK_IMPORTED_MODULE_39__components_tour_TopicRouteTabs_vue__["a" /* default */]
      },
      children: [{
        path: '/tour/topicRoutes/routes',
        name: 'RoutesTab',
        component: __WEBPACK_IMPORTED_MODULE_44__components_tour_RoutesTab_vue__["a" /* default */]
      }, {
        path: '/tour/topicRoutes/topics',
        name: 'TopicsTab',
        component: __WEBPACK_IMPORTED_MODULE_43__components_tour_TopicsTab_vue__["a" /* default */]
      }]
    }, {
      path: '/tour/settings',
      name: 'TourSettingsTab',
      component: __WEBPACK_IMPORTED_MODULE_40__components_tour_TourSettings_vue__["a" /* default */],
      children: [{
        path: '/tour/settings/general',
        name: 'TourGeneralTab',
        component: __WEBPACK_IMPORTED_MODULE_41__components_tour_TourGeneralTab_vue__["a" /* default */]
      }, {
        path: '/tour/settings/media',
        name: 'TourMediaTab',
        component: __WEBPACK_IMPORTED_MODULE_42__components_tour_TourMediaTab_vue__["a" /* default */]
      }]
    }, {
      path: '/tour/new',
      name: 'NewTour',
      components: {
        header: __WEBPACK_IMPORTED_MODULE_48__components_tour_NewTourFigure_vue__["a" /* default */],
        body: __WEBPACK_IMPORTED_MODULE_45__components_tour_newTour_vue__["a" /* default */]
      }
    }, {
      path: '/tour/route',
      name: 'Route',
      components: {
        header: __WEBPACK_IMPORTED_MODULE_49__components_tour_RouteFigure_vue__["a" /* default */],
        body: __WEBPACK_IMPORTED_MODULE_46__components_tour_TourRoute_vue__["a" /* default */]
      }
    }, {
      path: '/tour/topic',
      name: 'Topic',
      redirect: '/tour/topic/triggers',
      components: {
        header: __WEBPACK_IMPORTED_MODULE_50__components_tour_TopicFigure_vue__["a" /* default */],
        body: __WEBPACK_IMPORTED_MODULE_52__components_tour_TopicTriggerNoteTabs_vue__["a" /* default */]
      },
      children: [{
        path: '/tour/topic/triggers',
        name: 'TopicTriggers',
        component: __WEBPACK_IMPORTED_MODULE_53__components_tour_TriggersTab_vue__["a" /* default */]
      }, {
        path: '/tour/topic/notes',
        name: 'TopicNotes',
        component: __WEBPACK_IMPORTED_MODULE_55__components_tour_TriggerNotesTab_vue__["a" /* default */]
      }]
    }, {
      path: '/tour/trigger',
      name: 'Trigger',
      redirect: '/tour/trigger/settings',
      components: {
        header: __WEBPACK_IMPORTED_MODULE_51__components_tour_TriggerFigure_vue__["a" /* default */],
        body: __WEBPACK_IMPORTED_MODULE_52__components_tour_TopicTriggerNoteTabs_vue__["a" /* default */]
      },
      children: [{
        path: '/tour/trigger/settings',
        name: 'TriggerSettings',
        component: __WEBPACK_IMPORTED_MODULE_54__components_tour_TriggerSettingsTab_vue__["a" /* default */]
      }, {
        path: '/tour/trigger/notes',
        name: 'TriggerNotes',
        component: __WEBPACK_IMPORTED_MODULE_56__components_tour_TriggerNotesAddTab_vue__["a" /* default */]
      }]
    }]
  }, {
    path: '/user',
    name: 'UserEdit',
    component: __WEBPACK_IMPORTED_MODULE_11__components_settings_EditUser_vue__["a" /* default */],
    redirect: '/user/profile',
    children: [{
      path: '/user/profile',
      name: 'UserProfile',
      component: __WEBPACK_IMPORTED_MODULE_13__components_settings_EditUserProfile_vue__["a" /* default */]
    }, {
      path: '/user/password',
      name: 'UserPassword',
      component: __WEBPACK_IMPORTED_MODULE_12__components_settings_EditUserPassword_vue__["a" /* default */]
    }, {
      path: '/user/permissions',
      name: 'UserPermissions',
      component: __WEBPACK_IMPORTED_MODULE_14__components_settings_EditUserPermissions_vue__["a" /* default */]
    }]
  }, {
    path: '/403',
    name: 'ForbiddenError',
    component: __WEBPACK_IMPORTED_MODULE_3__components_error_Forbidden_vue__["a" /* default */]
  }, {
    path: '/401',
    name: 'UnauthorizedError',
    component: __WEBPACK_IMPORTED_MODULE_4__components_error_Unauthorized_vue__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.isSignedIn) {
    if (to.path === '/login' || to.path === '/forgot' || to.path === '/email/sent' || to.path.startsWith('/reset/') || to.path === '/usermanual/video' || to.path === '/usermanual/pdf') {
      return next();
    }
    return next({ path: '/login' });
  } else if (to.path !== '/403') {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.isAdmin) {
      var userClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.user.clientId;
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient) {
        var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
        if (userClientId !== currentClientId) {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('client/resetClient');
          return next({ path: '/403' });
        } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.tours.currentTour.id) {
          var currentTourClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.tours.currentTour.clientId;
          if (userClientId !== currentTourClientId || currentClientId !== currentTourClientId) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('client/resetClient');
            return next({ path: '/403' });
          }
        }
      }
    }
  }

  if (from.name === '401') {
    return next({ path: '/login' });
  }

  if (from.name === '403' && to.name === 'client') {
    return next({ path: '/login' });
  }

  if (to.name === 'generalSettings' || to.name === 'ClientListTab') {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['user/isAdmin']) {
      return next(false);
    }
  }

  if (from.name === 'Route') {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('map/togglePencilIconSelected', false);
  }

  if (to.name !== 'TopicTriggers' && to.name !== 'TopicNotes' && to.name !== 'TriggerSettings' && to.name !== 'TriggerNotes') {
    // Might to adjust how this logic works or expand it's range of 'from' routes
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('topics/resetCurrentTopic');
  }

  if (from.name === 'TopicsTab') {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('topics/resetSelectedTopics');
  }

  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['editor/showSettings']) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('editor/toggleShowSettings', false);
  }

  if (to.matched[0].name === 'client') {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.tours.currentTour.id) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('library/clearTourNotifications');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('tours/clearCurrentTour');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('routes/clearCurrentRoute');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('topics/resetCurrentTopic');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('triggers/clearCurrentTrigger');
    }
  }

  if (to.name === 'ClientListTab') {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('client/resetClient');
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.routes.currentRoute.id) {
    if (to.name === 'TopicsTab' || to.name === 'RoutesTab') {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('routes/clearCurrentRoute');
    }
  }

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('topics/resetTopicHover');
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('triggers/resetTriggerHover');

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YuBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"users-settings-list"},[(_vm.releaseList === null)?_c('div',{staticClass:"item-wrap"},[_vm._m(0,false,false)]):_c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"row mt-40 version-table"},[_c('div',{staticClass:"col-sm-12 ",class:{ static: _vm.clinetVersionCheck}},[_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Version")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"}},[_vm._v(" Date")]),_vm._v(" "),_c('th',{staticStyle:{"width":"500px"}},[_vm._v(" Description")]),_vm._v(" "),(_vm.isAdmin)?_c('th',{staticStyle:{"width":"200px"}},[_vm._v(" Action")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.releaseList),function(release,indexParent){return _c('tr',{key:indexParent},[_c('td',{staticStyle:{"text-align":"center","vertical-align":"top","padding-top":"20px"}},[_vm._v(" "+_vm._s(release.v_no))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"top","padding-top":"20px","width":"200px"}},[_vm._v(" "+_vm._s(release.description[0]['date']))]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_c('table',{staticClass:"version-iiner-table"},_vm._l((release.description),function(releasebuild,index){return _c('tr',{key:index},[(index <= 0)?_c('span',[_vm._l((releasebuild.features),function(releasebuildss,indexss){return _c('td',{staticStyle:{"width":"1000px"}},[_vm._v("\n                                                        "+_vm._s(releasebuildss.descriptionVersion)+"\n                                                    ")])}),_vm._v(" "),_c('td',{staticClass:"custom-btn",staticStyle:{"width":"600px"}}),_vm._v(" "),(_vm.isAdmin)?_c('td',{staticClass:"custom-btn",staticStyle:{"text-align":"center","vertical-align":"top","padding-top":"20px","width":"200px"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.expandAll(_vm.rowStatus, indexParent)}}},[_c('i',{staticClass:"md-icon md-icon-font md-icon-image md-list-expand-icon md-theme-default"},[_c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0-.75h24v24H0z","fill":"none"}})])])]),_vm._v(" "),(!_vm.clinetVersionCheck && _vm.isAdmin)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showCurrentReleaseProfileVersion(releasebuild.id, release.v_no)}}},[_c('md-icon',[_vm._v("mode_edit")])],1):_vm._e()],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rowStatus[indexParent]),expression:"rowStatus[indexParent]"}]},[(_vm.showExpand)?_c('thead',[(index === 0)?_c('tr',[_c('th',[_vm._v("Build")]),_vm._v(" "),_c('th',[_vm._v("Feature")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),(_vm.isAdmin)?_c('th',[_vm._v("Action")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(releasebuild.v_no)+"."+_vm._s(releasebuild.r_no))]),_vm._v(" "),_vm._l((releasebuild.features),function(releasebuilds,indexs){return _c('td',[_vm._v("\n                                                                "+_vm._s(releasebuilds.heading)+"\n                                                            ")])}),_vm._v(" "),_vm._l((releasebuild.features),function(releasebuilds,indexs){return _c('td',[_vm._v("\n                                                                "+_vm._s(releasebuilds.description)+"\n                                                            ")])}),_vm._v(" "),(!_vm.clinetVersionCheck && _vm.isAdmin)?_c('td',{staticClass:"custom-btn"},[(_vm.isAdmin)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showCurrentReleaseProfile(releasebuild.id, release.v_no)}}},[_c('md-icon',[_vm._v("mode_edit")])],1):_vm._e()],1):_vm._e()],2)])])])}))])])}))])])])])]),_vm._v(" "),(_vm.isSuperAdmin)?_c('div',{staticClass:"bottom-btn-position"},[_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":function($event){_vm.clickAddNewRelease()}}},[_c('md-icon',[_vm._v("add")])],1)],1)]):_vm._e()]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete release"),_c('b',[_vm._v(" "+_vm._s(this.releaseToDeleteName))]),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteSelectedRelease()}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-ir u tem releaseListWraper"},[_c('div',{staticClass:"block-1"}),_vm._v(" "),_c('div',{staticClass:"block-2"}),_vm._v(" "),_c('div',{staticClass:"block-3",staticStyle:{"padding-top":"20px"}},[_vm._v("\n                            No version found.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"block-4"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a3hw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aSxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['showTriggerTabs']))
});

/***/ }),

/***/ "aXAk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "achx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPassword_vue__ = __webpack_require__("Fi+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13391ead_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPassword_vue__ = __webpack_require__("EtkF");
function injectStyle (ssrContext) {
  __webpack_require__("htSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13391ead"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13391ead_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ad+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"client-box"},[_c('section',{staticClass:"add-user global-section"},[_c('div',{staticClass:"row"},[_c('md-button',{staticClass:"md-icon-button cancel-add-user",on:{"click":function($event){_vm.cancelEditRelease()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_vm._m(0,false,false)],1),_vm._v(" "),(_vm.formError)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"disabled":true,"placeholder":"Release Number"},model:{value:(_vm.releaseToEdit.r_no),callback:function ($$v) {_vm.$set(_vm.releaseToEdit, "r_no", $$v)},expression:"releaseToEdit.r_no"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('md-field',{staticClass:"md-block"},[_vm._v(_vm._s(_vm.releaseToEdit.date)+"\n                            "),_c('datepicker',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"disabled":true,"placeholder":"Release Date","format":_vm.format},model:{value:(_vm.releaseToEdit.date),callback:function ($$v) {_vm.$set(_vm.releaseToEdit, "date", $$v)},expression:"releaseToEdit.date"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.releaseDetail),function(releasefunction,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"uploadImgWrapper"},[_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"client-name-box"},[_c('div',{staticClass:"line-item"},[_c('md-field',{staticClass:"md-block"},[_c('md-input',{attrs:{"placeholder":"Functionality Name"},model:{value:(releasefunction.heading),callback:function ($$v) {_vm.$set(releasefunction, "heading", $$v)},expression:"releasefunction.heading"}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"textareaWrapper"},[_c('md-field',{staticClass:"md-block boder-0"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(releasefunction.description),expression:"releasefunction.description"}],staticClass:"textareaW",attrs:{"placeholder":"Description"},domProps:{"value":(releasefunction.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(releasefunction, "description", $event.target.value)}}})]),_vm._v(" "),(_vm.hasMultipleRelease)?_c('md-button',{staticClass:"md-icon-button delete-btn ",attrs:{"aria-label":"Delete Functionality"},on:{"click":function($event){_vm.deleteRelease(index)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e()],1)])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bottomBtnWrapper"},[_c('div',{},[_c('md-button',{staticClass:"save-user-button md-primary",staticStyle:{"margin-left":"1000px"},attrs:{"aria-label":"Add New Client"},on:{"click":function($event){_vm.clickSaveNewRelease()}}},[_vm._v("Update")])],1)])])])],2)])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"user-saving-message"},[_c('span',[_c('md-progress-spinner',{staticClass:"md-accent user-saving-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}),_vm._v("\n              Updating Release...\n            ")],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title"},[_vm._v("Edit Build Notes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar upload s-48 feature-icon-m"},[_c('img',{attrs:{"src":"static/img/settings.svg","alt":"feature icon","width":"34"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aySU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTimezones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getTimezones() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/timezones');
}



/***/ }),

/***/ "bOGD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__("IC97");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      format: 'MM-dd-yyyy',
      r_no: '',
      r_date: '',
      v_no: '',
      el: '#demo',
      name: 'MultipleSelect',
      formError: null,
      showDialog: false,
      message: '',
      releaseDetail: []
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('release', ['releaseToEdit', 'releaseEdited']), {
    hasMultipleRelease: function hasMultipleRelease() {
      return this.releaseDetail.length > 1;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateUserProfile', 'setReleaseToEdit']), {
    cancelEditRelease: function cancelEditRelease() {
      this.$router.push('/settings/release');
    },
    deleteRelease: function deleteRelease(index) {
      if (this.releaseDetail[index].isPrimaryContact) {
        if (index === 0) {
          this.releaseDetail[1].isPrimaryContact = true;
        } else {
          this.releaseDetail[0].isPrimaryContact = true;
        }
      }
      this.releaseDetail.splice(index, 1);
    },
    addRelease: function addRelease() {
      var releaseDetail = {
        heading: null,
        description: null
      };
      this.releaseDetail.push(releaseDetail);
    },
    loadReleasefunctiondetail: function loadReleasefunctiondetail(rid) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = '';
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["getReleaseDetail"])(rid);

              case 3:
                result = _context.sent;

                _this.releaseDetail = result.data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clickSaveNewRelease: function clickSaveNewRelease() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showDialog = true;

                if (!(_this2.releaseToEdit.r_no === '')) {
                  _context2.next = 6;
                  break;
                }

                _this2.formError = 'Please enter release number.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 6:
                if (!(_this2.releaseToEdit.date === '')) {
                  _context2.next = 11;
                  break;
                }

                _this2.formError = 'Please enter release date.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 11:
                if (!(_this2.releaseToEdit.v_no === '')) {
                  _context2.next = 16;
                  break;
                }

                _this2.formError = 'Please enter version number.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 16:
                if (!(_this2.releaseDetail[0].heading === null || _this2.releaseDetail[0].description === null)) {
                  _context2.next = 21;
                  break;
                }

                _this2.formError = 'Please enter release notes.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 21:
                newData = {
                  r_id: _this2.releaseToEdit.id,
                  r_no: _this2.releaseToEdit.r_no,
                  v_no: _this2.releaseToEdit.v_no,
                  date: _this2.releaseToEdit.date,
                  descriptionVersion: _this2.releaseToEdit.descriptionVersion,
                  functionsDetail: _this2.releaseDetail
                };
                _context2.next = 24;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["updateNewRelease"])(newData).then(function (response) {
                  _this2.$router.push('/settings/release');
                  _this2.showDialog = false;
                }).catch(function (error) {
                  if (error.response.data.type !== '') {
                    _this2.formError = error.response.data.message;
                  }
                  _this2.showDialog = false;
                });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  mounted: function mounted() {
    this.loadReleasefunctiondetail(this.releaseToEdit.id);
  }
});

/***/ }),

/***/ "bTS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveTour; });
/* unused harmony export saveTours */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return newTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRouteTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateRouteDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return newTour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateRouteTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saveNewRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTopicTriggers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return saveTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNewRouteTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteTopicFromRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateTriggerName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkExportTours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return uploadRouteFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




function uploadRouteFile(data, routeId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  var formData = new FormData();
  formData.append('image', data);
  formData.append('currentClientId', currentClientId);
  formData.append('route_id', routeId);
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/uploadRouteImage', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

function saveTour(tour) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + tour.clientId + '/saveTour', {
    id: tour.id,
    card: tour.card,
    city: tour.city,
    clientId: tour.clientId,
    defaultActivate: tour.defaultActivate,
    defaultDelay: tour.defaultDelay,
    defaultRadiusDistance: tour.defaultRadiusDistance,
    defaultTolerance: tour.defaultTolerance,
    description: tour.description,
    name: tour.name,
    systemId: tour.systemId,
    latLng: tour.latLng,
    timezone_id: tour.timezone_id
  }).catch(function (error) {
    console.log(error);
  });
}

function saveTours(tour) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + tour.clientId + '/saveTours', {
    id: tour.id,
    card: tour.card,
    city: tour.city,
    clientId: tour.clientId,
    description: tour.description,
    name: tour.name,
    systemId: tour.systemId,
    latLng: tour.latLng,
    timezone_id: tour.timezone_id
  }).catch(function (error) {
    console.log(error);
  });
}

function getRouteTopics(routeId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('api/client/' + currentClientId + '/getRouteTopics/' + routeId);
}

function updateRouteDetails(route) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/saveRoute', {
    id: route.id,
    clientId: route.clientId,
    systemId: route.systemId,
    notificationSound: route.notificationSound,
    notificationSongId: route.notificationSongId,
    name: route.name,
    description: route.description,
    vehicleId: route.vehicleId,
    path: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(route.path),
    alt_path: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(route.alt_path),
    channels: route.channels,
    commentary: route.commentary,
    commentaryDelay: route.commentaryDelay,
    audioControllerNotification: route.audioControllerNotification,
    audioControllerFlashTime: route.audioControllerFlashTime,
    headendSys: route.headendSys
  });
}

function updateRouteTopics(topicOrder) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/updateRouteTopicOrder', { topicOrder: topicOrder });
}

function newTour(tour) {
  var formData = new FormData();
  formData.append('image', tour.image);
  formData.append('card', tour.card);
  formData.append('city', tour.city);
  formData.append('clientId', tour.clientId);
  formData.append('defaultActivate', tour.defaultActivate);
  formData.append('defaultDelay', tour.defaultDelay);
  formData.append('defaultRadiusDistance', tour.defaultRadiusDistance);
  formData.append('defaultTolerance', tour.defaultTolerance);
  formData.append('description', tour.description);
  formData.append('name', tour.name);
  formData.append('systemId', tour.systemId);
  formData.append('latLng', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tour.latLng));
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + tour.clientId + '/newTour', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

function newTopic(topic) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/newTopic', {
    avatar: topic.avatar,
    icon: topic.icon,
    placeId: topic.place_id,
    city: topic.city,
    tourId: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.tours.currentTour.id,
    reference: topic.reference,
    viewport: topic.viewport,
    address: topic.formatted_address,
    name: topic.name,
    idInPlace: topic.id,
    isReal: topic.isReal,
    latLng: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(topic.latLng)
  });
}

function updateTopics() {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/updateTopics', {
    topics: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.topics.topicsList
  }).then(function (response) {
    if (response.status === 200) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('topics/toggleVirtualConditional', false);
      return response;
    }
  }).catch(function (error) {
    console.log(error);
  });
}

function getTopicTriggers(routeId, topicId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('api/client/' + currentClientId + '/getTopicTriggers/' + routeId + '/' + topicId);
}

function saveNewRoute(newRoute) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/insertNewRoute', newRoute);
}

function addNewRouteTopics(payload) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/insertNewRouteTopics', payload);
}

function saveTrigger(trigger) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('apiclient/' + currentClientId + '/updateTrigger', trigger);
}

function updateTriggerName(trigger) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('apiclient/' + currentClientId + '/updateTriggerName', trigger);
}

function saveTopic(topic) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/updateTopics', { topics: topic });
}

function addTrigger(trigger) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/insertTrigger', trigger);
}

function deleteTopicFromRoute(ids) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('api/client/' + currentClientId + '/routes/' + ids[0] + '/topics/remove', {
    routeID: ids[0],
    topicIDs: ids[1]
  });
}

function checkExportTours(tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('api/client/' + currentClientId + '/checkExportTours/' + tourId);
}



/***/ }),

/***/ "bdgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bgO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LanguageService__ = __webpack_require__("kOA1");






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    initialLanguages: [],
    languageList: [],
    tourLanguageList: [],
    checkRouteIsMappingTable: false
  },
  getters: {
    getLanguageList: function getLanguageList(state) {
      return state.languageList;
    },
    getTourLanguageList: function getTourLanguageList(state) {
      return state.tourLanguageList;
    },
    checkRouteIsMappingTable: function checkRouteIsMappingTable(state) {
      return state.checkRouteIsMappingTable;
    },
    tourLanguagesReordered: function tourLanguagesReordered(state) {
      var reordered = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.tourLanguageList.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var index = _ref2[0];
          var lang = _ref2[1];

          if (!state.initialLanguages[index] || lang.order !== state.initialLanguages[index].order) {
            reordered = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return reordered;
    }
  },
  mutations: {
    setLanguageList: function setLanguageList(state, languages) {
      state.languageList = languages;
    },
    setTourLanguageList: function setTourLanguageList(state, tourLanguages) {
      state.initialLanguages = tourLanguages;
      state.tourLanguageList = tourLanguages;
    },
    checkRouteIsMappingTable: function checkRouteIsMappingTable(state, data) {
      state.checkRouteIsMappingTable = data;
    },
    updateLanguageOrderForTour: function updateLanguageOrderForTour(state, data) {
      state.tourLanguageList = data.languages;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.tourLanguageList.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var index = _ref4[0];
          var language = _ref4[1];

          language.order = index;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    updateInitialLanguages: function updateInitialLanguages(state, languages) {
      state.initialLanguages = languages;
    }
  },
  actions: {
    loadLanguageList: function loadLanguageList(_ref5) {
      var _this = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var languages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["c" /* getLanguageList */])();

              case 2:
                languages = _context.sent;

                commit('setLanguageList', languages.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeStateRouteIsMappingTable: function changeStateRouteIsMappingTable(_ref6, data) {
      var _this2 = this;

      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('checkRouteIsMappingTable', data);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadTourLanguageList: function loadTourLanguageList(_ref7, tourId) {
      var _this3 = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var tourLanguages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["e" /* getTourLanguageList */])(tourId);

              case 2:
                tourLanguages = _context3.sent;

                commit('setTourLanguageList', tourLanguages.data);
                commit('updateInitialLanguages', tourLanguages.data);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    createLanguage: function createLanguage(_ref8, data) {
      var _this4 = this;

      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["f" /* newLanguage */])(data);

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 5]]);
      }))();
    },
    addTourLanguage: function addTourLanguage(_ref9, data) {
      var _this5 = this;

      var commit = _ref9.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result, tourLanguages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["g" /* newTourLanguage */])(data);

              case 3:
                result = _context5.sent;

                if (!(result.data === 'success')) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["e" /* getTourLanguageList */])(data.tourId);

              case 7:
                tourLanguages = _context5.sent;

                commit('setTourLanguageList', tourLanguages.data);
                commit('updateInitialLanguages', tourLanguages.data);

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 12]]);
      }))();
    },
    removeTourLanguage: function removeTourLanguage(_ref10, data) {
      var _this6 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result, tourLanguages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["h" /* removeTourLanguage */])(data);

              case 3:
                result = _context6.sent;

                if (result.data === 0) {
                  commit('checkRouteIsMappingTable', true);
                }

                if (!(result.data === 'success')) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["e" /* getTourLanguageList */])(data.tourId);

              case 8:
                tourLanguages = _context6.sent;

                commit('setTourLanguageList', tourLanguages.data);
                commit('updateInitialLanguages', tourLanguages.data);

              case 11:
                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 13]]);
      }))();
    },
    removeTourLanguages: function removeTourLanguages(_ref11, data) {
      var _this7 = this;

      var commit = _ref11.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var result, tourLanguages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["i" /* removeTourLanguages */])(data);

              case 3:
                result = _context7.sent;

                if (!(result.data === 'success')) {
                  _context7.next = 11;
                  break;
                }

                commit('checkRouteIsMappingTable', false);
                _context7.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["e" /* getTourLanguageList */])(data.tourId);

              case 8:
                tourLanguages = _context7.sent;

                commit('setTourLanguageList', tourLanguages.data);
                commit('updateInitialLanguages', tourLanguages.data);

              case 11:
                _context7.next = 16;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 13]]);
      }))();
    },
    updateLanguageOrder: function updateLanguageOrder(_ref12, data) {
      var commit = _ref12.commit;

      commit('updateLanguageOrderForTour', data);
    },
    updateTourLanguages: function updateTourLanguages(_ref13, data) {
      var _this8 = this;

      var commit = _ref13.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService__["j" /* updateTourLanguages */])(data);

              case 3:
                _context8.next = 8;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 5]]);
      }))();
    }
  }
});

/***/ }),

/***/ "bp51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientListTab_vue__ = __webpack_require__("OkT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6963a1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientListTab_vue__ = __webpack_require__("Arye");
function injectStyle (ssrContext) {
  __webpack_require__("4+RA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientListTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6963a1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientListTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cDao":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cRr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global"},[_c('header',{staticClass:"global-header"},[_c('div',{staticClass:"line-item"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el popover-container",staticStyle:{"margin":"23px"}},[_c('span',{on:{"click":function($event){_vm.releaseSettings()}}},[_c('span',{staticClass:"message-icon unread",staticStyle:{"cursor":"pointer","font-family":"Arial, Helvetica, sans-serif","font-size":"16px","color":"rgb(0, 168, 202)"}},[_vm._v("\n                            Version "+_vm._s(_vm.latestVersion)+"\n                        ")])]),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"el"},[_c('img',{staticClass:"pencilSelected",attrs:{"src":"static/img/Help_Icon-gr.png"},on:{"click":function($event){_vm.showVideoPdf()}}})]),_vm._v(" "),_c('div',{staticClass:"el header-avatar"},[_c('md-button',{staticClass:"avatar-button",on:{"click":function($event){_vm.showCurrentUserProfile()}}},[(_vm.currentUser.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.currentUser.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue"},[_vm._v("\n                            "+_vm._s(_vm.getUserInitials(_vm.currentUser))+"\n                        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.navToSettings()}}},[_c('md-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el logout-button"},[_c('md-button',{on:{"click":function($event){_vm.clickLogout()}}},[_vm._v("Logout")])],1)])])]),_vm._v(" "),_c('section',{staticClass:"page-content"},[_c('div',{staticClass:"wrap btn-position-wrap",attrs:{"id":"ClientListTab"}},[_c('md-list',{staticClass:"clients-wrap"},_vm._l((_vm.userClients),function(client,index){return (_vm.userClients != null)?_c('div',{staticClass:"collapsing-list-item",attrs:{"id":client.client_id}},[_c('md-list-item',{staticClass:"client-line",on:{"click":function($event){_vm.navToClient(client)}}},[_c('div',{staticClass:"left-item"},[_c('a',{staticClass:"client-nav"},[_c('h2',[_vm._v(_vm._s(client.companyName)+"\n                                    "),_c('small',[_vm._v(_vm._s(client.description))])])])]),_vm._v(" "),_c('div',{staticClass:"right-item"}),_vm._v(" "),_c('md-list',{attrs:{"slot":"md-expand"},slot:"md-expand"},[_c('md-list-item',{staticClass:"md-inset"},[_c('div',{staticClass:"client-info-wrap line-item"},[_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el"})])])])],1)],1)],1):_vm._e()})),_vm._v(" "),_c('modal',{attrs:{"name":"ReleaseModal","resizable":true,"reset":true,"height":"60%","width":"60%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindowRelease()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindowRelease()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.releasePanel)?_c('button',{staticClass:"close md-button md-icon-button backBtn",attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon"},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.releasePanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                            Version List\n                                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"vedionameList",attrs:{"id":"releseList"}},[(_vm.releaseData === 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No new version found.")]):_vm._l((_vm.releaseData.release),function(release,index){return _c('div',{key:index},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showRelease(release)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("settings")])]),_vm._v(" Version "+_vm._s(release.v_no)+"\n                                                ")])])])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.releaseDetailPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                            Version Detail\n                                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"customScrollWrapper"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"releaseWrapper",attrs:{"id":"releseDetail"}},[_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Version No.")]),_vm._v(" "+_vm._s(this.singleReleaseData.v_no))]),_vm._v(" "),_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Date.")]),_vm._v(" "+_vm._s(this.singleReleaseData.date))])]),_vm._v(" "),_c('div',{attrs:{"id":"functionaldescription"}},_vm._l((this.singleReleaseData.detail),function(releasefunction,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"funcDespWrapper"},[_c('div',{staticClass:"dec-left-panel"},[_c('b',[_vm._v(_vm._s(releasefunction.heading)+" :- ")])]),_vm._v(" "),_c('div',{staticClass:"dec-right-panel"},[_vm._v(" "+_vm._s(releasefunction.description))])])])])])}))])])])])])]):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"name":"ReleaseModal1","resizable":true,"reset":true,"height":"100%","width":"100%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindowRelease()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindowRelease()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.releasePanel)?_c('button',{staticClass:"close md-button md-icon-button backBtn",attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon"},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.releasePanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                            Version List\n                                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"vedionameList",attrs:{"id":"releseList"}},[(_vm.releaseData.release.length === 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No new version found.")]):_vm._l((_vm.releaseData.release),function(release,index){return _c('div',{key:index},[_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showRelease(release)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("settings")])]),_vm._v(" Version "+_vm._s(release.v_no)+"\n                                                ")])])])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.releaseDetailPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Release-list-front redActiveManual",attrs:{"type":"button"}},[_c('div',{staticClass:"fontManualTab"},[_vm._v("\n                                            Version Detail\n                                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"customScrollWrapper fullViewContent"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"releaseWrapper",attrs:{"id":"releseDetail"}},[_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Version No.")]),_vm._v(" "+_vm._s(this.singleReleaseData.v_no))]),_vm._v(" "),_c('div',{staticClass:"releaseText"},[_c('b',[_vm._v("Date.")]),_vm._v(" "+_vm._s(this.singleReleaseData.date))])]),_vm._v(" "),_c('div',{attrs:{"id":"functionaldescription"}},_vm._l((this.singleReleaseData.detail),function(releasefunction,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"funcDespWrapper"},[_c('div',{staticClass:"dec-left-panel"},[_c('b',[_vm._v(_vm._s(releasefunction.heading)+" :- ")])]),_vm._v(" "),_c('div',{staticClass:"dec-right-panel"},[_vm._v(" "+_vm._s(releasefunction.description))])])])])])}))])])])])])]):_vm._e()])])],1)]),_vm._v(" "),_c('md-dialog',{staticStyle:{"width":"120%","height":"-webkit-fill-available"},attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('ReleaseSettings',{attrs:{"clinetVersionCheck":"1","latestVersion":_vm.latestVersion}})],1),_vm._v(" "),_c('modal',{staticClass:"help-modal-small",attrs:{"name":"hello-world","resizable":true,"reset":true,"height":"60%","width":"60%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                Video\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                PDF\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                FAQ\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"20px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})]),_vm._v("\n                                        "+_vm._s(usermanual.question)+"\n                                    ")])]):_vm._e(),_vm._v(" "),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',[_c('md-icon',{staticClass:"faq-section-back-button",staticStyle:{"padding-right":"15px"}},[_vm._v("arrow_back")]),_vm._v(" "),_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})],1),_vm._v("\n                                    "+_vm._s(this.detailinfo.question)+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}})]),_vm._v(" "),_c('p',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important","margin-left":"0px"}},[_vm._v(_vm._s(this.detailinfo.answers))])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logout-button conatinerForSupport"},[_c('a',{staticClass:"GFG",attrs:{"href":"https://www.listentech.com/listen-navilution-support/","target":"_blank"}},[_c('button',{staticClass:"md-button md-theme-default",staticStyle:{"margin-bottom":"10px","padding":"10px"}},[_vm._v("\n                        Website support\n                    ")])]),_vm._v(" "),_c('md-button',{staticClass:"md-button md-theme-default",attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v("\n                    Email support\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("PDF")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()]),_vm._v(" "),_c('modal',{staticClass:"help-modal-large",attrs:{"name":"hello-world2","resizable":true,"reset":true,"height":"100%","width":"100%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{staticClass:"row "},[_c('button',{staticClass:"close-icon",staticStyle:{"right":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.closeshowVideoPdf()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("clear")])]),_vm._v(" "),_c('button',{staticClass:"minimize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.maxWindow()}}},[_c('img',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"},attrs:{"src":"static/img/max1.png"}})]),_vm._v(" "),_c('button',{staticClass:"maximize-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.minWindow()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("minimize")])]),_vm._v(" "),(!_vm.listPanel)?_c('button',{staticClass:"close md-button md-icon-button",staticStyle:{"left":"0","position":"absolute","z-index":"9999","cursor":"pointer","top":"0"},attrs:{"type":"button"},on:{"click":function($event){_vm.backList()}}},[_c('i',{staticClass:"md-icon",staticStyle:{"color":"#ffffff !important","height":"26px !important"}},[_vm._v("arrow_back")])]):_vm._e()]),_vm._v(" "),(_vm.listPanel)?_c('div',{staticClass:"scroll-cont"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions "},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                Video\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('infoActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                PDF\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usemanual-list-front",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('faqActive')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                                FAQ\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-cont-wrap"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('homeActive')),expression:"isActiveTab('homeActive')"}],staticClass:"boxes",attrs:{"id":"home"}},[_c('div',{staticClass:"vedionameList",attrs:{"id":"videoList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '0')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showVedio(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('infoActive')),expression:"isActiveTab('infoActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[_c('div',{staticClass:"pdfnameList",attrs:{"id":"pdfList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '1')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showPdf(usermanual.id)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]),_vm._v(" "+_vm._s(usermanual.attachment_name))])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveTab('faqActive')),expression:"isActiveTab('faqActive')"}],staticClass:"boxes",attrs:{"id":"info"}},[(_vm.showquestion)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No file found.")]):_vm._l((_vm.UserManualList),function(usermanual,index){return _c('div',{key:usermanual.id},[(usermanual.type == '2')?_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaq(usermanual)}}},[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"0px","padding-right":"7.6px"},attrs:{"src":"static/img/Help_Icon-gr.png"}}),_vm._v("\n                                        "+_vm._s(usermanual.question)+"\n                                    ")])]):_vm._e(),(_vm.isHidden)?_c('p',[_vm._v(_vm._s(usermanual.answers))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.showquestiondetail)?_c('div',{staticClass:"pdfnameList",attrs:{"id":"faqList"}},[_c('p',[_c('a',{staticClass:"d-flex",staticStyle:{"text-decoration":"none !important"},on:{"click":function($event){_vm.showfaqs(_vm.usermanual)}}},[_c('span',{staticStyle:{"padding-left":"0px","padding-right":"7.6px"}},[_c('md-icon',{staticClass:"faq-section-back-button"},[_vm._v("arrow_back")]),_vm._v(" "),_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px","padding-left":"0px","padding-right":"7.6px"},attrs:{"src":"static/img/Help_Icon-gr.png"}})],1),_vm._v("\n                                    "+_vm._s(this.detailinfo.question)+"\n                                ")])]),_vm._v(" "),_c('p',{staticClass:"d-flex-align1",staticStyle:{"text-decoration":"none !important"}},[_c('span',[_c('img',{staticClass:"pencilSelectedfaq",staticStyle:{"height":"20px"},attrs:{"src":"static/img/bulbicon.jpg"}})]),_vm._v("\n                                "+_vm._s(this.detailinfo.answers)+"\n                            ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logout-button conatinerForSupport"},[_c('a',{staticClass:"GFG",attrs:{"href":"https://www.listentech.com/listen-navilution-support/","target":"_blank"}},[_c('button',{staticClass:"md-button md-theme-default",staticStyle:{"margin-bottom":"10px","padding":"10px"}},[_vm._v("\n                        Website support\n                    ")])]),_vm._v(" "),_c('md-button',{staticClass:"md-button md-theme-default",attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v("\n                    Email support\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.vedioPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions ",attrs:{"data-v-ec680dbc":""}},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"data-v-ec680dbc":"","type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Video")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.pdfPanel)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"md-dialog-actions full-btn"},[_c('button',{staticClass:"md-button md-raised md-primary md-theme-default",staticStyle:{"background-color":"#00A8CA","width":"100%","height":"62px"},attrs:{"type":"button"},on:{"click":function($event){_vm.makeActive('homeActive')}}},[_c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Version")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.pdfSrc,"width":"100%","height":"800","alt":"pdf"}})])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('h1',[_c('span',[_vm._v("Clients")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cTu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);






var _require = __webpack_require__("N8fj"),
    resetPassword = _require.resetPassword,
    sendResetEmail = _require.sendResetEmail,
    signIn = _require.signIn,
    _signInUserToken = _require.signInUserToken,
    validatePasswordResetToken = _require.validatePasswordResetToken,
    SendOtpService = _require.SendOtpService;

var _require2 = __webpack_require__("+q4l"),
    getAllUsers = _require2.getAllUsers,
    getUsersForClient = _require2.getUsersForClient,
    getUserById = _require2.getUserById;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    userList: null,
    user: null,
    isSignedIn: false,
    isValidToken: null,
    isPasswordReset: false,
    token: null,
    userToEdit: null,
    initialUser: null,
    isAdminEmailCheck: 0
  },
  getters: {
    isAdmin: function isAdmin(state) {
      return state.user && state.user.isAdmin;
    },
    isSuperAdmin: function isSuperAdmin(state) {
      return state.user && state.user.isSuperAdmin;
    },
    isAdminEmailCheck: function isAdminEmailCheck(state) {
      return state.isAdminEmailCheck;
    },
    clientId: function clientId(state) {
      return state.user && state.user.clientId ? state.user.clientId : null;
    },
    currentUser: function currentUser(state) {
      return state.user;
    },
    isValidToken: function isValidToken(state) {
      return state.isValidToken;
    },
    isPasswordReset: function isPasswordReset(state) {
      return state.isPasswordReset;
    },
    getToken: function getToken(state) {
      return state.token;
    },
    userList: function userList(state) {
      return state.userList;
    },
    isSignedIn: function isSignedIn(state) {
      return state.isSignedIn;
    },
    userToEdit: function userToEdit(state) {
      return state.userToEdit;
    },
    initialUser: function initialUser(state) {
      return state.initialUser;
    },
    userEdited: function userEdited(state) {
      if (state.userToEdit) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.userToEdit)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (key === 'email' || key === 'directPhone' || key === 'officePhone') {
              var editValue = state.userToEdit[key] ? String(state.userToEdit[key]).toLowerCase() : '';
              var initialValue = state.initialUser[key] ? String(state.initialUser[key]).toLowerCase() : '';
              if (editValue !== initialValue) {
                return true;
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    }
  },
  mutations: {
    signIn: function signIn(state, user) {
      state.user = user;
      state.isAdmin = user.isAdmin === 1;
      state.isSignedIn = true;
    },
    signInEmailId: function signInEmailId(state, user) {
      state.isAdminEmailCheck = 1;
    },
    updateUserClient: function updateUserClient(state, user) {
      state.user = user;
    },
    setIsValidToken: function setIsValidToken(state, isValid) {
      state.isValidToken = isValid;
    },
    setIsPasswordReset: function setIsPasswordReset(state, isReset) {
      state.isPasswordReset = isReset;
    },
    setToken: function setToken(state, token) {
      state.token = token;
    },
    setUserList: function setUserList(state, userList) {
      state.userList = userList;
    },
    signOut: function signOut(state) {
      state.user = null;
      state.isAdmin = false;
      state.isSignedIn = false;
    },
    setUserToEdit: function setUserToEdit(state, user) {
      state.userToEdit = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, user);
      state.initialUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, user);
    },
    updateUserProfile: function updateUserProfile(state, user) {
      state.user = user;
    },
    removeCurrentUserToken: function removeCurrentUserToken(state) {
      state.user.access_token = null;
    },
    removeCurrentEmailIdCheck: function removeCurrentEmailIdCheck(state) {
      state.isAdminEmailCheck = 0;
    }
  },
  actions: {
    signInUser: function signInUser(_ref, data) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                commit('removeCurrentEmailIdCheck');
                _context.next = 4;
                return signIn(data.email, data.password);

              case 4:
                user = _context.sent;

                if (user.data !== 'Incorrect password.') {}
                if (user.data === 'No matching user found.') {
                  commit('signInEmailId', user.data);
                } else {
                  commit('signIn', user.data);
                }
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.error('Could not sign user in.', _context.t0);
                throw _context.t0;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    signInUserToken: function signInUserToken(_ref2, data) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _signInUserToken(data);

              case 3:
                user = _context2.sent;

                if (user.data.length !== 0) {
                  console.log('User ' + user.data[0].email + ' signed in successfully.');
                }
                if (user.data.length) {
                  commit('signIn', user.data[0]);
                }
                return _context2.abrupt('return', user);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.error('Could not sign user in.', _context2.t0);
                throw _context2.t0;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    SendOtpModal: function SendOtpModal(_ref3, data) {
      var _this3 = this;

      var commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return SendOtpService(data);

              case 3:
                user = _context3.sent;
                return _context3.abrupt('return', user);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('Could not sign user in.', _context3.t0);
                throw _context3.t0;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    updateUserClientData: function updateUserClientData(_ref4, data) {
      var _this4 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getUserById(data.id);

              case 3:
                user = _context4.sent;

                commit('updateUserClient', user.data);
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.error('Could not sign user in.', _context4.t0);
                throw _context4.t0;

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 7]]);
      }))();
    },
    sendResetPasswordEmail: function sendResetPasswordEmail(_ref5, data) {
      var _this5 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return sendResetEmail(data);

              case 3:
                _context5.next = 9;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);
                throw _context5.t0;

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 5]]);
      }))();
    },
    validateToken: function validateToken(_ref6, token) {
      var _this6 = this;

      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return validatePasswordResetToken(token);

              case 3:
                isValid = _context6.sent;

                commit('setIsValidToken', isValid.data);
                commit('setToken', token);
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);

                commit('setIsValidToken', _context6.t0.response.data);
                throw _context6.t0;

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8]]);
      }))();
    },
    resetUserPassword: function resetUserPassword(_ref7, data) {
      var _this7 = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var passwordReset;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return resetPassword(data.password, data.token);

              case 3:
                passwordReset = _context7.sent;

                commit('setIsPasswordReset', passwordReset.data);
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0;

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 7]]);
      }))();
    },
    loadUserList: function loadUserList(_ref8) {
      var _this8 = this;

      var commit = _ref8.commit;
      var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var userList, clientUsers, allUsers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                userList = null;

                if (!clientId) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 5;
                return getUsersForClient(clientId);

              case 5:
                clientUsers = _context8.sent;

                userList = clientUsers.data;
                _context8.next = 13;
                break;

              case 9:
                _context8.next = 11;
                return getAllUsers();

              case 11:
                allUsers = _context8.sent;

                userList = allUsers.data;

              case 13:
                commit('setUserList', userList);
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);
                throw _context8.t0;

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 16]]);
      }))();
    },
    clearUserList: function clearUserList(_ref9) {
      var commit = _ref9.commit;

      commit('setUserList', null);
    },
    signOutUser: function signOutUser(_ref10) {
      var commit = _ref10.commit;

      commit('signOut');
    },
    setUserToEdit: function setUserToEdit(_ref11, user) {
      var commit = _ref11.commit;

      commit('setUserToEdit', user);
    },
    clearUserToEdit: function clearUserToEdit(_ref12) {
      var commit = _ref12.commit;

      commit('setUserToEdit', null);
    },
    updateUserProfile: function updateUserProfile(_ref13, user) {
      var commit = _ref13.commit;

      commit('updateUserProfile', user);
    },
    cleanTokenFromCurrentUser: function cleanTokenFromCurrentUser(_ref14) {
      var commit = _ref14.commit;

      commit('removeCurrentUserToken');
    }
  }
});

/***/ }),

/***/ "cXeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportDetailsTab_vue__ = __webpack_require__("+Jkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a189e53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportDetailsTab_vue__ = __webpack_require__("YJcL");
function injectStyle (ssrContext) {
  __webpack_require__("h0tj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a189e53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportDetailsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a189e53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportDetailsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "doCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dqWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseSettings_vue__ = __webpack_require__("9iII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dedb878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseSettings_vue__ = __webpack_require__("ZQQG");
function injectStyle (ssrContext) {
  __webpack_require__("T6Wp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dedb878"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dedb878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0nJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fileflag: false,
      files: '',
      preViewImage: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('tours', ['currentTourImage'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tours', ['loadTourEditorImage']), {
    handleFiles: function handleFiles() {
      var uploadedFiles = this.$refs.files.files;
      this.files = uploadedFiles[0];
      this.preViewImage = URL.createObjectURL(uploadedFiles[0]);
      this.fileflag = true;
      this.loadTourEditorImage(this.files);
    },
    returnToPrevious: function returnToPrevious() {
      this.$router.push('/client/tours');
    },
    getImageSrc: function getImageSrc(image) {
      return 'static/img/' + image;
    }
  })
});

/***/ }),

/***/ "eQ8z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "emM0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"exports-wrap"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"exports-wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2",staticStyle:{"margin-top":"7px"}},[_c('span',{staticStyle:{"font-size":"15px","color":"black","font-weight":"550"}},[_vm._v("Start Date ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"MM-dd-yyyy","name":"uniquename"},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-2",staticStyle:{"margin-top":"7px"}},[_c('span',{staticStyle:{"font-size":"15px","color":"black","font-weight":"550"}},[_vm._v("End Date ")]),_vm._v(" "),_c('datepicker',{attrs:{"format":"MM-dd-yyyy","name":"uniquename"},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('span',[_c('md-checkbox',{staticStyle:{"position":"relative","top":"8px","margin-left":"26px"},attrs:{"value":"failed"},model:{value:(_vm.arrayData),callback:function ($$v) {_vm.arrayData=$$v},expression:"arrayData"}},[_vm._v("Failed")]),_vm._v(" "),_c('md-checkbox',{staticStyle:{"position":"relative","top":"8px","margin-left":"26px"},attrs:{"value":"inprocess"},model:{value:(_vm.arrayData),callback:function ($$v) {_vm.arrayData=$$v},expression:"arrayData"}},[_vm._v("In-process")]),_vm._v(" "),_c('md-checkbox',{staticStyle:{"position":"relative","top":"8px","margin-left":"26px"},attrs:{"value":"completed"},model:{value:(_vm.arrayData),callback:function ($$v) {_vm.arrayData=$$v},expression:"arrayData"}},[_vm._v("Completed")]),_vm._v(" "),_c('md-checkbox',{staticStyle:{"position":"relative","top":"8px","margin-left":"26px"},attrs:{"value":"deleted"},model:{value:(_vm.arrayData),callback:function ($$v) {_vm.arrayData=$$v},expression:"arrayData"}},[_vm._v("Deleted")]),_vm._v(" "),_c('md-button',{staticClass:"submit-analytics-button md-primardy",on:{"click":function($event){_vm.loadQueueData()}}},[_vm._v("Apply")])],1)])])]),_vm._v(" "),_c('div',[(_vm.exportDataNotFound)?_c('div',{staticClass:"righContent",staticStyle:{"float":"right","margin-top":"28px","font-size":"initial"}},[_c('span',{staticStyle:{"font-size":"15px","color":"black","font-weight":"550"}},[_vm._v("Total Jobs:")]),_vm._v(" "+_vm._s(_vm.jobsCount)+"\n            ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"page-content settings"},[_c('div',{staticStyle:{"width":"100%","max-height":"400px","overflow-y":"auto","overflow-x":"auto"}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"firstTable"}},[_vm._m(1,false,false),_vm._v(" "),(_vm.exportDataNotFound)?_c('tbody',_vm._l((_vm.exportLists),function(exports){return (_vm.country === 'runningJobs')?_c('tr',{key:exports.jobId},[_c('td',[_vm._v(_vm._s(exports.ClientName))]),_vm._v(" "),_c('td',_vm._l((_vm.splitedList(exports.tourName)),function(code){return _c('div',[_c('span',{on:{"click":function($event){_vm.openCLientCListPage(exports.tourAllDetails)}}},[_c('a',[_vm._v(_vm._s(code))])]),_c('br')])})),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.createAt))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.startedAt))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.completedAt))]),_vm._v(" "),(exports.queueJobFaild ==1)?_c('td',[_vm._v("3")]):_c('td',[_vm._v("1")]),_vm._v(" "),(exports.queueJobFaild==0)?_c('td',[_vm._v("In-process")]):(exports.completedAt =='0000-00-00 00:00:00')?_c('td',[_vm._v("In-process")]):(exports.queueJobFaild == 1)?_c('td',[_vm._v("Failed")]):(exports.deleted_at != null)?_c('td',[_vm._v("Deleted")]):_c('td',[_vm._v("Completed")]),_vm._v(" "),_c('td',[(exports.queueJobFaild =='0')?_c('md-button',{staticClass:"md-accent md-raised",staticStyle:{"background-color":"#d9534f !important","height":"25px","font-size":"12px","padding":"5px 0","color":"white"},on:{"click":function($event){_vm.showModalPop(exports.exportId)}}},[_vm._v("CANCEL")]):_vm._e(),_vm._v(" "),(exports.queueJobFaild =='1')?_c('md-button',{staticClass:"md-accent md-raised",staticStyle:{"background-color":"#00A8CA !important","height":"25px","font-size":"12px","padding":"5px 0","color":"white"},on:{"click":function($event){_vm.showModalPopRestart(exports.queueJobId)}}},[_vm._v("RESTART")]):_vm._e(),_vm._v(" "),(exports.completedAt =='0000-00-00 00:00:00')?_c('md-button',{staticClass:"md-accent md-raised",staticStyle:{"background-color":"#00A8CA !important","height":"25px","font-size":"12px","padding":"5px 0","color":"white"},on:{"click":function($event){_vm.showModalPop(exports.exportId)}}},[_vm._v("CANCEL")]):_vm._e()],1)]):_vm._e()})):_vm._e()])]),_vm._v(" "),(_vm.exportDataNotFound)?_c('div',{staticClass:"exportJobs",staticStyle:{"margin-top":"100px"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1):_vm._e(),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n                        Confirm Delete\n                    ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n                        Are you sure you want to delete this Jobs?\n                    ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteClient(_vm.exportIdQueue)}}},[_vm._v("Delete")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogRe},on:{"update:mdActive":function($event){_vm.showDeleteDialogRe=$event}}},[_c('md-dialog-title',[_vm._v("\n                        Confirm Restart\n                    ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n                        Are you sure you want to Restart this Jobs?\n                    ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.reStartQueueJob(_vm.reStartJobID)}}},[_vm._v("Restart")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialogRe = false}}},[_vm._v("Cancel")])],1)],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-item toolbar"},[_c('div',{staticClass:"left-item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("CLIENT NAME")]),_vm._v(" "),_c('th',[_vm._v("Tour Name")]),_vm._v(" "),_c('th',[_vm._v("CREATED AT")]),_vm._v(" "),_c('th',[_vm._v("STARTED AT")]),_vm._v(" "),_c('th',[_vm._v("Completed AT")]),_vm._v(" "),_c('th',[_vm._v("attempts")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fXhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__("uZUK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72e1acf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__("spvM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72e1acf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCopyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adChannelIdToARoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteRouteTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updatePriorityForRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function deleteRoute(routeId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/client/' + currentClientId + '/route/' + routeId);
}

function deleteRouteTopic(currentRoute, topicId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/deleteRouteTopic/currentRoute/' + currentRoute + '/topicId/' + topicId);
}

function getCopyName(name) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/getCopyName/', {
    name: name
  });
}

function adChannelIdToARoute(routeId, channelId, tourId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/adChannelIdToARoute/', {
    routeId: routeId,
    channelId: channelId,
    tourId: tourId
  });
}

function updatePriorityForRoutes(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/updatePriorityRoutes', data);
}


/***/ }),

/***/ "fslx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"tourFigure"},[(!_vm.showInfo)?_c('div',[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.currentTour.card)}}),_vm._v(" "),_c('div',{staticClass:"gradient-box"}),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Back to Tours","aria-label":"Back"},on:{"click":_vm.returnToPrevious}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed","margin-left":"3%"}},[_c('h3',{staticClass:"link",on:{"click":function($event){_vm.toggleInfoBlock('EDITOPEN')}}},[_vm._v(_vm._s(_vm.currentTour.name))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('md-menu',{staticClass:"tourSettings"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',{attrs:{"width":"3"}},[_c('md-menu-item',[_c('button',{staticClass:"md-button",on:{"click":function($event){_vm.exportCurrentTour(_vm.currentTour.id)}}},[_vm._v("Export Tour")])]),_vm._v(" "),_c('md-menu-item',[_c('button',{staticClass:"md-button",on:{"click":function($event){_vm.toggleShowSettings(true)}}},[_vm._v("Tour Settings")])])],1)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"info-block"},[_c('h3',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTour.name),expression:"currentTour.name"}],attrs:{"maxlength":"60","rows":"1","placeholder":"Tour Name"},domProps:{"value":(_vm.currentTour.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTour, "name", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTour.description),expression:"currentTour.description"}],attrs:{"maxlength":"200","placeholder":"Description"},domProps:{"value":(_vm.currentTour.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTour, "description", $event.target.value)}}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button close-info",on:{"click":function($event){_vm.toggleInfoBlock('EDITCLOSE')}}},[_c('md-icon',[_vm._v("close")])],1),_vm._v(" "),_c('md-button',{staticClass:"save-button md-raised md-primary",on:{"click":_vm.saveTourDetails}},[_vm._v("Save")])],1):_vm._e()]),_vm._v(" "),_c('md-dialog',{staticStyle:{"overflow-y":"scroll"},attrs:{"md-active":_vm.checkTarballComplet},on:{"update:mdActive":function($event){_vm.checkTarballComplet=$event}}},[_c('md-list',{staticClass:"full-control"},[_c('p',[_vm._v("\n                Your tour is still incomplete to make tarball. So complete your tour and export tarball.\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeCheckTarballComplet()}}},[_vm._v("Close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g4iZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"tourFigure"},[(!_vm.showInfo)?_c('div',[_c('img',{attrs:{"src":_vm.currentRouteImages}}),_vm._v(" "),(!_vm.currentRoute.route_image&&!_vm.currentRoute.avatar)?_c('div',{staticClass:"upload-icon visible-upload-icon",staticStyle:{"margin-top":"40px"}},[_c('md-button',{attrs:{"aria-label":"Upload Image"}},[_c('form',{staticClass:"upload-btn btn-for-upload",attrs:{"id":"tourImage","enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"files",staticClass:"file-input",attrs:{"accept":"image/*","type":"file","id":"files"},on:{"change":function($event){_vm.handleFileUpload($event)}}}),_vm._v(" "),_c('md-icon',{staticClass:"photo-icon"},[_vm._v("photo_size_select_actual")])],1),_vm._v(" "),(!_vm.fileflag)?_c('p',{staticClass:"upload-text"},[_vm._v("Click to upload a route image")]):_c('p',{staticClass:"upload-text"},[_vm._v("File selected click here to change file")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"gradient-box"}),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Back to Routes","aria-label":"Back"},on:{"click":_vm.returnToPrevious}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed","margin-left":"3%"}},[_c('h3',{staticClass:"link",on:{"click":function($event){_vm.toggleInfoBlock('EDITOPEN')}}},[_vm._v(_vm._s(_vm.currentRoute.name))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('md-menu',[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',{attrs:{"width":"3"}},[_c('md-menu-item',[_c('button',{staticClass:"md-button",on:{"click":function($event){_vm.exportCurrentTour(_vm.currentTour.id)}}},[_vm._v("Export Tour")])]),_vm._v(" "),_c('md-menu-item',[_c('button',{staticClass:"md-button",on:{"click":function($event){_vm.toggleShowSettings(true), _vm.callRouteSettingFunction(1)}}},[_vm._v("Route Settings")])]),_vm._v(" "),(_vm.currentRoute.route_image || _vm.currentRoute.avatar)?_c('md-menu-item',[_c('div',{staticClass:"upload-btn"},[_c('form',{attrs:{"id":"tourImage","enctype":"multipart/form-data"}},[_c('label',{staticClass:"md-button",staticStyle:{"width":"192px"},attrs:{"for":"files"}},[_vm._v(" Change Route Image ")]),_vm._v(" "),_c('input',{ref:"files",staticClass:"file-input",attrs:{"accept":"image/*","type":"file","id":"files"},on:{"change":function($event){_vm.handleFileUpload($event)}}})])])]):_vm._e()],1)],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"info-block"},[_c('h3',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentRoute.name),expression:"currentRoute.name"}],attrs:{"maxlength":"60","rows":"1","placeholder":"Route Name"},domProps:{"value":(_vm.currentRoute.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentRoute, "name", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentRoute.description),expression:"currentRoute.description"}],attrs:{"maxlength":"200","placeholder":"Description"},domProps:{"value":(_vm.currentRoute.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentRoute, "description", $event.target.value)}}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button close-info",on:{"click":function($event){_vm.toggleInfoBlock('EDITCLOSE')}}},[_c('md-icon',[_vm._v("close")])],1),_vm._v(" "),_c('md-button',{staticClass:"save-button md-raised md-primary",on:{"click":_vm.saveRouteDetails}},[_vm._v("Save")])],1):_vm._e()]),_vm._v(" "),_c('md-dialog',{staticStyle:{"overflow-y":"scroll"},attrs:{"md-active":_vm.checkTarballComplet},on:{"update:mdActive":function($event){_vm.checkTarballComplet=$event}}},[_c('md-list',{staticClass:"full-control"},[_c('p',[_vm._v("\n                Your tour is still incomplete to make tarball. So complete your tour and export tarball.\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeCheckTarballComplet()}}},[_vm._v("Close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gC3n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('analytics', { analytics: 'analytics', colors: 'getColors', isLoading: 'isLoading' })),
  methods: {
    toggleLanguage: function toggleLanguage($language) {}
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "gHwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllExports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSingleExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteExports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toursExportDownload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var toursExportDownload = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_axios___default()({
              method: 'post',
              url: 'api/client/exports/blob/' + payload.exportsId + '/',
              responseType: 'arraybuffer',
              data: payload
            }).catch(function (error) {
              console.log(error);
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function toursExportDownload(_x) {
    return _ref.apply(this, arguments);
  };
}();



function getAllExports(clientId) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + clientId + '/exports/');
}

function getSingleExport(clientId, exportIds) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/client/' + clientId + '/exports/' + exportIds);
}

function deleteExports(clientId, exportIds) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete('api/client/' + clientId + '/exports/delete', {
    params: {
      exportIds: exportIds
    }
  });
}



/***/ }),

/***/ "gRkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",attrs:{"id":"analyticsTab"}},[_c('div',{staticClass:"line-item toolbar"},[_c('div',{staticClass:"left-item"}),_vm._v(" "),_c('div',{staticClass:"right-item tour-buttons"},[_c('span',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(_vm._.isEmpty(_vm.invalidTours) && !_vm.importRunning)?_c('md-button',{staticClass:"upload-btn"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"file-input",attrs:{"id":"files","type":"file","multiple":"multiple"},on:{"change":function($event){_vm.processFiles($event)}}})]),_vm._v(" "),_c('span',[_vm._v("import")])]):(!_vm._.isEmpty(_vm.invalidTours))?_c('md-button',{staticClass:"upload-btn",on:{"click":function($event){_vm.showWarning()}}},[_c('span',[_vm._v("import")])]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"line-item analytics-toolbar"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('md-field',[_c('md-select',{attrs:{"name":"analyticsView","placeholder":"Select Analytics","change":_vm.switchView()},model:{value:(_vm.currentView),callback:function ($$v) {_vm.currentView=$$v},expression:"currentView"}},[_c('md-option',{attrs:{"value":"/client/analytics/audience","selected":""}},[_vm._v("Audience Overview")]),_vm._v(" "),_c('md-option',{attrs:{"value":"/client/analytics/topic"}},[_vm._v("TOI Sessions")])],1)],1)],1)]),_vm._v(" "),_c('form',[_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el"},[_c('md-field',[_c('md-select',{staticClass:"half-field",attrs:{"placeholder":"Select Tour"},model:{value:(_vm.analytics.tourId),callback:function ($$v) {_vm.$set(_vm.analytics, "tourId", $$v)},expression:"analytics.tourId"}},[_c('md-option',{attrs:{"value":0}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.tours),function(tour){return _c('md-option',{key:tour.name,attrs:{"value":tour.id}},[_vm._v(_vm._s(tour.name))])})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-field',[( false)?_c('md-select',{staticClass:"half-field",attrs:{"placeholder":"Select Route"},model:{value:(_vm.analytics.routeId),callback:function ($$v) {_vm.$set(_vm.analytics, "routeId", $$v)},expression:"analytics.routeId"}},[_c('md-option',{attrs:{"value":_vm.allOption}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.routes),function(route){return _c('md-option',{key:route.name,attrs:{"value":route.id}},[_vm._v(_vm._s(route.name))])})],2):_vm._e()],1)],1),_vm._v(" "),(_vm.showLanguageDropdown)?_c('div',{staticClass:"el"},[_c('md-field',[_c('md-select',{staticClass:"half-field",attrs:{"placeholder":"Select Language"},model:{value:(_vm.analytics.language),callback:function ($$v) {_vm.$set(_vm.analytics, "language", $$v)},expression:"analytics.language"}},[_c('md-option',{attrs:{"value":_vm.allOption}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.analytics.usage.languages),function(language){return (_vm.analytics.usage && _vm.analytics.usage.languages)?_c('md-option',{key:language.channelName,attrs:{"value":language.channelName}},[_vm._v(_vm._s(language.channelName))]):_vm._e()})],2)],1),_vm._v(" "),_vm._m(0,false,false)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-field',[_c('md-select',{staticClass:"half-field",attrs:{"placeholder":"Date Range"},model:{value:(_vm.analytics.dateRange),callback:function ($$v) {_vm.$set(_vm.analytics, "dateRange", $$v)},expression:"analytics.dateRange"}},_vm._l((_vm.dateRanges),function(range){return _c('md-option',{key:range.value,attrs:{"value":range.value}},[_vm._v(_vm._s(range.label))])}))],1)],1),_vm._v(" "),_c('div',{staticClass:"submit-button-el"},[_c('md-button',{staticClass:"submit-analytics-button md-primary",on:{"click":function($event){_vm.loadAnalytics()}}},[_vm._v("Load")])],1)])])]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"upload-text centered"},[_vm._v("Analyzing...\n        "),_c('md-progress-spinner',{staticClass:"md-accent export-running-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}})],1):_vm._e(),_vm._v(" "),_c('div',[_c('router-view')],1),_vm._v(" "),_c('md-dialog',{staticClass:"small-modal",attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Import Files")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":_vm.closeDialog}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),(_vm.isUploading)?_c('div',{staticClass:"upload-text centered"},[_vm._v("Uploading Files ...\n            "),_c('md-progress-spinner',{staticClass:"md-accent export-running-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}})],1):(_vm.validationError)?_c('div',{staticClass:"upload-text centered"},[_c('p',[_vm._v(_vm._s(_vm.validationError))])]):_vm._e(),_vm._v(" "),(!_vm.isUploading && _vm.fileResults)?_c('md-list',{staticClass:"scroll-list"},_vm._l((_vm.fileResults),function(file,index){return _c('md-list-item',{key:file,staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(file === true),expression:"file === true"}],staticClass:"md-icon-button top-index"},[_c('md-icon',{staticClass:"green-color"},[_vm._v("done")])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(file === false),expression:"file === false"}],staticClass:"md-icon-button top-index"},[_c('md-icon',{staticClass:"red-color"},[_vm._v("cancel")])],1)],1)])})):_vm._e(),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",attrs:{"disabled":_vm.isUploading},on:{"click":_vm.closeDialog}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showWarningDialog},on:{"update:mdActive":function($event){_vm.showWarningDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Invalid Tours")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":_vm.closeWarningDialog}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('div',{staticClass:"upload-text centered"},[_c('p',[_vm._v("The following Tours have no time zone set. Please set the Time Zone property in Tour settings before importing analytics data.")])]),_vm._v(" "),(!_vm._.isEmpty(_vm.invalidTours))?_c('md-list',{staticClass:"scroll-list"},_vm._l((_vm.invalidTours),function(tour,index){return _c('md-list-item',{key:tour.id,staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_vm._v(_vm._s(tour.name))])])])})):_vm._e(),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.closeWarningDialog}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showClientWarningDialog},on:{"update:mdActive":function($event){_vm.showClientWarningDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Analytics Disabled")])]),_vm._v(" "),_c('div',{staticClass:"upload-text centered"},[_c('p',[_vm._v("Analytics is not currently enabled for this account.")])]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.closeClientWarningDialog}},[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"single-lang"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "grG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forbidden_vue__ = __webpack_require__("TG7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf6b880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forbidden_vue__ = __webpack_require__("+nf6");
function injectStyle (ssrContext) {
  __webpack_require__("LBYO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbf6b880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forbidden_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbf6b880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forbidden_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h0tj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hJG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);






var _require = __webpack_require__("w98i"),
    getReleaseList = _require.getReleaseList;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    releaseList: [],
    release: null,
    releaseToEdit: null
  },
  getters: {
    clientId: function clientId(state) {
      return state.user && state.user.clientId ? state.user.clientId : null;
    },
    currentUser: function currentUser(state) {
      return state.user;
    },
    isValidToken: function isValidToken(state) {
      return state.isValidToken;
    },
    getToken: function getToken(state) {
      return state.token;
    },
    releaseList: function releaseList(state) {
      return state.releaseList;
    },
    releaseToEdit: function releaseToEdit(state) {
      return state.releaseToEdit;
    },
    initialRelease: function initialRelease(state) {
      return state.initialRelease;
    },
    releaseEdited: function releaseEdited(state) {
      if (state.releaseToEdit) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.releaseToEdit)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (key === 'email' || key === 'directPhone' || key === 'officePhone') {
              var editValue = state.releaseToEdit[key] ? String(state.releaseToEdit[key]).toLowerCase() : '';
              var initialValue = state.initialrelease[key] ? String(state.initialrelease[key]).toLowerCase() : '';
              if (editValue !== initialValue) {
                return true;
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    }
  },
  mutations: {
    updateUserClient: function updateUserClient(state, user) {
      state.user = user;
    },
    setIsValidToken: function setIsValidToken(state, isValid) {
      state.isValidToken = isValid;
    },
    setToken: function setToken(state, token) {
      state.token = token;
    },
    setReleaseList: function setReleaseList(state, releaseList) {
      state.releaseList = releaseList;
    },
    setReleaseToEdit: function setReleaseToEdit(state, release) {
      state.releaseToEdit = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, release);
      state.initialrelease = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, release);
    },
    setReleaseToEditVersion: function setReleaseToEditVersion(state, release) {
      state.releaseToEdit = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, release);
      state.initialrelease = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, release);
    }
  },
  actions: {
    loadReleaseList: function loadReleaseList(_ref) {
      var _this = this;

      var commit = _ref.commit;
      var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ReleaseList, releasedata;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                ReleaseList = null;

                if (!clientId) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return getReleaseList(clientId);

              case 5:
                releasedata = _context.sent;

                ReleaseList = releasedata.data;

              case 7:
                commit('setReleaseList', ReleaseList);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                throw _context.t0;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    clearReleaseList: function clearReleaseList(_ref2) {
      var commit = _ref2.commit;

      commit('setReleaseList', null);
    },
    setReleaseToEdit: function setReleaseToEdit(_ref3, release) {
      var commit = _ref3.commit;

      commit('setReleaseToEdit', release);
    },
    clearReleaseToEdit: function clearReleaseToEdit(_ref4) {
      var commit = _ref4.commit;

      commit('setReleaseToEdit', null);
    },
    setReleaseToEditVersion: function setReleaseToEditVersion(_ref5, release) {
      var commit = _ref5.commit;

      commit('setReleaseToEditVersion', release);
    },
    clearReleaseToEditVersion: function clearReleaseToEditVersion(_ref6) {
      var commit = _ref6.commit;

      commit('setReleaseToEditVersion', null);
    }
  }
});

/***/ }),

/***/ "hchd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"//fonts.googleapis.com/icon?family=Material+Icons"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iUWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__("IC97");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      format: 'MM-dd-yyyy',
      r_no: '',
      r_date: '',
      v_no: '',
      el: '#demo',
      name: 'MultipleSelect',
      formError: null,
      showDialog: false,
      message: '',
      releaseDetail: []
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('release', ['releaseToEdit', 'releaseEdited']), {
    hasMultipleRelease: function hasMultipleRelease() {
      return this.releaseDetail.length > 1;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateUserProfile', 'setReleaseToEdit']), {
    cancelEditRelease: function cancelEditRelease() {
      this.$router.push('/settings/release');
    },
    deleteRelease: function deleteRelease(index) {
      if (this.releaseDetail[index].isPrimaryContact) {
        if (index === 0) {
          this.releaseDetail[1].isPrimaryContact = true;
        } else {
          this.releaseDetail[0].isPrimaryContact = true;
        }
      }
      this.releaseDetail.splice(index, 1);
    },
    loadReleasefunctiondetail: function loadReleasefunctiondetail(rid) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = '';
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["getReleaseDetail"])(rid);

              case 3:
                result = _context.sent;

                _this.releaseDetail = result.data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clickSaveNewRelease: function clickSaveNewRelease() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showDialog = true;

                if (!(_this2.releaseToEdit.r_no === '')) {
                  _context2.next = 6;
                  break;
                }

                _this2.formError = 'Please enter release number.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 6:
                if (!(_this2.releaseToEdit.date === '')) {
                  _context2.next = 11;
                  break;
                }

                _this2.formError = 'Please enter release date.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 11:
                if (!(_this2.releaseToEdit.v_no === '')) {
                  _context2.next = 16;
                  break;
                }

                _this2.formError = 'Please enter version number.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 16:
                if (!(_this2.releaseDetail[0].heading === null || _this2.releaseDetail[0].description === null)) {
                  _context2.next = 21;
                  break;
                }

                _this2.formError = 'Please enter release notes.';
                _this2.showDialog = false;
                _context2.next = 24;
                break;

              case 21:
                newData = {
                  r_id: _this2.releaseToEdit.id,
                  r_no: _this2.releaseToEdit.r_no,
                  v_no: _this2.releaseToEdit.v_no,
                  date: _this2.releaseToEdit.date,
                  descriptionVersion: _this2.releaseToEdit.descriptionVersion,
                  functionsDetail: _this2.releaseDetail
                };
                _context2.next = 24;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["updateNewRelease"])(newData).then(function (response) {
                  _this2.$router.push('/settings/release');
                  _this2.showDialog = false;
                }).catch(function (error) {
                  if (error.response.data.type !== '') {
                    _this2.formError = error.response.data.message;
                  }
                  _this2.showDialog = false;
                });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  mounted: function mounted() {
    this.loadReleasefunctiondetail(this.releaseToEdit.id);
  }
});

/***/ }),

/***/ "iXGw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j8gs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__ = __webpack_require__("fcCE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_LibraryService_js__ = __webpack_require__("FIGs");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialogPath: false,
      topicDeleteid: '',
      showDeleteDialog: false,
      filterString: '',
      tooltipActive: [],
      triggerzone: [],
      scrollHeightUsingRefsVuejs: '',
      scrollWidth: '',
      showDeleteDialogClear: false,
      deletePathConfirmation: '',
      triggersListTrue: false,
      showTriggerListId: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('routes', ['currentRoute', 'currentRouteAlt', 'routeTopics', 'routeChanged', 'routeChangedAlt', 'pathHasPoints', 'pathHasPointsAlt', 'removedTopics']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('map', ['pencilIconSelected', 'pencilIconSelectedAlt']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('topics', ['topicsList']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('triggers', { triggersList: 'triggersList' }), {
    filterStringIsEmpty: function filterStringIsEmpty() {
      return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
    },

    topics: {
      get: function get() {
        return this.routeTopics;
      },
      set: function set(value) {
        this.updateTopicOrder({ topics: value });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('scrollList');
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('routes', ['loadRouteTopics', 'updateTopicOrder', 'updateInitialTopicList', 'saveRouteChanges', 'clearRouteTopics', 'killPath', 'killPathAlt', 'setUpdateCheck', 'setUpdateCheckAlt', 'removeRouteTopic', 'removeRouteTopicAlt', 'removeRouteTopicsFromState', 'resetRemovedTopics', 'resetRemovedTopicsAlt']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('map', ['setCenter']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('topics', ['loadEditorTopic', 'setTopicsList', 'removeMapTopicsFromState']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('triggers', ['loadRouteTriggers', 'clearStateTriggersList', 'removeMapTriggersFromState']), {
    getImageSrc: function getImageSrc(image) {
      if (image.substring(0, 5) !== 'https') {
        return 'static/img/' + image;
      } else {
        return image;
      }
    },
    onUpdate: function onUpdate(cate) {
      Object(__WEBPACK_IMPORTED_MODULE_6__services_LibraryService_js__["n" /* updatePriorityForTopicROute */])(cate);
    },
    confirmDelete: function confirmDelete(id) {
      this.showDeleteDialog = true;
      this.showTriggerListId = this.routeTopics[id].id;
      this.topicDeleteid = id;
    },
    confirmDeleteClear: function confirmDeleteClear(type) {
      this.deletePathConfirmation = type;
      this.showDeleteDialogClear = true;
    },
    notTop: function notTop(index) {
      return index > 0 && this.topics.length > 1 && this.filterStringIsEmpty;
    },
    notBottom: function notBottom(index) {
      return index < this.topics.length - 1 && this.topics.length > 1 && this.filterStringIsEmpty;
    },
    filterCheck: function filterCheck(text) {
      var passesFilter = true;
      if (text && text.replace(/^\s+|\s+$/g, '').length > 0 && !this.filterStringIsEmpty) {
        passesFilter = text.toLowerCase().includes(this.filterString.toLowerCase());
      }
      return passesFilter;
    },
    checkifNumberOfTopicsInRouteMoreThan4: function checkifNumberOfTopicsInRouteMoreThan4() {
      return this.routeTopics.length > 4;
    },
    deletePath: function deletePath() {
      this.killPath();
      this.setUpdateCheck(true);
      this.showDeleteDialogClear = false;
      this.deletePathConfirmation = '';
      this.pencilIconSelected = false;
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.routeTopics), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var topic = _step.value;

          topicOrder.push({ route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.saveRouteChanges({ topicOrder: topicOrder, routeTopics: this.routeTopics });
    },
    deletePathAlt: function deletePathAlt() {
      this.killPathAlt();
      this.setUpdateCheckAlt(true);
      this.showDeleteDialogClear = false;
      this.deletePathConfirmation = '';
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.routeTopics), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var topic = _step2.value;

          topicOrder.push({ route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.saveRouteChanges({ topicOrder: topicOrder, routeTopics: this.routeTopics });
    },
    saveRoute: function saveRoute() {
      if (this.removedTopics !== []) {
        this.removeRouteTopic([this.currentRoute.id, this.removedTopics]);
        this.resetRemovedTopics();
      }
      var topicOrder = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.routeTopics), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var topic = _step3.value;

          topicOrder.push({ route: this.currentRoute.id, topic: topic.id, orderInRoute: topic.orderInRoute });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.saveRouteChanges({ topicOrder: topicOrder, routeTopics: this.routeTopics });
    },
    saveRouteAlt: function saveRouteAlt() {
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.routeTopics), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var topic = _step4.value;

          topicOrder.push({ route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.saveRouteChanges({ topicOrder: topicOrder, routeTopics: this.routeTopics });
    },
    navigateToTopic: function navigateToTopic(topic, newIndex) {
      __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default.a.set('scrollTopHeight', newIndex);
      this.scrollWidth = __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default.a.get('scrollTopHeight');
      if (this.scrollWidth > 0) {
        this.$bus.$emit('hoveredTopic', { topicIndex: newIndex, toggle: false });
      }
      this.loadEditorTopic(topic);
      this.setCenter(topic);
      this.clearStateTriggersList();
      this.$router.push('/tour/topic');
    },

    // since the list order can be changed we need to pass where in the list the topic highlighted WAS, so that the function interacting with the emit can process it properly
    toggleHoverOn: function toggleHoverOn(index) {
      var newIndex = index;
      for (var i = 0; i < this.topicsList.length; i++) {
        if (this.topicsList[i].id === this.routeTopics[index].id) {
          newIndex = i;
        }
      }
      this.$bus.$emit('hoveredTopic', { topicIndex: newIndex, toggle: true });
      this.routeTopics[index].hover = true;
    },
    toggleHoverLeave: function toggleHoverLeave(index) {
      var newIndex = index;
      for (var i = 0; i < this.topicsList.length; i++) {
        if (this.topicsList[i].id === this.routeTopics[index].id) {
          newIndex = i;
        }
      }
      this.$bus.$emit('hoveredTopic', { topicIndex: newIndex, toggle: false });
      this.routeTopics[index].hover = false;
    },
    clickDeleteTopic: function clickDeleteTopic(index) {
      Object(__WEBPACK_IMPORTED_MODULE_5__services_RouteService_js__["c" /* deleteRouteTopic */])(this.currentRoute.id, this.routeTopics[index].id);
      this.removedTopics.push(this.routeTopics[index].id);
      this.removeMapTriggersFromState(this.routeTopics[index].id);
      this.removeRouteTopicsFromState(index);
      this.removeMapTopicsFromState(index);
      this.topicDeleteid = '';
      this.showDeleteDialog = false;
    }
  }),
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.clearRouteTopics();
    this.loadRouteTopics().then(function () {
      _this.setTopicsList(_this.routeTopics);
    });
    this.clearStateTriggersList();
    this.loadRouteTriggers(this.currentRoute.id).then(function () {
      if (_this.triggersList.length > 0) {
        _this.triggersListTrue = true;
      }
    });
    this.resetRemovedTopics();
    this.resetRemovedTopicsAlt();
    this.$bus.$on('scrollList', function ($params) {
      if ($params.toggle) {
        _this.tooltipActive[$params.topicIndex] = true;
        var container = document.getElementById('scrollSize');
        var element = document.getElementById('topicsTabList').childNodes[$params.topicIndex];
        var cTop = container.scrollTop;
        var cBottom = cTop + container.clientHeight;

        // Determine element top and bottom
        var eTop = element.offsetTop;
        var eBottom = eTop + element.clientHeight;

        // Check if out of view
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= cTop - eTop;
        } else if (eBottom > cBottom) {
          container.scrollTop += eBottom - cBottom;
        }
      } else {
        _this.tooltipActive[$params.topicIndex] = false;
      }
    });
    this.scrollWidth = __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default.a.get('scrollTopHeight');
    if (this.scrollWidth > 0) {
      var pp = this;
      this.intervalid1 = setTimeout(function () {
        var container = document.getElementById('scrollSize');
        var element = document.getElementById('topicsTabList').childNodes[pp.scrollWidth];
        var cTop = container.scrollTop;
        var cBottom = cTop + container.clientHeight;
        // Determine element top and bottom
        var eTop = element.offsetTop;
        var eBottom = eTop + element.clientHeight;
        // Check if out of view
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= cTop - eTop;
        } else if (eBottom > cBottom) {
          container.scrollTop += eBottom - cBottom;
        }
        __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default.a.set('scrollTopHeight', 0);
      }, 1000);
    }
  }
});

/***/ }),

/***/ "jP6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-content settings"},[_c('div',{staticClass:"wrap btn-position-wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usermanual-Tab",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.changePage('VIDEO')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                            Video\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usermanual-Tab",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.changePage('PDF')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                            Pdf\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"md-button md-raised md-theme-default Usermanual-Tab",class:{redActiveManual: _vm.redActiveManual},attrs:{"type":"button"},on:{"click":function($event){_vm.changePage('FAQ')}}},[_c('div',{class:{fontManualTab: _vm.fontManualTab}},[_vm._v("\n                            FAQ\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"users-settings-list"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.video)?_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.UserManualList,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of support file"},on:{"update":_vm.onUpdate,"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No files found.")]):_vm._l((_vm.UserManualList),function(usermanual){return _c('div',{key:usermanual.attachment_name,staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item"},[_c('div',{staticClass:"avatar s-48"},[_c('md-avatar',{staticClass:"md-avatar-icon"},[(usermanual.type === 1)?_c('div',[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]):_vm._e(),_vm._v(" "),(usermanual.type === 0)?_c('div',[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])]):_vm._e(),_vm._v(" "),(usermanual.type === 2)?_c('div',[_c('img',{staticClass:"pencilSelectedfaq",attrs:{"src":"static/img/Help_Icon-gr.png"}})]):_vm._e()])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(usermanual.attachment_name.substring(0, 35))+" "),_c('small')])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('a',{staticClass:"email-link"},[_vm._v(_vm._s(usermanual.path.substring(0, 75)))])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(_vm.isAdmin)?_c('div',[_c('div',{staticClass:"el admin-check"}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Edit Link"},on:{"click":function($event){_vm.showCurrentUserManual(usermanual)}}},[_c('md-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete"},on:{"click":function($event){_vm.confirmDelete(usermanual)}}},[_c('md-icon',[_vm._v("delete")])],1)],1):_vm._e()])])])})],2)],1):(_vm.faq)?_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.UserManualListfaq,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of support file"},on:{"update":_vm.onUpdate,"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},[(_vm.getUserManualListfaq.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No files found.")]):_vm._l((_vm.getUserManualListfaq),function(usermanual,index){return _c('div',{key:index,staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item question"},[_c('div',{staticClass:"avatar avatar2 s-48"},[_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":"static/img/Help_Icon-gr.png"}})])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(usermanual.question)+" "),_c('small')])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('h3',[_vm._v(_vm._s(usermanual.answers)+" "),_c('small')])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(_vm.isAdmin)?_c('div',[_c('div',{staticClass:"el admin-check"}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Edit Link"},on:{"click":function($event){_vm.showCurrentUserManualfaq(usermanual)}}},[_c('md-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete"},on:{"click":function($event){_vm.confirmDeletefaq(usermanual)}}},[_c('md-icon',[_vm._v("delete")])],1)],1):_vm._e()])])])})],2)],1):_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.UserManualList,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of support file"},on:{"update":_vm.onUpdate,"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},[(_vm.UserManualList.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No files found.")]):_vm._l((_vm.UserManualList),function(usermanual){return _c('div',{key:usermanual.attachment_name,staticClass:"item-wrap"},[_c('div',{staticClass:"line-item hovered-line list-group-item btn-visible"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el user-item"},[_c('div',{staticClass:"avatar s-48"},[_c('md-avatar',{staticClass:"md-avatar-icon"},[(usermanual.type)?_c('div',[_c('i',{staticClass:"md-icon"},[_vm._v("picture_as_pdf")])]):_c('div',[_c('i',{staticClass:"md-icon"},[_vm._v("videocam")])])])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(usermanual.attachment_name.substring(0, 35))+" "),_c('small')])]),_vm._v(" "),_c('div',{staticClass:"el email-item"},[_c('a',{staticClass:"email-link"},[_vm._v(_vm._s(usermanual.path.substring(0, 75)))])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(_vm.isAdmin)?_c('div',[_c('div',{staticClass:"el admin-check"}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Edit Link"},on:{"click":function($event){_vm.showCurrentUserManual(usermanual)}}},[_c('md-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Delete"},on:{"click":function($event){_vm.confirmDelete(usermanual)}}},[_c('md-icon',[_vm._v("delete")])],1)],1):_vm._e()])])])})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"bottom-btn-position"},[(_vm.showVideoPdf && !_vm.showfaq)?_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":function($event){_vm.clickAddNewManual()}}},[_c('md-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.showVideoPdf && _vm.showfaq)?_c('div',{staticClass:"wrap"},[_c('md-button',{staticClass:"add-tour-button md-fab md-accent md-primary",on:{"click":function($event){_vm.clickAddNewManualtext()}}},[_c('md-icon',[_vm._v("add")])],1)],1):_vm._e()])])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete "),_c('b',[_vm._v(_vm._s(_vm.userManualDelete.attachment_name))]),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.remove(_vm.userManualDelete.id)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogfaq},on:{"update:mdActive":function($event){_vm.showDeleteDialogfaq=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete "),_c('b',[_vm._v(_vm._s(_vm.userManualDeletefaq.question))]),_vm._v("? This action cannot be undone and also delete Answer.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.removes(_vm.userManualDeletefaq.id)}}},[_vm._v("Delete")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialogtext()}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('md-dialog',{staticStyle:{"height":"70%"},attrs:{"md-click-outside-to-close":false,"md-active":_vm.showEditDialog,"width":"70%"},on:{"update:mdActive":function($event){_vm.showEditDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Update Support\n        ")]),_vm._v(" "),(_vm.responseProcess)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"green"}},[_vm._v(_vm._s(this.responseProcess))]):_vm._e(),_vm._v(" "),(_vm.errors)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"red"}},[_vm._v(_vm._s(this.errors))]):_vm._e(),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attachmentname),expression:"attachmentname"}],staticClass:"md-input",attrs:{"type":"text","placeholder":"File Name"},domProps:{"value":(_vm.attachmentname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.attachmentname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{ref:"files",staticClass:"remove-no-file-chosen",attrs:{"type":"file","id":"files"},on:{"change":function($event){_vm.handleFiles()}}}),_vm._v(" "),_c('span',{staticClass:"showSelectedFile"},[_vm._v(_vm._s(this.shownamefile))])]),_vm._v(" "),_c('p',{staticClass:"info-manual"},[_c('b',[_vm._v("Note:")]),_vm._v(" Please select file with extension mp4, ogv, webm and pdf")])]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn",staticStyle:{"background-color":"#00a8ca !important"},on:{"click":function($event){_vm.updateUsermnual(_vm.userManualEdit.id)}}},[_vm._v("Update")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn",staticStyle:{"color":"black !important","background-color":"white !important","border-color":"#ccc !important"},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('md-dialog',{staticStyle:{"height":"75%","overflow":"auto"},attrs:{"md-click-outside-to-close":false,"md-active":_vm.showEditDialogfaq,"width":"70%"},on:{"update:mdActive":function($event){_vm.showEditDialogfaq=$event}}},[_c('md-dialog-title',[_vm._v("\n            Update Support\n        ")]),_vm._v(" "),(_vm.errors)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"red"}},[_vm._v(_vm._s(this.errors))]):_vm._e(),_vm._v(" "),(_vm.responseProcess)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"green"}},[_vm._v(_vm._s(this.responseProcess))]):_vm._e(),_vm._v(" "),_c('md-dialog-content',[_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.question),expression:"question"}],staticClass:"md-textarea",attrs:{"maxlength":"250","placeholder":"Enter Question","cols":"300","rows":"10"},domProps:{"value":(_vm.question)},on:{"input":function($event){if($event.target.composing){ return; }_vm.question=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.answers),expression:"answers"}],staticClass:"md-textareaa",attrs:{"maxlength":"400","placeholder":"Enter Answer","id":"question","cols":"30","rows":"10"},domProps:{"value":(_vm.answers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.answers=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("Note:")]),_vm._v(" These are text only fields")])]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn",staticStyle:{"background-color":"#00a8ca !important"},on:{"click":function($event){_vm.updateUsermnualfaq(_vm.userManualEditfaq.id)}}},[_vm._v("Update")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn",staticStyle:{"color":"black !important","background-color":"white !important","border-color":"#ccc !important"},on:{"click":function($event){_vm.closeDialogtext()}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),(_vm.showVideoPdf && !_vm.showfaq)?_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showAddDialog},on:{"update:mdActive":function($event){_vm.showAddDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Add Support\n        ")]),_vm._v(" "),(_vm.errors)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"red"}},[_vm._v(_vm._s(this.errors))]):_vm._e(),_vm._v(" "),(_vm.responseProcess)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"green"}},[_vm._v(_vm._s(this.responseProcess))]):_vm._e(),_vm._v(" "),_c('md-dialog-content',{staticStyle:{"height":"200%"}},[_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attachmentname),expression:"attachmentname"}],staticClass:"md-input",attrs:{"type":"text","placeholder":"File Name"},domProps:{"value":(_vm.attachmentname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.attachmentname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{ref:"files",staticClass:"remove-no-file-chosen",attrs:{"type":"file","id":"files"},on:{"change":function($event){_vm.handleFiles()}}}),_vm._v(" "),_c('span',{staticClass:"showSelectedFile"},[_vm._v(_vm._s(this.shownamefile))])]),_vm._v(" "),_c('p',{staticClass:"info-manual"},[_c('b',[_vm._v("Note:")]),_vm._v(" Please select file with extension mp4, ogv, webm and pdf")])]),_vm._v(" "),(_vm.showVideoPdf && !_vm.showfaq)?_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn",staticStyle:{"background-color":"#00a8ca !important"},on:{"click":function($event){_vm.saveUsermnual()}}},[_vm._v("Save")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn",staticStyle:{"color":"black !important","background-color":"white !important","border-color":"#ccc !important"},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancel")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showVideoPdf && !_vm.showfaq)?_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showAddDialog},on:{"update:mdActive":function($event){_vm.showAddDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Add Support\n        ")]),_vm._v(" "),(_vm.errors)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"red"}},[_vm._v(_vm._s(this.errors))]):_vm._e(),_vm._v(" "),(_vm.responseProcess)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"green"}},[_vm._v(_vm._s(this.responseProcess))]):_vm._e(),_vm._v(" "),_c('md-dialog-content',{staticStyle:{"height":"200%"}},[_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.attachmentname),expression:"attachmentname"}],staticClass:"md-input",attrs:{"type":"text","placeholder":"File Name"},domProps:{"value":(_vm.attachmentname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.attachmentname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"md-field md-block md-theme-default md-has-placeholder"},[_c('input',{ref:"files",staticClass:"remove-no-file-chosen",attrs:{"type":"file","id":"files"},on:{"change":function($event){_vm.handleFiles()}}}),_vm._v(" "),_c('span',{staticClass:"showSelectedFile"},[_vm._v(_vm._s(this.shownamefile))])]),_vm._v(" "),_c('p',{staticClass:"info-manual"},[_c('b',[_vm._v("Note:")]),_vm._v(" Please select file with extension mp4, ogv, webm and pdf")])]),_vm._v(" "),(_vm.showVideoPdf && !_vm.showfaq)?_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn",staticStyle:{"background-color":"#00a8ca !important"},on:{"click":function($event){_vm.saveUsermnual()}}},[_vm._v("Save")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn",staticStyle:{"color":"black !important","background-color":"white !important","border-color":"#ccc !important"},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancel")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showfaq && !_vm.showVideoPdf)?_c('md-dialog',{staticStyle:{"height":"75%"},attrs:{"md-click-outside-to-close":false,"md-active":_vm.showAddDialogtext,"width":"70%"},on:{"update:mdActive":function($event){_vm.showAddDialogtext=$event}}},[_c('md-dialog-title',[_vm._v("\n            Add Support\n        ")]),_vm._v(" "),(_vm.errors)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"red"}},[_vm._v(_vm._s(this.errors))]):_vm._e(),_vm._v(" "),(_vm.responseProcess)?_c('p',{staticStyle:{"padding":"24px 24px 0","color":"green"}},[_vm._v(_vm._s(this.responseProcess))]):_vm._e(),_vm._v(" "),_c('md-dialog-content',[_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.question),expression:"question"}],staticClass:"md-textarea",attrs:{"maxlength":"250","placeholder":"Enter Question","cols":"300","rows":"10","required":""},domProps:{"value":(_vm.question)},on:{"input":function($event){if($event.target.composing){ return; }_vm.question=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.answers),expression:"answers"}],staticClass:"md-textareaa",attrs:{"maxlength":"400","placeholder":"Enter Answer","id":"question","cols":"30","rows":"10","required":""},domProps:{"value":(_vm.answers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.answers=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"-220px"}},[_c('b',[_vm._v("Note:")]),_vm._v(" These are text only fields")])]),_vm._v(" "),(_vm.showfaq && !_vm.showVideoPdf)?_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn",staticStyle:{"background-color":"#00a8ca !important","margin-top":"-10px"},on:{"click":function($event){_vm.saveUsermnualtext()}}},[_vm._v("Save")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn",staticStyle:{"margin-top":"-10px","color":"black !important","background-color":"white !important","border-color":"#ccc !important"},on:{"click":function($event){_vm.closeDialogtext()}}},[_vm._v("Cancel")])],1):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jV2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"scroll-list"},[_c('div',{staticClass:"triggers-list",attrs:{"id":"NotesZone"}},[_c('div',{staticClass:"list-item heightAuto listing-height1"},[_c('button',{staticClass:"md-button md-theme-default",attrs:{"type":"button"},on:{"click":function($event){_vm.add()}}},[_vm._m(0,false,false)])]),_vm._v(" "),_c('div',{attrs:{"id":"add-Note"}},_vm._l((_vm.noteList),function(note,index){return _c('div',{key:index,staticClass:"md-button-content"},[_c('div',{staticClass:"line-item title-line paddingClass"},[_c('div',{staticClass:"left-item widthClass"},[(!_vm.editTableIndex.includes(index) && _vm.saveFlag)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(note.Description),expression:"note.Description"}],staticClass:"textAreaClass",attrs:{"id":"notes_description","placeholder":"Type note here ...."},domProps:{"value":(note.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(note, "Description", $event.target.value)}}}):(!_vm.notesIndexList.includes(index))?_c('p',[_c('span',{staticClass:"note_description"},[_vm._v(_vm._s(note.Description.substring(0, 60))+"\n                                    "),(note.Description.length>=60)?_c('span',[_vm._v("...")]):_vm._e()]),_vm._v(" "),(note.Description.length>=60)?_c('span',{on:{"click":function($event){_vm.showComplete(note,index)}}},[_vm._m(1,true,false)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notesdate"},[_vm._v(_vm._s(note.date))])]):(_vm.notesIndexList.includes(index))?_c('p',[_c('span',{staticClass:"note_description"},[_vm._v(_vm._s(note.Description.substring(0, 1100)))]),_vm._v(" "),(note.Description.length>=60)?_c('span',{on:{"click":function($event){_vm.showComplete(note,index)}}},[_vm._m(2,true,false)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notesdate"},[_vm._v(_vm._s(note.date))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item rightWidth"},[(_vm.editTableIndex.includes(index))?_c('i',{staticClass:"md-icon md-icon-font md-theme-default action",on:{"click":function($event){_vm.edit(index, note.id)}}},[_vm._v("mode_edit")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.editTableIndex.includes(index))?_c('i',{staticClass:"md-icon md-icon-font md-theme-default action",on:{"click":function($event){_vm.confirmRemove(note, index)}}},[_vm._v("delete")]):_vm._e()])])])}))]),_vm._v(" "),_c('div',{attrs:{"id":"SaveNotes"}},[(_vm.saveFlag)?_c('div',{staticClass:"btnClass"},[_c('button',{staticClass:"md-button md-primary md-raised btn-danger md-theme-default",on:{"click":function($event){_vm.refreshScreen()}}},[_vm._m(3,false,false)]),_vm._v(" "),_c('button',{staticClass:"md-button md-primary md-raised md-theme-default",attrs:{"type":"submit"},on:{"click":function($event){_vm.saveNotes()}}},[_vm._m(4,false,false)])]):_vm._e()])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog,"id":"NotesZoneModel"},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this note?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.remove(_vm.note, _vm.index)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_c('div',{staticClass:"line-item title-line"},[_c('div',{staticClass:"right-item"},[_c('i',{staticClass:"icon icon-add action"}),_vm._v("Add Note\n                                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"show_less"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Show more")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"show_less"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Show less")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Cancel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-ripple"},[_c('span',{staticClass:"md-button-content"},[_vm._v("Save")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jYpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTours; });
/* unused harmony export getTopics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteTours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return copyTourToNewTours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeToursImagesServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deteleQueueJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reStartQueueJobApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getTours(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + clientId + '/tours/');
}

function getTopics(tourId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/tour/' + tourId + '/topics');
}

// function getAllexportData () {
//   return axios.get('api/client/getAllexportData');
// }

function copyTourToNewTours(tourId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/copyTourToNewTours/' + tourId);
}

function changeToursImagesServices(data, toursId) {
  var formData = new FormData();
  formData.append('image', data);
  formData.append('toursId', toursId);
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/changeToursImagesServices/' + toursId, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

function deleteTours(clientId, tourIds) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/client/' + clientId + '/tours/delete', {
    params: {
      tourIds: tourIds
    }
  });
}

function deteleQueueJob(exportId) {
  console.log('DeteleQueueJob(): exportId = ');
  console.log(exportId);
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/client/deteleQueueJob', {
    params: {
      exportId: exportId
    }
  });
}

function reStartQueueJobApi(jobID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/reStartQueueJob', {
    params: {
      jobID: jobID
    }
  });
}



/***/ }),

/***/ "k13r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__("IC97");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      format: 'MM-dd-yyyy',
      r_no: '',
      r_date: '',
      v_no: '',
      newUsers: [{
        functionalityName: null,
        functionalityDesc: null,
        functionalityDescVer: null
      }],
      formError: null,
      showDialog: false
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientActive', 'clientList', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['userList', 'isAdmin', 'currentUser']), {
    hasMultipleUsers: function hasMultipleUsers() {
      return this.newUsers.length > 1;
    }
  }),
  methods: {
    userTouchHanlder: function userTouchHanlder(index, key) {
      if (!this.$v.newUsers.$each[index][key].$dirty) {
        this.$v.newUsers.$each[index][key].$touch();
      }
    },
    cancelAddRelease: function cancelAddRelease() {
      this.$router.push('/settings/release');
    },
    loadReleasefunctiondetail: function loadReleasefunctiondetail(rid) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = '';
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ReleaseService_js__["getReleaseDetail"])(rid);

              case 3:
                result = _context.sent;

                _this.releaseDetail = result.data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addUser: function addUser() {
      var newUser = {
        r_no: null,
        r_date: null,
        v_no: null,
        u_id: null,
        functionalityName: null,
        functionalityDesc: null,
        functionalityDescVer: null
      };
      if (this.clientActive) {
        newUser.clientId = this.currentClient.id;
      } else {
        newUser.clientId = null;
      }
      newUser.clientId = [];
      this.newUsers.push(newUser);
    },
    deleteUser: function deleteUser(index) {
      if (this.newUsers[index].isPrimaryContact) {
        if (index === 0) {
          this.newUsers[1].isPrimaryContact = true;
        } else {
          this.newUsers[0].isPrimaryContact = true;
        }
      }

      this.newUsers.splice(index, 1);
    },
    clickSaveNewRelease: function clickSaveNewRelease() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var date, dateforrequest;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showDialog = true;

                if (!(_this2.r_no === '')) {
                  _context2.next = 6;
                  break;
                }

                _this2.formError = 'Please enter build number.';
                _this2.showDialog = false;
                _context2.next = 29;
                break;

              case 6:
                if (!(_this2.r_date === '')) {
                  _context2.next = 11;
                  break;
                }

                _this2.formError = 'Please enter build date.';
                _this2.showDialog = false;
                _context2.next = 29;
                break;

              case 11:
                if (!(_this2.v_no === '')) {
                  _context2.next = 16;
                  break;
                }

                _this2.formError = 'Please enter version number.';
                _this2.showDialog = false;
                _context2.next = 29;
                break;

              case 16:
                if (!(_this2.newUsers[0].functionalityDesc === '' || _this2.newUsers[0].functionalityDesc === null || _this2.newUsers[0].functionalityName === null)) {
                  _context2.next = 21;
                  break;
                }

                _this2.formError = 'Please enter build notes.';
                _this2.showDialog = false;
                _context2.next = 29;
                break;

              case 21:
                date = new Date(_this2.r_date);
                dateforrequest = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

                _this2.newUsers[0].r_no = _this2.r_no;
                _this2.newUsers[0].r_date = dateforrequest;
                _this2.newUsers[0].v_no = _this2.v_no;
                _this2.newUsers[0].u_id = _this2.currentUser.id;
                _context2.next = 29;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_ReleaseService_js__["saveNewRelease"])(_this2.newUsers).then(function (response) {
                  _this2.$router.push('/settings/release');
                  _this2.showDialog = false;
                }).catch(function (error) {
                  if (error.response.data.type !== '') {
                    _this2.formError = error.response.data.message;
                  }
                  _this2.showDialog = false;
                });

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  validations: {
    newUsers: {
      $each: {
        functionalityName: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
        },
        functionalityDesc: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
        },
        clientId: {
          required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.clientActive) {
      this.newUsers[0].clientId = this.currentUser.id;
    }
    this.loadReleasefunctiondetail(this.releaseToEdit.id);
  }
});

/***/ }),

/***/ "kOA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLanguageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTourLanguageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return newLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return newTourLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeTourLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeTourLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateTourLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return delLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLanguageListWithRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkRouteHasLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getLanguageList() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/languages');
}

function getLanguageListWithRoute(tourId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/getLanguageListWithRoute/' + tourId);
}

function checkRouteHasLanguage(routeID) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/checkRouteHasLanguage/currentRouteId/' + routeID);
}

function delLanguage(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/del-language/' + id);
}

function getTourLanguageList(tourId) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/client/' + currentClientId + '/languages/' + tourId);
}

function newLanguage(newLanguage) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/languages', {
    code: newLanguage.code,
    language: newLanguage.language
  });
}

function newTourLanguage(data) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/languages/tours', {
    tourId: data.tourId,
    languageIds: data.addLanguages,
    order: data.languageOrder
  });
}

function removeTourLanguage(data) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/languages/tours/remove', {
    tourId: data.tourId,
    languageId: data.languageId
  });
}

function removeTourLanguages(data) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/languages/tours/removes', {
    tourId: data.tourId,
    languageId: data.languageId
  });
}

function updateTourLanguages(data) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/languages/tours/update', {
    tourId: data.tourId,
    languageOrder: data.languageOrder
  });
}



/***/ }),

/***/ "kPd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"triggerZone"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"scroll-list",staticStyle:{"{'height'":"topicsListHeight+104 + 'px'}"}},[_c('div',{staticClass:"triggers-list"},[_c('draggable',{staticClass:"list-group",attrs:{"triggersList":_vm.triggersList,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove},on:{"update":_vm.onUpdate,"start":function($event){_vm.dragging = true}},model:{value:(_vm.sortedLanguages),callback:function ($$v) {_vm.sortedLanguages=$$v},expression:"sortedLanguages"}},_vm._l((_vm.triggersList),function(trigger,index){return (trigger.toiId === _vm.currentTopic.id)?_c('div',{staticClass:"list-item",staticStyle:{"margin-bottom":"5%"},on:{"mouseover":function($event){_vm.hoverOn(index,trigger.name)},"mouseleave":function($event){_vm.hoverOff(index)}}},[_c('md-button',{on:{"click":function($event){_vm.navToTriggerSettings(trigger)}}},[_c('div',{staticClass:"line-item title-line"},[_c('div',{staticClass:"left-item"},[_c('span',[(trigger.activeInactiveImages === 1)?_c('span',[_c('img',{staticClass:"completeImages",attrs:{"src":"static/img/complete.png"}})]):_c('span',[_c('img',{staticClass:"inCompleteImages",staticStyle:{"width":"13px"},attrs:{"src":"static/img/inComplete.png"}})]),_vm._v("\n                                    "+_vm._s(trigger.name)+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el lock-el",attrs:{"ng-show":"item.lock"}},[_c('i',{staticClass:"icon icon-lock_outline",staticStyle:{"margin-left":"20px","float":"right"}})]),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-menu',[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',{attrs:{"title":"Options"}},[_vm._v("more_vert")])],1),_vm._v(" "),(trigger.on_off == 1)?_c('md-menu-content',{attrs:{"width":"3"}},[_c('md-menu-item',[_c('md-button',{on:{"click":function($event){_vm.loadStoryFiles(trigger.storyName,trigger.storyNameCopy,trigger.routeId, trigger.id, trigger.toiId)}}},[_vm._v("Show Story Files")])],1),_vm._v(" "),_c('md-menu-item',[_c('md-button',{on:{"click":function($event){_vm.copyTriggerZone(trigger.id)}}},[_vm._v("Duplicate TriggerZone")])],1),_vm._v(" "),_c('md-menu-item',[(!_vm.showChilddData.includes(index))?_c('md-button',{on:{"click":function($event){_vm.MoreInfoFunction(trigger.id , index)}}},[_vm._v("Add More Info")]):_vm._e(),_vm._v(" "),(_vm.showChilddData.includes(index))?_c('md-button',{on:{"click":function($event){_vm.confirmDeleteMore(trigger.id , index)}}},[_vm._v("Remove More Info")]):_vm._e()],1),_vm._v(" "),_c('md-menu-item',[_c('md-button',{on:{"click":function($event){_vm.confirmDelete(trigger.id, index)}}},[_vm._v("Delete")])],1)],1):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{staticClass:"right-item"},[(trigger.on_off == 0)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("OFF")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"left-item"},[(_vm.stories.length > 0  && trigger.file_name !== '' && trigger.file_type==0)?_c('span',{staticClass:"show-lengthTrigger"},[_c('small',[_vm._v(" "+_vm._s(trigger.file_length)+" ")]),_vm._v(" "),_c('small',[_c('img',{staticClass:"videoPLayIcon",attrs:{"src":"static/img/playicon.png"},on:{"click":function($event){trigger.on_off == 0 ? '': _vm.playVideMp3(trigger.file_name , trigger.file_type)}}})])]):_vm._e(),_vm._v(" "),(_vm.stories.length > 0  && trigger.file_name == '')?_c('span',{staticClass:"show-lengthTrigger"}):_vm._e()]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.navToTriggerSettings(trigger)}}},[_c('div',{staticClass:"line-item title-line"},[_c('div',{staticClass:"right-item"},[(_vm.triggernotesids.includes(trigger.id))?_c('span',{staticStyle:{"margin-right":"31px"}},[_c('img',{staticClass:"icon-note",attrs:{"src":'/static/img/note_icon.jpg'},on:{"click":function($event){_vm.goChangeNote(trigger)}}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"select-wrap"},[_c('md-field',[(_vm.stories.length > 0 )?_c('md-select',{attrs:{"disabled":trigger.on_off == 0,"placeholder":"Select a story...","change":_vm.assignStoryToTrigger(trigger,trigger.routeId)},model:{value:(trigger.storyName),callback:function ($$v) {_vm.$set(trigger, "storyName", $$v)},expression:"trigger.storyName"}},_vm._l((_vm.stories),function(story,index){return _c('md-option',{key:story.friendly_name,attrs:{"value":story.friendly_name}},[_vm._v(_vm._s(story.friendly_name)+"\n                                    "),(story.isVideo === 1)?_c('md-icon',{staticClass:"list-icon",domProps:{"innerHTML":_vm._s(_vm.rawIcon)}}):_vm._e()],1)})):_c('div',[_vm._v("No stories available.")])],1),_vm._v(" "),(trigger.file_name_video)?_c('div',{on:{"click":function($event){_vm.playVideMp3(trigger.file_name_video , trigger.file_type_video)}}},[_c('md-icon',{staticClass:"vid-icon",attrs:{"title":"This story has video"}},[_vm._v("videocam")])],1):_vm._e()],1),_vm._v(" "),(_vm.showChilddData.includes(index))?_c('div',{staticClass:"select-wrap"},[_c('md-field',[(_vm.stories.length > 0)?_c('md-select',{attrs:{"disabled":trigger.on_off == 0,"placeholder":"Select a story...","change":_vm.assignStoryToTriggerCopy(trigger,1,trigger.routeId)},model:{value:(trigger.storyNameCopy),callback:function ($$v) {_vm.$set(trigger, "storyNameCopy", $$v)},expression:"trigger.storyNameCopy"}},_vm._l((_vm.stories),function(story,index){return (story.isVideo !== 1)?_c('md-option',{key:story.friendly_name,attrs:{"value":story.friendly_name}},[_vm._v("\n                                    "+_vm._s(story.friendly_name)+"\n                                    "),(story.isVideo === 1)?_c('md-icon',{staticClass:"list-icon",domProps:{"innerHTML":_vm._s(_vm.rawIcon)}}):_vm._e()],1):_vm._e()})):_c('div',[_vm._v("No stories available.")])],1),_vm._v(" "),(_vm.triggerHasVideo(trigger.storyNameCopy))?_c('div',[_c('md-icon',{staticClass:"vid-icon",attrs:{"title":"This story has video"}},[_vm._v("videocam")])],1):_vm._e(),_vm._v(" "),_c('img',{staticClass:"more_info_icon",attrs:{"src":'/static/img/More_info_Icon.png'}})],1):_vm._e()],1):_vm._e()}))],1)]),_vm._v(" "),_c('footer',{staticClass:"aside-btn"},[_c('div',{staticClass:"btn-wrap new-trigger-zone"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.createTriggerZone}},[_vm._v("New Trigger Zone")])],1)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogChannel},on:{"update:mdActive":function($event){_vm.showDeleteDialogChannel=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Please choose at least one channel before creating TriggerZone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialogChannel = false}}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete this trigger?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.clickDeleteTrigger(_vm.triggerIdDelete, _vm.indexDataDelete)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMore},on:{"update:mdActive":function($event){_vm.showDeleteDialogMore=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to remove more info?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.removeMoreInfoFunction(_vm.triggerIdDelete, _vm.indexDataDelete)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialogMore = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('modal',{staticClass:"full-size-video",attrs:{"name":"video-file-play","resizable":"true"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"audio-file-play","resizable":"true"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('audio-player',{staticClass:"audioFile",attrs:{"file":_vm.file1}})],1)])])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"resizable":"true","md-active":_vm.showModalForTrgPass},on:{"update:mdActive":function($event){_vm.showModalForTrgPass=$event}}},[_c('md-dialog-title',[_vm._v("\n            Create Password For ("+_vm._s(_vm.triggerZonePassName)+")\n        ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input',{attrs:{"name":"first-name","type":"password","id":"first-name","autocomplete":"given-name"},model:{value:(_vm.triggerZonePassword),callback:function ($$v) {_vm.triggerZonePassword=$$v},expression:"triggerZonePassword"}})],1),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.insertPassForTrigger(_vm.triggerZonePassId, _vm.triggerZonePassName)}}},[_vm._v("submit")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showModalForTrgPass = false}}},[_vm._v("Cancel")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kTEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    center: { lat: null, lng: null },
    pencilIconSelected: false,
    pencilIconSelectedAlt: false,
    bounds: {},
    boundsalt: {}
  },
  getters: {
    pencilIconSelected: function pencilIconSelected(state) {
      return state.pencilIconSelected;
    },
    pencilIconSelectedAlt: function pencilIconSelectedAlt(state) {
      return state.pencilIconSelectedAlt;
    },
    bounds: function bounds(state) {
      return state.bounds;
    },
    boundsalt: function boundsalt(state) {
      return state.boundsalt;
    },
    center: function center(state) {
      return state.center;
    }
  },
  mutations: {
    setCenter: function setCenter(state, center) {
      if (typeof center.latLng === 'string') {
        state.center = JSON.parse(center.latLng);
      } else {
        state.center.lat = center.latLng.lat;
        state.center.lng = center.latLng.lng;
      }
    },
    setPencilIconSelected: function setPencilIconSelected(state, toggle) {
      state.pencilIconSelected = toggle;
    },
    setPencilIconSelectedAlt: function setPencilIconSelectedAlt(state, toggle) {
      state.pencilIconSelectedAlt = toggle;
    },
    setBounds: function setBounds(state, bounds) {
      state.bounds = bounds;
    },
    setBoundsAlt: function setBoundsAlt(state, boundsalt) {
      state.boundsAlt = boundsalt;
    }
  },
  actions: {
    setCenter: function setCenter(_ref, center) {
      var commit = _ref.commit;

      commit('setCenter', center);
    },
    togglePencilIconSelected: function togglePencilIconSelected(_ref2, toggle) {
      var commit = _ref2.commit;

      commit('setPencilIconSelected', toggle);
    },
    togglePencilIconSelectedAlt: function togglePencilIconSelectedAlt(_ref3, toggle) {
      var commit = _ref3.commit;

      commit('setPencilIconSelectedAlt', toggle);
    },
    setBounds: function setBounds(_ref4, bounds) {
      var commit = _ref4.commit;

      commit('setBounds', bounds);
    },
    setBoundsAlt: function setBoundsAlt(_ref5, boundsalt) {
      var commit = _ref5.commit;

      commit('setBoundsAlt', boundsalt);
    }
  }
});

/***/ }),

/***/ "kir7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lhSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      returnPath: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['userToEdit', 'currentUser'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['clearUserToEdit']), {
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    exitEditUser: function exitEditUser() {
      this.clearUserToEdit();
      this.$router.push(this.returnPath);
    }
  }),
  mounted: function mounted() {
    this.returnPath = this.$store.state.RouterModule.from.fullPath;
  }
});

/***/ }),

/***/ "m07b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"newTourFigure"},[_c('div',{staticClass:"gradient-box"}),_vm._v(" "),_c('label',{attrs:{"for":"files"}},[_c('input',{ref:"files",staticClass:"file-input",attrs:{"accept":"image/*","type":"file","id":"files"},on:{"change":function($event){_vm.handleFiles()}}}),_vm._v(" "),_c('div',{staticClass:"upload-icon visible-upload-icon"},[_c('span',{staticClass:"md-button md-theme-default"},[_c('md-icon',{staticClass:"photo-icon"},[_vm._v("photo_size_select_actual")]),_vm._v(" "),(!_vm.fileflag)?_c('p',{staticClass:"upload-text"},[_vm._v("Click to upload a tour image")]):_c('p',{staticClass:"upload-text"},[_c('img',{staticStyle:{"position":"absolute","top":"8px","/* margin-left":"-16px","*/\n                    left":"3px","right":"-2px","margin-right":"-4px"},attrs:{"id":"blah","src":_vm.preViewImage,"alt":"your image"}})])],1)])]),_vm._v(" "),_c('md-button',{staticClass:"close-new-tour md-icon-button",attrs:{"aria-label":"Back"},on:{"click":_vm.returnToPrevious}},[_c('md-icon',[_vm._v("close")])],1),_vm._v(" "),_c('img',{staticClass:"newTourlogo",attrs:{"src":_vm.getImageSrc('logo.png')}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m7Pd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportsTab_vue__ = __webpack_require__("3fQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_173aa116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportsTab_vue__ = __webpack_require__("m9gg");
function injectStyle (ssrContext) {
  __webpack_require__("3Vl3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-173aa116"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_173aa116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m9gg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"exports-wrap"},[_vm._m(0,false,false),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n                Confirm Delete\n            ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n                Are you sure you want to delete ? This action cannot be undone.\n            ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.deleteSelectedExport(_vm.exportsId)}}},[_vm._v("Delete")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.closeDialogExport()}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showValidate},on:{"update:mdActive":function($event){_vm.showValidate=$event}}},[_c('md-dialog-title',[_vm._v("\n                Confirm Delete\n            ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n                Are you sure you want to Validate this tour ?\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"exports-wrap"},[(_vm.elementNotVisible)?_c('div',{staticStyle:{"float":"right","background-color":"#f8d7da !important","border-color":"#f5c6cb","position":"relative","padding":"5px 0px","margin-bottom":"10px","border":"2px solid transparent","border-radius":".25rem","height":"25px","font-size":"16px","color":"#721c24"}},[_vm._v(" "+_vm._s(_vm.errormessageContent))]):_vm._e(),_vm._v(" "),(_vm.elementVisible)?_c('div',{staticStyle:{"float":"right","background-color":"#d4edda !important","border-color":"#c3e6cb","position":"relative","padding":"5px 0px","margin-bottom":"10px","border":"2px solid transparent","border-radius":".25rem","height":"25px","font-size":"16px","color":"#155724"}},[_vm._v(" Your File is valid")]):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.exportListsWent)?_c('div',[_vm._m(1,false,false)]):_c('section',{staticClass:"page-content settings"},[_c('table',{attrs:{"id":"firstTable"}},[_vm._m(2,false,false),_vm._v(" "),_c('tbody',[_vm._l((_vm.exportLists),function(exports){return (!_vm.exportDataNotFound)?_c('tr',{key:exports.id},[_c('td',[_vm._v(_vm._s(exports.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.requested_time))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.fulfilled_time))]),_vm._v(" "),(_vm.downloadAvailable(exports))?_c('td',[_vm._v(_vm._s('appdata_client_' + exports.client_id + '_' + exports.id + '.tar.gz')+"    "),_c('a',{attrs:{"href":exports.file_url}},[_vm._v("Download")])]):_c('td',[_vm._v(_vm._s('appdata_client_' + exports.client_id + '_' + exports.id + '.tar.gz')+"   ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(exports.tour_name))]),_vm._v(" "),(exports.status == 1)?_c('td',[(exports.exportErrorCheck ==0)?_c('span',{staticStyle:{"color":"rgb(0, 168, 202) !important"}},[_vm._v("\n                                Tour File is Valid\n                            ")]):_c('span',[(exports.export_error === 'Tar File is Valid')?_c('span',{staticStyle:{"color":"rgb(0, 168, 202) !important"}},[_vm._v("\n                                    "+_vm._s(exports.export_error)+"\n                                ")]):_c('span',{staticStyle:{"color":"red"}},[_vm._v("\n                                    Incomplete Tour\n                                ")])])]):_c('td',[_vm._v("Currently processing.")]),_vm._v(" "),_c('td',[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.confirmDelete(exports.id)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)]):_vm._e()}),_vm._v(" "),(_vm.exportDataNotFound)?_c('tr',{staticClass:"greenRecord"},[_vm._v(" Record not found.....")]):_vm._e()],2)])])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-item toolbar"},[_c('div',{staticClass:"left-item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"id":"firstTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Export Id")]),_vm._v(" "),_c('th',[_vm._v("Requested Time")]),_vm._v(" "),_c('th',[_vm._v("Fulfilled Time")]),_vm._v(" "),_c('th',[_vm._v("Export Tarball")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('p',{staticClass:"somethingWent"},[_vm._v(" Something went wroung")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Export Id")]),_vm._v(" "),_c('th',[_vm._v("Requested Time")]),_vm._v(" "),_c('th',[_vm._v("Fulfilled Time")]),_vm._v(" "),_c('th',[_vm._v("Export Tarball")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Delete")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n8X+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nFFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-settings"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingmy ),expression:"isLoadingmy "}],staticStyle:{"background":"rgba(0,0,0,0.5)","position":"fixed","display":"flex","justify-content":"center","align-items":"center","z-index":"1000001","left":"0","top":"0","height":"100%","width":"100%"}},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]),_vm._v(" "),_c('div',{staticClass:"tour-settings-content"},[_c('md-button',{staticClass:"md-icon-button close-tour-settings",on:{"click":function($event){_vm.toggleShowSettings(false), _vm.toggleShowSettingsDummy()}}},[_c('md-icon',[_vm._v("clear")])],1),_vm._v(" "),_c('md-tabs',{staticClass:"centered-title",attrs:{"md-border-bottom":"","md-dynamic-height":""}},[_c('md-tab',{staticClass:"media-tab",attrs:{"md-label":"General"}},[_c('div',{staticClass:"wrap scroll-list"},[(_vm.recordUpdateSucc)?_c('p',{staticStyle:{"color":"green","position":"fixed","float":"right","right":"6%"}},[_vm._v("Record updated successfully!")]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('md-card-actions',[(_vm.TourSettingsChangedTets)?_c('md-button',{staticClass:"md-primary md-raised",staticStyle:{"color":"green","position":"fixed","float":"right","right":"6%","margin-top":"-30px"},attrs:{"type":"submit"},on:{"click":function($event){_vm.saveTour()}}},[_vm._v("save")]):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"md-layout md-gutter row"},[_c('div',{staticClass:"col-3"},[_c('h2',{staticClass:"section-title",staticStyle:{"font-size":"18px"}},[_vm._v("Default Trigger Setting")])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('md-field',{staticClass:"half-field"},[_c('label',{staticStyle:{"pointer-events":"auto","top":"0","opacity":"1","font-size":"12px"},attrs:{"for":"activate"}},[_vm._v("Activate")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tour.defaultActivate),expression:"tour.defaultActivate"}],staticStyle:{"width":"100%","border-color":"white"},attrs:{"name":"activate","id":"activate"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tour, "defaultActivate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.something($event,'activate')}]}},[_c('option',{attrs:{"value":"Enter"}},[_vm._v("Enter")]),_vm._v(" "),_c('option',{attrs:{"value":"Exit"}},[_vm._v("Exit")]),_vm._v(" "),_c('option',{attrs:{"value":"Proximity"}},[_vm._v("Proximity")])])]),_vm._v(" "),_c('md-field',{staticClass:"half-field"},[_c('label',{attrs:{"for":"radius"}},[_vm._v("Radius Distance")]),_vm._v(" "),_c('md-input',{staticStyle:{"margin-bottom":"-9px","width":"50%"},attrs:{"name":"radius","id":"radius"},nativeOn:{"keyup":function($event){_vm.something($event,'defaultRadiusDistance')}},model:{value:(_vm.tour.defaultRadiusDistance),callback:function ($$v) {_vm.$set(_vm.tour, "defaultRadiusDistance", $$v)},expression:"tour.defaultRadiusDistance"}}),_vm._v(" "),_c('div',{staticClass:"md-errors-spacer"})],1),_vm._v(" "),_c('md-field',{staticClass:"half-field"},[_c('label',{attrs:{"for":"tolerance"}},[_vm._v("Tolerance")]),_vm._v(" "),_c('md-input',{staticStyle:{"margin-bottom":"-9px"},attrs:{"name":"tolerance","id":"tolerance"},nativeOn:{"keyup":function($event){_vm.something($event,'defaultTolerance')}},model:{value:(_vm.tour.defaultTolerance),callback:function ($$v) {_vm.$set(_vm.tour, "defaultTolerance", $$v)},expression:"tour.defaultTolerance"}}),_vm._v(" "),_c('div',{staticClass:"md-errors-spacer"}),_vm._v(" "),_c('div',[(_vm.toleranceerror)?_c('p',{staticStyle:{"color":"red","font-size":"12px","position":"absolute","float":"right","right":"6%","margin-top":"35px"}},[_vm._v("Tolerance level must be between [30 and 360]")]):_vm._e()])],1),_vm._v(" "),_c('md-field',{staticClass:"half-field md-has-value"},[_c('label',{attrs:{"for":"delay"}},[_vm._v("Delay")]),_vm._v(" "),_c('md-input',{staticStyle:{"margin-bottom":"-9px"},attrs:{"name":"delay","id":"delay"},nativeOn:{"keyup":function($event){_vm.something($event,'defaultDelay')}},model:{value:(_vm.tour.defaultDelay),callback:function ($$v) {_vm.$set(_vm.tour, "defaultDelay", $$v)},expression:"tour.defaultDelay"}}),_vm._v(" "),_c('div',{staticClass:"md-errors-spacer"})],1)],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('section',{staticClass:"global-section",staticStyle:{"margin-top":"-15px"}},[_c('div',{staticClass:"md-layout md-gutter row"},[_c('div',{staticClass:"col-4"},[_c('h2',{staticClass:"section-title"},[_vm._v("Tour Time Zone")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('md-field',{staticClass:"wide"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tour.timezone_id),expression:"tour.timezone_id"}],staticStyle:{"width":"100%","border-color":"white"},attrs:{"name":"timezone","id":"timezone"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tour, "timezone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.something($event,'timezone')}]}},_vm._l((_vm.timezones),function(timezone){return _c('option',{key:timezone.timezone,domProps:{"value":timezone.id}},[_vm._v(_vm._s(timezone.timezone))])}))]),_vm._v(" "),_c('md-card-actions')],1)])]),_vm._v(" "),_c('section',{staticClass:"global-section"},[_c('div',{staticClass:"md-layout md-gutter row"},[_c('div',{staticClass:"col-4"},[_c('h2',{staticClass:"section-title"},[_vm._v("Channels ")])]),_vm._v(" "),_c('div',{staticClass:"col-8 align-col"},[_c('md-list',{staticClass:"draggable-list selectable"},[_c('draggable',{staticClass:"list-group",attrs:{"tourLanguages":_vm.tourLanguages,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.updateLanguages()}},model:{value:(_vm.sortedLanguages),callback:function ($$v) {_vm.sortedLanguages=$$v},expression:"sortedLanguages"}},_vm._l((_vm.tourLanguages),function(lang,itemObjKey){return _c('div',{key:lang.language,staticClass:"list-group-item"},[_c('span',{staticStyle:{"float":"left","position":"absolute","margin-left":"-6%","margin-top":"16px","font-size":"21px"}},[_vm._v("\n                                                "+_vm._s(itemObjKey + 1)+".\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"as-sortable-item"},[_c('div',{staticClass:"as-sortable-item-handle",attrs:{"role":"button"}},[_c('md-icon',[_vm._v("drag_handle")])],1),_vm._v(" "),_c('em',{staticStyle:{"margin-left":"100px"}},[_vm._v(_vm._s(lang.language))]),_vm._v(" "),_c('md-button',{staticClass:"delete-btn md-icon-button",staticStyle:{"margin-top":"0px"},on:{"click":function($event){_vm.confirmDelete(lang)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])}))],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-primary md-raised add-channel",on:{"click":function($event){_vm.addAllLangauge()}}},[_c('md-icon',[_vm._v("add")])],1)],1)]),_vm._v(" "),_c('md-dialog',{staticClass:"small-modal OverflowShowDialog",attrs:{"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Add Languages")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showDialog = false}}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('md-list',{staticClass:"scroll-listmy"},_vm._l((_vm.languages),function(lang){return _c('md-list-item',{key:lang.code},[_c('md-checkbox',{staticClass:"language-checkbox",attrs:{"value":lang.id,"disabled":_vm.disableLanguage(lang.id)},model:{value:(_vm.addLanguages),callback:function ($$v) {_vm.addLanguages=$$v},expression:"addLanguages"}},[_vm._v(_vm._s(lang.language))]),_vm._v(" "),(_vm.activeItem === lang.id)?_c('span',[_vm._v("You have exceed the maximum number of supported languages (60). Please reduce the number of languages selected to proceed")]):_vm._e()],1)})),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.addTourLanguages()}}},[_vm._v("ADD")])],1)],1)],1)],1)]),_vm._v(" "),_c('md-tab',{staticClass:"media-tab",attrs:{"md-label":"Media"}},[_c('div',{staticClass:"wrap scroll-list"},[_c('div',{staticClass:"inner-wrap"},[_c('section',{staticClass:"media-section ng-scope"},[_c('md-list',_vm._l((['Filler', 'Music', 'Notification', 'Safety']),function(type){return _c('md-list-item',{key:type,attrs:{"md-expand":""}},[_c('div',{staticClass:"line-item title-line hovered-line"},[_c('div',{staticClass:"left-item changeFontSize"},[_c('div',{staticClass:"el"},[_c('strong',{staticClass:"ng-binding "},[_vm._v(_vm._s(type))])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{},[_c('md-button',{staticClass:"md-icon-button md-fab md-primary top-index",attrs:{"title":"Add Media"},on:{"click":function($event){_vm.openMediaDialog(type)}}},[_c('md-icon',[_vm._v("add")])],1)],1)])]),_vm._v(" "),_c('md-list',{attrs:{"slot":"md-expand"},slot:"md-expand"},[(_vm.library.length == 0 || _vm.library[type.toLowerCase()].length == 0)?_c('li',{staticClass:"moveLeftContent"},[_vm._v("No item found")]):_vm._e(),_vm._v(" "),(type === 'Safety')?_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.convertObjToSafety,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of story file"},on:{"update":function($event){_vm.onUpdate('Safety')},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},_vm._l((_vm.library[type.toLowerCase()]),function(item,index){return _c('div',{staticClass:"line-item hovered-line"},[(index)?_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding moveLeftContent"},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{},[_c('md-button',{staticClass:"md-icon-button delete-btn md-button md-ink-ripple",attrs:{"title":"Remove Channel"},on:{"click":function($event){_vm.confirmDeleteMedia(type, index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])]):_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding"},[_vm._v("No content")])])])])}))],1):(type === 'Filler')?_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.convertObjToFiller,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of story file"},on:{"update":function($event){_vm.onUpdate('Filler')},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},_vm._l((_vm.library[type.toLowerCase()]),function(item,index){return _c('div',{staticClass:"line-item hovered-line"},[(index)?_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding moveLeftContent"},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{},[_c('md-button',{staticClass:"md-icon-button delete-btn md-button md-ink-ripple",attrs:{"title":"Remove Channel"},on:{"click":function($event){_vm.confirmDeleteMedia(type, index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])]):_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding"},[_vm._v("No content")])])])])}))],1):(type === 'Music')?_c('div',[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.convertObjToMusic,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of story file"},on:{"update":function($event){_vm.onUpdate('Music')},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},_vm._l((_vm.library[type.toLowerCase()]),function(item,index){return _c('div',{staticClass:"line-item hovered-line"},[(index)?_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding moveLeftContent"},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{},[_c('md-button',{staticClass:"md-icon-button delete-btn md-button md-ink-ripple",attrs:{"title":"Remove Channel"},on:{"click":function($event){_vm.confirmDeleteMedia(type, index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])]):_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding"},[_vm._v("No content")])])])])}))],1):_c('div',_vm._l((_vm.library[type.toLowerCase()]),function(item,index){return _c('div',{staticClass:"line-item hovered-line"},[(index)?_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding moveLeftContent"},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{},[_c('md-button',{staticClass:"md-icon-button delete-btn md-button md-ink-ripple",attrs:{"title":"Remove Channel"},on:{"click":function($event){_vm.confirmDeleteMedia(type, index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1)])]):_c('div',[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el ng-binding"},[_vm._v("No content")])])])])}))])],1)})),_vm._v(" "),_c('md-dialog',{staticClass:"small-modal",staticStyle:{"height":"350px","width":"448px"},attrs:{"md-active":_vm.showMediaDialog},on:{"update:mdActive":function($event){_vm.showMediaDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Add "+_vm._s(_vm.mediaDialogType)+" Files")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showMediaDialog = false}}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('md-list',{staticClass:"scroll-list",staticStyle:{"height":"100%"}},[_vm._l((_vm.assignableMedia),function(media){return _c('md-list-item',{key:media.friendly_name},[_c('md-checkbox',{key:media.friendly_name,attrs:{"value":media.friendly_name},model:{value:(_vm.addMedia),callback:function ($$v) {_vm.addMedia=$$v},expression:"addMedia"}},[_vm._v(_vm._s(media.friendly_name))])],1)}),_vm._v(" "),(_vm.assignableMedia.length === 0)?_c('md-list-item',[_vm._v("Add file for all channels")]):_vm._e(),_vm._v(" "),(_vm.assignableMedia.length < 0)?_c('md-list-item',[_vm._v("No files available in your Library.")]):_vm._e()],2),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.addMedia.length > 0),expression:"addMedia.length > 0"}],staticClass:"md-raised md-primary",on:{"click":function($event){_vm.addTourMedia(_vm.mediaDialogType)}}},[_vm._v("ADD")])],1)],1)],1)])])])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete "),_c('b',[_vm._v(_vm._s(_vm.langDelete.language))]),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btnDelete"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.removeLanguage(_vm.langDelete.id)}}},[_vm._v("Delete")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.checkRouteIsMappingTable},on:{"update:mdActive":function($event){_vm.checkRouteIsMappingTable=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Channels are associated with tour. Are you sure you want to delete "),_c('b',[_vm._v(_vm._s(_vm.langDelete.language))]),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.removeLanguageAfterConfirmation (_vm.langDelete.id)}}},[_vm._v("Delete")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":_vm.checkRouteIsMappingTableOk}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMedia},on:{"update:mdActive":function($event){_vm.showDeleteDialogMedia=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete this Media"),_c('b'),_vm._v("? This action cannot be undone.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btnDelete"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.removeTourMedia (_vm.categoryDelete, _vm.friendlyNameDelete)}}},[_vm._v("Delete")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancel")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nayk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "neHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogInHistory_vue__ = __webpack_require__("R3Xb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a3683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogInHistory_vue__ = __webpack_require__("7bTg");
function injectStyle (ssrContext) {
  __webpack_require__("n8X+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-407a3683"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogInHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a3683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogInHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oNan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "ojgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: ''
    };
  },
  methods: {
    returnToLogin: function returnToLogin() {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ "olkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicRouteTabs_vue__ = __webpack_require__("5ApK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f84873a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicRouteTabs_vue__ = __webpack_require__("CJXj");
function injectStyle (ssrContext) {
  __webpack_require__("+5wJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicRouteTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f84873a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicRouteTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pMA0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourEditor_vue__ = __webpack_require__("r/ej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f9fbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourEditor_vue__ = __webpack_require__("SVpx");
function injectStyle (ssrContext) {
  __webpack_require__("kir7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f9fbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("doCN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "psgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReleaseVersion_vue__ = __webpack_require__("iUWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291f4b64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReleaseVersion_vue__ = __webpack_require__("AU4n");
function injectStyle (ssrContext) {
  __webpack_require__("rGoQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-291f4b64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReleaseVersion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291f4b64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReleaseVersion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pu7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__ = __webpack_require__("4kyh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('routes', ['currentRoute']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('triggers', ['initialTrigger', 'currentTrigger', 'triggerEdited', 'headingEnabled'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('triggers', ['saveTriggerZone', 'loadRouteTriggers', 'clearStateTriggersList', 'toggleTriggerHovered']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['toggleShowTriggerTabs']), {
    returnToPrevious: function returnToPrevious() {
      this.$router.push('/tour/topic');
    }
  }),
  validations: {
    currentTrigger: {
      heading: {
        between: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(0, 360),
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */]
      },
      tolerance: {
        between: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(30, 360),
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */]
      },
      radiusDistance: {
        between: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(0, 45000),
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */]
      },
      delay: {
        numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      latLng: {
        lng: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */],
          validLatOrLng: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["b" /* validLatOrLng */],
          between: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(-180, 180)
        },
        lat: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
          notWhitespace: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["a" /* notWhitespace */],
          validLatOrLng: __WEBPACK_IMPORTED_MODULE_3__includes_validations_js__["b" /* validLatOrLng */],
          between: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(-90, 90)
        }
      }
    }
  }
});

/***/ }),

/***/ "q3O3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsTopic_vue__ = __webpack_require__("I8BZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303c827c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsTopic_vue__ = __webpack_require__("9/ht");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticsTopic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303c827c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticsTopic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4Gt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_UserService_js__ = __webpack_require__("+q4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__ = __webpack_require__("4kyh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      el: '#demo',
      name: 'MultipleSelect',
      formError: null,
      selectClient: [],
      admincheckBox: '',
      superadmincheckbox: '',
      adminEditedFields: false,
      showDeleteDialog: false,
      message: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientActive', 'clientList']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['currentUser', 'userToEdit', 'userEdited', 'isAdmin', 'isSuperAdmin'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateUserProfile', 'setUserToEdit']), {
    setUserAsAdmin: function setUserAsAdmin() {
      this.userToEdit['isAdmin'] = 0;
      if (this.superadmincheckbox === 'on') {
        this.admincheckBox = 'on';
        this.userToEdit['isAdmin'] = 1;
      }
    },
    touchHanlder: function touchHanlder(key) {
      if (!this.$v.userToEdit[key].$dirty) {
        this.$v.userToEdit[key].$touch();
      }
    },
    saveUserChangesForClient: function saveUserChangesForClient() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["updateUserForClient"])(_this.userToEdit).then(function (response) {
                  _this.updateUserProfile(_this.userToEdit);
                  _this.adminEditedFields = true;
                  setTimeout(function () {
                    _this.adminEditedFields = false;
                  }, 3000);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveUserChanges: function saveUserChanges() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.superadmincheckbox === 'on') {
                  _this2.userToEdit['isSuperAdmin'] = 1;
                } else {
                  _this2.userToEdit['isSuperAdmin'] = 0;
                }

                if (_this2.admincheckBox === 'on') {
                  _this2.userToEdit['isAdmin'] = 1;
                  _this2.userToEdit['user_clients_map'] = _this2.userToEdit.clientId;
                } else {
                  _this2.userToEdit['isAdmin'] = 0;
                }
                _this2.userToEdit['user_clients_map'] = _this2.selectClient;

                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["updateUser"])(_this2.userToEdit).then(function (response) {
                  if (_this2.userToEdit.id === _this2.currentUser.id) {
                    _this2.userToEdit['selectClient'] = _this2.userToEdit;
                    _this2.updateUserProfile(_this2.userToEdit);
                  }
                  _this2.setUserToEdit(_this2.userToEdit);
                  _this2.formError = null;
                  _this2.adminEditedFields = true;
                  setTimeout(function () {
                    _this2.adminEditedFields = false;
                  }, 3000);
                }).catch(function (error) {
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    _this2.formError = error.response.data.message;
                  }
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resendUserChanges: function resendUserChanges(userId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_UserService_js__["updateUser"])(userId).then(function (response) {
                  setTimeout(function () {
                    _this3.adminEditedFields = false;
                  }, 3000);
                  if (response.data === 'Email send successfully') {
                    _this3.message = 'Email send successfully';
                  }
                  _this3.showDeleteDialog = true;
                }).catch(function (error) {
                  if (error.response.data.type === 'DUPLICATE_EMAIL') {
                    _this3.formError = error.response.data.message;
                  }
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    hideNotification: function hideNotification() {
      this.adminEditedFields = false;
    },
    closeDialog: function closeDialog() {
      this.showDeleteDialog = false;
      this.message = null;
    }
  }),
  mounted: function mounted() {
    for (var i = 0; i < this.userToEdit.user_clients_map.length; i++) {
      this.selectClient.push(this.userToEdit.user_clients_map[i].client_id);
    }
    this.userToEdit.user_clients_map = [];
    this.userToEdit.user_clients_map = this.selectClient;
    if (this.userToEdit.isAdmin === 1) {
      this.admincheckBox = 'on';
    } else {
      this.admincheckBox = this.userToEdit.isAdmin;
    }
    if (this.userToEdit.isSuperAdmin === 1) {
      this.superadmincheckbox = 'on';
    }
    this.adminEditedFields = false;
  },

  validations: {
    userToEdit: {
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
      },
      title: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"]
      },
      directPhone: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
        validPhoneNumber: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["d" /* validPhoneNumber */]
      },
      officePhone: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        notWhitespace: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["a" /* notWhitespace */],
        validPhoneNumber: __WEBPACK_IMPORTED_MODULE_6__includes_validations_js__["d" /* validPhoneNumber */]
      }
    }
  }
});

/***/ }),

/***/ "qX0s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LanguageService_js__ = __webpack_require__("kOA1");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('language', { languages: 'getLanguageList' })),
  data: function data() {
    return {
      form: {
        code: '',
        language: ''
      },
      error: null,
      showDeleteDialog: false,
      languageDelete: ''
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('language', ['createLanguage', 'loadLanguageList']), {
    closeDialog: function closeDialog() {
      this.showDeleteDialog = false;
      this.languageDelete = '';
    },
    newLanguage: function newLanguage() {
      if (this.form.code.length < 3) {
        this.error = 'Code must be 3 characters long';
      } else if (this.form.language.length < 1) {
        this.error = 'Language cannot be empty';
      } else {
        this.error = null;
        this.createLanguage(this.form);
        this.form.code = '';
        this.form.language = '';
        this.loadLanguageList();
      }
    },
    confirmDelete: function confirmDelete(lang) {
      this.showDeleteDialog = true;
      this.languageDelete = lang;
    },
    remove: function remove(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_LanguageService_js__["b" /* delLanguage */])(id);

              case 2:
                result = _context.sent;

                if (result.data === 'success') {
                  _this.showDeleteDialog = false;
                  _this.languageDelete = '';
                  _this.loadLanguageList();
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {
    this.loadLanguageList();
  }
});

/***/ }),

/***/ "qaDs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qb4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_EditorService__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_TriggerService__ = __webpack_require__("V8i3");










/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    triggersList: [],
    initialTrigger: {},
    currentTrigger: {},
    storyFiles: []
  },
  getters: {
    storyFiles: function storyFiles(state) {
      return state.storyFiles;
    },
    triggersList: function triggersList(state) {
      return state.triggersList;
    },
    initialTrigger: function initialTrigger(state) {
      return state.initialTrigger;
    },
    currentTrigger: function currentTrigger(state) {
      return state.currentTrigger;
    },
    triggerEdited: function triggerEdited(state) {
      var edited = false;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(state.currentTrigger)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (key !== 'name') {
            if (key === 'latLng') {
              if (String(state.initialTrigger[key].lat) !== String(value.lat)) {
                edited = true;
              }
              if (String(state.initialTrigger[key].lng) !== String(value.lng)) {
                edited = true;
              }
            } else if (typeof state.initialTrigger[key] === 'number') {
              if (state.initialTrigger[key] !== parseFloat(value)) {
                edited = true;
              }
            } else {
              if (state.initialTrigger[key] !== value) {
                if (key === 'heading') {
                  if (parseFloat(state.currentTrigger.tolerance) < 360) {
                    edited = true;
                  }
                } else {
                  edited = true;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return edited;
    },
    headingEnabled: function headingEnabled(state) {
      return parseFloat(state.currentTrigger.tolerance) < 360;
    }
  },
  mutations: {
    updateLanguageOrderForTour: function updateLanguageOrderForTour(state, data) {
      state.triggersList = data.triggersList;
    },
    loadStoryFiles: function loadStoryFiles(state, storyFiles) {
      state.storyFiles = storyFiles;
    },
    loadTriggers: function loadTriggers(state, triggers) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(triggers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var trigger = _step2.value;

          if (trigger.latLng) {
            trigger.latLng = JSON.parse(trigger.latLng);
          }
          if (parseInt(trigger.heading) === -1) {
            trigger.heading = '0';
          }
          trigger.tolerance = (parseFloat(trigger.tolerance) * 2).toString();
          trigger.hovered = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.triggersList = triggers;
    },
    setTrigger: function setTrigger(state, trigger) {
      state.initialTrigger = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, trigger);
      state.currentTrigger = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, trigger);
      state.initialTrigger.latLng = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, trigger.latLng);
      state.currentTrigger.latLng = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, trigger.latLng);
    },
    addTrigger: function addTrigger(state, trigger) {
      state.triggersList.push(trigger);
    },
    clearCurrentAndInitialTriggers: function clearCurrentAndInitialTriggers(state) {
      state.currentTrigger = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {});
      state.initialTrigger = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {});
    },
    clearTriggersList: function clearTriggersList(state) {
      state.triggersList = [];
    },
    setNewCurrentTriggerLatLng: function setNewCurrentTriggerLatLng(state, latLng) {
      state.currentTrigger.latLng = latLng;
    },
    toggleTriggerHovered: function toggleTriggerHovered(state, payload) {
      if (payload.id) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.triggersList.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref3 = _step3.value;

            var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

            var index = _ref4[0];
            var value = _ref4[1];

            if (value.id === payload.id) {
              payload.index = index;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      state.triggersList[payload.index].hovered = payload.hovered;
      state.triggersList[payload.index]['triggerName'] = payload.triggerName;
    },
    updateTriggerInList: function updateTriggerInList(state, trigger) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.triggersList.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref5 = _step4.value;

          var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

          var index = _ref6[0];
          var value = _ref6[1];

          if (value.id === trigger.id) {
            state.triggersList[index] = trigger;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    removeMapTriggersFromState: function removeMapTriggersFromState(state, topicId) {
      var triggers = state.triggersList;
      var triggersLength = triggers.length;
      for (var i = 0; i < triggersLength; i++) {
        if (triggers[i].toiId === topicId) {
          if (i === 0) {
            triggers = triggers.slice(1);
          } else if (i === triggers.length - 1) {
            triggers = triggers.slice(0, triggers.length - 1);
          } else {
            triggers = triggers.slice(0, i).concat(triggers.slice(i + 1));
          }
          i--;
          triggersLength--;
        }
      }
      state.triggersList = triggers;
    },
    setMapHoverTrigger: function setMapHoverTrigger(state, indexAndToggle) {
      var index = indexAndToggle[0];
      var toggle = indexAndToggle[1];
      state.triggersList[index].mapHover = toggle;
    },
    setNewCurrentTriggerHeadingRadius: function setNewCurrentTriggerHeadingRadius(state, payload) {
      state.currentTrigger.heading = payload.heading;
      state.currentTrigger.radiusDistance = payload.radius;
    },
    setCurrentTriggerTolerance: function setCurrentTriggerTolerance(state, tolerance) {
      state.currentTrigger.tolerance = tolerance;
    },
    resetTriggerHover: function resetTriggerHover(state) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.triggersList), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var trigger = _step5.value;

          trigger.hovered = false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  },
  actions: {
    assignStoryFiles: function assignStoryFiles(_ref7, data) {
      var _this = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_TriggerService__["f" /* doStoryFilesExist */])(data);

              case 2:
                response = _context.sent;

                commit('loadStoryFiles', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    assignStory: function assignStory(_ref8, data) {
      var _this2 = this;

      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_TriggerService__["a" /* assignStoryToTrigger */])(data);

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_TriggerService__["g" /* getRouteTriggers */])(data.routeId);

              case 5:
                response = _context2.sent;

                commit('loadTriggers', response.data);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateTriggerZoneOrder: function updateTriggerZoneOrder(_ref9, data) {
      var commit = _ref9.commit;

      commit('updateLanguageOrderForTour', data);
    },
    loadTriggerList: function loadTriggerList(_ref10, payload) {
      var _this3 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, trigger;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_EditorService__["f" /* getTopicTriggers */])(payload.routeId, payload.topicId);

              case 2:
                result = _context3.sent;

                if (result.data.success) {
                  commit('loadTriggers', result.data.triggers);
                  for (trigger in result.data.triggers) {
                    commit('setTriggerStory', { triggerId: trigger.id, storyId: trigger.storyId });
                  }
                } else {
                  console.log(result.data.errors);
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setCurrentTrigger: function setCurrentTrigger(_ref11, trigger) {
      var commit = _ref11.commit;

      commit('setTrigger', trigger);
    },
    setMapHoverTrigger: function setMapHoverTrigger(_ref12, indexAndToggle) {
      var commit = _ref12.commit;

      commit('setMapHoverTrigger', indexAndToggle);
    },
    addNewTrigger: function addNewTrigger(_ref13, trigger) {
      var _this4 = this;

      var commit = _ref13.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                trigger.latLng = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(trigger.latLng);
                trigger.on_off = 1;
                trigger.priority = 0;
                trigger.tolerance = Math.round(trigger.tolerance / 2 * 100) / 100;
                _context4.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_EditorService__["b" /* addTrigger */])(trigger);

              case 6:
                result = _context4.sent;

                if (result.data.success) {
                  trigger.id = result.data.triggerId;
                  trigger.latLng = JSON.parse(trigger.latLng);
                  trigger.tolerance = (parseFloat(trigger.tolerance) * 2).toString();
                  commit('setTrigger', trigger);
                  commit('addTrigger', trigger);
                } else {
                  console.log(result.data.errors);
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    saveTriggerZone: function saveTriggerZone(_ref14, trigger) {
      var _this5 = this;

      var commit = _ref14.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                trigger.latLng = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(trigger.latLng);
                trigger.heading = parseFloat(trigger.tolerance) < 360 ? Math.round(trigger.heading * 100) / 100 : -1;
                trigger.radiusDistance = Math.round(trigger.radiusDistance * 100) / 100;
                trigger.tolerance = Math.round(trigger.tolerance / 2 * 100) / 100;

                _context5.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_EditorService__["l" /* saveTrigger */])(trigger);

              case 6:
                result = _context5.sent;

                if (result.data.success) {
                  trigger.latLng = JSON.parse(trigger.latLng);
                  trigger.hovered = false;
                  commit('updateTriggerInList', trigger);
                } else {
                  console.log(result.data.errors);
                }

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    clearCurrentTrigger: function clearCurrentTrigger(_ref15) {
      var commit = _ref15.commit;

      commit('clearCurrentAndInitialTriggers');
    },
    clearStateTriggersList: function clearStateTriggersList(_ref16) {
      var commit = _ref16.commit;

      commit('clearTriggersList');
    },
    updateCurrentTriggerLatLng: function updateCurrentTriggerLatLng(_ref17, latLng) {
      var commit = _ref17.commit;

      commit('setNewCurrentTriggerLatLng', latLng);
    },
    toggleTriggerHovered: function toggleTriggerHovered(_ref18, payload) {
      var commit = _ref18.commit;

      commit('toggleTriggerHovered', payload);
    },
    removeMapTriggersFromState: function removeMapTriggersFromState(_ref19, topicId) {
      var _this6 = this;

      var commit = _ref19.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit('removeMapTriggersFromState', topicId);

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    loadRouteTriggers: function loadRouteTriggers(_ref20, routeId) {
      var _this7 = this;

      var commit = _ref20.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_TriggerService__["g" /* getRouteTriggers */])(routeId);

              case 2:
                result = _context7.sent;

                if (result.status === 200) {
                  commit('loadTriggers', result.data);
                } else {
                  console.log('Get triggers for route failed: ' + result);
                }

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    updateCurrentTriggerHeadingRadius: function updateCurrentTriggerHeadingRadius(_ref21, payload) {
      var commit = _ref21.commit;

      commit('setNewCurrentTriggerHeadingRadius', payload);
    },
    updateCurrentTriggerTolerance: function updateCurrentTriggerTolerance(_ref22, newTolerance) {
      var commit = _ref22.commit;

      // This if block controls the min-max limits of the map marker handle to adjust trigger tolerance
      if (newTolerance > 359) {
        newTolerance = 359;
      } else if (newTolerance < 30) {
        newTolerance = 30;
      }
      commit('setCurrentTriggerTolerance', newTolerance);
    },
    resetTriggerHover: function resetTriggerHover(_ref23) {
      var commit = _ref23.commit;

      commit('resetTriggerHover');
    }
  }
});

/***/ }),

/***/ "qoN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__ = __webpack_require__("w98i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LoginService__ = __webpack_require__("N8fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReleaseSettings_vue__ = __webpack_require__("dqWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showDeleteDialog: false,
      msgStatus: false,
      errorMessage: null,
      userClients: [],
      latestVersion: '',
      releaseData: '',
      releasePanel: true,
      isHidden: false,
      releaseDetailPanel: false,
      listPanel: true,
      vedioPanel: false,
      pdfPanel: false,
      faqPanel: false,
      showquestion: true,
      showquestiondetail: false,
      UserManualList: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      UserManualListfaq: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      supportEmail: 'support@listentech.com',
      webSiteSupport: 'https://www.listentech.com/support/',
      activeTab: 'homeActive',
      choice: 'homeActive'
    };
  },

  components: {
    ReleaseSettings: __WEBPACK_IMPORTED_MODULE_7__ReleaseSettings_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])({
    routerPathName: function routerPathName(state) {
      return state.RouterModule.name;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['isAdmin', 'clientId', 'currentUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['currentClientName', 'currentClient', 'clientList', 'clientLoaded']), {
    creatingNewClient: function creatingNewClient() {
      return this.routerPathName === 'NewClient';
    }
  }),
  created: function created() {
    this.checkReleaseExistFunction();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('client', ['loadClient', 'resetClient', 'toggleClientLoadedFlag', 'unloadClient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateUserClientData', 'setUserToEdit', 'signOutUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tours', ['clearCurrentTour']), {
    getImageSrc: function getImageSrc(avatar) {
      return 'static/img/' + avatar;
    },
    backList: function backList() {
      console.log('rajesh srivastav');
      this.releaseDetailPanel = false;
      this.releasePanel = true;
    },
    checkReleaseExistFunction: function checkReleaseExistFunction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["b" /* checkReleaseExist */])(_this.currentUser.id);

              case 2:
                response = _context.sent;

                _this.releaseData = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showRelease: function showRelease(releaseDataDetail) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.releasePanel = false;
                _this2.releaseDetailPanel = true;
                _this2.singleReleaseData = releaseDataDetail;
                newData = {
                  r_id: releaseDataDetail.id,
                  u_id: _this2.currentUser.id
                };
                _context2.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["s" /* releaseStatusUpdate */])(newData);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    releaseSettings: function releaseSettings() {
      this.$router.push('/settings/release');
    },
    versionDetails: function versionDetails() {
      this.showDeleteDialog = true;
      console.log('version click');
    },

    /* closeshowVideoPdf () {
          this.showDeleteDialog = false;
          this.releasePanel = true;
          this.releaseDetailPanel = false;
          this.singleReleaseData = '';
          this.$modal.hide('ReleaseModal');
          this.$modal.hide('ReleaseModal1');
        }, */
    closeshowVideoPdf: function closeshowVideoPdf() {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    maxWindowRelease: function maxWindowRelease() {
      this.$modal.hide('ReleaseModal');
      this.$modal.show('ReleaseModal1');
    },
    minWindowRelease: function minWindowRelease() {
      this.$modal.show('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    maxWindow: function maxWindow() {
      this.$modal.hide('hello-world');
      this.$modal.show('hello-world2');
    },
    minWindow: function minWindow() {
      this.$modal.show('hello-world');
      this.$modal.hide('hello-world2');
    },
    getUserInitials: function getUserInitials(user) {
      var userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    navToClient: function navToClient(client) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var clientIDForBoth;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (client.clientId) {
                  clientIDForBoth = client.clientId;
                } else {
                  clientIDForBoth = client.client_id;
                }
                _context3.next = 3;
                return _this3.updateUserClient(_this3.currentUser.id, clientIDForBoth);

              case 3:
                _context3.next = 5;
                return _this3.loadClient({ isAdmin: false, clientId: clientIDForBoth });

              case 5:
                _context3.next = 7;
                return _this3.updateUserClientData({ id: _this3.currentUser.id });

              case 7:
                _this3.$router.push('/client/tours');

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    navToClientList: function navToClientList() {
      this.resetClient();
      this.$router.push({ path: '/client/list' });
    },
    toggleClientLoaded: function toggleClientLoaded() {
      this.toggleClientLoadedFlag();
    },
    navToSettings: function navToSettings() {
      if (this.isAdmin) {
        this.$router.push('/settings/general');
      } else {
        this.$router.push('/settings/users');
      }
    },
    showCurrentUserProfile: function showCurrentUserProfile() {
      this.setUserToEdit(this.currentUser);
      this.$router.push('/user');
    },
    clickLogout: function clickLogout() {
      Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["logout"])(this.currentUser.id);
      this.signOutUser();
      this.$router.push('/login');
    },
    getUserClientList: function getUserClientList(userId) {
      return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('api/users/clients/' + userId);
    },
    updateUserClient: function updateUserClient(userId, clientId) {
      return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('api/users/updateclient/' + userId + '/' + clientId);
    },
    showVideoPdf: function showVideoPdf() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$modal.show('hello-world');
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["m" /* getUserManual */])();

              case 3:
                result = _context4.sent;

                _this4.UserManualList = result.data;
                _this4.vedioPanel = false;
                _this4.pdfPanel = false;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    closeshowfaq: function closeshowfaq() {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    showVedio: function showVedio(id) {
      window.open('#/usermanual/video?' + id, '_blank');
    },
    showPdf: function showPdf(id) {
      window.open('#/usermanual/pdf?' + id, '_blank');
    },
    showfaq: function showfaq(detailfaq) {
      this.showquestion = false;
      this.showquestiondetail = true;
      this.detailinfo = detailfaq;
    },
    showfaqs: function showfaqs(detailfaq) {
      this.showquestion = true;
      this.showquestiondetail = false;
      this.detailinfo = detailfaq;
    },

    isActiveTab: function isActiveTab(val) {
      return this.choice === val;
    },
    makeActive: function makeActive(val) {
      if (val === 'homeActive' && this.activeTab !== 'homeActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'homeActive';
      }
      if (val === 'infoActive' && this.activeTab !== 'infoActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'infoActive';
      }
      if (val === 'faqActive' && this.activeTab !== 'faqActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'faqActive';
      }
      this.choice = val;
      console.log('this.activeTab', this.activeTab);
      console.log('this.choice', this.choice);
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var latestThis, result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              latestThis = _this5;

              Object(__WEBPACK_IMPORTED_MODULE_4__services_ReleaseService_js__["lastReleaselist"])().then(function (defs) {
                latestThis.latestVersion = defs.data[0].v_no;
              });
              _context5.prev = 2;

              if (!_this5.errorMessage) {
                _this5.errorMessage = null;
              }

              if (_this5.clientLoaded) {
                _context5.next = 14;
                break;
              }

              if (!(_this5.isAdmin === 0)) {
                _context5.next = 12;
                break;
              }

              _context5.next = 8;
              return _this5.loadClient({ isAdmin: false, clientId: _this5.clientId });

            case 8:
              _this5.toggleClientLoaded();
              _this5.$router.push('/clients/switch');
              _context5.next = 14;
              break;

            case 12:
              _this5.toggleClientLoaded();
              _this5.navToClientList();

            case 14:
              _context5.next = 16;
              return _this5.getUserClientList(_this5.currentUser.id);

            case 16:
              result = _context5.sent;

              _this5.userClients = result.data;
              _context5.next = 24;
              break;

            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5['catch'](2);

              console.error('Could not load client(s).', _context5.t0);
              _this5.errorMessage = 'System error:  could not load content';

            case 24:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[2, 20]]);
    }))();
  }
});

/***/ }),

/***/ "r/ZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r/ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMaps_vue__ = __webpack_require__("2l1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TourSettings_vue__ = __webpack_require__("QnAI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteSettings_vue__ = __webpack_require__("7BXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TriggerStoryList_vue__ = __webpack_require__("5aFM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    tourMap: __WEBPACK_IMPORTED_MODULE_3__GoogleMaps_vue__["a" /* default */],
    TourSettings: __WEBPACK_IMPORTED_MODULE_5__TourSettings_vue__["a" /* default */],
    RouteSettings: __WEBPACK_IMPORTED_MODULE_6__RouteSettings_vue__["a" /* default */],
    TriggerStoryList: __WEBPACK_IMPORTED_MODULE_7__TriggerStoryList_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({ routerPathName: function routerPathName(state) {
      return state.RouterModule.name;
    } }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('editor', ['showSettings']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('tours', ['currentTour', 'exportRunning']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['currentClient', 'currentClientName']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('topics', ['currentTopic', 'topicsList']), {
    showTourSettings: function showTourSettings() {
      return this.routerPathName === 'TopicsTab' || this.routerPathName === 'RoutesTab';
    },
    showRouteSettings: function showRouteSettings() {
      return this.routerPathName === 'Route';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('editor', ['toggleShowSettings']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('tours', ['closeExportModal']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('library', ['loadTourNotifications']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('topics', ['currentTopic', 'topicsList']), {
    closeDialog_export: function closeDialog_export() {
      this.closeExportModal();
    }
  }),
  beforeMount: function beforeMount() {
    this.loadTourNotifications({ tourId: this.currentTour.id, clientId: this.currentClient.id });
    var EventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype, {
      $bus: {
        get: function get() {
          return EventBus;
        }
      }
    });
  }
});

/***/ }),

/***/ "rGoQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rN30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_AnalyticsService__ = __webpack_require__("Spk9");







function setAnalyticsDataColour(analyticsData, colours) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(analyticsData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var index = _ref2[0];
      var data = _ref2[1];

      if (index < colours.length) {
        data.color = colours[index];
      } else {
        var newColor = generateUniqueColour(colours);
        data.color = newColor;
        colours.push(newColor);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function generateUniqueColour(colours) {
  var newColour = '';
  var validAndUnique = false;
  while (validAndUnique === false) {
    newColour = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    if (newColour.length === 7) {
      var matched = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(colours), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var colour = _step2.value;

          if (colour === newColour) {
            matched = true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!matched) {
        validAndUnique = true;
      }
    }
  }
  return newColour;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    analytics: {
      clientId: null,
      tourId: null,
      routeId: null,
      language: null,
      dateRange: 30,
      usage: {
        languages: [],
        languageData: []
      }
    },
    colors: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#651067', '#329262', '#5574a6', '#3b3eac', '#b77322', '#16d620', '#b91383', '#f4359e', '#9c5935', '#a9c413', '#2a778d', '#668d1c', '#bea413', '#0c5922', '#743411'],
    fileResults: null,
    invalidTours: null,
    isLoading: false,
    isUploading: false
  },
  getters: {
    analytics: function analytics(state) {
      return state.analytics;
    },
    fileResults: function fileResults(state) {
      return state.fileResults;
    },
    getColors: function getColors(state) {
      return state.colors;
    },
    getInvalidTours: function getInvalidTours(state) {
      return state.invalidTours;
    },
    isLoading: function isLoading(state) {
      return state.isLoading;
    },
    isUploading: function isUploading(state) {
      return state.isUploading;
    }
  },
  mutations: {
    setAnalytics: function setAnalytics(state, data) {
      state.analytics = data;
      if (state.analytics.usage) {
        if (state.analytics.usage.languageData) {
          setAnalyticsDataColour(state.analytics.usage.languageData, state.colors);
        }
        if (state.analytics.usage.topicData) {
          setAnalyticsDataColour(state.analytics.usage.topicData, state.colors);
        }
      }
    },
    setFileResults: function setFileResults(state, results) {
      state.fileResults = results;
    },
    setInvalidTours: function setInvalidTours(state, data) {
      state.invalidTours = data;
    },
    setIsLoading: function setIsLoading(state, toggle) {
      state.isLoading = toggle;
    },
    setIsUploading: function setIsUploading(state, toggle) {
      state.isUploading = toggle;
    }
  },
  actions: {
    checkTimeZonesForClient: function checkTimeZonesForClient(_ref3, clientId) {
      var _this = this;

      var commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var invalidTours;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_AnalyticsService__["a" /* checkTourTimeZones */])(clientId);

              case 3:
                invalidTours = _context.sent;

                commit('setInvalidTours', invalidTours.data);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    getAnalyticsData: function getAnalyticsData(_ref4, data) {
      var _this2 = this;

      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('setAnalytics', data);
                _context2.prev = 1;

                dispatch('analytics/isLoadingOn', {}, { root: true });
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_AnalyticsService__["b" /* getAnalytics */])(data);

              case 5:
                _context2.next = 12;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](1);

                dispatch('analytics/isLoadingOff', {}, { root: true });
                console.log(_context2.t0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 7]]);
      }))();
    },
    importFiles: function importFiles(_ref5, postData) {
      var _this3 = this;

      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                dispatch('analytics/isUploadingOn', {}, { root: true });
                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_AnalyticsService__["c" /* importFile */])(postData);

              case 4:
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                dispatch('analytics/isUploadingOff', {}, { root: true });
                console.log(_context3.t0);
                throw _context3.t0;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    isLoadingOn: function isLoadingOn(_ref6) {
      var commit = _ref6.commit;

      commit('setIsLoading', true);
    },
    isLoadingOff: function isLoadingOff(_ref7) {
      var commit = _ref7.commit;

      commit('setIsLoading', false);
    },
    isUploadingOn: function isUploadingOn(_ref8) {
      var commit = _ref8.commit;

      commit('setIsUploading', true);
    },
    isUploadingOff: function isUploadingOff(_ref9) {
      var commit = _ref9.commit;

      commit('setIsUploading', false);
    },
    loadImportResults: function loadImportResults(_ref10, results) {
      var commit = _ref10.commit;

      commit('setFileResults', results);
    },
    loadAnalytics: function loadAnalytics(_ref11, results) {
      var commit = _ref11.commit;

      commit('setAnalytics', results);
    },
    resetAnalytics: function resetAnalytics(_ref12, defaults) {
      var commit = _ref12.commit;

      commit('setAnalytics', defaults);
    }
  }
});

/***/ }),

/***/ "rRtF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ClientService_js__ = __webpack_require__("Fedb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_RouteService__ = __webpack_require__("fcCE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__ = __webpack_require__("bTS4");











/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    routesList: [],
    currentRoute: { path: [] },
    currentRouteAlt: { alt_path: [] },
    vertexToRemove: null,
    vertexToRemoveAlt: null,
    initialTopics: [],
    routeTopics: [],
    initialPath: [],
    initialPathAlt: [],
    initialRouteSettings: {},
    initialRouteSettingsAlt: {},
    updateCheck: false,
    updateCheckAlt: false,
    removedTopics: [],
    removedTopicsAlt: [],
    enableTourLanCheck: false,
    checkFileAnotherTours: false
  },
  getters: {
    routesList: function routesList(state) {
      return state.routesList;
    },
    currentRoute: function currentRoute(state) {
      return state.currentRoute;
    },
    currentRouteAlt: function currentRouteAlt(state) {
      return state.currentRouteAlt;
    },
    initialTopics: function initialTopics(state) {
      return state.initialTopics;
    },
    vertexToRemove: function vertexToRemove(state) {
      return state.vertexToRemove;
    },
    vertexToRemoveAlt: function vertexToRemoveAlt(state) {
      return state.vertexToRemoveAlt;
    },
    routeTopics: function routeTopics(state) {
      return state.routeTopics;
    },
    removedTopics: function removedTopics(state) {
      return state.removedTopics;
    },
    removedTopicsAlt: function removedTopicsAlt(state) {
      return state.removedTopicsAlt;
    },
    enableTourLanCheck: function enableTourLanCheck(state) {
      return state.enableTourLanCheck;
    },
    checkFileAnotherTours: function checkFileAnotherTours(state) {
      return state.checkFileAnotherTours;
    },
    routeChanged: function routeChanged(state) {
      var changed = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.routeTopics.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var index = _ref2[0];
          var topic = _ref2[1];

          if (topic.orderInRoute !== state.initialTopics[index].orderInRoute) {
            changed = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (state.currentRoute.id) {
        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.initialPath).length > -1) {
          if (state.updateCheck === true) {
            changed = true;
            state.updateCheck = false;
          }
        }
      }
      if (state.initialTopics.length !== state.routeTopics.length) {
        changed = true;
      }
      return changed;
    },
    routeChangedAlt: function routeChangedAlt(state) {
      var changedAlt = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.routeTopics.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var index = _ref4[0];
          var topic = _ref4[1];

          if (topic.orderInRoute !== state.initialTopics[index].orderInRoute) {
            changedAlt = true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (state.currentRouteAlt.id) {
        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.initialPath).length > -1) {
          if (state.updateCheckAlt === true) {
            changedAlt = true;
            state.updateCheckAlt = false;
          }
        }
      }
      if (state.initialTopics.length !== state.routeTopics.length) {
        changedAlt = true;
      }
      return changedAlt;
    },
    routeSettingsChanged: function routeSettingsChanged(state) {
      var edited = false;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(state.initialRouteSettings)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref5 = _step3.value;

          var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

          var key = _ref6[0];
          var value = _ref6[1];

          var currentValue = state.currentRoute[key];
          if (typeof value === 'number' && typeof currentValue !== 'number') {
            currentValue = parseInt(currentValue);
          }
          if (currentValue !== value) {
            edited = true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return edited;
    },
    routePaths: function routePaths(state) {
      return state.routesList;
    },
    routesListLength: function routesListLength(state) {
      return state.routesList.length;
    },
    updateCheck: function updateCheck(state) {
      return state.updateCheck;
    },
    updateCheckAlt: function updateCheckAlt(state) {
      return state.updateCheckAlt;
    },
    pathHasPoints: function pathHasPoints(state) {
      if (state.currentRoute.path) {
        return state.currentRoute.path.length !== 0;
      } else {
        return false;
      }
    },
    pathHasPointsAlt: function pathHasPointsAlt(state) {
      if (state.currentRouteAlt.alt_path) {
        return state.currentRouteAlt.alt_path.length !== 0;
      } else {
        return false;
      }
    }
  },
  mutations: {
    setRoutesList: function setRoutesList(state, routes) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(routes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var route = _step4.value;

          route.hover = false;
          route.mapHover = false;
          if (route.path !== null && route.path !== '') {
            route.path = JSON.parse(route.path);
            if (route.alt_path !== null && route.alt_path !== '') {
              route.alt_path = JSON.parse(route.alt_path);
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      state.routesList = routes;
    },
    setCurrentRoute: function setCurrentRoute(state, route) {
      state.currentRoute = route;
      state.initialPath = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, route.path);
      state.initialRouteSettings = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    enableTourLanCheck: function enableTourLanCheck(state, check) {
      state.enableTourLanCheck = check;
    },
    checkFileAnotherTours: function checkFileAnotherTours(state, check) {
      state.checkFileAnotherTours = check;
    },
    setCurrentRouteAlt: function setCurrentRouteAlt(state, route) {
      state.currentRouteAlt = route;
      state.initialPathAlt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, route.alt_path);
      state.initialRouteSettingsAlt = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    setVertex: function setVertex(state, index) {
      state.vertexToRemove = index;
    },
    setVertexAlt: function setVertexAlt(state, index) {
      state.vertexToRemoveAlt = index;
    },
    setInitialRouteSettings: function setInitialRouteSettings(state, route) {
      state.initialRouteSettings = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    setRouteTopics: function setRouteTopics(state, topics) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(topics), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var topic = _step5.value;

          topic.hover = false;
          topic.mapHover = false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      state.initialTopics = topics;
      state.routeTopics = topics;
    },
    removeRouteTopicsFromState: function removeRouteTopicsFromState(state, index) {
      var topics = state.routeTopics;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(topics), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var topic = _step6.value;

          topic.hover = false;
          topic.mapHover = false;
          if (topic.orderInRoute > topics[index].orderInRoute) {
            topic.orderInRoute--;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.routeTopics = topics;
    },
    removeRouteTopicsFromStateAlt: function removeRouteTopicsFromStateAlt(state, index) {
      var topics = state.routeTopics;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(topics), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var topic = _step7.value;

          topic.hover = false;
          topic.mapHover = false;
          if (topic.orderInRoute > topics[index].orderInRoute) {
            topic.orderInRoute--;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.routeTopics = topics;
    },
    resetRemovedTopics: function resetRemovedTopics(state) {
      state.removedTopics = [];
    },
    resetRemovedTopicsAlt: function resetRemovedTopicsAlt(state) {
      state.removedTopicsAlt = [];
    },
    clearRoutesList: function clearRoutesList(state) {
      state.routesList = [];
    },
    updateTopicsOrderInRoute: function updateTopicsOrderInRoute(state, payload) {
      state.routeTopics = payload.topics;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.routeTopics.entries()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref7 = _step8.value;

          var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

          var index = _ref8[0];
          var topic = _ref8[1];

          topic.orderInRoute = index + 1;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    updateInitialTopics: function updateInitialTopics(state, topics) {
      state.initialTopics = topics;
    },
    addRoutesList: function addRoutesList(state, route) {
      route.path = JSON.parse(route.path);
      route.alt_path = JSON.parse(route.alt_path);
      state.routesList.push(route);
    },
    addCurrentPath: function addCurrentPath(state, routePath) {
      state.currentRoute.path = routePath;
    },
    addCurrentPathAlt: function addCurrentPathAlt(state, routePathAlt) {
      state.currentRouteAlt.alt_path = routePathAlt;
      state.currentRoute.alt_path = routePathAlt;
    },
    setInitialPath: function setInitialPath(state) {
      state.initialPath = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.currentRoute.path);
      state.initialPathAlt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.currentRouteAlt.alt_path);
    },
    clearCurrentRoute: function clearCurrentRoute(state) {
      state.currentRoute = { path: [] };
      state.initialPath = [];
      state.currentRouteAlt = { alt_path: [] };
      state.initialPathAlt = [];
      state.routeTopics = [];
    },
    setUpdateCheck: function setUpdateCheck(state, bool) {
      state.updateCheck = bool;
    },
    setUpdateCheckAlt: function setUpdateCheckAlt(state, bool) {
      state.updateCheckAlt = bool;
    },
    clearRouteTopics: function clearRouteTopics(state) {
      state.routeTopics = [];
    },
    eraseCurrentPath: function eraseCurrentPath(state) {
      state.currentRoute.path = [];
    },
    eraseCurrentPathAlt: function eraseCurrentPathAlt(state) {
      state.currentRouteAlt.alt_path = [];
    }
  },
  actions: {
    loadRoutes: function loadRoutes(_ref9, tourId) {
      var _this = this;

      var commit = _ref9.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_ClientService_js__["j" /* getRoutes */])(tourId);

              case 2:
                response = _context.sent;

                if (response.status === 200) {
                  commit('setRoutesList', response.data);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeState: function changeState(_ref10, data) {
      var _this2 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('enableTourLanCheck', data);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeStateForFile: function changeStateForFile(_ref11, data) {
      var _this3 = this;

      var commit = _ref11.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit('checkFileAnotherTours', data);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadEditorRoute: function loadEditorRoute(_ref12, route) {
      var commit = _ref12.commit;

      commit('setCurrentRoute', route);
      commit('setCurrentRouteAlt', route);
    },
    loadRouteTopics: function loadRouteTopics(_ref13) {
      var _this4 = this;

      var commit = _ref13.commit,
          state = _ref13.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit('clearRouteTopics');
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["e" /* getRouteTopics */])(state.currentRoute.id);

              case 3:
                response = _context4.sent;

                if (response.data.success) {
                  commit('setRouteTopics', response.data.topics);
                } else {
                  console.log(response.data.errors);
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    cleanRoutesList: function cleanRoutesList(_ref14) {
      var commit = _ref14.commit;

      commit('clearRoutesList');
    },
    updateTopicOrder: function updateTopicOrder(_ref15, payload) {
      var commit = _ref15.commit;

      commit('updateTopicsOrderInRoute', payload);
    },
    updateInitialTopicList: function updateInitialTopicList(_ref16, topics) {
      var commit = _ref16.commit;

      commit('updateInitialTopics', topics);
    },
    addRoutesList: function addRoutesList(_ref17, route) {
      var commit = _ref17.commit;

      commit('addRoutesList', route);
    },
    addCurrentPath: function addCurrentPath(_ref18, routePath) {
      var commit = _ref18.commit;

      commit('addCurrentPath', routePath);
    },
    addCurrentPathAlt: function addCurrentPathAlt(_ref19, routePathAlt) {
      var commit = _ref19.commit;

      commit('addCurrentPathAlt', routePathAlt);
    },
    insertNewRoute: function insertNewRoute(_ref20, newRoute) {
      var _this5 = this;

      var commit = _ref20.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, responsenew;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["i" /* saveNewRoute */])(newRoute);

              case 2:
                response = _context5.sent;

                if (response.data === 2) {
                  commit('enableTourLanCheck', true);
                }
                if (response.data === 0) {
                  commit('checkFileAnotherTours', true);
                }

                if (!response.data.success) {
                  _context5.next = 13;
                  break;
                }

                newRoute.id = response.data.routeId;
                _context5.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_ClientService_js__["j" /* getRoutes */])(newRoute.tourId);

              case 9:
                responsenew = _context5.sent;

                if (responsenew.status === 200) {
                  commit('setRoutesList', responsenew.data);
                  commit('setCurrentRoute', newRoute);
                }
                _context5.next = 14;
                break;

              case 13:
                console.log(response.data.errors);

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    insertNewRouteTopics: function insertNewRouteTopics(_ref21, payload) {
      var _this6 = this;

      var commit = _ref21.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["a" /* addNewRouteTopics */])({ routeId: payload.route.id, newTopics: payload.newTopics });

              case 2:
                response = _context6.sent;

                if (response.data.success) {
                  commit('setCurrentRoute', payload.route);
                } else {
                  console.log(response.data.errors);
                }

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    saveRouteChanges: function saveRouteChanges(_ref22, payload) {
      var _this7 = this;

      var commit = _ref22.commit,
          state = _ref22.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var routeTopicResponse, routeUpdateResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["n" /* updateRouteTopics */])(payload.topicOrder);

              case 2:
                routeTopicResponse = _context7.sent;

                if (routeTopicResponse.status === 200) {
                  commit('updateInitialTopics', payload.routeTopics);
                }
                _context7.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["m" /* updateRouteDetails */])(state.currentRoute);

              case 6:
                routeUpdateResponse = _context7.sent;

                if (routeUpdateResponse.status === 200) {
                  commit('setInitialPath');
                  commit('setCurrentRoute', state.currentRoute);
                  commit('setCurrentRouteAlt', state.currentRouteAlt);
                }

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    clearCurrentRoute: function clearCurrentRoute(_ref23) {
      var commit = _ref23.commit;

      commit('clearCurrentRoute');
    },
    setVertex: function setVertex(_ref24, index) {
      var commit = _ref24.commit;

      commit('setVertex', index);
    },
    setVertexAlt: function setVertexAlt(_ref25, index) {
      var commit = _ref25.commit;

      commit('setVertexAlt', index);
    },
    setUpdateCheck: function setUpdateCheck(_ref26, bool) {
      var commit = _ref26.commit;

      commit('setUpdateCheck', bool);
    },
    setUpdateCheckAlt: function setUpdateCheckAlt(_ref27, bool) {
      var commit = _ref27.commit;

      commit('setUpdateCheckAlt', bool);
    },
    clearRouteTopics: function clearRouteTopics(_ref28) {
      var commit = _ref28.commit;

      commit('clearRouteTopics');
    },
    killPath: function killPath(_ref29) {
      var commit = _ref29.commit;

      commit('eraseCurrentPath');
    },
    killPathAlt: function killPathAlt(_ref30) {
      var commit = _ref30.commit;

      commit('eraseCurrentPathAlt');
    },
    saveRoute: function saveRoute(_ref31, route) {
      var _this8 = this;

      var commit = _ref31.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["m" /* updateRouteDetails */])(route);

              case 2:
                response = _context8.sent;

                if (response.status === 200) {
                  commit('setCurrentRoute', route);
                  commit('setCurrentRouteAlt', route);
                }

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    reorderTourRoutes: function reorderTourRoutes(_ref32, data) {
      var _this9 = this;

      var commit = _ref32.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var responsen;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_RouteService__["e" /* updatePriorityForRoutes */])(data);

              case 2:
                responsen = _context9.sent;

                if (!(responsen.data === 'success')) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt('return', 'Success');

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    removeRouteTopic: function removeRouteTopic(_ref33, ids) {
      var _this10 = this;

      var commit = _ref33.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["d" /* deleteTopicFromRoute */])(ids);

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    removeRouteTopicAlt: function removeRouteTopicAlt(_ref34, ids) {
      var _this11 = this;

      var commit = _ref34.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_9__services_EditorService_js__["d" /* deleteTopicFromRoute */])(ids);

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    removeRouteTopicsFromState: function removeRouteTopicsFromState(_ref35, index) {
      var _this12 = this;

      var commit = _ref35.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                commit('removeRouteTopicsFromState', index);

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    removeRouteTopicsFromStateAlt: function removeRouteTopicsFromStateAlt(_ref36, index) {
      var _this13 = this;

      var commit = _ref36.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                commit('removeRouteTopicsFromStateAlt', index);

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    resetRemovedTopicsAlt: function resetRemovedTopicsAlt(_ref37) {
      var commit = _ref37.commit;

      commit('resetRemovedTopicsAlt');
    },
    resetRemovedTopics: function resetRemovedTopics(_ref38) {
      var commit = _ref38.commit;

      commit('resetRemovedTopics');
    }
  }
});

/***/ }),

/***/ "rTFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.showLoader)?_c('div',{staticStyle:{"background":"rgba(0,0,0,0.5)","position":"fixed","display":"flex","justify-content":"center","align-items":"center","z-index":"1000001","left":"0","top":"0","height":"100%","width":"100%"}},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"library-wrap"},[_c('div',{staticClass:"line-item toolbar"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"search open-search"},[_c('md-icon',{staticClass:"search-glass-icon"},[_vm._v("search")]),_vm._v(" "),_c('div',{staticClass:"search-field"},[_c('div',{staticClass:"md-input-focused md-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterString),expression:"filterString"}],staticClass:"md-input",attrs:{"type":"text"},domProps:{"value":(_vm.filterString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterString=$event.target.value}}})])])],1)]),_vm._v(" "),_vm._m(0,false,false)]),_vm._v(" "),_c('div',{staticClass:"library-item"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_vm._m(1,false,false),_vm._v(" "),(_vm.categoryHasErrors(_vm.library.story))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"Stories has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button ",attrs:{"title":"Upload Stories"}},[_c('form',{attrs:{"id":"storyForm","enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"hidden","name":"category","value":"story"}}),_vm._v(" "),_c('input',{staticClass:" file-input",attrs:{"type":"file","name":"files","multiple":"multiple"},on:{"change":function($event){_vm.onFileUploadMulti($event, 'story')}}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1),_vm._v(" "),(_vm.storiesExpand)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.toggleExpandAll('story')}}},[_c('md-icon',{attrs:{"title":[_vm.expandAll['story'] ? 'close all' : 'open all']}},[_vm._v(_vm._s(_vm.expandAll['story'] ? 'first_page' : 'last_page'))])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Open Stories"},on:{"click":function($event){_vm.toggleExpand('story')}}},[_c('md-icon',{class:[_vm.storiesExpand ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),(_vm.storiesExpand)?_c('div',{staticClass:"inner-library-section slideDown"},[_c('md-checkbox',{attrs:{"value":1},on:{"change":function($event){_vm.selectAllCheckEvent($event)}},model:{value:(_vm.selectAllCheckBox),callback:function ($$v) {_vm.selectAllCheckBox=$$v},expression:"selectAllCheckBox"}},[_vm._v("SELECT All")]),_vm._v(" "),_vm._l((_vm.library.story),function(item,index){return (_vm.filterCheck(index))?_c('div',{staticClass:"wrap-inner-line list-group-item"},[_c('div',{staticClass:"inner-line"},[_c('div',{staticClass:"line-item hovered-line no-outline-btn"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('h4',[_vm._v(_vm._s(index))])]),_vm._v(" "),(_vm.hasVideo(item,'category'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_vm._e(),_vm._v(" "),(_vm.friendlyNameHasErrors(item))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"This item has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_vm._m(2,true,false),_vm._v(" "),_c('div',[(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button delete-btn top-index",attrs:{"title":"Delete","disabled":true}},[_c('md-icon',{staticClass:"icon-delete"})],1)],1):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button ",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Open section"},on:{"click":function($event){_vm.toggleLanguageExpand('story', index)}}},[_c('md-icon',{class:[item.expanded ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"hidden-el",class:[item.expanded ? 'open' : '']},_vm._l((item.media),function(el){return _c('div',{key:el.id,staticClass:"inner-line line-item hovered-line"},[_c('div',{staticClass:"el"},[_c('md-checkbox',{attrs:{"attName":el.filename,"value":el.id},on:{"change":function($event){_vm.checkBoxGetName($event,el.filename)}},model:{value:(_vm.arrayLibraryDetails),callback:function ($$v) {_vm.arrayLibraryDetails=$$v},expression:"arrayLibraryDetails"}})],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el indent"},[_c('h4',{staticClass:"grey-color"},[(el.uploaded === true)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File exists"}},[_vm._v("done")]):(el.uploaded === false)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(el.filename))])],1)]),_vm._v(" "),(_vm.hasVideo(el,'file'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_c('div',{staticClass:"el"},[_c('md-icon')],1),_vm._v("\n                            "+_vm._s(el.file_length)+"\n                        ")]),_vm._v(" "),(el.file_length)?_c('div',[(el.isVideo)?_c('div',{staticClass:"el"},[_c('div',{staticClass:"el logout-button"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 1)}}})])]):_c('div',{staticClass:"el"},[_c('div',{staticClass:"el logout-button"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 2)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(false)?_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1):_vm._e()],1)])])])}))]):_vm._e()}),_vm._v(" "),(_vm.shoMultiple)?_c('div',{staticStyle:{"float":"right"}},[_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#00a8ca !important"},attrs:{"type":"submit"},on:{"click":function($event){_vm.multipleDownload('STORY')}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.confirmRemoveMultipl(1)}}},[_vm._v("DELETE")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"library-item"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_vm._m(3,false,false),_vm._v(" "),(_vm.categoryHasErrors(_vm.library.filler))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"Fillers has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Upload Fillers"}},[_c('form',{attrs:{"id":"fillerForm","enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"hidden","name":"category","value":"story"}}),_vm._v(" "),_c('input',{staticClass:"file-input",attrs:{"name":"files","type":"file","multiple":"multiple"},on:{"change":function($event){_vm.onFileUploadMulti($event, 'filler')}}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1),_vm._v(" "),(_vm.fillersExpand)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.toggleExpandAll('filler')}}},[_c('md-icon',{attrs:{"title":[_vm.expandAll['filler'] ? 'close all' : 'open all']}},[_vm._v(_vm._s(_vm.expandAll['filler'] ? 'first_page' : 'last_page'))])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Open Fillers"},on:{"click":function($event){_vm.toggleExpand('filler')}}},[_c('md-icon',{class:[_vm.fillersExpand ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),(_vm.fillersExpand)?_c('div',{staticClass:"inner-library-section slideDown"},[_c('md-checkbox',{attrs:{"value":1},on:{"change":function($event){_vm.selectAllCheckEventFiller($event)}},model:{value:(_vm.selectAllCheckBoxFiller),callback:function ($$v) {_vm.selectAllCheckBoxFiller=$$v},expression:"selectAllCheckBoxFiller"}},[_vm._v("SELECT All")]),_vm._v(" "),_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.convertObjToFiller,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of story file"},on:{"update":function($event){_vm.onUpdate('Filler')},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},_vm._l((_vm.library.filler),function(item,index){return (_vm.filterCheck(index))?_c('div',{staticClass:"wrap-inner-line"},[_c('div',{staticClass:"inner-line",attrs:{"title":"Update sequence for filler files"}},[_c('div',{staticClass:"line-item hovered-line no-outline-btn"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('h4',[_vm._v(_vm._s(index))])]),_vm._v(" "),(_vm.hasVideo(item,'category'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_vm._e(),_vm._v(" "),(_vm.friendlyNameHasErrors(item))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"This item has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el time-el"},[_c('em')]),_vm._v(" "),_c('div',[(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button delete-btn top-index",attrs:{"title":"Delete","disabled":true}},[_c('md-icon',{staticClass:"icon-delete"})],1)],1):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Open section"},on:{"click":function($event){_vm.toggleLanguageExpand('filler', index)}}},[_c('md-icon',{class:[item.expanded ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"hidden-el",class:[item.expanded ? 'open' : '']},_vm._l((item.media),function(el){return _c('div',{key:el.id,staticClass:"inner-line line-item hovered-line"},[_c('div',{staticClass:"el"},[_c('md-checkbox',{attrs:{"attName":el.filename,"value":el.id},on:{"change":function($event){_vm.checkBoxGetName($event,el.filename)}},model:{value:(_vm.arrayLibraryDetailsFiller),callback:function ($$v) {_vm.arrayLibraryDetailsFiller=$$v},expression:"arrayLibraryDetailsFiller"}})],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el indent"},[_c('h4',{staticClass:"grey-color"},[(el.uploaded === true)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File exists"}},[_vm._v("done")]):(el.uploaded === false)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(el.filename))])],1)]),_vm._v(" "),(_vm.hasVideo(el,'file'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_c('div',{staticClass:"el"},[_c('md-icon')],1),_vm._v("\n                                "+_vm._s(el.file_length)+"\n                            ")]),_vm._v(" "),(el.file_length)?_c('div',[(el.isVideo)?_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 1)}}})]):_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 2)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(false)?_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1):_vm._e()],1)])])])}))]):_vm._e()})),_vm._v(" "),(_vm.shoMultiplefiller)?_c('div',{staticStyle:{"float":"right"}},[_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#00a8ca !important"},attrs:{"type":"submit"},on:{"click":function($event){_vm.multipleDownload('Filler')}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.confirmRemoveMultiplF(1)}}},[_vm._v("DELETE")])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"library-item"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_vm._m(4,false,false),_vm._v(" "),(_vm.categoryHasErrors(_vm.library.music))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"Music has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Upload Music"}},[_c('form',{attrs:{"id":"musicForm","enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"hidden","name":"category","value":"story"}}),_vm._v(" "),_c('input',{staticClass:"file-input",attrs:{"name":"files","type":"file","multiple":"multiple"},on:{"change":function($event){_vm.onFileUploadMulti($event, 'music')}}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Open Music"},on:{"click":function($event){_vm.toggleExpand('music')}}},[_c('md-icon',{class:[_vm.musicExpand ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),(_vm.musicExpand)?_c('div',{staticClass:"inner-library-section slideDown"},[_c('md-checkbox',{attrs:{"value":1},on:{"change":function($event){_vm.selectAllCheckEventMusic($event)}},model:{value:(_vm.selectAllCheckBoxMusic),callback:function ($$v) {_vm.selectAllCheckBoxMusic=$$v},expression:"selectAllCheckBoxMusic"}},[_vm._v("SELECT All")]),_vm._v(" "),_vm._l((_vm.library.music),function(item,index){return (_vm.filterCheck(index))?_c('div',{staticClass:"wrap-inner-line"},[_c('div',{staticClass:"hidden-el open"},_vm._l((item.media),function(el){return _c('div',{key:el.id,staticClass:"inner-line line-item hovered-line"},[_c('div',{staticClass:"el"},[_c('md-checkbox',{attrs:{"attName":el.filename,"value":el.id},on:{"change":function($event){_vm.checkBoxGetName($event,el.filename)}},model:{value:(_vm.arrayLibraryDetailsMusic),callback:function ($$v) {_vm.arrayLibraryDetailsMusic=$$v},expression:"arrayLibraryDetailsMusic"}})],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el indent"},[_c('h4',{staticClass:"grey-color"},[(el.uploaded === true)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File exists"}},[_vm._v("done")]):(el.uploaded === false)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(el.filename))])],1)]),_vm._v("\n                            "+_vm._s(el.file_length)+"\n                        ")]),_vm._v(" "),(el.file_length)?_c('div',[(el.isVideo)?_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 1)}}})]):_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 2)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(false)?_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1):_vm._e()],1)])])])}))]):_vm._e()}),_vm._v(" "),(_vm.shoMultiplemusic)?_c('div',{staticStyle:{"float":"right"}},[_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#00a8ca !important"},attrs:{"type":"submit"},on:{"click":function($event){_vm.multipleDownload('Music')}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.confirmRemoveMultiplM(1)}}},[_vm._v("DELETE")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"library-item"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_vm._m(5,false,false),_vm._v(" "),(_vm.categoryHasErrors(_vm.library.notification))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"Notifications has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Upload Notification Sounds"}},[_c('form',{attrs:{"id":"notificationForm","enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"hidden","name":"category","value":"story"}}),_vm._v(" "),_c('input',{staticClass:"file-input",attrs:{"type":"file","name":"files","multiple":"multiple"},on:{"change":function($event){_vm.onFileUploadMulti($event, 'notification')}}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Open Notification Sounds"},on:{"click":function($event){_vm.toggleExpand('notification')}}},[_c('md-icon',{class:[_vm.notificationsExpand ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),(_vm.notificationsExpand)?_c('div',{staticClass:"inner-library-section slideDown"},[_c('md-checkbox',{attrs:{"value":1},on:{"change":function($event){_vm.selectAllCheckEventNotification($event)}},model:{value:(_vm.selectAllCheckBoxNotification),callback:function ($$v) {_vm.selectAllCheckBoxNotification=$$v},expression:"selectAllCheckBoxNotification"}},[_vm._v("SELECT All")]),_vm._v(" "),_vm._l((_vm.library.notification),function(item,index){return (_vm.filterCheck(index))?_c('div',{staticClass:"wrap-inner-line"},[_c('div',{staticClass:"hidden-el open"},_vm._l((item.media),function(el){return _c('div',{key:el.id,staticClass:"inner-line line-item hovered-line"},[_c('div',{staticClass:"el"},[_c('md-checkbox',{attrs:{"attName":el.filename,"value":el.id},on:{"change":function($event){_vm.checkBoxGetName($event,el.filename)}},model:{value:(_vm.arrayLibraryDetailNotification),callback:function ($$v) {_vm.arrayLibraryDetailNotification=$$v},expression:"arrayLibraryDetailNotification"}})],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el indent"},[_c('h4',{staticClass:"grey-color"},[(el.uploaded === true)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File exists"}},[_vm._v("done")]):(el.uploaded === false)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(el.filename))])],1)]),_vm._v("\n                            "+_vm._s(el.file_length)+"\n                        ")]),_vm._v(" "),(el.file_length)?_c('div',[(el.isVideo)?_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 1)}}})]):_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 2)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(false)?_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1):_vm._e()],1)])])])}))]):_vm._e()}),_vm._v(" "),(_vm.shoMultiplenotification)?_c('div',{staticStyle:{"float":"right"}},[_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#00a8ca !important"},attrs:{"type":"submit"},on:{"click":function($event){_vm.multipleDownload('Notification')}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.confirmRemoveMultiplN(1)}}},[_vm._v("DELETE")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"library-item"},[_c('div',{staticClass:"line-item hovered-line"},[_c('div',{staticClass:"left-item"},[_vm._m(6,false,false),_vm._v(" "),(_vm.categoryHasErrors(_vm.library.safety))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"safety has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button ",attrs:{"title":"Upload Safety"}},[_c('form',{attrs:{"id":"safetyForm","enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"hidden","name":"category","value":"story"}}),_vm._v(" "),_c('input',{staticClass:"file-input",attrs:{"type":"file","name":"files","multiple":"multiple"},on:{"change":function($event){_vm.onFileUploadMulti($event, 'safety')}}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1),_vm._v(" "),(_vm.safetyExpand)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.toggleExpandAll('safety')}}},[_c('md-icon',{attrs:{"title":[_vm.expandAll['safety'] ? 'close all' : 'open all']}},[_vm._v(_vm._s(_vm.expandAll['safety'] ? 'first_page' : 'last_page'))])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Open Safety"},on:{"click":function($event){_vm.toggleExpand('safety')}}},[_c('md-icon',{class:[_vm.safetyExpand ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),(_vm.safetyExpand)?_c('div',{staticClass:"inner-library-section slideDown"},[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.convertObjToSafety,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of story file"},on:{"update":function($event){_vm.onUpdate('Safety')},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},[_c('md-checkbox',{attrs:{"value":1},on:{"change":function($event){_vm.selectAllCheckEventSafety($event)}},model:{value:(_vm.selectAllCheckBoxSafety),callback:function ($$v) {_vm.selectAllCheckBoxSafety=$$v},expression:"selectAllCheckBoxSafety"}},[_vm._v("SELECT All")]),_vm._v(" "),_vm._l((_vm.library.safety),function(item,index){return (_vm.filterCheck(index))?_c('div',{staticClass:"wrap-inner-line"},[_c('div',{staticClass:"inner-line",attrs:{"title":"Update sequence for safety files"}},[_c('div',{staticClass:"line-item hovered-line no-outline-btn"},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el"},[_c('h4',[_vm._v(_vm._s(index))])]),_vm._v(" "),(_vm.hasVideo(item,'category'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_vm._e(),_vm._v(" "),(_vm.friendlyNameHasErrors(item))?_c('div',{staticClass:"el"},[_c('md-icon',{staticClass:"orange-color",attrs:{"title":"This item has errors"}},[_vm._v("error_outline")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"el time-el"},[_c('em')]),_vm._v(" "),_c('div',[(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button delete-btn top-index",attrs:{"title":"Delete","disabled":true}},[_c('md-icon',{staticClass:"icon-delete"})],1)],1):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"el"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"aria-label":"Open section"},on:{"click":function($event){_vm.toggleLanguageExpand('safety', index)}}},[_c('md-icon',{class:[item.expanded ? 'icon-expand_more' : 'icon-expand_less']})],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"hidden-el",class:[item.expanded ? 'open' : '']},_vm._l((item.media),function(el){return _c('div',{key:el.id,staticClass:"inner-line line-item hovered-line"},[_c('div',{staticClass:"el"},[_c('md-checkbox',{attrs:{"attName":el.filename,"value":el.id},on:{"change":function($event){_vm.checkBoxGetName($event,el.filename)}},model:{value:(_vm.arrayLibraryDetailsafety),callback:function ($$v) {_vm.arrayLibraryDetailsafety=$$v},expression:"arrayLibraryDetailsafety"}})],1),_vm._v(" "),_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"el indent"},[_c('h4',{staticClass:"grey-color"},[(el.uploaded === true)?_c('md-icon',{staticClass:"green-color",attrs:{"title":"File exists"}},[_vm._v("done")]):(el.uploaded === false)?_c('md-icon',{staticClass:"red-color",attrs:{"title":"File is not in your library"}},[_vm._v("cancel")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(el.filename))])],1)]),_vm._v(" "),(_vm.hasVideo(el,'file'))?_c('div',{staticClass:"el"},[_c('md-icon',[_vm._v("videocam")])],1):_c('div',{staticClass:"el"},[_c('md-icon')],1),_vm._v("\n                                "+_vm._s(el.file_length)+"\n                            ")]),_vm._v(" "),(el.file_length)?_c('div',[(el.isVideo)?_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 1)}}})]):_c('div',{staticClass:"el"},[_c('img',{staticClass:"imgAudioVideo",attrs:{"src":"static/img/videoPlay.png"},on:{"click":function($event){_vm.playMedia(el, 2)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"},[(false)?_c('md-button',{staticClass:"md-icon-button upload-btn",attrs:{"aria-label":"Settings menu","disabled":true}},[_c('form',[_c('input',{staticClass:"file-input",attrs:{"type":"file"}})]),_vm._v(" "),_c('md-icon',[_vm._v("file_upload")])],1):_vm._e()],1)])])])}))]):_vm._e()})],2),_vm._v(" "),(_vm.shoMultiplesafety)?_c('div',{staticStyle:{"float":"right"}},[_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#00a8ca !important"},attrs:{"type":"submit"},on:{"click":function($event){_vm.multipleDownload('Safety')}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancelMultiple",staticStyle:{"background-color":"#d9534f !important"},on:{"click":function($event){_vm.confirmRemoveMultiplS(1)}}},[_vm._v("DELETE")])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('md-dialog',{staticClass:"uplado_medaia_acroller",attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDialog},on:{"update:mdActive":function($event){_vm.showDialog=$event}}},[_c('header',[_c('b',[_c('h2',[_vm._v("Uploading File(s) to Cortex")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"fillupload-table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"5%"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v("File Name")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30%"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticStyle:{"width":"40%"}},[_vm._v("Message")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.uploadFiles),function(uploadFile,index){return _c('tr',{key:index},[_c('td',[_c('md-icon',{class:uploadFile.iconInfo.color},[_vm._v(_vm._s(uploadFile.iconInfo.icon))])],1),_vm._v(" "),_c('td',[_c('div',{staticClass:"up-filename"},[_vm._v(_vm._s(uploadFile.name))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"progress",class:uploadFile.progressBarColor},[_c('div',{staticClass:"progress-bar",class:uploadFile.progressBarColor,style:({width:uploadFile.progress + '%'})},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(uploadFile.progressBarMessage))])])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"e-message"},[_vm._v(_vm._s(uploadFile.failureMessage))])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",attrs:{"disabled":_vm.disableCloseButtonOnFileUploadModal},on:{"click":_vm.closeDialog}},[_vm._v("close")])],1)],1)]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showValidateDialog},on:{"update:mdActive":function($event){_vm.showValidateDialog=$event}}},[_c('header',[_c('h2',[_vm._v("Validate Library")])]),_vm._v(" "),_c('div',{staticClass:"fill-modal"},[(_vm.isUploading)?_c('div',{staticClass:"upload-text centered"},[_vm._v("\n                    Uploading File(s) to Cortex\n                ")]):_vm._e(),_vm._v(" "),(_vm.isValidating)?_c('div',{staticClass:"upload-text centered"},[_vm._v("\n                    Validating library files ...\n                ")]):(!_vm.isValidating)?_c('div',{staticClass:"upload-text centered"},[_vm._v("\n                    Your library has been validated\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"loading-icon"},[(_vm.isValidating)?_c('md-progress-spinner',{staticClass:"md-accent export-running-spinner",attrs:{"md-diameter":30,"md-mode":"indeterminate"}}):_vm._e()],1)]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"md-raised md-primary",attrs:{"disabled":_vm.isValidating},on:{"click":_vm.closeValidateDialog}},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('modal',{staticClass:"full-size-video",attrs:{"name":"video-file-play","resizable":true}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.vedioSrc,"id":"video-container","width":"100%","controls":""}})])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"audio-file-play","resizable":true}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('audio-player',{staticClass:"audioFile",attrs:{"file":_vm.file1}})],1)])])]),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMedia (_vm.libraryItemDelete)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMultiple},on:{"update:mdActive":function($event){_vm.showDeleteDialogMultiple=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMediaMultiple (_vm.arrayLibraryDetails)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialogMultiple = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showMaxFileUplaodError},on:{"update:mdActive":function($event){_vm.showMaxFileUplaodError=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n          You can only upload 20 files at a time\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showMaxFileUplaodError = false}}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMultipleF},on:{"update:mdActive":function($event){_vm.showDeleteDialogMultipleF=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMediaMultiplefiller (_vm.arrayLibraryDetailsFiller)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialogMultipleF = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMultipleM},on:{"update:mdActive":function($event){_vm.showDeleteDialogMultipleM=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMediaMultiplemusic (_vm.arrayLibraryDetailsMusic)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialogMultipleM = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMultipleN},on:{"update:mdActive":function($event){_vm.showDeleteDialogMultipleN=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMediaMultiplenotification (_vm.arrayLibraryDetailNotification)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialogMultipleN = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialogMultilesafety},on:{"update:mdActive":function($event){_vm.showDeleteDialogMultilesafety=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Do you want to delete this Media?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.deleteMediaMultiplesafety (_vm.arrayLibraryDetailsafety)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('button',{staticClass:"ManualBtn ManualBtncancel extraClass",on:{"click":function($event){_vm.showDeleteDialogMultilesafety = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{staticStyle:{"overflow-y":"scroll"},attrs:{"md-active":_vm.showDialogAllRoute},on:{"update:mdActive":function($event){_vm.showDialogAllRoute=$event}}},[_c('md-list',{staticClass:"full-control"},[_c('md-subheader',[_vm._v("Routes")]),_vm._v(" "),_vm._l((_vm.arrayAllRoute),function(route,index){return _c('md-list-item',{key:index},[_c('md-checkbox',{attrs:{"value":route.id},model:{value:(_vm.selectClient),callback:function ($$v) {_vm.selectClient=$$v},expression:"selectClient"}},[_vm._v(_vm._s(route.name)+"("+_vm._s(route.toursName)+")")])],1)}),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.addLibraryFileToRoute(_vm.tempArray.libraryID)}}},[_vm._v("ADD")])],2)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-item tour-buttons"},[_c('span',[_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"}),_vm._v(" "),_c('div',{staticClass:"el"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el"},[_c('h3',[_vm._v("Stories ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el time-el"},[_c('em')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el"},[_c('h3',[_vm._v("Fillers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el"},[_c('h3',[_vm._v("Music")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el"},[_c('h3',[_vm._v("Notification Sounds")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el"},[_c('h3',[_vm._v("Safety")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "spvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "stSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportJobs_vue__ = __webpack_require__("XD2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5d61b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportJobs_vue__ = __webpack_require__("emM0");
function injectStyle (ssrContext) {
  __webpack_require__("55OV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad5d61b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportJobs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5d61b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportJobs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "syI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"routesTab"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingmy ),expression:"isLoadingmy "}],staticStyle:{"background":"rgba(0,0,0,0.5)","position":"fixed","display":"flex","justify-content":"center","align-items":"center","z-index":"1000001","left":"0","top":"0","height":"100%","width":"100%"}},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]),_vm._v(" "),_c('div',{staticClass:"scroll-list routeSectionWrapper"},[_c('md-list',{staticClass:"img-list check-avatar selectable"},[_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.routes,"disabled":!_vm.enabled,"ghost-class":"ghost","move":_vm.checkMove,"title":"Update sequence of routes"},on:{"update":function($event){_vm.onUpdate(_vm.routes)},"start":function($event){_vm.dragging = true},"end":function($event){_vm.endDragging(false)}}},_vm._l((_vm.routes),function(route,index){return _c('md-list-item',{key:index,on:{"click":function($event){_vm.navigateToTourRoute(route)},"mouseover":function($event){_vm.toggleHoverOn(index)},"mouseleave":function($event){_vm.toggleHoverLeave(index)}}},[(route.activeInactiveImages === 1)?_c('span',[_c('img',{staticClass:"completeImages",attrs:{"src":"static/img/complete.png"}})]):_c('span',[_c('img',{staticClass:"inCompleteImages",staticStyle:{"width":"13px"},attrs:{"src":"static/img/inComplete.png"}})]),_vm._v(" "),_c('div',{attrs:{"role":"button"}},[_c('div',{staticClass:"avatar s-36 material-icons"},[_c('img',{attrs:{"src":_vm.getImageSrc('route_default.png')}})]),_vm._v(" "),_c('div',{staticClass:"md-list-item-text"},[_c('h3',[_vm._v(_vm._s(route.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(route.description))])]),_vm._v(" "),_c('md-menu',{staticClass:"upload-btn"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{staticClass:"md-list-item-text",staticStyle:{"cursor":"pointer"},attrs:{"disabled":_vm.clickedcopy},on:{"~click":function($event){_vm.addRouteAnotherTours(route.id, route.tourId,route.routeTopics,route.name,route.description, route.route_image, route.commentary,route.notificationSound,route.commentaryDelay,route.audioControllerNotification,route.audioControllerFlashTime,route.alt_path,route.headendSys,route.notificationSongId)}}},[_vm._v("\n                                Copy Route To Tour\n                            ")]),_vm._v(" "),_c('md-menu-item',{staticClass:"md-list-item-text",on:{"click":function($event){_vm.confirmDelete(route.id)}}},[_vm._v("\n                                Delete\n                            ")])],1)],1)],1)])}))],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.showDeleteDialog},on:{"update:mdActive":function($event){_vm.showDeleteDialog=$event}}},[_c('md-dialog-title',[_vm._v("\n            Confirm Delete\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Are you sure you want to delete this Route?\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtndelete",on:{"click":function($event){_vm.clickDelete(_vm.routeIdDelete)}}},[_vm._v("DELETE")]),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("CANCEL")])],1)],1),_vm._v(" "),_c('md-dialog',{staticStyle:{"overflow-y":"scroll"},attrs:{"md-active":_vm.showDialogAllTours},on:{"update:mdActive":function($event){_vm.showDialogAllTours=$event}}},[_c('md-list',{staticClass:"full-control"},[_c('md-subheader',[_vm._v("TOURS")]),_vm._v(" "),_vm._l((_vm.arraytours),function(tours,index){return _c('md-list-item',{key:index},[_c('md-radio',{staticClass:"radioButtonTours",attrs:{"name":"toursIdForCopy","value":tours.id},model:{value:(_vm.toursIdForCopy),callback:function ($$v) {_vm.toursIdForCopy=$$v},expression:"toursIdForCopy"}}),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v(_vm._s(tours.name))])],1)}),_vm._v(" "),_c('md-button',{staticClass:"ManualBtn ManualBtncancel",attrs:{"disabled":_vm.onetimeRouteCopy},on:{"click":function($event){_vm.addRouteAnotherToursModal(_vm.tempArray.routeID, _vm.tempArray.tourId, _vm.tempArray.routeTopics, _vm.tempArray.name, _vm.tempArray.description, _vm.tempArray.routeimage, _vm.tempArray.commentary, _vm.tempArray.notificationSound, _vm.tempArray.commentaryDelay, _vm.tempArray.audioControllerNotification, _vm.tempArray.audioControllerFlashTime, _vm.tempArray.altpath, _vm.tempArray.headendSys, _vm.tempArray.notificationSongId)}}},[_vm._v("ADD Tours")])],2)],1),_vm._v(" "),_c('md-dialog',{staticStyle:{"overflow-y":"scroll"},attrs:{"md-active":_vm.arrayChannelModal},on:{"update:mdActive":function($event){_vm.arrayChannelModal=$event}}},[_c('md-list',{staticClass:"full-control"},[_c('md-subheader',[_vm._v("Channel")]),_vm._v(" "),_vm._l((_vm.arrayChannel),function(lang){return _c('md-list-item',{key:lang.code},[_c('md-checkbox',{attrs:{"value":lang.id},on:{"change":function($event){_vm.somethingchannel($event,'channelsadd')}},model:{value:(_vm.addLanguages),callback:function ($$v) {_vm.addLanguages=$$v},expression:"addLanguages"}},[_vm._v(_vm._s(lang.language))])],1)}),_vm._v(" "),(_vm.ManageAddChannel)?_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":function($event){_vm.addChannelAnotherToursModal(_vm.tempArrayChannel.routeID, _vm.tempArrayChannel.tourId, _vm.tempArrayChannel.routeTopics, _vm.tempArrayChannel.name, _vm.tempArrayChannel.description)}}},[_vm._v("Save")]):_vm._e()],2)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.enableTourLanCheck},on:{"update:mdActive":function($event){_vm.enableTourLanCheck=$event}}},[_c('md-dialog-title',[_vm._v("\n            Copy Error\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            The Tour you are copying to has no languages assigned. Please add at least one\n            language to the Tour within the Tour Settings page then try again\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":_vm.showDeleteDialogChannel}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.checkFileAnotherTours},on:{"update:mdActive":function($event){_vm.checkFileAnotherTours=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Please upload libary files for another tours (languages) in which you want to copy this route.\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":_vm.showDeleteDialogChannelLibrary}},[_vm._v("Ok")])],1)],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-click-outside-to-close":false,"md-active":_vm.checkRouteCompleteORnot},on:{"update:mdActive":function($event){_vm.checkRouteCompleteORnot=$event}}},[_c('md-dialog-title',[_vm._v("\n            Important Information\n        ")]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n            Please Complete your Route .\n        ")]),_vm._v(" "),_c('md-dialog-actions',{staticClass:"full-btn"},[_c('md-button',{staticClass:"ManualBtn ManualBtncancel",on:{"click":_vm.checkRouteCompleteORnotOK}},[_vm._v("Ok")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tSaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__ = __webpack_require__("55uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2143c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__ = __webpack_require__("SGag");
function injectStyle (ssrContext) {
  __webpack_require__("X8Sg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b2143c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2143c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uLEt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{class:{ heightPopuo: _vm.isActive },attrs:{"name":"hello-world","resizable":true,"reset":true,"height":"74.4%","width":"50%","minHeight":300,"minWidth":600,"maxHeight":900,"maxWidth":1200,"pivotX":0.5,"pivotY":0.5,"root":true}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoContent),expression:"videoContent"}],staticClass:"row  pppp"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes videoHeightWrapper",attrs:{"tabindex":"-1"}},[_c('video',{ref:"videoRef",attrs:{"src":this.videoSrc,"id":"video-container","width":"100%","controls":""}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdfContent),expression:"pdfContent"}],staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.videoSrc,"width":"100%","height":"800","alt":"pdf"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.faqContent),expression:"faqContent"}],staticClass:"row"},[_c('div',{staticClass:"md-dialog-container",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"boxes",attrs:{"tabindex":"-1"}},[_c('embed',{staticStyle:{"height":"700px"},attrs:{"src":this.videoSrc,"width":"100%","height":"800","alt":"pdf"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uYfp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uZUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);





//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // mime type [xls, csv]
    type: {
      type: String,
      default: "xls"
    },
    // Json to download
    data: {
      type: Array,
      required: false,
      default: null
    },
    // fields inside the Json Object that you want to export
    // if no given, all the properties in the Json are exported
    fields: {
      type: Object,
      required: false
    },
    // this prop is used to fix the problem with other components that use the
    // variable fields, like vee-validate. exportFields works exactly like fields
    exportFields: {
      type: Object,
      required: false
    },
    // Use as fallback when the row has no field values
    defaultValue: {
      type: String,
      required: false,
      default: ""
    },
    // Title(s) for the data, could be a string or an array of strings (multiple titles)
    title: {
      default: null
    },
    // Footer(s) for the data, could be a string or an array of strings (multiple footers)
    footer: {
      default: null
    },
    // filename to export
    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    worksheet: {
      type: String,
      default: "Sheet1"
    },
    //event before generate was called
    beforeGenerate: {
      type: Function
    },
    //event before download pops up
    beforeFinish: {
      type: Function
    }
  },
  computed: {
    // unique identifier
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, json;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _this.beforeGenerate === 'function')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.beforeGenerate();

              case 3:
                data = _this.data;

                if (!(typeof _this.fetch === 'function' || !data)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return _this.fetch();

              case 7:
                data = _context.sent;

              case 8:
                if (!(!data || !data.length)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                json = _this.getProcessedJson(data, _this.downloadFields);

                if (!(_this.type === "html")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

              case 15:
                if (!(_this.type === "csv")) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

              case 17:
                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    /*
    Use downloadjs to generate the download link
    */
    export: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(data, filename, mime) {
        var blob;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = this.base64ToBlob(data, mime);

                if (!(typeof this.beforeFinish === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.beforeFinish();

              case 4:
                __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, filename, mime);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _export(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _export;
    }(),
    /*
    jsonToXLS
    ---------------
    Transform json data into an xml document with MS Excel format, sadly
    it shows a prompt when it opens, that is a default behavior for
    Microsoft office and cannot be avoided. It's recommended to use CSV format instead.
    */
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;
      var _self = this;

      //Header
      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      //Fields
      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      //Data
      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      //Footer
      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
    },

    /*
    jsonToCSV
    ---------------
    Transform json data into an CSV file.
    */
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];
      //Header
      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }
      //Fields
      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");
      //Data
      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = '=\"' + item[_key2] + '\"'; // cast Numbers to string
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });
      //Footer
      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },

    /*
    getProcessedJson
    ---------------
    Get only the data to export, if no fields are set return all the data
    */
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },

    /*
    parseExtraData
    ---------------
    Parse title and footer attribute to the csv format
    */
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },


    /*
    convert values with newline \n characters into <br/>
    */
    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } // end methods
});

/***/ }),

/***/ "ucxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPermissions_vue__ = __webpack_require__("2FW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2643caca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPermissions_vue__ = __webpack_require__("+zoY");
function injectStyle (ssrContext) {
  __webpack_require__("PcsQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2643caca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPermissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2643caca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPermissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "unwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global edit-user"},[_c('header',{staticClass:"global-header"},[_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"user-avatar"},[(_vm.userToEdit.avatar)?_c('md-avatar',{staticClass:"md-avatar-icon md-large"},[_c('img',{attrs:{"src":_vm.getImageSrc(_vm.userToEdit.avatar)}})]):_c('md-avatar',{staticClass:"md-avatar-icon blue md-large"},[_vm._v("\n                    "+_vm._s(_vm.getUserInitials(_vm.userToEdit))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"user-details"},[_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.userToEdit.firstName + ' ' + _vm.userToEdit.lastName))]),_vm._v(" "),_c('div',{staticClass:"user-title"},[_vm._v(_vm._s(_vm.userToEdit.title))])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button exit-user",on:{"click":function($event){_vm.exitEditUser()}}},[_c('md-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('div',{staticClass:"line-item client-tabs btn-position-wrap"},[_c('md-tabs',{staticClass:"centered-title md-tabs-wrapper container",attrs:{"md-sync-route":"","md-alignment":"left"}},[_c('md-tab',{attrs:{"md-label":"Profile","to":"/user/profile"}}),_vm._v(" "),(_vm.userToEdit.id === _vm.currentUser.id)?_c('md-tab',{attrs:{"md-label":"Password","to":"/user/password"}}):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"wrap"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uvOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsermanualSettings_vue__ = __webpack_require__("yYZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422faa8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsermanualSettings_vue__ = __webpack_require__("jP6O");
function injectStyle (ssrContext) {
  __webpack_require__("BGbQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-422faa8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsermanualSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422faa8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsermanualSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v50o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRouteNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function deleteTopics(topicIds) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/topic/delete', { topicIds: topicIds });
}

function getRouteNames(topicIds) {
  var currentClientId = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.client.currentClient.id;
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/client/' + currentClientId + '/topic/getRouteNames', { topicIds: topicIds });
}



/***/ }),

/***/ "v8Pq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__("oNan");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tour: { type: Object, required: true },
    index: { type: Number, required: true }
  },
  data: function data() {
    return {
      showThreeDots: false,
      incompletGetDelete: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('tours', ['checked', 'redCount']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('client', ['currentClient']), {
    checkedIncomCom: function checkedIncomCom() {
      return this.redCount;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('tours', ['loadTourEditor', 'mutateCheckedList', 'checkComIncomp', 'closeExportModal']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('map', ['setCenter']), {
    getImageSrc: function getImageSrc(image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    tourChecked: function tourChecked(param) {
      var passData = { indexFor: this.index, incompletComplete: param };
      this.mutateCheckedList(passData);
      this.showThreeDots = true;
    },
    tourCheckedIncomplete: function tourCheckedIncomplete(param) {
      var passData = { indexFor: this.index, incompletComplete: param };
      this.checkComIncomp(passData);
      this.incompletGetDelete = param;
    },
    isChecked: function isChecked() {
      for (var i = 0; i < this.checked.length; i++) {
        if (this.checked[i] === this.index) {
          return true;
        }
      }
      this.showThreeDots = false;
      return false;
    },
    navigateToEditor: function navigateToEditor() {
      this.closeExportModal();
      this.loadTourEditor(this.tour);
      this.setCenter(this.tour);
      this.$router.push('/tour');
    },
    openDialogForSingle: function openDialogForSingle(param) {
      __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('openDialogForSingle', param);
    },
    copyToursAndCreateNew: function copyToursAndCreateNew(param) {
      this.showThreeDots = false;
      this.$parent.copyAtoursAndCreateNewTour(param);
    },
    changeToursImages: function changeToursImages(tourID) {
      this.$parent.changeToursImagesParent(tourID);
    },
    handleFileUpload: function handleFileUpload(event, tourID) {
      this.$parent.changeToursImagesParent(event.target.files[0], tourID);
    }
  })
});

/***/ }),

/***/ "vKGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__("HV5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bc0f2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__("Ur29");
function injectStyle (ssrContext) {
  __webpack_require__("0iYr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66bc0f2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bc0f2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vWLs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryTab_vue__ = __webpack_require__("LiuN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9aaa4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryTab_vue__ = __webpack_require__("rTFm");
function injectStyle (ssrContext) {
  __webpack_require__("IrxW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d9aaa4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9aaa4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "va1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourFigure_vue__ = __webpack_require__("1AC+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0f6d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourFigure_vue__ = __webpack_require__("fslx");
function injectStyle (ssrContext) {
  __webpack_require__("7Gqz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TourFigure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0f6d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TourFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vlAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('em',{staticClass:"logo ng-scope"}),_vm._v(" "),(_vm.isValidToken === null)?_c('div',{staticClass:"col col-md-6 my-auto login-text"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]):_c('div',{staticClass:"col col-md-6 my-auto login-text"},[(!_vm.isValidToken)?_c('div',{},[_c('h3',{staticClass:"centered"},[_vm._v("Invalid or Expired Token")])]):_vm._e(),_vm._v(" "),(_vm.isValidToken)?_c('div',{},[_c('h3',[_vm._v("Reset Your Password")]),_vm._v(" "),(!_vm.isPasswordReset)?_c('p',[_vm._v("(Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character)")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isValidToken)?_c('div',{staticClass:"centered"},[_c('p',[_vm._v("We're sorry, but the link you clicked to get here could not be verified. Please click below to return to the sign in page, and use the 'forgot password' button to reset your password.")])]):_vm._e(),_vm._v(" "),_c('div',{},[(_vm.isValidToken && !_vm.isPasswordReset)?_c('div',{staticClass:"fields"},[_c('div',{staticClass:"line-item"},[_c('md-field',{attrs:{"md-toggle-password":false}},[_c('md-input',{staticClass:"login-input",attrs:{"id":"newPassword","type":"password","placeholder":"New Password"},on:{"blur":function($event){_vm.touchNewPassHanlder()}},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1),_vm._v(" "),(_vm.$v.newPassword.$error)?_c('div',{staticClass:"invalid-password"},[_vm._v("\n                        Password must be valid (Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character)\n                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('md-field',{attrs:{"md-toggle-password":false}},[_c('md-input',{staticClass:"login-input",attrs:{"id":"confirmPassword","type":"password","placeholder":"Confirm Password"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),(_vm.newPassword)?_c('div',{staticClass:"centered form-error"},[(_vm.$v.$invalid)?_c('h4',{staticClass:"red-text"},[_vm._v("Passwords must match\n                        "),_c('md-icon',[_vm._v("thumb_down")])],1):_c('h4',{staticClass:"green-text"},[_vm._v("Passwords match\n                        "),_c('md-icon',[_vm._v("thumb_up")])],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.resetUserPasswordVar)?_c('div',[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":"static/img/loader.gif"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[(!_vm.$v.$invalid && _vm.isValidToken && !_vm.isPasswordReset)?_c('md-button',{staticClass:"md-primary md-ink-ripple md-raised",attrs:{"id":"add-password"},on:{"click":function($event){_vm.resetPassword()}}},[_vm._v("Reset\n                    Password\n                ")]):_vm._e(),_vm._v(" "),(_vm.isPasswordReset)?_c('p',{staticClass:"centered"},[_vm._v("Your password has been reset. Please sign in using the link below.")]):_vm._e()],1)]),_vm._v(" "),_c('p',{staticClass:"centered"},[_c('a',{staticClass:"login-text text-center",on:{"click":function($event){_vm.returnToLogin()}}},[_vm._v("Back to Sign In")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vpE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LoginService__ = __webpack_require__("N8fj");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: {
    meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1' }]
  },
  data: function data() {
    return {
      wrongEmailIdmsg: false,
      wrongEmailIdmsgs: false,
      email: null,
      password: null,
      rememberMe: true,
      siginInError: false,
      siginInErrorForOTP: false,
      flagForActive: false,
      flagForDeactive: false,
      inputOTP: '',
      ActiveString: 'As6pPqj3t7OBn2LQbZCUU7abvZx4',
      DeActiveString: 'As6pPqj3t7OBn2LQbZCUU7abvZx42',
      maintenance: false,
      count: localStorage.access_token.length
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['isAdmin', 'isSignedIn', 'currentUser', 'isAdminEmailCheck']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('client', ['clientLoaded'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['signInUser', 'signInUserToken', 'signOutUser', 'cleanTokenFromCurrentUser', 'SendOtpModal']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('tours', ['clearCurrentTour']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('client', ['unloadClient']), {
    checkOtpSubmit: function checkOtpSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.siginInErrorForOTP = false;
                self = _this;
                _context.next = 4;
                return _this.SendOtpModal(_this.inputOTP).then(function (defs) {
                  if (defs.data === 'ACTIVE') {
                    self.siginInErrorForOTP = false;
                    if (self.$route.query.maintenance === self.ActiveString) {
                      Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["maintenanceAction"])(1);
                      self.maintenance = true;
                      self.flagForActive = false;
                      self.flagForDeactive = false;
                    } else if (self.$route.query.maintenance === self.DeActiveString) {
                      Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["maintenanceAction"])(0);
                      self.maintenance = false;
                      self.flagForActive = false;
                      self.flagForDeactive = false;
                    }
                  } else {
                    self.siginInErrorForOTP = true;
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    signIn: function signIn() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.wrongEmailIdmsg = false;
                _this2.siginInError = false;
                _this2.wrongEmailIdmsgs = false;

                if (!(_this2.email === '' || _this2.password === '')) {
                  _context2.next = 9;
                  break;
                }

                _this2.wrongEmailIdmsgs = true;
                return _context2.abrupt('return', false);

              case 9:
                _this2.wrongEmailIdmsg = false;

              case 10:
                _context2.next = 12;
                return _this2.signInUser({ email: _this2.email, password: _this2.password, rememberMe: _this2.rememberMe });

              case 12:
                if (_this2.isAdminEmailCheck === 1) {
                  _this2.wrongEmailIdmsg = true;
                  _this2.email = '';
                  _this2.password = '';
                  _this2.siginInError = false;
                }
                if (_this2.currentUser.access_token === undefined) {
                  _this2.wrongEmailIdmsg = true;
                  _this2.siginInError = false;
                  _this2.email = '';
                  _this2.password = '';
                } else {
                  _this2.siginInError = false;
                }
                localStorage.access_token = _this2.currentUser.access_token;
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['accessToken'] = _this2.currentUser.access_token;
                _this2.cleanTokenFromCurrentUser();
                if (_this2.isAdmin === true) {
                  _this2.$router.push({ path: 'client/list' });
                } else {
                  _this2.$router.push({ path: 'clients/switch' });
                }
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](0);

                console.error('Could not sign in user.', _context2.t0);

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 20]]);
      }))();
    },
    recoverPassword: function recoverPassword() {
      this.$router.push({ path: '/forgot' });
    }
  }),
  mounted: function mounted() {
    var self = this;
    if (self.count > 10) {
      this.signInUserToken(localStorage.access_token).then(function (defs) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['accessToken'] = localStorage.access_token;
        if (defs.data.length) {
          if (defs.data[0].isAdmin === 1) {
            self.$router.push({ path: '/client/list' });
          } else {
            self.$router.push({ path: '/clients/switch' });
          }
        } else {
          self.count = 0;
          localStorage.access_token = '';
        }
      });
    }
    Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["maintenanceFlag"])().then(function (defs) {
      if (defs.data.is_maintenance === 1) {
        self.maintenance = true;
        self.flagForActive = false;
        self.flagForDeactive = false;
        if (self.$route.query.maintenance === self.DeActiveString) {
          Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["sendOtp"])(self.$route.query.maintenance);
          self.flagForDeactive = true;
          self.maintenance = false;
        }
      } else {
        if (self.$route.query.maintenance === self.ActiveString) {
          Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["sendOtp"])(self.$route.query.maintenance);
          self.maintenance = false;
          self.flagForActive = true;
        } else if (self.$route.query.maintenance === self.DeActiveString) {
          self.flagForDeactive = false;
          self.maintenance = false;
          self.flagForActive = false;
        }
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["maintenanceFlagForIP"])().then(function (defs) {
      if (defs.data === 'Chetuiwk1455.chetu.com' || defs.data === '192.168.56.1' || defs.data === '192.168.99.1' || defs.data === 'India') {
        self.maintenance = false;
        self.flagForActive = false;
      }
    });
    delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['accessToken'];
    delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['userId'];
    if (this.isSignedIn) {
      Object(__WEBPACK_IMPORTED_MODULE_5__services_LoginService__["logout"])(this.currentUser.id);
      this.signOutUser();
    }
    if (!this.isSignedIn && this.clientLoaded) {
      this.unloadClient();
      this.clearCurrentTour();
    }
  }
});

/***/ }),

/***/ "w+u0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerNotesAddTab_vue__ = __webpack_require__("Ihqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376365ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerNotesAddTab_vue__ = __webpack_require__("jV2g");
function injectStyle (ssrContext) {
  __webpack_require__("JmY9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerNotesAddTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376365ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerNotesAddTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w98i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReleaseList", function() { return getReleaseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveNewRelease", function() { return saveNewRelease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteRelease", function() { return deleteRelease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUser", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReleaseDetail", function() { return getReleaseDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateNewRelease", function() { return updateNewRelease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastReleaselist", function() { return lastReleaselist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getReleaseList(clientId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/releaselist/' + clientId);
}

function lastReleaselist() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/lastReleaselist/');
}

function saveNewRelease(newUsers) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/release', { newRelease: newUsers });
}

function deleteRelease(releaseIdToDelete) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/releaseDelete/' + releaseIdToDelete);
}

function updateUser(user) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/users', { user: user });
}

function getReleaseDetail(releaseIdToDetail) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/releasedetail/' + releaseIdToDetail);
}

function updateNewRelease(newData) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/releaseupdate', { newData: newData });
}



/***/ }),

/***/ "wCeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_FileService__ = __webpack_require__("OenE");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    uploadFile: function uploadFile(_ref, formData) {
      var _this = this;

      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                dispatch('library/isUploadingOn', {}, { root: true });
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_FileService__["a" /* upload */])(formData);

              case 4:
                _context.next = 11;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                dispatch('library/isUploadingOff', {}, { root: true });
                console.log(_context.t0);
                throw _context.t0;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    uploadFiles: function uploadFiles(_ref2, formData) {
      var _this2 = this;

      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                dispatch('library/isUploadErrorOff', {}, { root: true });
                dispatch('library/isUploadingOn', {}, { root: true });
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_FileService__["b" /* uploads */])(formData);

              case 5:
                _context2.next = 12;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                dispatch('library/isUploadErrorOn', {}, { root: true });
                dispatch('library/isUploadingOff', {}, { root: true });
                console.log(_context2.t0);
                // throw (error);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),

/***/ "wErJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wMqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("K7Pi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750627fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("UFmS");
function injectStyle (ssrContext) {
  __webpack_require__("Af2g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-750627fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750627fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wQ/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xM1Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicsTab_vue__ = __webpack_require__("PkVN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e10c7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicsTab_vue__ = __webpack_require__("EaKk");
function injectStyle (ssrContext) {
  __webpack_require__("Xdo3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e10c7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xQsh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xyYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_TimezoneService__ = __webpack_require__("aySU");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    timezones: []
  },
  getters: {
    getTimezones: function getTimezones(state) {
      return state.timezones;
    }
  },
  mutations: {
    setTimezones: function setTimezones(state, timezones) {
      state.timezones = timezones;
    }
  },
  actions: {
    loadTimezones: function loadTimezones(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resposne;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_TimezoneService__["a" /* getTimezones */])();

              case 2:
                resposne = _context.sent;

                commit('setTimezones', resposne.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "y1nb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"tourFigure",attrs:{"id":"triggerFigure"}},[(!_vm.showInfo)?_c('div',[_c('div',{staticClass:"gradient-box"}),_vm._v(" "),_c('div',{staticClass:"line-item"},[_c('div',{staticClass:"left-item"},[_c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Back to Triggers","aria-label":"Back"},on:{"click":_vm.returnToPrevious}},[_c('md-icon',[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('div',{staticClass:"left-item",staticStyle:{"position":"fixed","margin-left":"3%"}},[_c('h3',{staticClass:"link",on:{"click":function($event){_vm.toggleInfoBlock('EDITOPEN')}}},[_vm._v(_vm._s(_vm.currentTrigger.name))])])])]):_vm._e(),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"info-block"},[_c('h3',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTrigger.name),expression:"currentTrigger.name"}],attrs:{"maxlength":"60","rows":"1"},domProps:{"value":(_vm.currentTrigger.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTrigger, "name", $event.target.value)}}})]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button close-info",on:{"click":function($event){_vm.toggleInfoBlock('EDITCLOSE')}}},[_c('md-icon',[_vm._v("close")])],1),_vm._v(" "),_c('md-button',{staticClass:"save-button md-raised md-primary",on:{"click":_vm.saveTriggerNameOnly}},[_vm._v("Save")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y7VS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserProfile_vue__ = __webpack_require__("q4Gt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9af2d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserProfile_vue__ = __webpack_require__("6ZEQ");
function injectStyle (ssrContext) {
  __webpack_require__("cDao")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b9af2d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9af2d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yMzV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yYZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__ = __webpack_require__("Fedb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  data: function data() {
    return {
      shownamefile: '',
      responseProcess: '',
      video: true,
      pdf: false,
      faq: false,
      errors: '',
      files: '',
      attachmentname: '',
      question: '',
      answers: '',
      showDeleteDialog: false,
      showEditDialog: false,
      showDeleteDialogfaq: false,
      showEditDialogfaq: false,
      showAddDialog: false,
      showAddDialogtext: false,
      showVideoPdf: true,
      showfaq: false,
      defaultTriSet: {},
      formError: false,
      userManualDelete: [],
      userManualEditfaq: [],
      userManualDeletefaq: [],
      userManualEdit: [],
      enabled: true,
      UserManualList: [{
        id: '',
        attachment_name: '',
        type: '',
        path: '',
        priority: ''
      }],
      UserManualListfaq: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: ''
      }],
      getUserManualListfaq: [],
      dragging: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client', ['clientActive', 'currentClient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('user', ['userList', 'isAdmin', 'currentUser'])),
  methods: {
    checkMove: function checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    onUpdate: function onUpdate() {
      this.$emit('updated', this.UserManualList);
      this.saveUserManualOrder();
    },
    saveUserManualOrder: function saveUserManualOrder() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["x" /* updateUsermnualList */])(_this.UserManualList);

              case 2:
                result = _context.sent;
                return _context.abrupt('return', result);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changePage: function changePage(page) {
      if (page === 'VIDEO') {
        this.showVideoPdf = true;
        this.showfaq = false;
        // if (this.video === false) {
        //   this.isActive = !this.isActive;
        // }
        this.video = true;
        this.pdf = false;
        this.faq = false;
      }
      if (page === 'PDF') {
        this.showVideoPdf = true;
        this.showfaq = false;
        // if (!this.pdf === false) {
        //   this.isActive = !this.isActive;
        // }
        this.pdf = true;
        this.video = false;
        this.faq = false;
      }
      if (page === 'FAQ') {
        this.showVideoPdf = false;
        this.showfaq = true;
        // if (!this.faq === false) {
        //   this.isActive = !this.isActive;
        // }
        this.faq = true;
        this.pdf = false;
        this.video = false;
      }
      this.loadUserManual();
    },
    clickAddNewManual: function clickAddNewManual() {
      this.showAddDialog = true;
    },
    clickAddNewManualtext: function clickAddNewManualtext() {
      this.showAddDialogtext = true;
    },
    confirmDelete: function confirmDelete(usermanual) {
      this.showDeleteDialog = true;
      this.userManualDelete = usermanual;
    },
    confirmDeletefaq: function confirmDeletefaq(usermanual) {
      this.showDeleteDialogfaq = true;
      this.userManualDeletefaq = usermanual;
    },
    closeDialog: function closeDialog() {
      this.shownamefile = '';
      this.files = '';
      this.attachmentname = '';
      this.showDeleteDialog = false;
      this.showEditDialog = false;
      this.showAddDialog = false;
      this.showAddDialogtext = false;
      this.usermanualIdToDelete = null;
      this.userManualDelete = [];
      this.userManualEdit = [];
      this.errors = '';
      this.responseProcess = '';
    },
    closeDialogtext: function closeDialogtext() {
      this.shownamefile = '';
      this.files = '';
      this.attachmentname = '';
      this.question = '';
      this.answers = '';
      this.showDeleteDialogfaq = false;
      this.showEditDialogfaq = false;
      this.showAddDialog = false;
      this.showAddDialogtext = false;
      this.usermanualIdToDeletefaq = null;
      this.userManualDeletefaq = [];
      this.userManualEdit = [];
      this.errors = '';
      this.responseProcess = '';
    },
    remove: function remove(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["d" /* deleteUsermanual */])(id);

              case 2:
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["p" /* getUserManualVideo */])();

              case 4:
                result = _context2.sent;

                _this2.UserManualList = result.data;
                _this2.showDeleteDialog = false;
                _this2.usermanualIdToDelete = null;
                _this2.userManualDelete = [];
                _this2.loadUserManual();

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removes: function removes(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["e" /* deleteUsermanualfaq */])(id);

              case 2:
                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["q" /* getUserManualfaq */])();

              case 4:
                result = _context3.sent;

                _this3.UserManualListfaq = result.data;
                _this3.showDeleteDialogfaq = false;
                _this3.usermanualIdToDeletefaq = null;
                _this3.userManualDeletefaq = [];
                _this3.loadUserManual();

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showCurrentUserManual: function showCurrentUserManual(usermanual) {
      this.showEditDialog = true;
      this.userManualEdit = usermanual;
      this.attachmentname = usermanual.attachment_name;
    },
    showCurrentUserManualfaq: function showCurrentUserManualfaq(usermanual) {
      this.showEditDialogfaq = true;
      this.userManualEditfaq = usermanual;
      this.question = usermanual.question;
      this.answers = usermanual.answers;
    },
    loadUserManual: function loadUserManual() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                result = '';

                if (!_this4.video) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["p" /* getUserManualVideo */])();

              case 4:
                result = _context4.sent;
                _context4.next = 18;
                break;

              case 7:
                if (!_this4.pdf) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["o" /* getUserManualPdf */])();

              case 10:
                result = _context4.sent;
                _context4.next = 18;
                break;

              case 13:
                if (!_this4.faq) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_ClientService_js__["q" /* getUserManualfaq */])();

              case 16:
                result = _context4.sent;

                _this4.getUserManualListfaq = result.data;

              case 18:
                _this4.UserManualList = result.data;

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleFiles: function handleFiles() {
      this.shownamefile = '';
      var uploadedFiles = this.$refs.files.files;
      this.files = uploadedFiles[0];
      this.shownamefile = this.files.name;
    },
    saveUsermnual: function saveUsermnual() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.responseProcess = 'Uploading Files...';
                _this5.errors = '';
                formData = new FormData();

                formData.append('attachmentname', _this5.attachmentname);
                formData.append('file', _this5.files);
                formData.append('created', _this5.currentUser.id);
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/createUsermanual', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function (response) {
                  if (response.data !== 'success') {
                    _this5.errors = response.data;
                    _this5.responseProcess = '';
                    _this5.shownamefile = '';
                  } else {
                    _this5.errors = '';
                    _this5.files = '';
                    _this5.attachmentname = '';
                    _this5.loadUserManual();
                    _this5.showAddDialog = false;
                    _this5.responseProcess = '';
                    _this5.shownamefile = '';
                  }
                }).catch(function () {
                  console.log('FAILURE!!');
                });

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    saveUsermnualtext: function saveUsermnualtext() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var formDatatext;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.errors = '';
                formDatatext = new FormData();

                formDatatext.append('question', _this6.question);
                formDatatext.append('answers', _this6.answers);
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/createUsermanualfaq', formDatatext, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function (response) {
                  if (response.data !== 'success') {
                    _this6.errors = response.data;
                    _this6.responseProcess = '';
                    _this6.shownamefile = '';
                    _this6.showAddDialogtext = true;
                    _this6.question = '';
                    _this6.answers = '';
                  } else {
                    _this6.errors = '';
                    _this6.files = '';
                    _this6.attachmentname = '';
                    _this6.loadUserManual();
                    _this6.showAddDialogtext = false;
                    _this6.responseProcess = '';
                    _this6.shownamefile = '';
                    _this6.question = '';
                    _this6.answers = '';
                  }
                }).catch(function () {
                  console.log('FAILURE!!');
                });

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateUsermnual: function updateUsermnual(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.responseProcess = 'Uploading Files...';
                formData = new FormData();

                formData.append('attachmentname', _this7.attachmentname);
                formData.append('file', _this7.files);
                formData.append('usermanual_id', id);
                formData.append('created', _this7.currentUser.id);
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/updateUsermanual', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function (response) {
                  if (response.data !== 'success') {
                    _this7.errors = response.data;
                    _this7.responseProcess = '';
                    _this7.shownamefile = '';
                    _this7.showAddDialogtext = true;
                  } else {
                    _this7.showAddDialogtext = false;
                    _this7.responseProcess = '';
                    _this7.errors = '';
                    _this7.files = '';
                    _this7.attachmentname = '';
                    id = '';
                    _this7.loadUserManual();
                    _this7.showEditDialog = false;
                    _this7.shownamefile = '';
                  }
                }).catch(function () {
                  console.log('FAILURE!!');
                });

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    updateUsermnualfaq: function updateUsermnualfaq(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                formData = new FormData();

                formData.append('question', _this8.question);
                formData.append('answers', _this8.answers);
                formData.append('usermanual_id', id);
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/client/updateUsermanualfaq', formData).then(function (response) {
                  if (response.data !== 'success') {
                    _this8.errors = response.data;
                    _this8.responseProcess = '';
                    _this8.question = '';
                    _this8.answers = '';
                    _this8.showEditDialogfaq = false;
                    _this8.loadUserManual();
                  } else {
                    _this8.responseProcess = '';
                    _this8.errors = '';
                    _this8.question = '';
                    _this8.answers = '';
                    id = '';
                    _this8.showEditDialogfaq = false;
                    _this8.loadUserManual();
                  }
                }).catch(function () {
                  console.log('FAILURE!!');
                });

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadUserManual();
  }
});

/***/ }),

/***/ "ya+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('em',{staticClass:"logo ng-scope"}),_vm._v(" "),_c('div',{staticClass:"col col-md-4 text-center login-text  my-auto"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"line-item"},[_c('md-field',[_c('md-input',{staticClass:"login-input",attrs:{"id":"email","type":"email","placeholder":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),(_vm.emialValid)?_c('p',{staticClass:"validationMessage"},[_vm._v("Account not Found. Please use valid email")]):_vm._e(),_vm._v(" "),(_vm.validEMaliReq)?_c('p',{staticClass:"validationMessage"},[_vm._v("Enter Email Address ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('md-button',{staticClass:"md-primary md-ink-ripple md-raised",attrs:{"id":"send-email"},on:{"click":function($event){_vm.sendEmail()}}},[_vm._v("Request\n                        Reset Link\n                    ")]),_vm._v(" "),_c('p',{staticClass:"centered"},[_c('a',{staticClass:"login-text text-center",on:{"click":function($event){_vm.returnToLogin()}}},[_vm._v("Back to sign in")])])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered"},[_c('h3',[_vm._v("Having trouble signing in?")]),_vm._v(" "),_c('p',[_vm._v("Enter your email address below and we’ll get you back on track.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zAoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__ = __webpack_require__("bTS4");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showInfo: false,
      editTourName: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('triggers', ['currentTrigger', 'initialTrigger'])),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('editor', ['toggleShowTriggerTabs']), {
    toggleInfoBlock: function toggleInfoBlock(editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTrigger.name;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTrigger.name = this.editTourName;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious: function returnToPrevious() {
      this.toggleShowTriggerTabs(false);
      this.$router.push('/tour/topic');
    },
    saveTriggerName: function saveTriggerName() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var triggerToSave;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                triggerToSave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.initialTrigger);

                triggerToSave.name = _this.currentTrigger.name;
                triggerToSave.latLng = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(triggerToSave.latLng);
                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__["l" /* saveTrigger */])(triggerToSave).then(function (response) {
                  _this.toggleInfoBlock('SAVECLOSE');
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveTriggerNameOnly: function saveTriggerNameOnly() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var triggerToSave;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                triggerToSave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this2.initialTrigger);

                triggerToSave.name = _this2.currentTrigger.name;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_EditorService_js__["p" /* updateTriggerName */])(triggerToSave).then(function (response) {
                  _this2.toggleInfoBlock('SAVECLOSE');
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "zNx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newTour_vue__ = __webpack_require__("QRNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6413cfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newTour_vue__ = __webpack_require__("PbIN");
function injectStyle (ssrContext) {
  __webpack_require__("DQUZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newTour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6413cfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newTour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zR7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerFigure_vue__ = __webpack_require__("zAoX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65df316c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerFigure_vue__ = __webpack_require__("y1nb");
function injectStyle (ssrContext) {
  __webpack_require__("B1Vw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TriggerFigure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65df316c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TriggerFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zkGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_EditorService_js__ = __webpack_require__("bTS4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showInfo: false,
      editTourName: '',
      editTourDes: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('topics', ['currentTopic'])),
  methods: {
    getImageSrc: function getImageSrc(image) {
      if (image.substring(0, 5) !== 'https') {
        return 'static/img/' + image;
      } else {
        return image;
      }
    },
    toggleInfoBlock: function toggleInfoBlock(editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTopic.name;
        this.editTourDes = this.currentTopic.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTopic.name = this.editTourName;
        this.currentTopic.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious: function returnToPrevious() {
      this.$router.push('/tour/route');
    },
    saveTopicDetails: function saveTopicDetails() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var topic, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.currentTopic.name.length >= 1)) {
                  _context.next = 6;
                  break;
                }

                topic = [_this.currentTopic];
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_EditorService_js__["j" /* saveTopic */])(topic);

              case 4:
                result = _context.sent;

                if (result.status !== 200) {
                  console.log(result);
                } else {
                  _this.toggleInfoBlock('SAVECLOSE');
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bd23c845bb146401b398.js